webpackJsonp([4],{

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(183);


/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

var _;

_ = __webpack_require__(0);

module.exports = __webpack_require__(3).extend({
  created: function() {
    var data;
    if (!_.isFunction(this.$options.template)) {
      return;
    }
    if (_.isFunction(this.serializeData)) {
      data = this.serializeData();
    }
    data || (data = {});
    return this.$options.template = this.$options.template(data);
  }
});


/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(663),
  methods: {
    submit: function() {
      return this.$refs.submitButton.click();
    },
    onSubmit: function() {
      return this.$emit('submit');
    }
  }
});


/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

var SpinJS;

SpinJS = __webpack_require__(34);

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(664),
  props: {
    duration: {
      "default": '2s'
    },
    color: {
      "default": '#66c9cc'
    },
    size: {
      "default": '50px'
    }
  },
  data: function() {
    return {
      visible: false
    };
  },
  methods: {
    show: function() {
      return this.$set(this, 'visible', true);
    },
    hide: function() {
      return this.$set(this, 'visible', false);
    }
  },
  mounted: function() {
    this._spinner = new SpinJS({
      lines: 11,
      length: 12,
      width: 2,
      radius: 8,
      scale: 1,
      corners: 1,
      color: '#000',
      opacity: 0.25,
      rotate: 0,
      direction: 1,
      speed: 1,
      trail: 60,
      fps: 20,
      zIndex: 2e9,
      className: 'spinner',
      top: '50%',
      left: '50%',
      shadow: false,
      hwaccel: false,
      position: 'absolute'
    });
    return this._spinner.spin(this.$el);
  },
  beforeDestroy: function() {
    if (this._spinner != null) {
      this._spinner.stop();
    }
    return this._spinner = null;
  }
});


/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(187).extend({
  template: __webpack_require__(694),
  methods: {
    updateValue: function(value) {
      return this.$emit('input', value);
    }
  }
});


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

var b64Decode, settings;

b64Decode = __webpack_require__(16).Base64.decode;

settings = document.getElementById('site-settings').innerText;

settings = settings.replace(/\s|\n/g, '');

settings = b64Decode(settings);

settings = JSON.parse(settings);

module.exports = settings;


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

var Q, Rollbar, _, _addPayload, _isPayloadStored, _readLocalStorage, _retryTimeout, _writeLocalStorage, config, enabled, idMapping, log, queue, ref, ref1, reportError, retryMs, retrySendPayloadQueue, rollbar, rollbarCallback, rollbarCallbackError, rollbarCallbackSuccess, rollbarCheckIgnoreCallback, storeKey;

Q = __webpack_require__(2);

_ = __webpack_require__(0);

Rollbar = __webpack_require__(37);

config = __webpack_require__(115);

enabled = config.environment === 'staging' || config.environment === 'production';

retryMs = 60000;

queue = [];

idMapping = {};

rollbar = null;

storeKey = 'appRollbarQueue';

_retryTimeout = null;

reportError = function(name, message, stack, error) {
  return log({
    level: 'error',
    message: name + ": " + message,
    error: error
  });
};

log = function(options) {
  var custom, error, internalQueueId, level, message, params;
  if (options == null) {
    options = {};
  }
  if (enabled !== true) {
    return;
  }
  internalQueueId = _.uniqueId('rollbar');
  level = options.level;
  message = options.message || null;
  error = options.error || null;
  custom = options.custom || {};
  custom.internal_queue_id = internalQueueId;
  params = [];
  params.push(level);
  if (_.isString(message)) {
    params.push(message);
  }
  if (_.size(params) === 0 && _.isError(error)) {
    params.push(error.message);
  }
  if (_.isError(error)) {
    params.push(error);
  }
  if (_.size(params) === 0) {
    params.push(new Error('No Message'));
  }
  params.push(custom);
  params.push((function(_this) {
    return function(error, data) {
      return rollbarCallback(internalQueueId, error, data);
    };
  })(this));
  rollbar.log.apply(rollbar, params);
  return _.each(window._rollbarPayloadQueue, (function(_this) {
    return function(payload) {
      return _addPayload(payload);
    };
  })(this));
};

rollbarCheckIgnoreCallback = function(isUncaught, args, payload) {
  if (isUncaught === true) {
    if (((args[0] != null) && args[0].indexOf('Script error') === 0) || ((args[1] != null) && args[1].indexOf('Script error') === 0)) {
      return true;
    }
    return false;
  } else {
    return false;
  }
};

rollbarCallback = function(internalQueueId, error, data) {
  if (error) {
    return rollbarCallbackError(error, internalQueueId);
  } else {
    return rollbarCallbackSuccess(data.result, internalQueueId);
  }
};

rollbarCallbackError = function(error, internalQueueId) {
  return _retryTimeout || (_retryTimeout = window.setTimeout(function() {
    _retryTimeout = null;
    return retrySendPayloadQueue();
  }, retryMs));
};

rollbarCallbackSuccess = function(data, internalQueueId) {
  queue = _.filter(queue, (function(_this) {
    return function(data) {
      var d, quid, uuid;
      if (data.payload.data.body.message) {
        d = data.payload.data.body.message;
      } else {
        d = data.payload.data.body.trace;
      }
      uuid = data.payload.data.uuid;
      quid = d.extra.internal_queue_id;
      if (quid !== internalQueueId) {
        return true;
      }
      if (idMapping[uuid]) {
        delete idMapping[uuid];
      }
      return false;
    };
  })(this));
  return _writeLocalStorage();
};

retrySendPayloadQueue = function() {
  var e;
  if (enabled !== true) {
    return;
  }
  if (!_.any(queue)) {
    return;
  }
  window._rollbarPayloadQueue = window._rollbarPayloadQueue.concat(queue);
  try {
    return RollbarNotifier.processPayloads();
  } catch (error1) {
    e = error1;
  }
};

_addPayload = function(payload, write) {
  var d;
  if (write == null) {
    write = true;
  }
  if (_isPayloadStored(payload)) {
    return;
  }
  if (payload.payload.data.body.message) {
    d = payload.payload.data.body.message;
  } else {
    d = payload.payload.data.body.trace;
  }
  idMapping[payload.payload.data.uuid] = d.extra.internal_queue_id;
  queue.push(payload);
  if (write === true) {
    return _writeLocalStorage();
  }
};

_isPayloadStored = function(payload) {
  var stored;
  stored = _.find(queue, function(p) {
    return p.payload.data.uuid === payload.payload.data.uuid;
  });
  return !_.isUndefined(stored) && !_.isNull(stored);
};

_readLocalStorage = function() {
  var data;
  data = localStorage.getItem(storeKey);
  if (!(_.isString(data) && data !== '')) {
    return;
  }
  data = JSON.parse(data);
  if (!_.isArray(data)) {
    return;
  }
  return _.each(data, (function(_this) {
    return function(payload) {
      return _addPayload(payload, false);
    };
  })(this));
};

_writeLocalStorage = function() {
  return localStorage.setItem(storeKey, JSON.stringify(queue));
};

rollbar = Rollbar.init({
  async: true,
  enabled: config.rollbar.enabled,
  accessToken: config.rollbar.client_key,
  checkIgnore: rollbarCheckIgnoreCallback,
  payload: {
    environment: config.environment,
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
        code_version: config.revision
      }
    },
    person: {
      id: ((ref = config.current_user) != null ? ref.id : void 0) || null,
      email: ((ref1 = config.current_user) != null ? ref1.email : void 0) || null
    }
  }
});

if (enabled === true) {
  _readLocalStorage();
  setTimeout(retrySendPayloadQueue, 500);
}

module.exports = {
  reportError: reportError,
  log: log
};


/***/ }),

/***/ 186:
/***/ (function(module, exports) {

module.exports = "https://assets.kunst-gegen-mauern.de/appassets/shared/kunstgegenmauern_50x50-326208f019ccdb8a5151a5e5adf715b7.png";

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

var _;

_ = __webpack_require__(0);

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(693),
  props: {
    id: {
      "default": null
    },
    value: {
      "default": null
    },
    label: {
      "default": null
    },
    error: {
      "default": null
    },
    required: {
      "default": false
    }
  },
  computed: {
    hasLabel: function() {
      return _.isString(this.label) && _.size(this.label) > 0;
    },
    hasError: function() {
      return _.isString(this.error) && _.size(this.error) > 0;
    },
    isRequired: function() {
      return this.required === true || this.required === 'true';
    }
  }
});


/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(119).extend({
  template: __webpack_require__(695),
  props: {
    rows: {
      "default": 3
    }
  }
});


/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(187).extend({
  template: __webpack_require__(696),
  methods: {
    updateValue: function(value) {
      return this.$emit('input', value);
    }
  }
});


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

var $eventBus, Vue;

Vue = __webpack_require__(3);

$eventBus = null;

module.exports = {
  EventBus: {
    get: function() {
      return $eventBus;
    }
  },
  VuePopups: {
    install: function(Vue, options) {
      if (options == null) {
        options = {};
      }
      $eventBus = new Vue();
      Object.defineProperty(Vue.prototype, '$popups', {
        get: function() {
          return $eventBus;
        }
      });
      return null;
    }
  }
};


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

var _;

_ = __webpack_require__(0);

module.exports = {
  methods: {
    onWindowKeyDown: function(event) {
      if (event.keyCode === 27) {
        this.$emit('keydownEsc');
        if (_.isFunction(this.onKeydownEsc)) {
          return this.onKeydownEsc();
        }
      } else if (event.keyCode === 13) {
        this.$emit('keydownEnter');
        if (_.isFunction(this.onKeydownEnter)) {
          return this.onKeydownEnter();
        }
      } else if (event.keyCode === 16) {
        this.$emit('keydownShift');
        if (_.isFunction(this.onKeydownShift)) {
          return this.onKeydownShift();
        }
      } else if (event.keyCode === 17) {
        this.$emit('keydownCtrl');
        if (_.isFunction(this.onKeydownCtrl)) {
          return this.onKeydownCtrl();
        }
      } else if (event.keyCode === 18) {
        this.$emit('keydownAlt');
        if (_.isFunction(this.onKeydownAlt)) {
          return this.onKeydownAlt();
        }
      } else if (event.keyCode === 37) {
        this.$emit('keydownLeft');
        if (_.isFunction(this.onKeydownLeft)) {
          return this.onKeydownLeft();
        }
      } else if (event.keyCode === 39) {
        this.$emit('keydownRight');
        if (_.isFunction(this.onKeydownRight)) {
          return this.onKeydownRight();
        }
      }
    },
    onWindowKeyUp: function(event) {
      if (event.keyCode === 27) {
        this.$emit('keyupEsc');
        if (_.isFunction(this.onKeyupEsc)) {
          return this.onKeyupEsc();
        }
      } else if (event.keyCode === 13) {
        this.$emit('keyupEnter');
        if (_.isFunction(this.onKeyupEnter)) {
          return this.onKeyupEnter();
        }
      } else if (event.keyCode === 16) {
        this.$emit('keyupShift');
        if (_.isFunction(this.onKeyupShift)) {
          return this.onKeyupShift();
        }
      } else if (event.keyCode === 17) {
        this.$emit('keyupCtrl');
        if (_.isFunction(this.onKeyupCtrl)) {
          return this.onKeyupCtrl();
        }
      } else if (event.keyCode === 18) {
        this.$emit('keyupAlt');
        if (_.isFunction(this.onKeyupAlt)) {
          return this.onKeyupAlt();
        }
      } else if (event.keyCode === 37) {
        this.$emit('KeyupLeft');
        if (_.isFunction(this.onKeyupLeft)) {
          return this.onKeyupLeft();
        }
      } else if (event.keyCode === 39) {
        this.$emit('KeyupRight');
        if (_.isFunction(this.onKeyupRight)) {
          return this.onKeyupRight();
        }
      }
    }
  },
  created: function() {
    window.addEventListener('keyup', this.onWindowKeyUp);
    return window.addEventListener('keydown', this.onWindowKeyDown);
  },
  beforeDestroy: function() {
    window.removeEventListener('keyup', this.onWindowKeyUp);
    return window.removeEventListener('keydown', this.onWindowKeyDown);
  }
};


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(627);


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

var Vue, VueI18n, VuePopups, VueRollbar, Vuex, _, config, domready, e, error, i18nConfig, store;

window.Promise = __webpack_require__(45);

_ = __webpack_require__(0);

domready = __webpack_require__(47);

error = __webpack_require__(628);

error.init();

__webpack_require__(630).polyfill();

__webpack_require__(631);

document.addEventListener('touchstart', (function() {}), true);

config = __webpack_require__(183);

i18nConfig = {
  locale: config.i18n.locale,
  messages: {}
};

i18nConfig.messages[config.i18n.locale] = config.i18n.translations;

try {
  Vue = __webpack_require__(3);
  Vuex = __webpack_require__(17)["default"];
  VueI18n = __webpack_require__(632)["default"];
  VueRollbar = __webpack_require__(633);
  VuePopups = __webpack_require__(198).VuePopups;
  Vue.use(Vuex);
  Vue.use(VueI18n);
  Vue.use(VueRollbar);
  Vue.use(VuePopups);
  __webpack_require__(635)(Vue);
  store = new (__webpack_require__(703))();
  window.app = new Vue({
    store: store.getVuexStore(),
    i18n: new VueI18n(i18nConfig),
    created: function() {
      return store.setup();
    }
  });
  domready(function() {
    return app.$mount('#page-wrapper');
  });
} catch (error1) {
  e = error1;
  error.TraceKit.report(e);
}


/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

var TraceKit, config, init, reporter, rollbar;

TraceKit = __webpack_require__(46);

TraceKit.remoteFetching = false;

TraceKit.collectWindowErrors = true;

config = __webpack_require__(115);

rollbar = __webpack_require__(184);

reporter = __webpack_require__(629);

init = function() {
  return TraceKit.report.subscribe(function(errorReport, isWindowError, error) {
    return reporter.report(errorReport, isWindowError, error);
  });
};

module.exports = {
  init: init,
  rollbar: rollbar,
  reporter: reporter,
  config: config,
  TraceKit: TraceKit
};


/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

var config, reporter, rollbar;

config = __webpack_require__(115);

rollbar = __webpack_require__(184);

reporter = {};

reporter.report = function(errorReport, isWindowError, error) {
  error._isReported = true;
  return rollbar.reportError(errorReport.name, errorReport.message, errorReport.stack, error);
};

module.exports = {
  report: reporter.report
};


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

var _;

_ = __webpack_require__(0);

if (!_.isFunction(window.requestAnimationFrame)) {
  window.requestAnimationFrame || (window.requestAnimationFrame = window.webkitRequestAnimationFrame);
  window.requestAnimationFrame || (window.requestAnimationFrame = window.mozRequestAnimationFrame);
  window.requestAnimationFrame || (window.requestAnimationFrame = window.oRequestAnimationFrame);
  window.requestAnimationFrame || (window.requestAnimationFrame = window.msRequestAnimationFrame);
  window.requestAnimationFrame || (window.requestAnimationFrame = function(callback) {
    return window.setTimeout(callback, 1000 / 60);
  });
}

module.exports = window.requestAnimationFrame;


/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

var _, config, rollbarHelper, util;

_ = __webpack_require__(0);

util = __webpack_require__(634);

rollbarHelper = __webpack_require__(184);

config = __webpack_require__(115);

module.exports = {
  install: function(Vue, options) {
    var _oldOnError;
    if (options == null) {
      options = {};
    }
    _oldOnError = Vue.config.errorHandler;
    return Vue.config.errorHandler = function(error, vm, info) {
      var message;
      error._isReported = true;
      message = message + " " + (vm != null ? util.formatLocation(util.formatComponentName(vm)) : '');
      if (config.environment !== 'production') {
        message = "Error in " + info + ":";
        util.vueWarn("[Vue]: " + message, vm);
      }
      rollbarHelper.reportError("[Vue]", message, error.stack, error);
      if (_.isFunction(_oldOnError)) {
        return _oldOnError.call(this, error, vm, info);
      } else {
        return console.error(error, ' in ', vm);
      }
    };
  }
};


/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var _, util;

_ = __webpack_require__(0);

util = {};

util.classifyRE = /(?:^|[-_])(\w)/g;

util.classify = function(str) {
  return str.replace(util.classifyRE, function(c) {
    return c.toUpperCase();
  }).replace(/[-_]/g, '');
};

util.formatLocation = function(str) {
  if (str === '<Anonymous>') {
    str += '- use the "name" option for better debugging messages.';
  }
  return "\n(found in " + str + ")";
};

util.formatComponentName = function(vm) {
  var file, match, name;
  if (vm.$root === vm) {
    return '<Root>';
  }
  name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name;
  file = vm._isVue && vm.$options.__file;
  if (!name && file) {
    match = file.match(/([^\/\\]+)\.vue$/);
    name = match && match[1];
  }
  name = name ? "<" + (util.classify(name)) + ">" : '<Anonymous>';
  if (file != null) {
    name = name + " at " + file;
  }
  return name;
};

util.vueWarn = _.noop;

if (process.env.NODE_ENV !== 'production') {
  util.vueWarn = function(msg, vm) {
    if (typeof console !== 'undefined') {
      return console.error("[Vue warn]: " + msg + " " + (vm != null ? util.formatLocation(util.formatComponentName(vm)) : ''));
    }
  };
}

module.exports = util;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(Vue) {
  Vue.component('recaptcha', __webpack_require__(636));
  Vue.component('settings-loader', __webpack_require__(638));
  Vue.component('window-listener', __webpack_require__(640));
  Vue.component('popups-container', __webpack_require__(642));
  Vue.component('popup', __webpack_require__(200));
  Vue.component('popup-content', __webpack_require__(645));
  Vue.component('popup-countries-map', __webpack_require__(647));
  Vue.component('page-bottom-static-container', __webpack_require__(649));
  Vue.component('footer-bottom-spacer', __webpack_require__(657));
  Vue.component('navigation-wrapper', __webpack_require__(659));
  Vue.component('school-login-form', __webpack_require__(661));
  Vue.component('lightbox', __webpack_require__(665));
  Vue.component('lightbox-item', __webpack_require__(667));
  Vue.component('lazy-image', __webpack_require__(669));
  Vue.component('accordion-toggle', __webpack_require__(671));
  Vue.component('accordion-item', __webpack_require__(673));
  Vue.component('hero-rotating-image', __webpack_require__(675));
  Vue.component('countries-map', __webpack_require__(677));
  Vue.component('countries-map-container', __webpack_require__(689));
  Vue.component('contact-form-registration', __webpack_require__(691));
  Vue.component('contact-form-default', __webpack_require__(699));
  return Vue.component('contact-form-become-partner', __webpack_require__(701));
};


/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

var _;

_ = __webpack_require__(0);

module.exports = __webpack_require__(116).extend({
  template: __webpack_require__(637),
  data: function() {
    return {
      recaptchaId: null,
      loadingTrials: 0
    };
  },
  computed: {
    id: function() {
      return this._id || (this._id = _.uniqueId('recaptcha'));
    }
  },
  methods: {
    getRecaptchaResponse: function() {
      return grecaptcha.getResponse(this.recaptchaId);
    },
    loadRecaptcha: function() {
      if ((window.grecaptcha != null) && _.isFunction(window.grecaptcha.render)) {
        this.$set(this, 'loadingTrials', 0);
        return this.$set(this, 'recaptchaId', window.grecaptcha.render(this.id, {
          sitekey: this.$store.state.settings.recaptcha.sitekey
        }));
      } else if (this.loadingTrials <= 5) {
        return setTimeout((function(_this) {
          return function() {
            _this.$set(_this, 'loadingTrials', _this.loadingTrials + 1);
            return _this.loadRecaptcha();
          };
        })(this), 500);
      }
    }
  },
  mounted: function() {
    return this.loadRecaptcha();
  }
});


/***/ }),

/***/ 637:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-recaptcha\" :id=\"id\"></div>";

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(116).extend({
  template: __webpack_require__(639),
  methods: {
    loadConfig: function() {
      var settings;
      settings = __webpack_require__(183);
      return this.$store.dispatch('settings/set', settings);
    }
  },
  created: function() {
    return this.loadConfig();
  }
});


/***/ }),

/***/ 639:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-settings-loader\"></div>";

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

var _, isIE, oldScrollFunction, resizeObject;

_ = __webpack_require__(0);

oldScrollFunction = null;

isIE = false;

resizeObject = null;

module.exports = __webpack_require__(116).extend({
  template: __webpack_require__(641),
  methods: {
    onWindowScroll: function(event) {
      var data;
      if (_.isFunction(oldScrollFunction)) {
        oldScrollFunction(event);
      }
      data = {
        scrollTop: window.pageYOffset,
        scrollLeft: window.pageXOffset
      };
      this.$store.dispatch('window/updateScroll', data);
      return this.$emit('scroll', data);
    },
    onWindowResize: function() {
      var data;
      data = {
        width: resizeObject.clientWidth,
        height: resizeObject.clientHeight
      };
      this.$store.dispatch('window/updateClientWidthHeight', data);
      return this.$emit('resize', data);
    },
    addResizeHandler: function() {
      if (resizeObject != null) {
        return resizeObject.contentDocument.defaultView.addEventListener('resize', this.onWindowResize);
      }
    }
  },
  created: function() {
    oldScrollFunction = window.onscroll;
    return window.onscroll = this.onWindowScroll;
  },
  mounted: function() {
    isIE = navigator.userAgent.match(/Trident/) === 'Trident';
    resizeObject = document.createElement('object');
    resizeObject.setAttribute('style', 'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1;');
    resizeObject.onload = this.addResizeHandler;
    resizeObject.type = 'text/html';
    if (isIE) {
      this.$el.appendChild(resizeObject);
    }
    resizeObject.data = 'about:blank';
    if (!isIE) {
      this.$el.appendChild(resizeObject);
    }
    return this.onWindowResize();
  },
  beforeDestroy: function() {
    window.onscroll = oldScrollFunction;
    oldScrollFunction = null;
    if (resizeObject && resizeObject.onload) {
      if (resizeObject.contentDocument) {
        resizeObject.contentDocument.defaultView.removeEventListener('resize', this.onWindowResize);
      }
      return delete resizeObject.onload;
    }
  }
});


/***/ }),

/***/ 641:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-window-listener\"></div>";

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(200).extend({
  template: __webpack_require__(648)
});


/***/ }),

/***/ 648:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-popup-countries-map\">\n  <popup-content :popup-key=\"popupKey\" mode=\"modal\" show-close-button=\"true\" v-on:click-backdrop=\"hide\" v-on:click-close=\"hide\" close-text=\"Karte schließen\">\n    <countries-map :active_country_codes=\"payload.active_country_codes\" :country_links=\"payload.country_links\" :zoom_state=\"payload.zoom_state\" :center_lat=\"payload.center_lat\" :center_lng=\"payload.center_lng\" interactive=\"true\"></countries-map>\n  </popup-content>\n</div>";

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(650),
  components: {
    'cookie-accept': __webpack_require__(651),
    'partners-slider': __webpack_require__(653)
  },
  computed: {
    windowWidth: function() {
      return this.$store.state.window.width;
    },
    cookieAcceptHidden: function() {
      return this.$store.state.cookie.cookies['kgm-cookie-accept-hidden'];
    },
    partners: function() {
      return this.$store.state.partners.partners;
    }
  },
  methods: {
    updateCalculatedHeight: function() {
      return this.$store.dispatch('window/updateFooterSpacerHeight', {
        height: this.$el.clientHeight
      });
    },
    onPartnersSliderBoundingUpdated: function() {
      return this.$nextTick((function(_this) {
        return function() {
          return _this.updateCalculatedHeight();
        };
      })(this));
    }
  },
  watch: {
    windowWidth: function() {
      return this.updateCalculatedHeight();
    },
    cookieAcceptHidden: function() {
      return this.$nextTick((function(_this) {
        return function() {
          return _this.updateCalculatedHeight();
        };
      })(this));
    },
    partners: function() {
      return this.$nextTick((function(_this) {
        return function() {
          return _this.updateCalculatedHeight();
        };
      })(this));
    }
  }
});


/***/ }),

/***/ 650:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-page-bottom-static-container\">\n  <partners-slider v-on:boundingUpdated=\"onPartnersSliderBoundingUpdated\"></partners-slider>\n  <cookie-accept></cookie-accept>\n</div>";

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(652),
  computed: {
    visible: function() {
      return this.$store.state.cookie.cookies['kgm-cookie-accept-hidden'] !== true;
    }
  },
  methods: {
    onClickOk: function() {
      return this.$store.dispatch('cookie/set', {
        module: 'cookie-accept',
        name: 'hidden',
        value: true
      });
    },
    loadFromCookie: function() {
      return this.$store.dispatch('cookie/load', {
        module: 'cookie-accept',
        name: 'hidden'
      });
    }
  },
  created: function() {
    return this.loadFromCookie();
  }
});


/***/ }),

/***/ 652:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-cookie-accept\" v-if=\"visible\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-xs-10\">\n        <p v-t=\"'cookie_accept.message'\"></p>\n      </div>\n      <div class=\"col-xs-2 text-right\"><a class=\"accept\" href=\"#\" v-on:click.prevent=\"onClickOk\" v-t=\"'cookie_accept.button'\"></a></div>\n    </div>\n  </div>\n</div>";

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(654),
  components: {
    'image-group': __webpack_require__(655)
  },
  data: function() {
    return {
      loaded: false,
      closed: false,
      animating: false,
      cssClassesFirst: '',
      cssClassesSecond: ''
    };
  },
  computed: {
    windowWidth: function() {
      return this.$store.state.window.height;
    }
  },
  methods: {
    loadData: function() {
      this.$store.dispatch('partners/load');
      return this.$set(this, 'loaded', true);
    },
    onImageLoaded: function() {
      return this.$emit('boundingUpdated');
    },
    onClickToggle: function() {
      this.$set(this, 'closed', this.closed === false);
      return this.$store.dispatch('cookie/set', {
        module: 'partners-slider',
        name: 'closed',
        value: this.closed === true
      });
    },
    loadClosedState: function() {
      return this.$store.dispatch('cookie/load', {
        module: 'partners-slider',
        name: 'closed'
      }).then((function(_this) {
        return function(value) {
          return _this.$set(_this, 'closed', value === true);
        };
      })(this)).done();
    }
  },
  watch: {
    windowWidth: function() {
      if (!this.loaded) {
        return this.loadData();
      }
    }
  },
  created: function() {
    return this.loadClosedState();
  },
  mounted: function() {
    if (this.$store.state.window.height > 650) {
      this.loadData();
      this.$set(this, 'animating', true);
    }
    return this.$nextTick((function(_this) {
      return function() {
        _this.$set(_this, 'cssClassesFirst', 'animate animate-first-time');
        _this.$set(_this, 'cssClassesSecond', 'animate');
        return setTimeout(function() {
          return _this.$set(_this, 'cssClassesFirst', 'animate');
        }, 30000);
      };
    })(this));
  }
});


/***/ }),

/***/ 654:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-partners-slider\" :class=\"[closed ? 'comp-partners-slider-closed' : '']\">\n  <div class=\"container\">\n    <p class=\"slider-info slider-opened\" v-t=\"'partners_slider.note_uncollapsed'\"></p>\n    <p class=\"slider-info slider-closed\" v-t=\"'partners_slider.note_collapsed'\"></p><a class=\"slider-toggle slider-opened\" href=\"#\" v-on:click.prevent=\"onClickToggle\">[ {{ $t('partners_slider.button_hide') }} ]</a><a class=\"slider-toggle slider-closed\" href=\"#\" v-on:click.prevent=\"onClickToggle\">[ {{ $t('partners_slider.button_show') }} ]</a>\n    <div class=\"scrolling-container\">\n      <image-group mode=\"first\" v-on:imageLoaded=\"onImageLoaded\"></image-group>\n      <image-group mode=\"second\" v-on:imageLoaded=\"onImageLoaded\"></image-group>\n      <image-group mode=\"third\" v-on:imageLoaded=\"onImageLoaded\"></image-group>\n      <image-group mode=\"fourth\" v-on:imageLoaded=\"onImageLoaded\"></image-group>\n    </div>\n  </div>\n</div>";

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(656),
  props: {
    mode: {
      "default": null
    }
  },
  computed: {
    partners: function() {
      return this.$store.state.partners.partners;
    },
    cssClasses: function() {
      return "list-" + this.mode;
    }
  },
  methods: {
    onImageLoaded: function() {
      return this.$emit('imageLoaded');
    }
  }
});


/***/ }),

/***/ 656:
/***/ (function(module, exports) {

module.exports = "\n<ul :class=\"cssClasses\">\n  <li v-for=\"partner in partners\" v-if=\"partner.image_thumb_url\"><a v-if=\"partner.website_url\" :href=\"partner.website_url\" target=\"_blank\" :title=\"partner.name\">\n      <lazy-image :src=\"partner.image_thumb_url\" :alt=\"partner.name\" min-width=\"20px\" min-height=\"45px\" v-on:loaded=\"onImageLoaded\"></lazy-image></a>\n    <lazy-image v-else :src=\"partner.image_thumb_url\" :alt=\"partner.name\" min-width=\"20px\" min-height=\"45px\" v-on:loaded=\"onImageLoaded\"></lazy-image>\n  </li>\n  <li v-for=\"partner in partners\" v-if=\"partner.image_thumb_url\"><a v-if=\"partner.website_url\" :href=\"partner.website_url\" target=\"_blank\" :title=\"partner.name\">\n      <lazy-image :src=\"partner.image_thumb_url\" :alt=\"partner.name\" min-width=\"20px\" min-height=\"45px\" v-on:loaded=\"onImageLoaded\"></lazy-image></a>\n    <lazy-image v-else :src=\"partner.image_thumb_url\" :alt=\"partner.name\" min-width=\"20px\" min-height=\"45px\" v-on:loaded=\"onImageLoaded\"></lazy-image>\n  </li>\n</ul>";

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(658),
  computed: {
    footerSpacerHeight: function() {
      return this.$store.state.window.footerSpacerHeight || 0;
    },
    style: function() {
      return {
        height: this.footerSpacerHeight + "px"
      };
    }
  }
});


/***/ }),

/***/ 658:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-footer-bottom-spacer\" :style=\"style\"></div>";

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(660),
  props: {
    rootUrl: {
      "default": null
    }
  },
  computed: {
    logoUrl: function() {
      return __webpack_require__(186);
    }
  },
  methods: {
    openMenu: function() {
      return document.getElementsByTagName('body')[0].setAttribute('class', 'comp-navigation-wrapper-open');
    },
    closeMenu: function() {
      return document.getElementsByTagName('body')[0].setAttribute('class', '');
    }
  }
});


/***/ }),

/***/ 660:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-navigation-wrapper\">\n  <div class=\"comp-navigation-wrapper-mobile\">\n    <nav><a class=\"mobile-logo\" :href=\"rootUrl\"><img :src=\"logoUrl\" size=\"50x50\" alt=\"Kunst gegen Mauern\"></a><a class=\"mobile-menu\" href=\"#\" v-on:click.prevent=\"openMenu\"><span>Menu</span><i class=\"mdi mdi-menu\"></i></a></nav>\n  </div>\n  <div class=\"comp-navigation-wrapper-outside\">\n    <div class=\"comp-navigation-wrapper-backdrop\" v-on:click.prevent.stop=\"closeMenu\"></div>\n    <div class=\"comp-navigation-wrapper-inside\">\n      <div class=\"text-right\"><a class=\"mobile-item mobile-close-drawer\" href=\"#\" v-on:click.prevent=\"closeMenu\"><i class=\"mdi mdi-close\"></i></a></div>\n      <slot></slot>\n    </div>\n  </div>\n</div>";

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

var Q, axios;

Q = __webpack_require__(2);

axios = __webpack_require__(13);

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(662),
  components: {
    'prevented-form': __webpack_require__(117),
    'loading-indicator': __webpack_require__(118)
  },
  data: function() {
    return {
      email: null,
      password: null,
      error: null
    };
  },
  methods: {
    resetDataToDefaults: function() {
      this.$set(this, 'email', null);
      this.$set(this, 'password', null);
      return this.$set(this, 'error', null);
    },
    getCsrfToken: function() {
      return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    },
    pressSubmit: function() {
      return this.$refs.form.submit();
    },
    showLoadingIndicator: function() {
      return this.$refs.loadingIndicator.show();
    },
    hideLoadingIndicator: function() {
      return this.$refs.loadingIndicator.hide();
    },
    submit: function() {
      var errorFunc, signInData;
      this.showLoadingIndicator();
      signInData = {
        method: 'post',
        url: '/account/sign_in.json',
        data: {
          school_user: {
            email: this.email,
            password: this.password
          }
        },
        headers: {
          'X-CSRF-Token': this.getCsrfToken()
        }
      };
      errorFunc = (function(_this) {
        return function(error) {
          var ref;
          window.error = error;
          if (((ref = error.response) != null ? ref.data : void 0) != null) {
            _this.$set(_this, 'error', error.response.data.error);
          } else {
            _this.$set(_this, 'error', 'Fehler bei der Anmeldung');
          }
          return _this.hideLoadingIndicator();
        };
      })(this);
      return axios(signInData).then((function(_this) {
        return function(response) {
          window.location.pathname = '/account';
          return _this.hideLoadingIndicator();
        };
      })(this))["catch"](errorFunc);
    }
  }
});


/***/ }),

/***/ 662:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-school-login-form\">\n  <loading-indicator ref=\"loadingIndicator\"></loading-indicator>\n  <prevented-form ref=\"form\" v-on:submit=\"submit\">\n    <div class=\"form-control\">\n      <label for=\"school-user-email-input\" v-t=\"'login_form.email'\"></label>\n      <input :placeholder=\"$t('login_form.email')\" name=\"school_user[email]\" v-model=\"email\" id=\"school-user-email-input\">\n    </div>\n    <div class=\"form-control\">\n      <label for=\"school-user-password-input\" v-t=\"'login_form.password'\"></label>\n      <input type=\"password\" :placeholder=\"$t('login_form.password')\" name=\"school_user[password]\" v-model=\"password\" id=\"school-user-password-input\">\n    </div>\n    <div class=\"info-box info-box-danger\" v-if=\"error\">{{ error }}</div>\n    <button class=\"kgm-btn kgm-btn-primary kgm-btn-block\" type=\"submit\" v-on:click.prevent=\"pressSubmit\" v-t=\"'login_form.submit'\"></button>\n  </prevented-form>\n</div>";

/***/ }),

/***/ 663:
/***/ (function(module, exports) {

module.exports = "\n<form method=\"POST\" v-on:submit.prevent=\"onSubmit\" name=\"mwc-prevented-form\">\n  <button type=\"submit\" ref=\"submitButton\" style=\"display:none;\"></button>\n  <slot></slot>\n</form>";

/***/ }),

/***/ 664:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-loading-indicator\" :class=\"[visible ? 'comp-loading-indicator-visible' : '']\"></div>";

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

var SpinJS, imgDirective, spinJsOptions;

SpinJS = __webpack_require__(34);

imgDirective = function(el, binding, vnode) {
  var event, img;
  if (binding.value === binding.oldValue) {
    return;
  }
  event = new CustomEvent('imageLoading');
  el.dispatchEvent(event);
  img = new Image();
  img.src = binding.value;
  el.src = '';
  return img.onload = function() {
    el.src = binding.value;
    event = new CustomEvent('imageLoaded', {
      detail: {
        width: img.width,
        height: img.height
      }
    });
    return el.dispatchEvent(event);
  };
};

spinJsOptions = {
  lines: 11,
  length: 12,
  width: 2,
  radius: 8,
  scale: 1,
  corners: 1,
  color: '#fff',
  opacity: 0.25,
  rotate: 0,
  direction: 1,
  speed: 1,
  trail: 60,
  fps: 20,
  zIndex: 2e9,
  className: 'spinner',
  top: '50%',
  left: '50%',
  shadow: false,
  hwaccel: false,
  position: 'absolute'
};

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(666),
  mixins: [__webpack_require__(199)],
  data: function() {
    return {
      loading: false,
      zoomed: false,
      mouseDown: false,
      dragging: false,
      dragCoord: {
        x: 0,
        y: 0
      },
      imageStyle: {},
      imageBoxStyle: {}
    };
  },
  directives: {
    img: {
      bind: imgDirective,
      update: imgDirective
    },
    spinJsSpinner: {
      bind: function(el, binding, vnode) {
        binding.spinner = new SpinJS(spinJsOptions);
        return binding.spinner.spin(el);
      },
      unbind: function(el, binding, vnode) {
        if (binding.spinner != null) {
          binding.spinner.stop();
        }
        return binding.spinner = null;
      }
    }
  },
  computed: {
    isOpen: function() {
      return (this.openedCollection != null) && (this.openedItem != null);
    },
    isZoomable: function() {
      if (this.loading) {
        return false;
      }
      if (!this.$refs.currentImage) {
        return false;
      }
      return this.$refs.currentImage.offsetWidth < this.$refs.currentImage.naturalWidth || this.$refs.currentImage.offsetHeight < this.$refs.currentImage.naturalHeight;
    },
    isZoomed: function() {
      return this.zoomed === true;
    },
    openedCollection: function() {
      return this.$store.state.lightbox.openedCollection;
    },
    openedItem: function() {
      return this.$store.state.lightbox.openedItem;
    },
    openedData: function() {
      return this.$store.getters['lightbox/current'] || {};
    },
    openedUrl: function() {
      return this.openedData.imageUrl || null;
    },
    openedTitle: function() {
      return this.openedData.title || null;
    },
    normalizedImageBoxStyle: function() {
      if (this.isZoomable && this.isZoomed) {
        return {};
      } else {
        return this.imageBoxStyle;
      }
    },
    normalizedImageStyle: function() {
      if (this.isZoomable && this.isZoomed) {
        return {};
      } else {
        return this.imageStyle;
      }
    },
    hasPreviousItem: function() {
      return this.$store.getters['lightbox/hasPreviousItem'] === true;
    },
    hasNextItem: function() {
      return this.$store.getters['lightbox/hasNextItem'] === true;
    },
    previousItemData: function() {},
    nextItemData: function() {}
  },
  methods: {
    close: function() {
      return this.$store.dispatch('lightbox/close');
    },
    onKeyupEsc: function() {
      return this.close();
    },
    onClickClose: function() {
      return this.close();
    },
    onKeyupLeft: function() {
      return this.$store.dispatch('lightbox/openPrevious');
    },
    onKeyupRight: function() {
      return this.$store.dispatch('lightbox/openNext');
    },
    onCurrentImageLoading: function() {
      this.$set(this, 'zoomed', false);
      return this.$set(this, 'loading', true);
    },
    onCurrentImageLoaded: function(event) {
      this.$set(this, 'zoomed', false);
      this.$set(this, 'loading', false);
      this.resetImageSize();
      return this.$nextTick((function(_this) {
        return function() {
          return _this.updateImageContainerSize(event.detail.width, event.detail.height);
        };
      })(this));
    },
    onCurrentImageClick: function() {
      if (!this.isZoomable) {
        return;
      }
      return this.$set(this, 'zoomed', this.zoomed === false);
    },
    onClickPrevious: function() {
      return this.$store.dispatch('lightbox/openPrevious');
    },
    onClickNext: function() {
      return this.$store.dispatch('lightbox/openNext');
    },
    onMouseDown: function(event) {
      return this.$set(this, 'mouseDown', true);
    },
    onMouseUp: function(event) {
      this.$set(this, 'mouseDown', false);
      if (this.dragging !== true) {
        this.onCurrentImageClick();
      }
      this.$set(this, 'dragging', false);
      return this.$set(this, 'dragCoord', {
        x: 0,
        y: 0
      });
    },
    onMouseMove: function(event) {
      var diff;
      if (this.mouseDown !== true) {
        return;
      }
      if (this.dragging === true) {
        diff = this.dragCoord.x - event.offsetX;
        return this.$refs.currentImageBox.scrollLeft = this.$refs.currentImageBox.scrollLeft + diff;
      } else {
        this.$set(this, 'dragging', true);
        return this.$set(this, 'dragCoord', {
          x: event.offsetX,
          y: event.offsetY
        });
      }
    },
    resetImageSize: function() {
      return this.$set(this, 'imageStyle', {});
    },
    updateImageContainerSize: function(width, height) {
      var style;
      style = {
        height: height,
        width: width
      };
      if (this.$refs.currentImageContainer.clientHeight < style.height) {
        style.height = this.$refs.currentImageContainer.clientHeight;
        style.width = parseInt(style.height / height * width);
      }
      if (this.$refs.currentImageContainer.clientWidth < style.width) {
        style.width = this.$refs.currentImageContainer.clientWidth;
        style.height = parseInt(style.width / width * height);
      }
      this.$set(this, 'imageBoxStyle', {
        height: style.height + "px",
        width: style.width + "px"
      });
      return this.$nextTick((function(_this) {
        return function() {
          return _this.updateImageSize(style.width, style.height);
        };
      })(this));
    },
    updateImageSize: function(width, height) {
      return this.$set(this, 'imageStyle', {
        height: height + "px",
        width: width + "px"
      });
    },
    updateBodyTagClass: function() {
      var bodyTag;
      bodyTag = document.getElementsByTagName('body')[0];
      return bodyTag.setAttribute('class', this.isOpen ? 'comp-lightbox-open' : '');
    }
  },
  watch: {
    openedCollection: function() {
      return this.updateBodyTagClass();
    },
    openedItem: function() {
      return this.updateBodyTagClass();
    }
  }
});


/***/ }),

/***/ 666:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-lightbox\" :class=\"[isOpen ? 'comp-lightbox-visible' : '', isZoomable ? 'comp-lightbox-zoomable' : '', isZoomed ? 'comp-lightbox-zoomed' : '']\">\n  <div class=\"comp-lightbox-backdrop\" v-on:click.prevent=\"close\"></div>\n  <div class=\"comp-lightbox-content\">\n    <div class=\"image-container image-container-active\"><a class=\"close-button\" href=\"#\" v-on:click.prevent=\"onClickClose\"><i class=\"mdi mdi-close\"></i></a>\n      <div class=\"image\" ref=\"currentImageContainer\"><a :class=\"['nav-btn', 'nav-btn-previous', hasPreviousItem ? 'nav-btn-active' : '']\" v-on:click.prevent=\"onClickPrevious\"><i class=\"mdi mdi-chevron-left\"></i></a><a :class=\"['nav-btn', 'nav-btn-next', hasNextItem ? 'nav-btn-active' : '']\" v-on:click.prevent=\"onClickNext\"><i class=\"mdi mdi-chevron-right\"></i></a>\n        <div class=\"image-inside\" ref=\"currentImageBox\" :style=\"normalizedImageBoxStyle\"><img v-if=\"openedUrl\" ref=\"currentImage\" :style=\"normalizedImageStyle\" v-on:imageLoaded=\"onCurrentImageLoaded\" v-on:imageLoading=\"onCurrentImageLoading\" v-img=\"openedUrl\" v-on:mousedown.prevent=\"onMouseDown\" v-on:mouseup.prevent=\"onMouseUp\" v-on:mousemove.prevent=\"onMouseMove\">\n          <div class=\"loading-indicator\" v-if=\"loading\" v-spin-js-spinner></div>\n        </div>\n      </div>\n      <div class=\"description\" v-if=\"openedTitle\">{{ openedTitle }}</div>\n    </div>\n  </div>\n</div>";

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(668),
  props: {
    c: {
      "default": 'default'
    },
    i: {
      "default": null
    },
    thumbUrl: {
      "default": null
    },
    imageUrl: {
      "default": null
    },
    title: {
      "default": null
    },
    previewShowCaption: {
      "default": false
    },
    previewShadow: {
      "default": false
    }
  },
  computed: {
    isPreviewCaptionVisible: function() {
      return this.previewShowCaption === true || this.previewShowCaption === 'true';
    },
    hasPreviewShadow: function() {
      return this.previewShadow !== false && this.previewShadow !== 'false';
    }
  },
  methods: {
    onClick: function() {
      return this.$store.dispatch('lightbox/open', {
        collection: this.c,
        id: this.i
      });
    }
  },
  created: function() {
    return this.$store.dispatch('lightbox/register', {
      collection: this.c,
      id: this.i,
      thumbUrl: this.thumbUrl,
      imageUrl: this.imageUrl,
      title: this.title
    });
  },
  beforeDestroy: function() {
    return this.$store.dispatch('lightbox/unregister', {
      collection: this.c,
      id: this.i
    });
  }
});


/***/ }),

/***/ 668:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-lightbox-item\">\n  <div class=\"comp-lightbox-item-thumb\" v-if=\"thumbUrl\" v-on:click.prevent=\"onClick\"><img :src=\"thumbUrl\" :alt=\"title\" :class=\"[hasPreviewShadow ? 'img-shadow' : '']\">\n    <p class=\"caption\" v-if=\"isPreviewCaptionVisible\">{{ title }}</p>\n  </div>\n  <slot></slot>\n</div>";

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

var SpinJS, imgDirective, spinJsOptions;

SpinJS = __webpack_require__(34);

imgDirective = function(el, binding, vnode) {
  var event, img;
  if (binding.value === binding.oldValue) {
    return;
  }
  event = new CustomEvent('imageLoading');
  el.dispatchEvent(event);
  img = new Image();
  img.src = binding.value;
  el.src = '';
  return img.onload = function() {
    el.src = binding.value;
    event = new CustomEvent('imageLoaded', {
      detail: {
        width: img.width,
        height: img.height
      }
    });
    return el.dispatchEvent(event);
  };
};

spinJsOptions = {
  lines: 11,
  length: 12,
  width: 2,
  radius: 8,
  scale: 1,
  corners: 1,
  color: '#fff',
  opacity: 0.25,
  rotate: 0,
  direction: 1,
  speed: 1,
  trail: 60,
  fps: 20,
  zIndex: 2e9,
  className: 'spinner',
  top: '50%',
  left: '50%',
  shadow: false,
  hwaccel: false,
  position: 'absolute'
};

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(670),
  directives: {
    img: {
      bind: imgDirective,
      update: imgDirective
    },
    spinJsSpinner: {
      bind: function(el, binding, vnode) {
        binding.spinner = new SpinJS(spinJsOptions);
        return binding.spinner.spin(el);
      },
      unbind: function(el, binding, vnode) {
        binding.spinner.stop();
        return binding.spinner = null;
      }
    }
  },
  props: {
    src: {
      "default": null
    },
    alt: {
      "default": null
    },
    size: {
      "default": null
    },
    minHeight: {
      "default": null
    },
    minWidth: {
      "default": null
    }
  },
  data: function() {
    return {
      loading: false
    };
  },
  computed: {
    style: function() {
      var style;
      style = {};
      if (this.minHeight != null) {
        style.minHeight = this.minHeight;
      }
      if (this.minWidth != null) {
        style.minWidth = this.minWidth;
      }
      return style;
    }
  },
  methods: {
    onImageLoading: function() {
      this.$set(this, 'loading', true);
      return this.$emit('loading');
    },
    onImageLoaded: function() {
      this.$set(this, 'loading', false);
      return this.$emit('loaded');
    }
  }
});


/***/ }),

/***/ 670:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-lazy-image\" :style=\"style\"><img v-on:imageLoaded=\"onImageLoaded\" v-on:imageLoading=\"onImageLoading\" v-img=\"src\" :alt=\"alt\" :size=\"size\">\n  <div class=\"loading-indicator\" v-if=\"loading\" v-spin-js-spinner></div>\n</div>";

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(672),
  props: {
    c: {
      "default": 'default'
    },
    i: {
      "default": null
    }
  },
  methods: {
    onClick: function() {
      return this.$store.dispatch('accordion/toggle', {
        collection: this.c,
        id: this.i
      });
    }
  }
});


/***/ }),

/***/ 672:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-accordion-toggle\" v-on:click.prevent.stop=\"onClick\">\n  <slot></slot>\n</div>";

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(674),
  props: {
    c: {
      "default": 'default'
    },
    i: {
      "default": null
    }
  },
  computed: {
    visible: function() {
      return this.$store.getters['accordion/isCollapsed'](this.c, this.i) === false;
    }
  },
  created: function() {
    return this.$store.dispatch('accordion/register', {
      collection: this.c,
      id: this.i
    });
  },
  beforeDestroy: function() {
    return this.$store.dispatch('accordion/unregister', {
      collection: this.c,
      id: this.i
    });
  }
});


/***/ }),

/***/ 674:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-accordion-item\" v-if=\"visible\" :class=\"[visible ? 'comp-accordion-item-visible' : '']\">\n  <slot></slot>\n</div>";

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

var _;

_ = __webpack_require__(0);

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(676),
  data: function() {
    return {
      images: [],
      activeIndex: 0
    };
  },
  methods: {
    switchImage: function() {
      var _images, index;
      if (!(_.size(this.images) > 0)) {
        return;
      }
      _images = this.images.concat([]);
      _.each(_images, (function(_this) {
        return function(img) {
          return img.active = false;
        };
      })(this));
      index = this.activeIndex + 1;
      if (index >= _.size(_images)) {
        index = 0;
      }
      _images[index].active = true;
      this.$set(this, 'images', _images);
      return this.$set(this, 'activeIndex', index);
    },
    startTimer: function() {
      return this._timer = setInterval(((function(_this) {
        return function() {
          return _this.switchImage();
        };
      })(this)), 10000);
    },
    stopTime: function() {
      if (this._timer != null) {
        clearInterval(this._timer);
      }
      return this._timer = null;
    }
  },
  mounted: function() {
    var images, index;
    images = [];
    _.each(this.$refs.input.children, function(child) {
      return images.push({
        active: false,
        url: child.getAttribute('src')
      });
    });
    if (!(_.size(images) > 0)) {
      return;
    }
    index = parseInt(Math.random() * _.size(images));
    images[index].active = true;
    this.$set(this, 'images', images);
    this.$set(this, 'activeIndex', index);
    return this.startTimer();
  },
  beforeDestroy: function() {
    return this.stopTimer();
  }
});


/***/ }),

/***/ 676:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-hero-rotating-image\">\n  <div class=\"hidden\" ref=\"input\">\n    <slot></slot>\n  </div>\n  <div class=\"image\" v-for=\"image in images\" :style=\"{ backgroundImage: 'url(' + image.url + ')' }\" :class=\"[image.active ? 'active' : '']\"></div>\n</div>";

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

var _, internalCallback;

_ = __webpack_require__(0);

internalCallback = null;

window.onFusionTablesLoaded = function(data) {
  if (_.isFunction(internalCallback)) {
    return internalCallback(data);
  }
};

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(678),
  components: {
    'map-canvas': __webpack_require__(679)
  },
  props: {
    active_country_codes: {
      "default": null
    },
    country_links: {
      "default": null
    },
    zoom_state: {
      "default": 'world'
    },
    center_lat: {
      "default": null
    },
    center_lng: {
      "default": null
    },
    interactive: {
      "default": false
    }
  },
  data: function() {
    return {
      maps: null,
      map: null,
      modalVisible: false
    };
  },
  computed: {
    windowWidth: function() {
      return this.$store.state.window.width;
    },
    activeCountryCodesArray: function() {
      return this.active_country_codes.split(',');
    },
    countryLinksData: function() {
      return this._countryLinksData || (this._countryLinksData = _.reduce(this.country_links.split(';;;'), function(memo, line) {
        line = line.split(':::');
        memo[line[0]] = {
          url: line[1],
          name: line[2]
        };
        return memo;
      }, {}));
    },
    mapZoom: function() {
      var z;
      z = this.zoom_state === 'world' ? 5 : 3;
      if (this.windowWidth <= 1000) {
        z = z + 1;
      }
      return z;
    },
    defaultCenterLatLng: function() {
      if (!((this.center_lat != null) && (this.center_lng != null))) {
        return {
          lat: 0.0,
          lng: 0.0
        };
      }
      return {
        lat: parseFloat(this.center_lat),
        lng: parseFloat(this.center_lng)
      };
    },
    isInteractive: function() {
      return this.interactive !== false && this.interactive !== 'false';
    }
  },
  methods: {
    onMapCountryClicked: function(data) {
      var link;
      if (data.active !== true) {
        return;
      }
      link = this.countryLinksData[data.iso_3166_2];
      if (!(_.isObject(link) && (link.url != null))) {
        return;
      }
      return window.location.href = link.url;
    }
  }
});


/***/ }),

/***/ 678:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-countries-map\" style=\"overflow:hidden;\">\n  <map-canvas :active-country-codes=\"activeCountryCodesArray\" v-on:countryClick=\"onMapCountryClicked\" :zoom=\"mapZoom\" :default-center=\"defaultCenterLatLng\" :interactive=\"isInteractive\"></map-canvas>\n  <div class=\"comp-countries-map-inner-shadow\"></div>\n  <div class=\"comp-countries-map-inner-shadow\"></div>\n</div>";

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

var Country, _, debounce, polygons;

_ = __webpack_require__(0);

debounce = __webpack_require__(680);

polygons = __webpack_require__(681);

Country = __webpack_require__(682);

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(687),
  props: {
    activeCountryCodes: {
      "default": null
    },
    zoom: {
      "default": 2
    },
    defaultCenter: {
      "default": null
    },
    interactive: {
      "default": null
    }
  },
  data: function() {
    return {
      countries: [],
      util: null,
      hoveredActive: false,
      mouseDown: false,
      dragging: false,
      dragCoord: {
        x: 0,
        y: 0
      },
      zoomStep: parseInt(this.zoom) || 2,
      clicks: 0,
      dblClickOffset: 500,
      tmpTouchPos: null
    };
  },
  computed: {
    windowWidth: function() {
      return this.$store.state.window.width;
    },
    windowHeight: function() {
      return this.$store.state.window.height;
    },
    context: function() {
      return this.$refs.canvas.getContext('2d');
    },
    isInteractive: function() {
      return this.interactive !== false && this.interactive !== 'false';
    }
  },
  methods: {
    updateFull: function() {
      this.updateData();
      this.reloadCountries();
      this.renderCanvasContent();
      return this.updateCursor();
    },
    updateDataAndRender: function() {
      this.updateData();
      return this.renderCanvasContent();
    },
    updateData: function() {
      this.$refs.canvas.width = this.$refs.canvas.offsetWidth;
      this.$refs.canvas.height = this.$refs.canvas.offsetHeight;
      this.util.setContext(this.context);
      this.util.setCanvasSize(this.$refs.canvas.width, this.$refs.canvas.height);
      return this.util.setZoomStep(this.zoomStep);
    },
    updateCursor: function() {
      if (this.dragging) {
        return this.$el.style.cursor = 'move';
      } else if (this.hoveredActive) {
        return this.$el.style.cursor = 'pointer';
      } else {
        return this.$el.style.cursor = 'default';
      }
    },
    renderCanvasContent: function() {
      this.drawBackground();
      return this.drawCountries();
    },
    reloadCountries: function() {
      return this.$set(this, 'countries', _.reduce(polygons['rows'], (function(_this) {
        return function(memo, countryData) {
          var active;
          active = _.contains(_this.activeCountryCodes, countryData[2]) ? true : false;
          if (!_.contains(['AQ'], countryData[2])) {
            memo.push(new Country({
              util: _this.util,
              geometries: countryData[1]['geometries'] || [countryData[1]['geometry']],
              iso_3166_2: countryData[2],
              name: countryData[0],
              active: active
            }));
          }
          return memo;
        };
      })(this), []));
    },
    drawBackground: function() {
      this.context.fillStyle = '#ffffff';
      this.context.beginPath();
      this.context.moveTo(0, this.$refs.canvas.height);
      this.context.lineTo(this.$refs.canvas.width, this.$refs.canvas.height);
      this.context.lineTo(this.$refs.canvas.width, 0);
      this.context.lineTo(0, 0);
      this.context.closePath();
      return this.context.fill();
    },
    drawCountries: function() {
      return _.each(this.countries, function(country) {
        return country.render();
      });
    },
    onMouseDown: function(event) {
      if (!this.isInteractive) {
        return;
      }
      return this.$set(this, 'mouseDown', true);
    },
    onTouchStart: function(event) {
      if (!this.isInteractive) {
        return;
      }
      this.$set(this, 'tmpTouchPos', this.getTouchPos(event));
      if (_.size(event.touches) === 1) {
        return this.$set(this, 'mouseDown', true);
      }
    },
    onMouseUp: function(event) {
      if (!this.isInteractive) {
        return;
      }
      return this._handleMouseUpOrTouchEnd({
        x: event.offsetX,
        y: event.offsetY
      });
    },
    onTouchEnd: function(event) {
      if (!this.isInteractive) {
        return;
      }
      if (!_.isObject(this.tmpTouchPos)) {
        return;
      }
      this._handleMouseUpOrTouchEnd({
        x: this.tmpTouchPos.x,
        y: this.tmpTouchPos.y
      });
      return this.$set(this, 'tmpTouchPos', null);
    },
    onMouseMove: function(event) {
      if (!this.isInteractive) {
        return;
      }
      return this._handleMouseMoveOrTouchMove({
        x: event.offsetX,
        y: event.offsetY
      });
    },
    onTouchMove: function(event) {
      if (!this.isInteractive) {
        return;
      }
      if (_.size(event.touches) !== 1) {
        return;
      }
      return this._handleMouseMoveOrTouchMove({
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      });
    },
    onClick: function(coords) {
      var clickedCountry, clickedLatLng, isActive;
      if (!this.isInteractive) {
        return;
      }
      clickedLatLng = this.util.coordinatesToLatLng(coords);
      if (clickedLatLng == null) {
        return;
      }
      clickedCountry = _.reduce(this.countries, function(memo, country) {
        if (memo != null) {
          return memo;
        }
        if (country.isLatLngInside(clickedLatLng) === true) {
          return country.iso_3166_2;
        } else {
          return memo;
        }
      }, null);
      if (clickedCountry == null) {
        return;
      }
      isActive = _.contains(this.activeCountryCodes, clickedCountry) ? true : false;
      return this.$emit('countryClick', {
        iso_3166_2: clickedCountry,
        active: isActive
      });
    },
    onDoubleClick: function(coords) {
      var latLng;
      if (!this.isInteractive) {
        return;
      }
      if (this.dragging === true) {
        return;
      }
      latLng = this.util.coordinatesToLatLng(coords);
      if (latLng == null) {
        return;
      }
      this.util.setCenterLatLng(latLng);
      return window.requestAnimationFrame((function(_this) {
        return function() {
          return _this._zoomIn();
        };
      })(this));
    },
    onClickZoomIn: function() {
      if (!this.isInteractive) {
        return;
      }
      return this._zoomIn();
    },
    onClickZoomOut: function() {
      if (!this.isInteractive) {
        return;
      }
      return this._zoomOut();
    },
    onMousewheel: function(event) {
      if (!this.isInteractive) {
        return;
      }
      if (event.deltaY < 0) {
        return this._debouncedZoomOut();
      } else if (event.deltaY > 0) {
        return this._debouncedZoomIn();
      }
    },
    onMouseLeave: function() {
      if (!this.isInteractive) {
        return;
      }
      if (_.isObject(this.tmpTouchPos)) {
        this._handleMouseUpOrTouchEnd({
          x: this.tmpTouchPos.x,
          y: this.tmpTouchPos.y
        });
      } else {
        this._handleMouseUpOrTouchEnd(null);
      }
      return this.$set(this, 'tmpTouchPos', null);
    },
    getTouchPos: function(touchEvent) {
      var rect;
      rect = this.$refs.canvas.getBoundingClientRect();
      return {
        x: touchEvent.touches[0].clientX - rect.left,
        y: touchEvent.touches[0].clientY - rect.top
      };
    },
    _zoomIn: function() {
      this.$set(this, 'zoomStep', this.util.zoomIn());
      return this.updateFull();
    },
    _debouncedZoomIn: debounce((function() {
      return this._zoomIn();
    }), 50, true),
    _zoomOut: function() {
      this.$set(this, 'zoomStep', this.util.zoomOut());
      return this.updateFull();
    },
    _debouncedZoomOut: debounce((function() {
      return this._zoomOut();
    }), 50, true),
    _handleMouseMoveOrTouchMove: function(coords) {
      if (this.mouseDown !== true) {
        return this._handleMoveNoDragging(coords);
      }
      if (this.dragging === true) {
        return this._handleDragging(coords);
      }
      this.$set(this, 'dragging', true);
      return this.$set(this, 'dragCoord', coords);
    },
    _handleMoveNoDragging: function(newCoords) {
      var hoveredLatLng;
      hoveredLatLng = this.util.coordinatesToLatLng(newCoords);
      if (hoveredLatLng == null) {
        return;
      }
      _.each(this.countries, function(country) {
        return country.onMouseHoveredLatLng(hoveredLatLng);
      });
      return this.$set(this, 'hoveredActive', _.some(this.countries, function(country) {
        return country.isHovered();
      }));
    },
    _handleDragging: function(newCoords) {
      var bottomRight, canvasBarrierX1, canvasBarrierX2, canvasBarrierY1, canvasBarrierY2, diff, pNew, pOld, topLeft;
      if (this.dragging !== true) {
        return;
      }
      pOld = this.util.coordinatesToLatLng(this.dragCoord);
      pNew = this.util.coordinatesToLatLng(newCoords);
      if (!((pOld != null) && (pNew != null))) {
        return;
      }
      diff = {
        lat: pOld.lat - pNew.lat,
        lng: pOld.lng - pNew.lng
      };
      topLeft = this.util.latLngToCoordinates({
        lat: 85.0,
        lng: -180.0
      });
      bottomRight = this.util.latLngToCoordinates({
        lat: -85.0,
        lng: 180.0
      });
      canvasBarrierX1 = this.$refs.canvas.width / 3;
      canvasBarrierX2 = this.$refs.canvas.width - (this.$refs.canvas.width / 3);
      canvasBarrierY1 = this.$refs.canvas.height / 4;
      canvasBarrierY2 = this.$refs.canvas.height - (this.$refs.canvas.height / 4);
      if (diff.lng < 0 && topLeft.x >= canvasBarrierX1) {
        diff.lng = 0.0;
      }
      if (diff.lng > 0 && bottomRight.x <= canvasBarrierX2) {
        diff.lng = 0.0;
      }
      if (diff.lat > 0 && topLeft.y >= canvasBarrierY1) {
        diff.lat = 0.0;
      }
      if (diff.lat < 0 && bottomRight.y <= canvasBarrierY2) {
        diff.lat = 0.0;
      }
      this.util.changeCenterByLatLng(diff);
      this.$set(this, 'dragCoord', {
        x: newCoords.x,
        y: newCoords.y
      });
      return window.requestAnimationFrame((function(_this) {
        return function() {
          return _this.renderCanvasContent();
        };
      })(this));
    },
    _handleMouseUpOrTouchEnd: function(coords) {
      this.$set(this, 'mouseDown', false);
      if (this.dragging !== true && _.isObject(coords)) {
        this._handleClickTrigger(coords);
      }
      this.$set(this, 'dragging', false);
      return this.$set(this, 'dragCoord', {
        x: 0,
        y: 0
      });
    },
    _handleClickTrigger: function(coords) {
      this.$set(this, 'clicks', this.clicks + 1);
      if (this.clicks === 1) {
        return this._dblClickTimer = window.setTimeout((function(_this) {
          return function() {
            _this.$set(_this, 'clicks', 0);
            return _this.onClick(coords);
          };
        })(this), this.dblClickOffset);
      } else {
        this.$set(this, 'clicks', 0);
        if (this._dblClickTimer != null) {
          window.clearTimeout(this._dblClickTimer);
        }
        return this.onDoubleClick(coords);
      }
    }
  },
  watch: {
    windowWidth: function() {
      return this.updateFull();
    },
    windowHeight: function() {
      return this.updateFull();
    },
    hoveredActive: function() {
      return this.updateCursor();
    },
    dragging: function() {
      return this.updateCursor();
    },
    zoom: function(newVal) {
      this.$set(this, 'zoomStep', parseInt(this.zoom) || 2);
      return this.updateDataAndRender();
    }
  },
  created: function() {
    return this.$set(this, 'util', new (__webpack_require__(688))());
  },
  mounted: function() {
    if (_.isObject(this.defaultCenter)) {
      this.util.setCenterLatLng(this.defaultCenter);
    }
    return window.requestAnimationFrame((function(_this) {
      return function() {
        return _this.updateFull();
      };
    })(this));
  },
  updated: function() {
    return window.requestAnimationFrame((function(_this) {
      return function() {
        return _this.updateFull();
      };
    })(this));
  }
});


/***/ }),

/***/ 681:
/***/ (function(module, exports) {

module.exports = {
  "kind": "fusiontables#sqlresponse",
  "columns": ["name", "kml_4326", "iso_a2", "iso_a3"],
  "rows": [
    [
      "Afghanistan",
      {
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
            [61.211, 35.65, 0.0], [62.231, 35.271, 0.0], [62.985, 35.404, 0.0], [63.194, 35.857, 0.0], [63.983, 36.008, 0.0], [64.546, 36.312, 0.0], [64.746, 37.112, 0.0], [65.589, 37.305, 0.0], [65.746, 37.661, 0.0], [66.217, 37.394, 0.0], [66.519, 37.363, 0.0], [67.076, 37.356, 0.0], [67.83, 37.145, 0.0], [68.136, 37.023, 0.0], [68.859, 37.344, 0.0], [69.196, 37.151, 0.0], [69.519, 37.609, 0.0], [70.117, 37.588, 0.0], [70.271, 37.735, 0.0], [70.376, 38.138, 0.0], [70.807, 38.486, 0.0], [71.348, 38.259, 0.0], [71.239, 37.953, 0.0], [71.542, 37.906, 0.0], [71.449, 37.066, 0.0], [71.845, 36.738, 0.0], [72.193, 36.948, 0.0], [72.637, 37.048, 0.0], [73.26, 37.495, 0.0], [73.949, 37.422, 0.0], [74.98, 37.42, 0.0], [75.158, 37.133, 0.0], [74.576, 37.021, 0.0], [74.068, 36.836, 0.0], [72.92, 36.72, 0.0], [71.846, 36.51, 0.0], [71.262, 36.074, 0.0], [71.499, 35.651, 0.0], [71.613, 35.153, 0.0], [71.115, 34.733, 0.0], [71.157, 34.349, 0.0], [70.882, 33.989, 0.0], [69.931, 34.02, 0.0], [70.324, 33.359, 0.0], [69.687, 33.105, 0.0], [69.263, 32.502, 0.0], [69.318, 31.901, 0.0], [68.927, 31.62, 0.0], [68.557, 31.713, 0.0], [67.793, 31.583, 0.0], [67.683, 31.303, 0.0], [66.939, 31.305, 0.0], [66.381, 30.739, 0.0], [66.346, 29.888, 0.0], [65.047, 29.472, 0.0], [64.35, 29.56, 0.0], [64.148, 29.341, 0.0], [63.55, 29.468, 0.0], [62.55, 29.319, 0.0], [60.874, 29.829, 0.0], [61.781, 30.736, 0.0], [61.699, 31.38, 0.0], [60.942, 31.548, 0.0], [60.864, 32.183, 0.0], [60.536, 32.981, 0.0], [60.964, 33.529, 0.0], [60.528, 33.676, 0.0], [60.803, 34.404, 0.0], [61.211, 35.65, 0.0]
          ]]
        }
      },
      "AF",
      "AFG"
    ],
    [
      "United Arab Emirates",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [51.58, 24.245, 0.0], [51.757, 24.294, 0.0], [51.794, 24.02, 0.0], [52.577, 24.177, 0.0], [53.404, 24.151, 0.0], [54.008, 24.122, 0.0], [54.693, 24.798, 0.0], [55.439, 25.439, 0.0], [56.071, 26.055, 0.0], [56.261, 25.715, 0.0], [56.397, 24.925, 0.0], [55.886, 24.921, 0.0], [55.804, 24.27, 0.0], [55.981, 24.131, 0.0], [55.529, 23.934, 0.0], [55.526, 23.525, 0.0], [55.234, 23.111, 0.0], [55.208, 22.708, 0.0], [55.007, 22.497, 0.0], [52.001, 23.001, 0.0], [51.618, 24.014, 0.0], [51.58, 24.245, 0.0]
        ]]
      }
    },
    "AE",
    "ARE"
    ],
    [
      "Burkina Faso",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-2.827, 9.642, 0.0], [-3.512, 9.9, 0.0], [-3.98, 9.862, 0.0], [-4.33, 9.611, 0.0], [-4.78, 9.822, 0.0], [-4.955, 10.153, 0.0], [-5.404, 10.371, 0.0], [-5.471, 10.951, 0.0], [-5.198, 11.375, 0.0], [-5.221, 11.714, 0.0], [-4.427, 12.543, 0.0], [-4.28, 13.228, 0.0], [-4.006, 13.472, 0.0], [-3.523, 13.338, 0.0], [-3.104, 13.541, 0.0], [-2.968, 13.798, 0.0], [-2.192, 14.246, 0.0], [-2.001, 14.559, 0.0], [-1.066, 14.974, 0.0], [-0.516, 15.116, 0.0], [-0.266, 14.924, 0.0], [0.375, 14.929, 0.0], [0.296, 14.444, 0.0], [0.43, 13.989, 0.0], [0.993, 13.336, 0.0], [1.024, 12.852, 0.0], [2.177, 12.625, 0.0], [2.154, 11.94, 0.0], [1.936, 11.641, 0.0], [1.447, 11.548, 0.0], [1.243, 11.111, 0.0], [0.9, 10.997, 0.0], [0.024, 11.019, 0.0], [-0.439, 11.098, 0.0], [-0.762, 10.937, 0.0], [-1.203, 11.01, 0.0], [-2.94, 10.963, 0.0], [-2.964, 10.395, 0.0], [-2.827, 9.642, 0.0]
        ]]
      }
    },
    "BF",
    "BFA"
    ],
    [
      "Bangladesh",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [92.673, 22.041, 0.0], [92.652, 21.324, 0.0], [92.303, 21.475, 0.0], [92.369, 20.671, 0.0], [92.083, 21.192, 0.0], [92.025, 21.702, 0.0], [91.835, 22.183, 0.0], [91.417, 22.765, 0.0], [90.496, 22.805, 0.0], [90.587, 22.393, 0.0], [90.273, 21.836, 0.0], [89.847, 22.039, 0.0], [89.702, 21.857, 0.0], [89.419, 21.966, 0.0], [89.032, 22.056, 0.0], [88.876, 22.879, 0.0], [88.53, 23.631, 0.0], [88.7, 24.234, 0.0], [88.084, 24.502, 0.0], [88.306, 24.866, 0.0], [88.932, 25.239, 0.0], [88.21, 25.768, 0.0], [88.563, 26.447, 0.0], [89.355, 26.014, 0.0], [89.832, 25.965, 0.0], [89.921, 25.27, 0.0], [90.872, 25.133, 0.0], [91.8, 25.147, 0.0], [92.376, 24.977, 0.0], [91.915, 24.13, 0.0], [91.468, 24.073, 0.0], [91.159, 23.504, 0.0], [91.706, 22.985, 0.0], [91.87, 23.624, 0.0], [92.146, 23.627, 0.0], [92.673, 22.041, 0.0]
        ]]
      }
    },
    "BD",
    "BGD"
    ],
    [
      "Congo (Kinshasa)",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [30.834, 3.509, 0.0], [30.773, 2.34, 0.0], [31.174, 2.204, 0.0], [30.853, 1.849, 0.0], [30.469, 1.584, 0.0], [30.086, 1.062, 0.0], [29.876, 0.597, 0.0], [29.82, -0.205, 0.0], [29.588, -0.587, 0.0], [29.579, -1.341, 0.0], [29.292, -1.62, 0.0], [29.255, -2.215, 0.0], [29.117, -2.292, 0.0], [29.025, -2.839, 0.0], [29.276, -3.294, 0.0], [29.34, -4.5, 0.0], [29.52, -5.42, 0.0], [29.42, -5.94, 0.0], [29.62, -6.52, 0.0], [30.2, -7.08, 0.0], [30.74, -8.34, 0.0], [30.346, -8.238, 0.0], [29.003, -8.407, 0.0], [28.735, -8.527, 0.0], [28.45, -9.165, 0.0], [28.674, -9.606, 0.0], [28.496, -10.79, 0.0], [28.372, -11.794, 0.0], [28.642, -11.972, 0.0], [29.342, -12.361, 0.0], [29.616, -12.179, 0.0], [29.7, -13.257, 0.0], [28.934, -13.249, 0.0], [28.524, -12.699, 0.0], [28.155, -12.272, 0.0], [27.389, -12.133, 0.0], [27.164, -11.609, 0.0], [26.553, -11.924, 0.0], [25.752, -11.785, 0.0], [25.418, -11.331, 0.0], [24.783, -11.239, 0.0], [24.315, -11.263, 0.0], [24.257, -10.952, 0.0], [23.912, -10.927, 0.0], [23.457, -10.868, 0.0], [22.837, -11.018, 0.0], [22.403, -10.993, 0.0], [22.155, -11.085, 0.0], [22.209, -9.895, 0.0], [21.875, -9.524, 0.0], [21.802, -8.909, 0.0], [21.949, -8.306, 0.0], [21.746, -7.92, 0.0], [21.728, -7.291, 0.0], [20.515, -7.3, 0.0], [20.602, -6.939, 0.0], [20.092, -6.943, 0.0], [20.038, -7.116, 0.0], [19.418, -7.155, 0.0], [19.167, -7.738, 0.0], [19.017, -7.988, 0.0], [18.464, -7.847, 0.0], [18.134, -7.988, 0.0], [17.473, -8.069, 0.0], [17.09, -7.546, 0.0], [16.86, -7.222, 0.0], [16.573, -6.623, 0.0], [16.327, -5.877, 0.0], [13.376, -5.864, 0.0], [13.025, -5.984, 0.0], [12.735, -5.966, 0.0], [12.322, -6.1, 0.0], [12.182, -5.79, 0.0], [12.437, -5.684, 0.0], [12.468, -5.248, 0.0], [12.632, -4.991, 0.0], [12.996, -4.781, 0.0], [13.258, -4.883, 0.0], [13.6, -4.5, 0.0], [14.145, -4.51, 0.0], [14.209, -4.793, 0.0], [14.583, -4.97, 0.0], [15.171, -4.344, 0.0], [15.754, -3.855, 0.0], [16.006, -3.535, 0.0], [15.973, -2.712, 0.0], [16.407, -1.741, 0.0], [16.865, -1.226, 0.0], [17.524, -0.744, 0.0], [17.639, -0.425, 0.0], [17.664, -0.058, 0.0], [17.827, 0.289, 0.0], [17.774, 0.856, 0.0], [17.899, 1.742, 0.0], [18.094, 2.366, 0.0], [18.394, 2.9, 0.0], [18.453, 3.504, 0.0], [18.543, 4.202, 0.0], [18.932, 4.71, 0.0], [19.468, 5.032, 0.0], [20.291, 4.692, 0.0], [20.928, 4.323, 0.0], [21.659, 4.224, 0.0], [22.405, 4.029, 0.0], [22.704, 4.633, 0.0], [22.841, 4.71, 0.0], [23.297, 4.61, 0.0], [24.411, 5.109, 0.0], [24.805, 4.897, 0.0], [25.129, 4.927, 0.0], [25.279, 5.17, 0.0], [25.65, 5.256, 0.0], [26.403, 5.151, 0.0], [27.044, 5.128, 0.0], [27.374, 5.234, 0.0], [27.98, 4.408, 0.0], [28.429, 4.287, 0.0], [28.697, 4.455, 0.0], [29.159, 4.389, 0.0], [29.716, 4.601, 0.0], [29.954, 4.174, 0.0], [30.834, 3.509, 0.0]
        ]]
      }
    },
    "CD",
    "COD"
    ],
    [
      "Cuba",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-82.268, 23.189, 0.0], [-81.404, 23.117, 0.0], [-80.619, 23.106, 0.0], [-79.68, 22.765, 0.0], [-79.281, 22.399, 0.0], [-78.347, 22.512, 0.0], [-77.993, 22.277, 0.0], [-77.146, 21.658, 0.0], [-76.524, 21.207, 0.0], [-76.195, 21.221, 0.0], [-75.598, 21.017, 0.0], [-75.671, 20.735, 0.0], [-74.934, 20.694, 0.0], [-74.178, 20.285, 0.0], [-74.297, 20.05, 0.0], [-74.962, 19.923, 0.0], [-75.635, 19.874, 0.0], [-76.324, 19.953, 0.0], [-77.755, 19.855, 0.0], [-77.085, 20.413, 0.0], [-77.493, 20.673, 0.0], [-78.137, 20.74, 0.0], [-78.483, 21.029, 0.0], [-78.72, 21.598, 0.0], [-79.285, 21.559, 0.0], [-80.217, 21.827, 0.0], [-80.518, 22.037, 0.0], [-81.821, 22.192, 0.0], [-82.17, 22.387, 0.0], [-81.795, 22.637, 0.0], [-82.776, 22.688, 0.0], [-83.494, 22.169, 0.0], [-83.909, 22.155, 0.0], [-84.052, 21.911, 0.0], [-84.547, 21.801, 0.0], [-84.975, 21.896, 0.0], [-84.447, 22.205, 0.0], [-84.23, 22.566, 0.0], [-83.778, 22.788, 0.0], [-83.268, 22.983, 0.0], [-82.51, 23.079, 0.0], [-82.268, 23.189, 0.0]
        ]]
      }
    },
    "CU",
    "CUB"
    ],
    [
      "Czech Rep.",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [16.96, 48.597, 0.0], [16.499, 48.786, 0.0], [16.03, 48.734, 0.0], [15.253, 49.039, 0.0], [14.901, 48.964, 0.0], [14.339, 48.555, 0.0], [13.596, 48.877, 0.0], [13.031, 49.307, 0.0], [12.521, 49.547, 0.0], [12.415, 49.969, 0.0], [12.24, 50.266, 0.0], [12.967, 50.484, 0.0], [13.338, 50.733, 0.0], [14.056, 50.927, 0.0], [14.307, 51.117, 0.0], [14.571, 51.002, 0.0], [15.017, 51.107, 0.0], [15.491, 50.785, 0.0], [16.239, 50.698, 0.0], [16.176, 50.423, 0.0], [16.719, 50.216, 0.0], [16.869, 50.474, 0.0], [17.555, 50.362, 0.0], [17.649, 50.049, 0.0], [18.393, 49.989, 0.0], [18.853, 49.496, 0.0], [18.555, 49.495, 0.0], [18.4, 49.315, 0.0], [18.17, 49.272, 0.0], [18.105, 49.044, 0.0], [17.914, 48.996, 0.0], [17.886, 48.903, 0.0], [17.545, 48.8, 0.0], [17.102, 48.817, 0.0], [16.96, 48.597, 0.0]
        ]]
      }
    },
    "CZ",
    "CZE"
    ],
    [
      "Denmark",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [12.69, 55.61, 0.0], [12.09, 54.8, 0.0], [11.044, 55.365, 0.0], [10.904, 55.78, 0.0], [12.371, 56.111, 0.0], [12.69, 55.61, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [10.912, 56.459, 0.0], [10.668, 56.081, 0.0], [10.37, 56.19, 0.0], [9.65, 55.47, 0.0], [9.922, 54.983, 0.0], [9.282, 54.831, 0.0], [8.526, 54.963, 0.0], [8.12, 55.518, 0.0], [8.09, 56.54, 0.0], [8.257, 56.81, 0.0], [8.543, 57.11, 0.0], [9.424, 57.172, 0.0], [9.776, 57.448, 0.0], [10.58, 57.73, 0.0], [10.546, 57.216, 0.0], [10.25, 56.89, 0.0], [10.37, 56.61, 0.0], [10.912, 56.459, 0.0]
       ]
      ]
     }
    ]
    },
    "DK",
    "DNK"
    ],
    [
      "Ethiopia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [37.906, 14.959, 0.0], [38.513, 14.505, 0.0], [39.099, 14.741, 0.0], [39.341, 14.532, 0.0], [40.026, 14.52, 0.0], [40.897, 14.119, 0.0], [41.155, 13.773, 0.0], [41.599, 13.452, 0.0], [42.01, 12.866, 0.0], [42.352, 12.542, 0.0], [42.0, 12.1, 0.0], [41.662, 11.631, 0.0], [41.74, 11.355, 0.0], [41.756, 11.051, 0.0], [42.314, 11.034, 0.0], [42.555, 11.105, 0.0], [42.777, 10.927, 0.0], [42.559, 10.573, 0.0], [42.928, 10.022, 0.0], [43.297, 9.54, 0.0], [43.679, 9.184, 0.0], [46.948, 7.997, 0.0], [47.789, 8.003, 0.0], [44.964, 5.002, 0.0], [43.661, 4.958, 0.0], [42.77, 4.253, 0.0], [42.129, 4.234, 0.0], [41.855, 3.919, 0.0], [41.172, 3.919, 0.0], [40.768, 4.257, 0.0], [39.855, 3.839, 0.0], [39.559, 3.422, 0.0], [38.893, 3.501, 0.0], [38.671, 3.616, 0.0], [38.437, 3.589, 0.0], [38.121, 3.599, 0.0], [36.855, 4.448, 0.0], [36.159, 4.448, 0.0], [35.817, 4.777, 0.0], [35.817, 5.338, 0.0], [35.298, 5.506, 0.0], [34.707, 6.594, 0.0], [34.25, 6.826, 0.0], [34.075, 7.226, 0.0], [33.568, 7.713, 0.0], [32.954, 7.785, 0.0], [33.295, 8.355, 0.0], [33.826, 8.379, 0.0], [33.975, 8.685, 0.0], [33.962, 9.584, 0.0], [34.257, 10.63, 0.0], [34.731, 10.91, 0.0], [34.832, 11.319, 0.0], [35.26, 12.083, 0.0], [35.864, 12.578, 0.0], [36.27, 13.563, 0.0], [36.43, 14.422, 0.0], [37.594, 14.213, 0.0], [37.906, 14.959, 0.0]
        ]]
      }
    },
    "ET",
    "ETH"
    ],
    [
      "Guinea Bissau",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-15.13, 11.04, 0.0], [-15.664, 11.458, 0.0], [-16.085, 11.525, 0.0], [-16.315, 11.807, 0.0], [-16.309, 11.959, 0.0], [-16.614, 12.171, 0.0], [-16.677, 12.385, 0.0], [-16.148, 12.548, 0.0], [-15.817, 12.516, 0.0], [-15.548, 12.628, 0.0], [-13.7, 12.586, 0.0], [-13.719, 12.247, 0.0], [-13.828, 12.143, 0.0], [-13.743, 11.811, 0.0], [-13.901, 11.679, 0.0], [-14.121, 11.677, 0.0], [-14.382, 11.509, 0.0], [-14.686, 11.528, 0.0], [-15.13, 11.04, 0.0]
        ]]
      }
    },
    "GW",
    "GNB"
    ],
    [
      "Eq. Guinea",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [9.493, 1.01, 0.0], [9.306, 1.161, 0.0], [9.649, 2.284, 0.0], [11.276, 2.261, 0.0], [11.285, 1.058, 0.0], [9.83, 1.068, 0.0], [9.493, 1.01, 0.0]
        ]]
      }
    },
    "GQ",
    "GNQ"
    ],
    [
      "Croatia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [18.83, 45.909, 0.0], [19.073, 45.522, 0.0], [19.39, 45.237, 0.0], [19.005, 44.86, 0.0], [18.553, 45.082, 0.0], [17.862, 45.068, 0.0], [17.002, 45.234, 0.0], [16.535, 45.212, 0.0], [16.318, 45.004, 0.0], [15.959, 45.234, 0.0], [15.75, 44.819, 0.0], [16.24, 44.351, 0.0], [16.456, 44.041, 0.0], [16.916, 43.668, 0.0], [17.297, 43.446, 0.0], [17.675, 43.029, 0.0], [18.56, 42.65, 0.0], [18.45, 42.48, 0.0], [17.51, 42.85, 0.0], [16.93, 43.21, 0.0], [16.015, 43.507, 0.0], [15.174, 44.243, 0.0], [15.376, 44.318, 0.0], [14.92, 44.738, 0.0], [14.902, 45.076, 0.0], [14.259, 45.234, 0.0], [13.952, 44.802, 0.0], [13.657, 45.137, 0.0], [13.679, 45.484, 0.0], [13.715, 45.5, 0.0], [14.412, 45.466, 0.0], [14.595, 45.635, 0.0], [14.935, 45.472, 0.0], [15.328, 45.452, 0.0], [15.324, 45.732, 0.0], [15.672, 45.834, 0.0], [15.769, 46.238, 0.0], [16.565, 46.504, 0.0], [16.883, 46.381, 0.0], [17.63, 45.952, 0.0], [18.456, 45.759, 0.0], [18.83, 45.909, 0.0]
        ]]
      }
    },
    "HR",
    "HRV"
    ],
    [
      "Indonesia",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [120.716, -10.24, 0.0], [120.295, -10.259, 0.0], [118.968, -9.558, 0.0], [119.9, -9.361, 0.0], [120.426, -9.666, 0.0], [120.776, -9.97, 0.0], [120.716, -10.24, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [124.436, -10.14, 0.0], [123.58, -10.36, 0.0], [123.46, -10.24, 0.0], [123.55, -9.9, 0.0], [123.98, -9.29, 0.0], [124.969, -8.893, 0.0], [125.07, -9.09, 0.0], [125.089, -9.393, 0.0], [124.436, -10.14, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [117.9, -8.096, 0.0], [118.261, -8.362, 0.0], [118.878, -8.281, 0.0], [119.127, -8.706, 0.0], [117.97, -8.907, 0.0], [117.278, -9.041, 0.0], [116.74, -9.033, 0.0], [117.084, -8.457, 0.0], [117.632, -8.449, 0.0], [117.9, -8.096, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [122.904, -8.094, 0.0], [122.757, -8.65, 0.0], [121.254, -8.934, 0.0], [119.924, -8.81, 0.0], [119.921, -8.445, 0.0], [120.715, -8.237, 0.0], [121.342, -8.537, 0.0], [122.007, -8.461, 0.0], [122.904, -8.094, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [108.623, -6.778, 0.0], [110.539, -6.877, 0.0], [110.76, -6.465, 0.0], [112.615, -6.946, 0.0], [112.979, -7.594, 0.0], [114.479, -7.777, 0.0], [115.706, -8.371, 0.0], [114.565, -8.752, 0.0], [113.465, -8.349, 0.0], [112.56, -8.376, 0.0], [111.522, -8.302, 0.0], [110.586, -8.123, 0.0], [109.428, -7.741, 0.0], [108.694, -7.642, 0.0], [108.278, -7.767, 0.0], [106.454, -7.355, 0.0], [106.281, -6.925, 0.0], [105.365, -6.851, 0.0], [106.052, -5.896, 0.0], [107.265, -5.955, 0.0], [108.072, -6.346, 0.0], [108.487, -6.422, 0.0], [108.623, -6.778, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [134.725, -6.214, 0.0], [134.21, -6.895, 0.0], [134.113, -6.142, 0.0], [134.29, -5.783, 0.0], [134.5, -5.445, 0.0], [134.727, -5.738, 0.0], [134.725, -6.214, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [127.249, -3.459, 0.0], [126.875, -3.791, 0.0], [126.184, -3.607, 0.0], [125.989, -3.177, 0.0], [127.001, -3.129, 0.0], [127.249, -3.459, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [130.471, -3.094, 0.0], [130.835, -3.858, 0.0], [129.991, -3.446, 0.0], [129.155, -3.363, 0.0], [128.591, -3.429, 0.0], [127.899, -3.393, 0.0], [128.136, -2.844, 0.0], [129.371, -2.802, 0.0], [130.471, -3.094, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [134.143, -1.152, 0.0], [134.423, -2.769, 0.0], [135.458, -3.368, 0.0], [136.293, -2.307, 0.0], [137.441, -1.704, 0.0], [138.33, -1.703, 0.0], [139.185, -2.051, 0.0], [139.927, -2.409, 0.0], [141.0, -2.6, 0.0], [141.017, -5.859, 0.0], [141.034, -9.118, 0.0], [140.143, -8.297, 0.0], [139.128, -8.096, 0.0], [138.881, -8.381, 0.0], [137.614, -8.412, 0.0], [138.039, -7.598, 0.0], [138.669, -7.32, 0.0], [138.408, -6.233, 0.0], [137.928, -5.393, 0.0], [135.989, -4.547, 0.0], [135.165, -4.463, 0.0], [133.663, -3.539, 0.0], [133.368, -4.025, 0.0], [132.984, -4.113, 0.0], [132.757, -3.746, 0.0], [132.754, -3.312, 0.0], [131.99, -2.821, 0.0], [133.067, -2.46, 0.0], [133.78, -2.48, 0.0], [133.696, -2.215, 0.0], [132.232, -2.213, 0.0], [131.836, -1.617, 0.0], [130.943, -1.433, 0.0], [130.52, -0.938, 0.0], [131.868, -0.695, 0.0], [132.38, -0.37, 0.0], [133.986, -0.78, 0.0], [134.143, -1.152, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [125.241, 1.42, 0.0], [124.437, 0.428, 0.0], [123.686, 0.236, 0.0], [122.723, 0.431, 0.0], [121.057, 0.381, 0.0], [120.183, 0.237, 0.0], [120.041, -0.52, 0.0], [120.936, -1.409, 0.0], [121.476, -0.956, 0.0], [123.341, -0.616, 0.0], [123.258, -1.076, 0.0], [122.823, -0.931, 0.0], [122.389, -1.517, 0.0], [121.508, -1.904, 0.0], [122.455, -3.186, 0.0], [122.272, -3.53, 0.0], [123.171, -4.684, 0.0], [123.162, -5.341, 0.0], [122.629, -5.635, 0.0], [122.236, -5.283, 0.0], [122.72, -4.464, 0.0], [121.738, -4.851, 0.0], [121.489, -4.575, 0.0], [121.619, -4.188, 0.0], [120.898, -3.602, 0.0], [120.972, -2.628, 0.0], [120.305, -2.932, 0.0], [120.39, -4.098, 0.0], [120.431, -5.528, 0.0], [119.797, -5.673, 0.0], [119.367, -5.38, 0.0], [119.654, -4.459, 0.0], [119.499, -3.494, 0.0], [119.078, -3.487, 0.0], [118.768, -2.802, 0.0], [119.181, -2.147, 0.0], [119.323, -1.353, 0.0], [119.826, 0.154, 0.0], [120.036, 0.566, 0.0], [120.886, 1.309, 0.0], [121.667, 1.014, 0.0], [122.928, 0.875, 0.0], [124.078, 0.917, 0.0], [125.066, 1.643, 0.0], [125.241, 1.42, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [128.688, 1.132, 0.0], [128.636, 0.258, 0.0], [128.12, 0.356, 0.0], [127.968, -0.252, 0.0], [128.38, -0.78, 0.0], [128.1, -0.9, 0.0], [127.696, -0.267, 0.0], [127.399, 1.012, 0.0], [127.601, 1.811, 0.0], [127.932, 2.175, 0.0], [128.004, 1.629, 0.0], [128.595, 1.541, 0.0], [128.688, 1.132, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [117.876, 1.828, 0.0], [118.997, 0.902, 0.0], [117.812, 0.784, 0.0], [117.478, 0.102, 0.0], [117.522, -0.804, 0.0], [116.56, -1.488, 0.0], [116.534, -2.484, 0.0], [116.148, -4.013, 0.0], [116.001, -3.657, 0.0], [114.865, -4.107, 0.0], [114.469, -3.496, 0.0], [113.756, -3.439, 0.0], [113.257, -3.119, 0.0], [112.068, -3.478, 0.0], [111.703, -2.994, 0.0], [111.048, -3.049, 0.0], [110.224, -2.934, 0.0], [110.071, -1.593, 0.0], [109.572, -1.315, 0.0], [109.092, -0.46, 0.0], [108.953, 0.415, 0.0], [109.069, 1.342, 0.0], [109.663, 2.006, 0.0], [109.83, 1.338, 0.0], [110.514, 0.773, 0.0], [111.159, 0.976, 0.0], [111.798, 0.904, 0.0], [112.38, 1.41, 0.0], [112.86, 1.498, 0.0], [113.806, 1.218, 0.0], [114.621, 1.431, 0.0], [115.134, 2.821, 0.0], [115.519, 3.169, 0.0], [115.866, 4.307, 0.0], [117.015, 4.306, 0.0], [117.882, 4.138, 0.0], [117.313, 3.234, 0.0], [118.048, 2.288, 0.0], [117.876, 1.828, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [105.818, -5.852, 0.0], [104.71, -5.873, 0.0], [103.868, -5.037, 0.0], [102.584, -4.22, 0.0], [102.156, -3.614, 0.0], [101.399, -2.8, 0.0], [100.903, -2.05, 0.0], [100.142, -0.65, 0.0], [99.264, 0.183, 0.0], [98.97, 1.043, 0.0], [98.601, 1.824, 0.0], [97.7, 2.453, 0.0], [97.177, 3.309, 0.0], [96.424, 3.869, 0.0], [95.381, 4.971, 0.0], [95.293, 5.48, 0.0], [95.937, 5.44, 0.0], [97.485, 5.246, 0.0], [98.369, 4.268, 0.0], [99.143, 3.59, 0.0], [99.694, 3.174, 0.0], [100.641, 2.099, 0.0], [101.658, 2.084, 0.0], [102.498, 1.399, 0.0], [103.077, 0.561, 0.0], [103.838, 0.105, 0.0], [103.438, -0.712, 0.0], [104.011, -1.059, 0.0], [104.37, -1.085, 0.0], [104.539, -1.782, 0.0], [104.888, -2.34, 0.0], [105.622, -2.429, 0.0], [106.109, -3.062, 0.0], [105.857, -4.306, 0.0], [105.818, -5.852, 0.0]
       ]
      ]
     }
    ]
    },
    "ID",
    "IDN"
    ],
    [
      "Iran",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [53.922, 37.199, 0.0], [54.8, 37.392, 0.0], [55.512, 37.964, 0.0], [56.18, 37.935, 0.0], [56.619, 38.121, 0.0], [57.33, 38.029, 0.0], [58.436, 37.522, 0.0], [59.235, 37.413, 0.0], [60.378, 36.527, 0.0], [61.123, 36.492, 0.0], [61.211, 35.65, 0.0], [60.803, 34.404, 0.0], [60.528, 33.676, 0.0], [60.964, 33.529, 0.0], [60.536, 32.981, 0.0], [60.864, 32.183, 0.0], [60.942, 31.548, 0.0], [61.699, 31.38, 0.0], [61.781, 30.736, 0.0], [60.874, 29.829, 0.0], [61.369, 29.303, 0.0], [61.772, 28.699, 0.0], [62.728, 28.26, 0.0], [62.755, 27.379, 0.0], [63.234, 27.217, 0.0], [63.317, 26.757, 0.0], [61.874, 26.24, 0.0], [61.497, 25.078, 0.0], [59.616, 25.38, 0.0], [58.526, 25.61, 0.0], [57.397, 25.74, 0.0], [56.971, 26.966, 0.0], [56.492, 27.143, 0.0], [55.724, 26.965, 0.0], [54.715, 26.481, 0.0], [53.493, 26.812, 0.0], [52.484, 27.581, 0.0], [51.521, 27.866, 0.0], [50.853, 28.815, 0.0], [50.115, 30.148, 0.0], [49.577, 29.986, 0.0], [48.941, 30.317, 0.0], [48.568, 29.927, 0.0], [48.015, 30.452, 0.0], [48.005, 30.985, 0.0], [47.685, 30.985, 0.0], [47.849, 31.709, 0.0], [47.335, 32.469, 0.0], [46.109, 33.017, 0.0], [45.417, 33.968, 0.0], [45.648, 34.748, 0.0], [46.152, 35.093, 0.0], [46.076, 35.677, 0.0], [45.421, 35.978, 0.0], [44.773, 37.17, 0.0], [44.226, 37.972, 0.0], [44.421, 38.281, 0.0], [44.109, 39.428, 0.0], [44.794, 39.713, 0.0], [44.953, 39.336, 0.0], [45.458, 38.874, 0.0], [46.144, 38.741, 0.0], [46.506, 38.771, 0.0], [47.685, 39.508, 0.0], [48.06, 39.582, 0.0], [48.356, 39.289, 0.0], [48.011, 38.794, 0.0], [48.634, 38.27, 0.0], [48.883, 38.32, 0.0], [49.2, 37.583, 0.0], [50.148, 37.375, 0.0], [50.842, 36.873, 0.0], [52.264, 36.7, 0.0], [53.826, 36.965, 0.0], [53.922, 37.199, 0.0]
        ]]
      }
    },
    "IR",
    "IRN"
    ],
    [
      "Jordan",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [35.546, 32.394, 0.0], [35.72, 32.709, 0.0], [36.834, 32.313, 0.0], [38.792, 33.379, 0.0], [39.195, 32.161, 0.0], [39.005, 32.01, 0.0], [37.002, 31.508, 0.0], [37.999, 30.508, 0.0], [37.668, 30.339, 0.0], [37.504, 30.004, 0.0], [36.741, 29.865, 0.0], [36.501, 29.505, 0.0], [36.069, 29.197, 0.0], [34.956, 29.357, 0.0], [34.923, 29.501, 0.0], [35.421, 31.1, 0.0], [35.398, 31.489, 0.0], [35.545, 31.783, 0.0], [35.546, 32.394, 0.0]
        ]]
      }
    },
    "JO",
    "JOR"
    ],
    [
      "Kazakhstan",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [70.962, 42.266, 0.0], [70.389, 42.081, 0.0], [69.07, 41.384, 0.0], [68.632, 40.669, 0.0], [68.26, 40.662, 0.0], [67.986, 41.136, 0.0], [66.714, 41.168, 0.0], [66.511, 41.988, 0.0], [66.023, 41.995, 0.0], [66.098, 42.998, 0.0], [64.901, 43.728, 0.0], [63.186, 43.65, 0.0], [62.013, 43.504, 0.0], [61.058, 44.406, 0.0], [60.24, 44.784, 0.0], [58.69, 45.5, 0.0], [58.503, 45.587, 0.0], [55.929, 44.996, 0.0], [55.968, 41.309, 0.0], [55.455, 41.26, 0.0], [54.755, 42.044, 0.0], [54.079, 42.324, 0.0], [52.944, 42.116, 0.0], [52.502, 41.783, 0.0], [52.446, 42.027, 0.0], [52.692, 42.444, 0.0], [52.501, 42.792, 0.0], [51.342, 43.133, 0.0], [50.891, 44.031, 0.0], [50.339, 44.284, 0.0], [50.306, 44.61, 0.0], [51.279, 44.515, 0.0], [51.317, 45.246, 0.0], [52.167, 45.408, 0.0], [53.041, 45.259, 0.0], [53.221, 46.235, 0.0], [53.043, 46.853, 0.0], [52.042, 46.805, 0.0], [51.192, 47.049, 0.0], [50.034, 46.609, 0.0], [49.101, 46.399, 0.0], [48.593, 46.561, 0.0], [48.695, 47.076, 0.0], [48.057, 47.744, 0.0], [47.315, 47.716, 0.0], [46.466, 48.394, 0.0], [47.044, 49.152, 0.0], [46.752, 49.356, 0.0], [47.549, 50.455, 0.0], [48.578, 49.875, 0.0], [48.702, 50.605, 0.0], [50.767, 51.693, 0.0], [52.329, 51.719, 0.0], [54.533, 51.026, 0.0], [55.717, 50.622, 0.0], [56.778, 51.044, 0.0], [58.363, 51.064, 0.0], [59.642, 50.545, 0.0], [59.933, 50.842, 0.0], [61.337, 50.799, 0.0], [61.588, 51.273, 0.0], [59.968, 51.96, 0.0], [60.927, 52.448, 0.0], [60.74, 52.72, 0.0], [61.7, 52.98, 0.0], [60.978, 53.665, 0.0], [61.437, 54.006, 0.0], [65.179, 54.354, 0.0], [65.667, 54.601, 0.0], [68.169, 54.97, 0.0], [69.068, 55.385, 0.0], [70.865, 55.17, 0.0], [71.18, 54.133, 0.0], [72.224, 54.377, 0.0], [73.509, 54.036, 0.0], [73.426, 53.49, 0.0], [74.385, 53.547, 0.0], [76.891, 54.491, 0.0], [76.525, 54.177, 0.0], [77.801, 53.404, 0.0], [80.036, 50.865, 0.0], [80.568, 51.388, 0.0], [81.946, 50.812, 0.0], [83.383, 51.069, 0.0], [83.935, 50.889, 0.0], [84.416, 50.311, 0.0], [85.116, 50.117, 0.0], [85.541, 49.693, 0.0], [86.829, 49.827, 0.0], [87.36, 49.215, 0.0], [86.599, 48.549, 0.0], [85.768, 48.456, 0.0], [85.72, 47.453, 0.0], [85.164, 47.001, 0.0], [83.18, 47.33, 0.0], [82.459, 45.54, 0.0], [81.947, 45.317, 0.0], [79.966, 44.918, 0.0], [80.866, 43.18, 0.0], [80.18, 42.92, 0.0], [80.26, 42.35, 0.0], [79.644, 42.497, 0.0], [79.142, 42.856, 0.0], [77.658, 42.961, 0.0], [76.0, 42.988, 0.0], [75.637, 42.878, 0.0], [74.213, 43.298, 0.0], [73.645, 43.091, 0.0], [73.49, 42.501, 0.0], [71.845, 42.845, 0.0], [71.186, 42.704, 0.0], [70.962, 42.266, 0.0]
        ]]
      }
    },
    "KZ",
    "KAZ"
    ],
    [
      "Cambodia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [103.497, 10.633, 0.0], [103.091, 11.154, 0.0], [102.585, 12.187, 0.0], [102.348, 13.394, 0.0], [102.988, 14.226, 0.0], [104.281, 14.417, 0.0], [105.219, 14.273, 0.0], [106.044, 13.881, 0.0], [106.496, 14.571, 0.0], [107.383, 14.202, 0.0], [107.615, 13.536, 0.0], [107.491, 12.337, 0.0], [105.811, 11.568, 0.0], [106.25, 10.962, 0.0], [105.2, 10.889, 0.0], [104.334, 10.487, 0.0], [103.497, 10.633, 0.0]
        ]]
      }
    },
    "KH",
    "KHM"
    ],
    [
      "Laos",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [105.219, 14.273, 0.0], [105.544, 14.724, 0.0], [105.589, 15.57, 0.0], [104.779, 16.442, 0.0], [104.717, 17.429, 0.0], [103.956, 18.241, 0.0], [103.2, 18.31, 0.0], [102.999, 17.962, 0.0], [102.413, 17.933, 0.0], [102.114, 18.109, 0.0], [101.06, 17.512, 0.0], [101.036, 18.409, 0.0], [101.282, 19.463, 0.0], [100.606, 19.508, 0.0], [100.549, 20.109, 0.0], [100.116, 20.418, 0.0], [100.329, 20.786, 0.0], [101.18, 21.437, 0.0], [101.27, 21.202, 0.0], [101.803, 21.174, 0.0], [101.652, 22.318, 0.0], [102.17, 22.465, 0.0], [102.755, 21.675, 0.0], [103.204, 20.767, 0.0], [104.435, 20.759, 0.0], [104.823, 19.887, 0.0], [104.183, 19.625, 0.0], [103.897, 19.265, 0.0], [105.095, 18.667, 0.0], [105.926, 17.485, 0.0], [106.556, 16.604, 0.0], [107.313, 15.909, 0.0], [107.565, 15.202, 0.0], [107.383, 14.202, 0.0], [106.496, 14.571, 0.0], [106.044, 13.881, 0.0], [105.219, 14.273, 0.0]
        ]]
      }
    },
    "LA",
    "LAO"
    ],
    [
      "New Zealand",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [173.02, -40.919, 0.0], [173.247, -41.332, 0.0], [173.958, -40.927, 0.0], [174.248, -41.349, 0.0], [174.249, -41.77, 0.0], [173.876, -42.233, 0.0], [173.223, -42.97, 0.0], [172.711, -43.372, 0.0], [173.08, -43.853, 0.0], [172.309, -43.866, 0.0], [171.453, -44.243, 0.0], [171.185, -44.897, 0.0], [170.617, -45.909, 0.0], [169.831, -46.356, 0.0], [169.332, -46.641, 0.0], [168.411, -46.62, 0.0], [167.764, -46.29, 0.0], [166.677, -46.22, 0.0], [166.509, -45.853, 0.0], [167.046, -45.111, 0.0], [168.304, -44.124, 0.0], [168.949, -43.936, 0.0], [169.668, -43.555, 0.0], [170.525, -43.032, 0.0], [171.125, -42.513, 0.0], [171.57, -41.767, 0.0], [171.949, -41.514, 0.0], [172.097, -40.956, 0.0], [172.799, -40.494, 0.0], [173.02, -40.919, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [174.612, -36.156, 0.0], [175.337, -37.209, 0.0], [175.358, -36.526, 0.0], [175.809, -36.799, 0.0], [175.958, -37.555, 0.0], [176.763, -37.881, 0.0], [177.439, -37.961, 0.0], [178.01, -37.58, 0.0], [178.517, -37.695, 0.0], [178.275, -38.583, 0.0], [177.97, -39.166, 0.0], [177.207, -39.146, 0.0], [176.94, -39.45, 0.0], [177.033, -39.88, 0.0], [176.886, -40.066, 0.0], [176.508, -40.605, 0.0], [176.012, -41.29, 0.0], [175.24, -41.688, 0.0], [175.068, -41.426, 0.0], [174.651, -41.282, 0.0], [175.228, -40.459, 0.0], [174.9, -39.909, 0.0], [173.824, -39.509, 0.0], [173.852, -39.147, 0.0], [174.575, -38.798, 0.0], [174.743, -38.028, 0.0], [174.697, -37.381, 0.0], [174.292, -36.711, 0.0], [174.319, -36.535, 0.0], [173.841, -36.122, 0.0], [173.054, -35.237, 0.0], [172.636, -34.529, 0.0], [173.007, -34.451, 0.0], [173.551, -35.006, 0.0], [174.329, -35.265, 0.0], [174.612, -36.156, 0.0]
       ]
      ]
     }
    ]
    },
    "NZ",
    "NZL"
    ],
    [
      "Papua New Guinea",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [155.88, -6.82, 0.0], [155.6, -6.92, 0.0], [155.167, -6.536, 0.0], [154.729, -5.901, 0.0], [154.514, -5.139, 0.0], [154.653, -5.042, 0.0], [154.76, -5.34, 0.0], [155.063, -5.567, 0.0], [155.548, -6.201, 0.0], [156.02, -6.54, 0.0], [155.88, -6.82, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [151.983, -5.478, 0.0], [151.459, -5.56, 0.0], [151.301, -5.841, 0.0], [150.754, -6.084, 0.0], [150.241, -6.318, 0.0], [149.71, -6.317, 0.0], [148.89, -6.026, 0.0], [148.319, -5.747, 0.0], [148.402, -5.438, 0.0], [149.298, -5.584, 0.0], [149.846, -5.506, 0.0], [149.996, -5.026, 0.0], [150.14, -5.001, 0.0], [150.237, -5.532, 0.0], [150.807, -5.456, 0.0], [151.09, -5.114, 0.0], [151.648, -4.757, 0.0], [151.538, -4.168, 0.0], [152.137, -4.149, 0.0], [152.339, -4.313, 0.0], [152.319, -4.868, 0.0], [151.983, -5.478, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [147.192, -7.388, 0.0], [148.085, -8.044, 0.0], [148.734, -9.105, 0.0], [149.307, -9.071, 0.0], [149.267, -9.514, 0.0], [150.039, -9.684, 0.0], [149.739, -9.873, 0.0], [150.802, -10.294, 0.0], [150.691, -10.583, 0.0], [150.028, -10.652, 0.0], [149.782, -10.393, 0.0], [148.923, -10.281, 0.0], [147.913, -10.13, 0.0], [147.135, -9.492, 0.0], [146.568, -8.943, 0.0], [146.048, -8.067, 0.0], [144.744, -7.63, 0.0], [143.897, -7.915, 0.0], [143.286, -8.245, 0.0], [143.414, -8.983, 0.0], [142.628, -9.327, 0.0], [142.068, -9.16, 0.0], [141.034, -9.118, 0.0], [141.017, -5.859, 0.0], [141.0, -2.6, 0.0], [142.735, -3.289, 0.0], [144.584, -3.861, 0.0], [145.273, -4.374, 0.0], [145.83, -4.876, 0.0], [145.982, -5.466, 0.0], [147.648, -6.084, 0.0], [147.891, -6.614, 0.0], [146.971, -6.722, 0.0], [147.192, -7.388, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [153.14, -4.5, 0.0], [152.827, -4.766, 0.0], [152.639, -4.176, 0.0], [152.406, -3.79, 0.0], [151.953, -3.462, 0.0], [151.384, -3.035, 0.0], [150.662, -2.741, 0.0], [150.94, -2.5, 0.0], [151.48, -2.78, 0.0], [151.82, -3.0, 0.0], [152.24, -3.24, 0.0], [152.64, -3.66, 0.0], [153.02, -3.98, 0.0], [153.14, -4.5, 0.0]
       ]
      ]
     }
    ]
    },
    "PG",
    "PNG"
    ],
    [
      "Russia",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [143.648, 50.748, 0.0], [144.654, 48.976, 0.0], [143.174, 49.307, 0.0], [142.559, 47.862, 0.0], [143.533, 46.837, 0.0], [143.505, 46.138, 0.0], [142.748, 46.741, 0.0], [142.092, 45.967, 0.0], [141.907, 46.806, 0.0], [142.018, 47.78, 0.0], [141.904, 48.859, 0.0], [142.136, 49.615, 0.0], [142.18, 50.952, 0.0], [141.594, 51.935, 0.0], [141.683, 53.302, 0.0], [142.607, 53.762, 0.0], [142.21, 54.225, 0.0], [142.655, 54.366, 0.0], [142.915, 53.705, 0.0], [143.261, 52.741, 0.0], [143.235, 51.757, 0.0], [143.648, 50.748, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [22.731, 54.328, 0.0], [20.892, 54.313, 0.0], [19.661, 54.426, 0.0], [19.888, 54.866, 0.0], [21.268, 55.19, 0.0], [22.316, 55.015, 0.0], [22.758, 54.857, 0.0], [22.651, 54.583, 0.0], [22.731, 54.328, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-175.014, 66.584, 0.0], [-174.34, 66.336, 0.0], [-174.572, 67.062, 0.0], [-171.857, 66.913, 0.0], [-169.9, 65.977, 0.0], [-170.891, 65.541, 0.0], [-172.53, 65.438, 0.0], [-172.555, 64.461, 0.0], [-172.955, 64.253, 0.0], [-173.892, 64.283, 0.0], [-174.654, 64.631, 0.0], [-175.984, 64.923, 0.0], [-176.207, 65.357, 0.0], [-177.223, 65.52, 0.0], [-178.36, 65.391, 0.0], [-178.903, 65.74, 0.0], [-178.686, 66.112, 0.0], [-179.884, 65.875, 0.0], [-179.433, 65.404, 0.0], [-180.0, 64.98, 0.0], [-180.0, 68.964, 0.0], [-177.55, 68.2, 0.0], [-174.928, 67.206, 0.0], [-175.014, 66.584, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [180.0, 70.832, 0.0], [178.903, 70.781, 0.0], [178.725, 71.099, 0.0], [180.0, 71.516, 0.0], [180.0, 70.832, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-178.694, 70.893, 0.0], [-180.0, 70.832, 0.0], [-180.0, 71.516, 0.0], [-179.872, 71.558, 0.0], [-179.024, 71.556, 0.0], [-177.578, 71.269, 0.0], [-177.664, 71.133, 0.0], [-178.694, 70.893, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [143.604, 73.212, 0.0], [142.088, 73.205, 0.0], [140.038, 73.317, 0.0], [139.863, 73.37, 0.0], [140.812, 73.765, 0.0], [142.062, 73.858, 0.0], [143.483, 73.475, 0.0], [143.604, 73.212, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [150.732, 75.084, 0.0], [149.576, 74.689, 0.0], [147.977, 74.778, 0.0], [146.119, 75.173, 0.0], [146.358, 75.497, 0.0], [148.222, 75.346, 0.0], [150.732, 75.084, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [145.086, 75.563, 0.0], [144.3, 74.82, 0.0], [140.614, 74.848, 0.0], [138.955, 74.611, 0.0], [136.974, 75.262, 0.0], [137.512, 75.949, 0.0], [138.831, 76.137, 0.0], [141.472, 76.093, 0.0], [145.086, 75.563, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [57.536, 70.72, 0.0], [56.945, 70.633, 0.0], [53.677, 70.763, 0.0], [53.412, 71.207, 0.0], [51.602, 71.475, 0.0], [51.456, 72.015, 0.0], [52.478, 72.229, 0.0], [52.444, 72.775, 0.0], [54.428, 73.628, 0.0], [53.508, 73.75, 0.0], [55.902, 74.627, 0.0], [55.632, 75.081, 0.0], [57.869, 75.609, 0.0], [61.17, 76.252, 0.0], [64.498, 76.439, 0.0], [66.211, 76.81, 0.0], [68.157, 76.94, 0.0], [68.852, 76.545, 0.0], [68.181, 76.234, 0.0], [64.637, 75.738, 0.0], [61.584, 75.261, 0.0], [58.477, 74.309, 0.0], [56.987, 73.333, 0.0], [55.419, 72.371, 0.0], [55.623, 71.541, 0.0], [57.536, 70.72, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [106.97, 76.974, 0.0], [107.24, 76.48, 0.0], [108.154, 76.723, 0.0], [111.077, 76.71, 0.0], [113.332, 76.222, 0.0], [114.134, 75.848, 0.0], [113.885, 75.328, 0.0], [112.779, 75.032, 0.0], [110.151, 74.477, 0.0], [109.4, 74.18, 0.0], [110.64, 74.04, 0.0], [112.119, 73.788, 0.0], [113.02, 73.977, 0.0], [113.53, 73.335, 0.0], [113.969, 73.595, 0.0], [115.568, 73.753, 0.0], [118.776, 73.588, 0.0], [119.02, 73.12, 0.0], [123.201, 72.971, 0.0], [123.258, 73.735, 0.0], [125.38, 73.56, 0.0], [126.976, 73.565, 0.0], [128.591, 73.039, 0.0], [129.052, 72.399, 0.0], [128.46, 71.98, 0.0], [129.716, 71.193, 0.0], [131.289, 70.787, 0.0], [132.254, 71.836, 0.0], [133.858, 71.386, 0.0], [135.562, 71.655, 0.0], [137.498, 71.348, 0.0], [138.234, 71.628, 0.0], [139.87, 71.488, 0.0], [139.148, 72.416, 0.0], [140.468, 72.849, 0.0], [149.5, 72.2, 0.0], [150.351, 71.606, 0.0], [152.969, 70.842, 0.0], [157.007, 71.031, 0.0], [158.998, 70.867, 0.0], [159.83, 70.453, 0.0], [159.709, 69.722, 0.0], [160.941, 69.437, 0.0], [162.279, 69.642, 0.0], [164.052, 69.668, 0.0], [165.94, 69.472, 0.0], [167.836, 69.583, 0.0], [169.578, 68.694, 0.0], [170.817, 69.014, 0.0], [170.008, 69.653, 0.0], [170.453, 70.097, 0.0], [173.644, 69.817, 0.0], [175.724, 69.877, 0.0], [178.6, 69.4, 0.0], [180.0, 68.964, 0.0], [180.0, 64.98, 0.0], [179.993, 64.974, 0.0], [178.707, 64.535, 0.0], [177.411, 64.608, 0.0], [178.313, 64.076, 0.0], [178.908, 63.252, 0.0], [179.37, 62.983, 0.0], [179.486, 62.569, 0.0], [179.228, 62.304, 0.0], [177.364, 62.522, 0.0], [174.569, 61.769, 0.0], [173.68, 61.653, 0.0], [172.15, 60.95, 0.0], [170.699, 60.336, 0.0], [170.331, 59.882, 0.0], [168.9, 60.574, 0.0], [166.295, 59.789, 0.0], [165.84, 60.16, 0.0], [164.877, 59.732, 0.0], [163.539, 59.869, 0.0], [163.217, 59.211, 0.0], [162.017, 58.243, 0.0], [162.053, 57.839, 0.0], [163.192, 57.615, 0.0], [163.058, 56.159, 0.0], [162.13, 56.122, 0.0], [161.701, 55.286, 0.0], [162.117, 54.855, 0.0], [160.369, 54.344, 0.0], [160.022, 53.203, 0.0], [158.531, 52.959, 0.0], [158.231, 51.943, 0.0], [156.79, 51.011, 0.0], [156.42, 51.7, 0.0], [155.992, 53.159, 0.0], [155.434, 55.381, 0.0], [155.914, 56.768, 0.0], [156.758, 57.365, 0.0], [156.81, 57.832, 0.0], [158.364, 58.056, 0.0], [160.151, 59.315, 0.0], [161.872, 60.343, 0.0], [163.67, 61.141, 0.0], [164.474, 62.551, 0.0], [163.258, 62.466, 0.0], [162.658, 61.643, 0.0], [160.121, 60.544, 0.0], [159.302, 61.774, 0.0], [156.721, 61.434, 0.0], [154.218, 59.758, 0.0], [155.044, 59.145, 0.0], [152.812, 58.884, 0.0], [151.266, 58.781, 0.0], [151.338, 59.504, 0.0], [149.784, 59.656, 0.0], [148.545, 59.164, 0.0], [145.487, 59.336, 0.0], [142.198, 59.04, 0.0], [138.958, 57.088, 0.0], [135.126, 54.73, 0.0], [136.702, 54.604, 0.0], [137.193, 53.977, 0.0], [138.165, 53.755, 0.0], [138.805, 54.255, 0.0], [139.902, 54.19, 0.0], [141.345, 53.09, 0.0], [141.379, 52.239, 0.0], [140.597, 51.24, 0.0], [140.513, 50.046, 0.0], [140.062, 48.447, 0.0], [138.555, 47.0, 0.0], [138.22, 46.308, 0.0], [136.862, 45.144, 0.0], [135.515, 43.989, 0.0], [134.869, 43.398, 0.0], [133.537, 42.811, 0.0], [132.906, 42.798, 0.0], [132.278, 43.285, 0.0], [130.936, 42.553, 0.0], [130.78, 42.22, 0.0], [130.64, 42.395, 0.0], [130.634, 42.903, 0.0], [131.145, 42.93, 0.0], [131.289, 44.112, 0.0], [131.025, 44.968, 0.0], [131.883, 45.321, 0.0], [133.097, 45.144, 0.0], [133.77, 46.117, 0.0], [134.112, 47.212, 0.0], [134.501, 47.578, 0.0], [135.026, 48.478, 0.0], [133.374, 48.183, 0.0], [132.507, 47.789, 0.0], [130.987, 47.79, 0.0], [130.582, 48.73, 0.0], [129.398, 49.441, 0.0], [127.657, 49.76, 0.0], [127.287, 50.74, 0.0], [126.939, 51.354, 0.0], [126.564, 51.784, 0.0], [125.946, 52.793, 0.0], [125.068, 53.161, 0.0], [123.571, 53.459, 0.0], [122.246, 53.432, 0.0], [121.003, 53.251, 0.0], [120.177, 52.754, 0.0], [120.726, 52.516, 0.0], [120.738, 51.964, 0.0], [120.182, 51.644, 0.0], [119.279, 50.583, 0.0], [119.288, 50.143, 0.0], [117.879, 49.511, 0.0], [116.679, 49.889, 0.0], [115.486, 49.805, 0.0], [114.962, 50.14, 0.0], [114.362, 50.248, 0.0], [112.898, 49.544, 0.0], [111.581, 49.378, 0.0], [110.662, 49.13, 0.0], [109.402, 49.293, 0.0], [108.475, 49.283, 0.0], [107.868, 49.794, 0.0], [106.889, 50.274, 0.0], [105.887, 50.406, 0.0], [104.622, 50.275, 0.0], [103.677, 50.09, 0.0], [102.256, 50.511, 0.0], [102.065, 51.26, 0.0], [100.889, 51.517, 0.0], [99.982, 51.634, 0.0], [98.861, 52.047, 0.0], [97.826, 51.011, 0.0], [98.232, 50.422, 0.0], [97.26, 49.726, 0.0], [95.814, 49.977, 0.0], [94.816, 50.013, 0.0], [94.148, 50.481, 0.0], [93.104, 50.495, 0.0], [92.235, 50.802, 0.0], [90.714, 50.332, 0.0], [88.806, 49.471, 0.0], [87.751, 49.297, 0.0], [87.36, 49.215, 0.0], [86.829, 49.827, 0.0], [85.541, 49.693, 0.0], [85.116, 50.117, 0.0], [84.416, 50.311, 0.0], [83.935, 50.889, 0.0], [83.383, 51.069, 0.0], [81.946, 50.812, 0.0], [80.568, 51.388, 0.0], [80.036, 50.865, 0.0], [77.801, 53.404, 0.0], [76.525, 54.177, 0.0], [76.891, 54.491, 0.0], [74.385, 53.547, 0.0], [73.426, 53.49, 0.0], [73.509, 54.036, 0.0], [72.224, 54.377, 0.0], [71.18, 54.133, 0.0], [70.865, 55.17, 0.0], [69.068, 55.385, 0.0], [68.169, 54.97, 0.0], [65.667, 54.601, 0.0], [65.179, 54.354, 0.0], [61.437, 54.006, 0.0], [60.978, 53.665, 0.0], [61.7, 52.98, 0.0], [60.74, 52.72, 0.0], [60.927, 52.448, 0.0], [59.968, 51.96, 0.0], [61.588, 51.273, 0.0], [61.337, 50.799, 0.0], [59.933, 50.842, 0.0], [59.642, 50.545, 0.0], [58.363, 51.064, 0.0], [56.778, 51.044, 0.0], [55.717, 50.622, 0.0], [54.533, 51.026, 0.0], [52.329, 51.719, 0.0], [50.767, 51.693, 0.0], [48.702, 50.605, 0.0], [48.578, 49.875, 0.0], [47.549, 50.455, 0.0], [46.752, 49.356, 0.0], [47.044, 49.152, 0.0], [46.466, 48.394, 0.0], [47.315, 47.716, 0.0], [48.057, 47.744, 0.0], [48.695, 47.076, 0.0], [48.593, 46.561, 0.0], [49.101, 46.399, 0.0], [48.645, 45.806, 0.0], [47.676, 45.641, 0.0], [46.682, 44.609, 0.0], [47.591, 43.66, 0.0], [47.493, 42.987, 0.0], [48.584, 41.809, 0.0], [47.987, 41.406, 0.0], [47.816, 41.151, 0.0], [47.373, 41.22, 0.0], [46.686, 41.827, 0.0], [46.405, 41.861, 0.0], [45.776, 42.092, 0.0], [45.47, 42.503, 0.0], [44.538, 42.712, 0.0], [43.931, 42.555, 0.0], [43.756, 42.741, 0.0], [42.394, 43.22, 0.0], [40.922, 43.382, 0.0], [40.077, 43.553, 0.0], [39.955, 43.435, 0.0], [38.68, 44.28, 0.0], [37.539, 44.657, 0.0], [36.675, 45.245, 0.0], [37.403, 45.405, 0.0], [38.233, 46.241, 0.0], [37.674, 46.637, 0.0], [39.148, 47.045, 0.0], [39.121, 47.263, 0.0], [38.224, 47.102, 0.0], [38.255, 47.546, 0.0], [38.771, 47.826, 0.0], [39.738, 47.899, 0.0], [39.896, 48.232, 0.0], [39.675, 48.784, 0.0], [40.081, 49.307, 0.0], [40.069, 49.601, 0.0], [38.595, 49.926, 0.0], [38.011, 49.916, 0.0], [37.393, 50.384, 0.0], [36.626, 50.226, 0.0], [35.356, 50.577, 0.0], [35.378, 50.774, 0.0], [35.022, 51.208, 0.0], [34.225, 51.256, 0.0], [34.142, 51.566, 0.0], [34.392, 51.769, 0.0], [33.753, 52.335, 0.0], [32.716, 52.238, 0.0], [32.412, 52.289, 0.0], [32.159, 52.061, 0.0], [31.786, 52.102, 0.0], [31.54, 52.742, 0.0], [31.305, 53.074, 0.0], [31.498, 53.167, 0.0], [32.305, 53.133, 0.0], [32.694, 53.351, 0.0], [32.406, 53.618, 0.0], [31.731, 53.794, 0.0], [31.791, 53.975, 0.0], [31.384, 54.157, 0.0], [30.758, 54.812, 0.0], [30.972, 55.082, 0.0], [30.874, 55.551, 0.0], [29.896, 55.789, 0.0], [29.372, 55.67, 0.0], [29.23, 55.918, 0.0], [28.177, 56.169, 0.0], [27.855, 56.759, 0.0], [27.77, 57.244, 0.0], [27.288, 57.475, 0.0], [27.717, 57.792, 0.0], [27.42, 58.725, 0.0], [28.132, 59.301, 0.0], [27.981, 59.475, 0.0], [29.118, 60.028, 0.0], [28.07, 60.504, 0.0], [30.211, 61.78, 0.0], [31.14, 62.358, 0.0], [31.516, 62.868, 0.0], [30.036, 63.553, 0.0], [30.445, 64.204, 0.0], [29.544, 64.949, 0.0], [30.218, 65.806, 0.0], [29.055, 66.944, 0.0], [29.977, 67.698, 0.0], [28.446, 68.365, 0.0], [28.592, 69.065, 0.0], [29.4, 69.157, 0.0], [31.101, 69.558, 0.0], [32.133, 69.906, 0.0], [33.775, 69.301, 0.0], [36.514, 69.063, 0.0], [40.292, 67.932, 0.0], [41.06, 67.457, 0.0], [41.126, 66.792, 0.0], [40.016, 66.266, 0.0], [38.383, 66.0, 0.0], [33.919, 66.76, 0.0], [33.184, 66.633, 0.0], [34.815, 65.9, 0.0], [34.879, 65.436, 0.0], [34.944, 64.414, 0.0], [36.231, 64.109, 0.0], [37.013, 63.85, 0.0], [37.142, 64.335, 0.0], [36.54, 64.764, 0.0], [37.176, 65.143, 0.0], [39.593, 64.521, 0.0], [40.436, 64.764, 0.0], [39.763, 65.497, 0.0], [42.093, 66.476, 0.0], [43.016, 66.419, 0.0], [43.95, 66.069, 0.0], [44.532, 66.756, 0.0], [43.698, 67.352, 0.0], [44.188, 67.951, 0.0], [43.453, 68.571, 0.0], [46.25, 68.25, 0.0], [46.821, 67.69, 0.0], [45.555, 67.567, 0.0], [45.562, 67.01, 0.0], [46.349, 66.668, 0.0], [47.894, 66.885, 0.0], [48.139, 67.522, 0.0], [50.228, 67.999, 0.0], [53.717, 68.857, 0.0], [54.472, 68.808, 0.0], [53.486, 68.201, 0.0], [54.726, 68.097, 0.0], [55.443, 68.439, 0.0], [57.317, 68.466, 0.0], [58.802, 68.881, 0.0], [59.941, 68.278, 0.0], [61.078, 68.941, 0.0], [60.03, 69.52, 0.0], [60.55, 69.85, 0.0], [63.504, 69.547, 0.0], [64.888, 69.235, 0.0], [68.512, 68.092, 0.0], [69.181, 68.616, 0.0], [68.164, 69.144, 0.0], [68.135, 69.356, 0.0], [66.93, 69.455, 0.0], [67.26, 69.929, 0.0], [66.725, 70.709, 0.0], [66.695, 71.029, 0.0], [68.54, 71.935, 0.0], [69.196, 72.843, 0.0], [69.94, 73.04, 0.0], [72.588, 72.776, 0.0], [72.796, 72.22, 0.0], [71.848, 71.409, 0.0], [72.47, 71.09, 0.0], [72.792, 70.391, 0.0], [72.565, 69.021, 0.0], [73.668, 68.408, 0.0], [73.239, 67.74, 0.0], [71.28, 66.32, 0.0], [72.423, 66.173, 0.0], [72.821, 66.533, 0.0], [73.921, 66.789, 0.0], [74.187, 67.284, 0.0], [75.052, 67.76, 0.0], [74.469, 68.329, 0.0], [74.936, 68.989, 0.0], [73.842, 69.071, 0.0], [73.602, 69.628, 0.0], [74.4, 70.632, 0.0], [73.101, 71.447, 0.0], [74.891, 72.121, 0.0], [74.659, 72.832, 0.0], [75.158, 72.855, 0.0], [75.684, 72.301, 0.0], [75.289, 71.336, 0.0], [76.359, 71.153, 0.0], [75.903, 71.874, 0.0], [77.577, 72.267, 0.0], [79.652, 72.32, 0.0], [81.5, 71.75, 0.0], [80.611, 72.583, 0.0], [80.511, 73.648, 0.0], [82.25, 73.85, 0.0], [84.655, 73.806, 0.0], [86.822, 73.937, 0.0], [86.01, 74.46, 0.0], [87.167, 75.116, 0.0], [88.316, 75.144, 0.0], [90.26, 75.64, 0.0], [92.901, 75.773, 0.0], [93.234, 76.047, 0.0], [95.86, 76.14, 0.0], [96.678, 75.915, 0.0], [98.923, 76.447, 0.0], [100.76, 76.43, 0.0], [101.035, 76.862, 0.0], [101.991, 77.288, 0.0], [104.352, 77.698, 0.0], [106.067, 77.374, 0.0], [104.705, 77.127, 0.0], [106.97, 76.974, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [105.075, 78.307, 0.0], [99.438, 77.921, 0.0], [101.265, 79.234, 0.0], [102.086, 79.346, 0.0], [102.838, 79.281, 0.0], [105.372, 78.713, 0.0], [105.075, 78.307, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [51.136, 80.547, 0.0], [49.794, 80.415, 0.0], [48.894, 80.34, 0.0], [48.755, 80.175, 0.0], [47.586, 80.01, 0.0], [46.503, 80.247, 0.0], [47.072, 80.559, 0.0], [44.847, 80.59, 0.0], [46.799, 80.772, 0.0], [48.318, 80.784, 0.0], [48.523, 80.515, 0.0], [49.097, 80.754, 0.0], [50.04, 80.919, 0.0], [51.523, 80.7, 0.0], [51.136, 80.547, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [99.94, 78.881, 0.0], [97.758, 78.756, 0.0], [94.973, 79.045, 0.0], [93.313, 79.427, 0.0], [92.545, 80.144, 0.0], [91.181, 80.341, 0.0], [93.778, 81.025, 0.0], [95.941, 81.25, 0.0], [97.884, 80.747, 0.0], [100.187, 79.78, 0.0], [99.94, 78.881, 0.0]
       ]
      ]
     }
    ]
    },
    "RU",
    "RUS"
    ],
    [
      "Rwanda",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [30.419, -1.135, 0.0], [30.816, -1.699, 0.0], [30.758, -2.287, 0.0], [30.47, -2.414, 0.0], [29.938, -2.348, 0.0], [29.632, -2.918, 0.0], [29.025, -2.839, 0.0], [29.117, -2.292, 0.0], [29.255, -2.215, 0.0], [29.292, -1.62, 0.0], [29.579, -1.341, 0.0], [29.822, -1.443, 0.0], [30.419, -1.135, 0.0]
        ]]
      }
    },
    "RW",
    "RWA"
    ],
    [
      "Somalia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [49.729, 11.579, 0.0], [50.259, 11.68, 0.0], [50.732, 12.022, 0.0], [51.111, 12.025, 0.0], [51.134, 11.748, 0.0], [51.042, 11.167, 0.0], [51.045, 10.641, 0.0], [50.834, 10.28, 0.0], [50.552, 9.199, 0.0], [50.071, 8.082, 0.0], [49.453, 6.805, 0.0], [48.595, 5.339, 0.0], [47.741, 4.219, 0.0], [46.565, 2.855, 0.0], [45.564, 2.046, 0.0], [44.068, 1.053, 0.0], [43.136, 0.292, 0.0], [42.042, -0.919, 0.0], [41.811, -1.446, 0.0], [41.585, -1.683, 0.0], [40.993, -0.858, 0.0], [40.981, 2.785, 0.0], [41.855, 3.919, 0.0], [42.129, 4.234, 0.0], [42.77, 4.253, 0.0], [43.661, 4.958, 0.0], [44.964, 5.002, 0.0], [47.789, 8.003, 0.0], [48.487, 8.838, 0.0], [48.938, 9.452, 0.0], [48.938, 9.974, 0.0], [48.938, 10.982, 0.0], [48.942, 11.394, 0.0], [48.948, 11.411, 0.0], [49.268, 11.43, 0.0], [49.729, 11.579, 0.0]
        ]]
      }
    },
    "SO",
    "SOM"
    ],
    [
      "Serbia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [20.874, 45.416, 0.0], [21.484, 45.181, 0.0], [21.562, 44.769, 0.0], [22.145, 44.478, 0.0], [22.459, 44.703, 0.0], [22.706, 44.578, 0.0], [22.474, 44.409, 0.0], [22.657, 44.235, 0.0], [22.41, 44.008, 0.0], [22.5, 43.643, 0.0], [22.986, 43.211, 0.0], [22.605, 42.899, 0.0], [22.437, 42.58, 0.0], [22.545, 42.461, 0.0], [22.381, 42.32, 0.0], [21.917, 42.304, 0.0], [21.577, 42.245, 0.0], [21.543, 42.32, 0.0], [21.663, 42.439, 0.0], [21.775, 42.683, 0.0], [21.633, 42.677, 0.0], [21.439, 42.863, 0.0], [21.274, 42.91, 0.0], [21.143, 43.069, 0.0], [20.957, 43.131, 0.0], [20.814, 43.272, 0.0], [20.635, 43.217, 0.0], [20.497, 42.885, 0.0], [20.258, 42.813, 0.0], [20.34, 42.899, 0.0], [19.959, 43.106, 0.0], [19.63, 43.214, 0.0], [19.484, 43.352, 0.0], [19.219, 43.524, 0.0], [19.454, 43.568, 0.0], [19.6, 44.038, 0.0], [19.118, 44.423, 0.0], [19.368, 44.863, 0.0], [19.005, 44.86, 0.0], [19.39, 45.237, 0.0], [19.073, 45.522, 0.0], [18.83, 45.909, 0.0], [19.596, 46.172, 0.0], [20.22, 46.127, 0.0], [20.762, 45.735, 0.0], [20.874, 45.416, 0.0]
        ]]
      }
    },
    "RS",
    "SRB"
    ],
    [
      "Trinidad and Tobago",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-61.68, 10.76, 0.0], [-61.105, 10.89, 0.0], [-60.895, 10.855, 0.0], [-60.935, 10.11, 0.0], [-61.77, 10.0, 0.0], [-61.95, 10.09, 0.0], [-61.66, 10.365, 0.0], [-61.68, 10.76, 0.0]
        ]]
      }
    },
    "TT",
    "TTO"
    ],
    [
      "Tunisia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [9.482, 30.308, 0.0], [9.056, 32.103, 0.0], [8.439, 32.506, 0.0], [8.43, 32.748, 0.0], [7.613, 33.344, 0.0], [7.524, 34.097, 0.0], [8.141, 34.655, 0.0], [8.376, 35.48, 0.0], [8.218, 36.433, 0.0], [8.421, 36.946, 0.0], [9.51, 37.35, 0.0], [10.21, 37.23, 0.0], [10.181, 36.724, 0.0], [11.029, 37.092, 0.0], [11.1, 36.9, 0.0], [10.6, 36.41, 0.0], [10.593, 35.947, 0.0], [10.94, 35.699, 0.0], [10.808, 34.834, 0.0], [10.15, 34.331, 0.0], [10.34, 33.786, 0.0], [10.857, 33.769, 0.0], [11.109, 33.293, 0.0], [11.489, 33.137, 0.0], [11.432, 32.369, 0.0], [10.945, 32.082, 0.0], [10.637, 31.761, 0.0], [9.95, 31.376, 0.0], [10.057, 30.962, 0.0], [9.97, 30.539, 0.0], [9.482, 30.308, 0.0]
        ]]
      }
    },
    "TN",
    "TUN"
    ],
    [
      "Yemen",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [53.109, 16.651, 0.0], [52.385, 16.382, 0.0], [52.192, 15.938, 0.0], [52.168, 15.597, 0.0], [51.173, 15.175, 0.0], [49.575, 14.709, 0.0], [48.679, 14.003, 0.0], [48.239, 13.948, 0.0], [47.939, 14.007, 0.0], [47.354, 13.592, 0.0], [46.717, 13.4, 0.0], [45.878, 13.348, 0.0], [45.625, 13.291, 0.0], [45.406, 13.027, 0.0], [45.144, 12.954, 0.0], [44.99, 12.7, 0.0], [44.495, 12.722, 0.0], [44.175, 12.586, 0.0], [43.483, 12.637, 0.0], [43.223, 13.221, 0.0], [43.251, 13.768, 0.0], [43.088, 14.063, 0.0], [42.892, 14.802, 0.0], [42.605, 15.213, 0.0], [42.805, 15.262, 0.0], [42.702, 15.719, 0.0], [42.824, 15.912, 0.0], [42.779, 16.348, 0.0], [43.218, 16.667, 0.0], [43.116, 17.088, 0.0], [43.381, 17.58, 0.0], [43.792, 17.32, 0.0], [44.063, 17.41, 0.0], [45.217, 17.433, 0.0], [45.4, 17.333, 0.0], [46.367, 17.233, 0.0], [46.75, 17.283, 0.0], [47.0, 16.95, 0.0], [47.467, 17.117, 0.0], [48.183, 18.167, 0.0], [49.117, 18.617, 0.0], [52.0, 19.0, 0.0], [52.782, 17.35, 0.0], [53.109, 16.651, 0.0]
        ]]
      }
    },
    "YE",
    "YEM"
    ],
    [
      "Zimbabwe",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [31.191, -22.252, 0.0], [30.66, -22.152, 0.0], [30.323, -22.272, 0.0], [29.839, -22.102, 0.0], [29.432, -22.091, 0.0], [28.795, -21.639, 0.0], [28.021, -21.486, 0.0], [27.727, -20.852, 0.0], [27.725, -20.499, 0.0], [27.297, -20.392, 0.0], [26.165, -19.293, 0.0], [25.85, -18.714, 0.0], [25.649, -18.536, 0.0], [25.264, -17.737, 0.0], [26.382, -17.846, 0.0], [26.707, -17.961, 0.0], [27.044, -17.938, 0.0], [27.598, -17.291, 0.0], [28.468, -16.468, 0.0], [28.826, -16.39, 0.0], [28.947, -16.043, 0.0], [29.517, -15.645, 0.0], [30.274, -15.508, 0.0], [30.339, -15.881, 0.0], [31.173, -15.861, 0.0], [31.636, -16.072, 0.0], [31.852, -16.319, 0.0], [32.328, -16.392, 0.0], [32.848, -16.713, 0.0], [32.85, -17.979, 0.0], [32.655, -18.672, 0.0], [32.612, -19.419, 0.0], [32.773, -19.716, 0.0], [32.66, -20.304, 0.0], [32.509, -20.395, 0.0], [32.245, -21.116, 0.0], [31.191, -22.252, 0.0]
        ]]
      }
    },
    "ZW",
    "ZWE"
    ],
    [
      "Angola",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [16.327, -5.877, 0.0], [16.573, -6.623, 0.0], [16.86, -7.222, 0.0], [17.09, -7.546, 0.0], [17.473, -8.069, 0.0], [18.134, -7.988, 0.0], [18.464, -7.847, 0.0], [19.017, -7.988, 0.0], [19.167, -7.738, 0.0], [19.418, -7.155, 0.0], [20.038, -7.116, 0.0], [20.092, -6.943, 0.0], [20.602, -6.939, 0.0], [20.515, -7.3, 0.0], [21.728, -7.291, 0.0], [21.746, -7.92, 0.0], [21.949, -8.306, 0.0], [21.802, -8.909, 0.0], [21.875, -9.524, 0.0], [22.209, -9.895, 0.0], [22.155, -11.085, 0.0], [22.403, -10.993, 0.0], [22.837, -11.018, 0.0], [23.457, -10.868, 0.0], [23.912, -10.927, 0.0], [24.018, -11.237, 0.0], [23.904, -11.722, 0.0], [24.08, -12.191, 0.0], [23.931, -12.566, 0.0], [24.016, -12.911, 0.0], [21.934, -12.898, 0.0], [21.888, -16.08, 0.0], [22.562, -16.898, 0.0], [23.215, -17.523, 0.0], [21.377, -17.931, 0.0], [18.956, -17.789, 0.0], [18.263, -17.31, 0.0], [14.21, -17.353, 0.0], [14.059, -17.423, 0.0], [13.462, -16.971, 0.0], [12.814, -16.941, 0.0], [12.215, -17.112, 0.0], [11.734, -17.302, 0.0], [11.64, -16.673, 0.0], [11.779, -15.794, 0.0], [12.124, -14.878, 0.0], [12.176, -14.449, 0.0], [12.5, -13.548, 0.0], [12.738, -13.138, 0.0], [13.313, -12.484, 0.0], [13.634, -12.039, 0.0], [13.739, -11.298, 0.0], [13.686, -10.731, 0.0], [13.387, -10.374, 0.0], [13.121, -9.767, 0.0], [12.875, -9.167, 0.0], [12.929, -8.959, 0.0], [13.236, -8.563, 0.0], [12.933, -7.597, 0.0], [12.728, -6.927, 0.0], [12.227, -6.294, 0.0], [12.322, -6.1, 0.0], [12.735, -5.966, 0.0], [13.025, -5.984, 0.0], [13.376, -5.864, 0.0], [16.327, -5.877, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [12.437, -5.684, 0.0], [12.182, -5.79, 0.0], [11.915, -5.038, 0.0], [12.319, -4.606, 0.0], [12.621, -4.438, 0.0], [12.996, -4.781, 0.0], [12.632, -4.991, 0.0], [12.468, -5.248, 0.0], [12.437, -5.684, 0.0]
       ]
      ]
     }
    ]
    },
    "AO",
    "AGO"
    ],
    [
      "Armenia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [43.583, 41.092, 0.0], [44.972, 41.248, 0.0], [45.179, 40.985, 0.0], [45.56, 40.812, 0.0], [45.359, 40.562, 0.0], [45.892, 40.218, 0.0], [45.61, 39.9, 0.0], [46.035, 39.628, 0.0], [46.483, 39.464, 0.0], [46.506, 38.771, 0.0], [46.144, 38.741, 0.0], [45.735, 39.32, 0.0], [45.74, 39.474, 0.0], [45.298, 39.472, 0.0], [45.002, 39.74, 0.0], [44.794, 39.713, 0.0], [44.4, 40.005, 0.0], [43.656, 40.254, 0.0], [43.753, 40.74, 0.0], [43.583, 41.092, 0.0]
        ]]
      }
    },
    "AM",
    "ARM"
    ],
    [
      "Fr. S. and Antarctic Lands",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [68.935, -48.625, 0.0], [69.58, -48.94, 0.0], [70.525, -49.065, 0.0], [70.56, -49.255, 0.0], [70.28, -49.71, 0.0], [68.745, -49.775, 0.0], [68.72, -49.243, 0.0], [68.868, -48.83, 0.0], [68.935, -48.625, 0.0]
        ]]
      }
    },
    "TF",
    "ATF"
    ],
    [
      "Burundi",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [29.34, -4.5, 0.0], [29.276, -3.294, 0.0], [29.025, -2.839, 0.0], [29.632, -2.918, 0.0], [29.938, -2.348, 0.0], [30.47, -2.414, 0.0], [30.528, -2.808, 0.0], [30.743, -3.034, 0.0], [30.752, -3.359, 0.0], [30.506, -3.569, 0.0], [30.116, -4.09, 0.0], [29.754, -4.452, 0.0], [29.34, -4.5, 0.0]
        ]]
      }
    },
    "BI",
    "BDI"
    ],
    [
      "Bosnia and Herz.",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [19.005, 44.86, 0.0], [19.368, 44.863, 0.0], [19.118, 44.423, 0.0], [19.6, 44.038, 0.0], [19.454, 43.568, 0.0], [19.219, 43.524, 0.0], [19.032, 43.433, 0.0], [18.706, 43.2, 0.0], [18.56, 42.65, 0.0], [17.675, 43.029, 0.0], [17.297, 43.446, 0.0], [16.916, 43.668, 0.0], [16.456, 44.041, 0.0], [16.24, 44.351, 0.0], [15.75, 44.819, 0.0], [15.959, 45.234, 0.0], [16.318, 45.004, 0.0], [16.535, 45.212, 0.0], [17.002, 45.234, 0.0], [17.862, 45.068, 0.0], [18.553, 45.082, 0.0], [19.005, 44.86, 0.0]
        ]]
      }
    },
    "BA",
    "BIH"
    ],
    [
      "Colombia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-75.373, -0.152, 0.0],[ -75.801, 0.085, 0.0], [-76.292, 0.416, 0.0], [-76.576, 0.257, 0.0], [-77.425, 0.396, 0.0], [-77.669, 0.826, 0.0], [-77.855, 0.81, 0.0], [-78.855, 1.381, 0.0], [-78.991, 1.691, 0.0], [-78.618, 1.766, 0.0], [-78.662, 2.267, 0.0], [-78.428, 2.63, 0.0], [-77.932, 2.697, 0.0], [-77.51, 3.325, 0.0], [-77.128, 3.85, 0.0], [-77.496, 4.088, 0.0], [-77.308, 4.668, 0.0], [-77.533, 5.583, 0.0], [-77.319, 5.845, 0.0], [-77.477, 6.691, 0.0], [-77.882, 7.224, 0.0], [-77.753, 7.71, 0.0], [-77.431, 7.638, 0.0], [-77.243, 7.935, 0.0], [-77.475, 8.524, 0.0], [-77.353, 8.671, 0.0], [-76.837, 8.639, 0.0], [-76.086, 9.337, 0.0], [-75.675, 9.443, 0.0], [-75.665, 9.774, 0.0], [-75.48, 10.619, 0.0], [-74.907, 11.083, 0.0], [-74.277, 11.102, 0.0], [-74.197, 11.31, 0.0], [-73.415, 11.227, 0.0], [-72.628, 11.732, 0.0], [-72.238, 11.956, 0.0], [-71.754, 12.437, 0.0], [-71.4, 12.376, 0.0], [-71.137, 12.113, 0.0], [-71.332, 11.776, 0.0], [-71.974, 11.609, 0.0], [-72.228, 11.109, 0.0], [-72.615, 10.822, 0.0], [-72.905, 10.45, 0.0], [-73.028, 9.737, 0.0], [-73.305, 9.152, 0.0], [-72.789, 9.085, 0.0], [-72.66, 8.625, 0.0], [-72.44, 8.405, 0.0], [-72.361, 8.003, 0.0], [-72.48, 7.633, 0.0], [-72.444, 7.424, 0.0], [-72.198, 7.34, 0.0], [-71.96, 6.992, 0.0], [-70.674, 7.088, 0.0], [-70.093, 6.96, 0.0], [-69.389, 6.1, 0.0], [-68.985, 6.207, 0.0], [-68.265, 6.153, 0.0], [-67.695, 6.267, 0.0], [-67.341, 6.095, 0.0], [-67.522, 5.557, 0.0], [-67.745, 5.221, 0.0], [-67.823, 4.504, 0.0], [-67.622, 3.839, 0.0], [-67.338, 3.542, 0.0], [-67.303, 3.318, 0.0], [-67.81, 2.821, 0.0], [-67.447, 2.6, 0.0], [-67.181, 2.251, 0.0], [-66.876, 1.253, 0.0], [-67.065, 1.13, 0.0], [-67.26, 1.72, 0.0], [-67.538, 2.037, 0.0], [-67.869, 1.692, 0.0], [-69.817, 1.715, 0.0], [-69.805, 1.089, 0.0], [-69.219, 0.986, 0.0], [-69.252, 0.603, 0.0], [-69.452, 0.706, 0.0], [-70.016, 0.541, 0.0], [-70.021, -0.185, 0.0], [-69.577, -0.55, 0.0], [-69.42, -1.123, 0.0], [-69.444, -1.556, 0.0], [-69.894, -4.298, 0.0], [-70.394, -3.767, 0.0], [-70.693, -3.743, 0.0], [-70.048, -2.725, 0.0], [-70.813, -2.257, 0.0], [-71.414, -2.343, 0.0], [-71.775, -2.17, 0.0], [-72.326, -2.434, 0.0], [-73.07, -2.309, 0.0], [-73.66, -1.26, 0.0], [-74.122, -1.003, 0.0], [-74.442, -0.531, 0.0], [-75.107, -0.057, 0.0], [-75.373, -0.152, 0.0]
        ]]
      }
    },
    "CO",
    "COL"
    ],
    [
      "Cyprus",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [33.974, 35.059, 0.0], [34.005, 34.978, 0.0], [32.98, 34.572, 0.0], [32.49, 34.702, 0.0], [32.257, 35.103, 0.0], [32.732, 35.14, 0.0], [32.92, 35.088, 0.0], [33.191, 35.173, 0.0], [33.384, 35.163, 0.0], [33.456, 35.101, 0.0], [33.476, 35.0, 0.0], [33.526, 35.039, 0.0], [33.675, 35.018, 0.0], [33.866, 35.094, 0.0], [33.974, 35.059, 0.0]
        ]]
      }
    },
    "CY",
    "CYP"
    ],
    [
      "Ecuador",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-80.303, -3.405, 0.0], [-79.77, -2.658, 0.0], [-79.987, -2.221, 0.0], [-80.369, -2.685, 0.0], [-80.968, -2.247, 0.0], [-80.765, -1.965, 0.0], [-80.934, -1.057, 0.0], [-80.583, -0.907, 0.0], [-80.399, -0.284, 0.0], [-80.021, 0.36, 0.0], [-80.091, 0.768, 0.0], [-79.543, 0.983, 0.0], [-78.855, 1.381, 0.0], [-77.855, 0.81, 0.0], [-77.669, 0.826, 0.0], [-77.425, 0.396, 0.0], [-76.576, 0.257, 0.0], [-76.292, 0.416, 0.0],[ -75.801, 0.085, 0.0], [-75.373, -0.152, 0.0], [-75.234, -0.911, 0.0], [-75.545, -1.562, 0.0], [-76.635, -2.609, 0.0], [-77.838, -3.003, 0.0], [-78.451, -3.873, 0.0], [-78.64, -4.548, 0.0], [-79.205, -4.959, 0.0], [-79.625, -4.454, 0.0], [-80.029, -4.346, 0.0], [-80.442, -4.426, 0.0], [-80.469, -4.059, 0.0], [-80.184, -3.821, 0.0], [-80.303, -3.405, 0.0]
        ]]
      }
    },
    "EC",
    "ECU"
    ],
    [
      "Eritrea",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [42.352, 12.542, 0.0], [42.01, 12.866, 0.0], [41.599, 13.452, 0.0], [41.155, 13.773, 0.0], [40.897, 14.119, 0.0], [40.026, 14.52, 0.0], [39.341, 14.532, 0.0], [39.099, 14.741, 0.0], [38.513, 14.505, 0.0], [37.906, 14.959, 0.0], [37.594, 14.213, 0.0], [36.43, 14.422, 0.0], [36.323, 14.822, 0.0], [36.754, 16.292, 0.0], [36.853, 16.957, 0.0], [37.167, 17.263, 0.0], [37.904, 17.428, 0.0], [38.41, 17.998, 0.0], [38.991, 16.841, 0.0], [39.266, 15.923, 0.0], [39.814, 15.436, 0.0], [41.179, 14.491, 0.0], [41.735, 13.921, 0.0], [42.277, 13.344, 0.0], [42.59, 13.0, 0.0], [43.081, 12.7, 0.0], [42.78, 12.455, 0.0], [42.352, 12.542, 0.0]
        ]]
      }
    },
    "ER",
    "ERI"
    ],
    [
      "Honduras",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-87.317, 12.985, 0.0], [-87.489, 13.298, 0.0], [-87.793, 13.384, 0.0], [-87.724, 13.785, 0.0], [-87.86, 13.893, 0.0], [-88.065, 13.965, 0.0], [-88.504, 13.845, 0.0], [-88.541, 13.98, 0.0], [-88.843, 14.141, 0.0], [-89.059, 14.34, 0.0], [-89.353, 14.424, 0.0], [-89.146, 14.678, 0.0], [-89.225, 14.874, 0.0], [-89.155, 15.066, 0.0], [-88.681, 15.346, 0.0], [-88.225, 15.728, 0.0], [-88.121, 15.689, 0.0], [-87.902, 15.864, 0.0], [-87.616, 15.879, 0.0], [-87.523, 15.797, 0.0], [-87.368, 15.847, 0.0], [-86.903, 15.757, 0.0], [-86.441, 15.783, 0.0], [-86.119, 15.893, 0.0], [-86.002, 16.005, 0.0], [-85.683, 15.954, 0.0], [-85.444, 15.886, 0.0], [-85.182, 15.909, 0.0], [-84.984, 15.996, 0.0], [-84.527, 15.857, 0.0], [-84.368, 15.835, 0.0], [-84.063, 15.648, 0.0], [-83.774, 15.424, 0.0], [-83.41, 15.271, 0.0], [-83.147, 14.996, 0.0], [-83.49, 15.016, 0.0], [-83.629, 14.88, 0.0], [-83.976, 14.749, 0.0], [-84.228, 14.749, 0.0], [-84.449, 14.622, 0.0], [-84.65, 14.667, 0.0], [-84.82, 14.82, 0.0], [-84.925, 14.79, 0.0], [-85.053, 14.552, 0.0], [-85.149, 14.56, 0.0], [-85.165, 14.354, 0.0], [-85.514, 14.079, 0.0], [-85.699, 13.96, 0.0], [-85.801, 13.836, 0.0], [-86.096, 14.038, 0.0], [-86.312, 13.771, 0.0], [-86.521, 13.778, 0.0], [-86.755, 13.755, 0.0], [-86.734, 13.263, 0.0], [-86.881, 13.254, 0.0], [-87.006, 13.026, 0.0], [-87.317, 12.985, 0.0]
        ]]
      }
    },
    "HN",
    "HND"
    ],
    [
      "Kuwait",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [47.975, 29.976, 0.0], [48.183, 29.534, 0.0], [48.094, 29.306, 0.0], [48.416, 28.552, 0.0], [47.709, 28.526, 0.0], [47.46, 29.003, 0.0], [46.569, 29.099, 0.0], [47.303, 30.059, 0.0], [47.975, 29.976, 0.0]
        ]]
      }
    },
    "KW",
    "KWT"
    ],
    [
      "Sri Lanka",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [81.788, 7.523, 0.0], [81.637, 6.482, 0.0], [81.218, 6.197, 0.0], [80.348, 5.968, 0.0], [79.872, 6.763, 0.0], [79.695, 8.201, 0.0], [80.148, 9.824, 0.0], [80.839, 9.268, 0.0], [81.304, 8.564, 0.0], [81.788, 7.523, 0.0]
        ]]
      }
    },
    "LK",
    "LKA"
    ],
    [
      "Lithuania",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [22.731, 54.328, 0.0], [22.651, 54.583, 0.0], [22.758, 54.857, 0.0], [22.316, 55.015, 0.0], [21.268, 55.19, 0.0], [21.056, 56.031, 0.0], [22.201, 56.338, 0.0], [23.878, 56.274, 0.0], [24.861, 56.373, 0.0], [25.001, 56.165, 0.0], [25.533, 56.1, 0.0], [26.494, 55.615, 0.0], [26.588, 55.167, 0.0], [25.768, 54.847, 0.0], [25.536, 54.282, 0.0], [24.451, 53.906, 0.0], [23.484, 53.912, 0.0], [23.244, 54.221, 0.0], [22.731, 54.328, 0.0]
        ]]
      }
    },
    "LT",
    "LTU"
    ],
    [
      "Moldova",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [26.619, 48.221, 0.0], [26.858, 48.368, 0.0], [27.523, 48.467, 0.0], [28.26, 48.156, 0.0], [28.671, 48.118, 0.0], [29.123, 47.849, 0.0], [29.051, 47.51, 0.0], [29.415, 47.347, 0.0], [29.56, 46.929, 0.0], [29.909, 46.674, 0.0], [29.838, 46.525, 0.0], [30.025, 46.424, 0.0], [29.76, 46.35, 0.0], [29.171, 46.379, 0.0], [29.072, 46.518, 0.0], [28.863, 46.438, 0.0], [28.934, 46.259, 0.0], [28.66, 45.94, 0.0], [28.485, 45.597, 0.0], [28.234, 45.488, 0.0], [28.054, 45.945, 0.0], [28.16, 46.372, 0.0], [28.128, 46.81, 0.0], [27.551, 47.405, 0.0], [27.234, 47.827, 0.0], [26.924, 48.123, 0.0], [26.619, 48.221, 0.0]
        ]]
      }
    },
    "MD",
    "MDA"
    ],
    [
      "Nicaragua",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-85.713, 11.088, 0.0], [-86.058, 11.403, 0.0], [-86.526, 11.807, 0.0], [-86.746, 12.144, 0.0], [-87.168, 12.458, 0.0], [-87.668, 12.91, 0.0], [-87.557, 13.065, 0.0], [-87.392, 12.914, 0.0], [-87.317, 12.985, 0.0], [-87.006, 13.026, 0.0], [-86.881, 13.254, 0.0], [-86.734, 13.263, 0.0], [-86.755, 13.755, 0.0], [-86.521, 13.778, 0.0], [-86.312, 13.771, 0.0], [-86.096, 14.038, 0.0], [-85.801, 13.836, 0.0], [-85.699, 13.96, 0.0], [-85.514, 14.079, 0.0], [-85.165, 14.354, 0.0], [-85.149, 14.56, 0.0], [-85.053, 14.552, 0.0], [-84.925, 14.79, 0.0], [-84.82, 14.82, 0.0], [-84.65, 14.667, 0.0], [-84.449, 14.622, 0.0], [-84.228, 14.749, 0.0], [-83.976, 14.749, 0.0], [-83.629, 14.88, 0.0], [-83.49, 15.016, 0.0], [-83.147, 14.996, 0.0], [-83.233, 14.9, 0.0], [-83.284, 14.677, 0.0], [-83.182, 14.311, 0.0], [-83.412, 13.97, 0.0], [-83.52, 13.568, 0.0], [-83.552, 13.127, 0.0], [-83.499, 12.869, 0.0], [-83.473, 12.419, 0.0], [-83.626, 12.321, 0.0], [-83.72, 11.893, 0.0], [-83.651, 11.629, 0.0], [-83.855, 11.373, 0.0], [-83.809, 11.103, 0.0], [-83.656, 10.939, 0.0], [-83.895, 10.727, 0.0], [-84.19, 10.793, 0.0], [-84.356, 10.999, 0.0], [-84.673, 11.083, 0.0], [-84.903, 10.952, 0.0], [-85.562, 11.217, 0.0], [-85.713, 11.088, 0.0]
        ]]
      }
    },
    "NI",
    "NIC"
    ],
    [
      "Nepal",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [88.12, 27.877, 0.0], [88.043, 27.446, 0.0], [88.175, 26.81, 0.0], [88.06, 26.415, 0.0], [87.227, 26.398, 0.0], [86.024, 26.631, 0.0], [85.252, 26.726, 0.0], [84.675, 27.235, 0.0], [83.304, 27.365, 0.0], [82.0, 27.925, 0.0], [81.057, 28.416, 0.0], [80.088, 28.794, 0.0], [80.477, 29.73, 0.0], [81.111, 30.183, 0.0], [81.526, 30.423, 0.0], [82.328, 30.115, 0.0], [83.337, 29.464, 0.0], [83.899, 29.32, 0.0], [84.235, 28.84, 0.0], [85.012, 28.643, 0.0], [85.823, 28.204, 0.0], [86.955, 27.974, 0.0], [88.12, 27.877, 0.0]
        ]]
      }
    },
    "NP",
    "NPL"
    ],
    [
      "Panama",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-77.882, 7.224, 0.0], [-78.215, 7.512, 0.0], [-78.429, 8.052, 0.0], [-78.182, 8.319, 0.0], [-78.435, 8.388, 0.0], [-78.622, 8.718, 0.0], [-79.12, 8.996, 0.0], [-79.558, 8.932, 0.0], [-79.761, 8.585, 0.0], [-80.164, 8.333, 0.0], [-80.383, 8.298, 0.0], [-80.481, 8.09, 0.0], [-80.004, 7.548, 0.0], [-80.277, 7.42, 0.0], [-80.421, 7.272, 0.0], [-80.886, 7.221, 0.0], [-81.06, 7.818, 0.0], [-81.19, 7.648, 0.0], [-81.52, 7.707, 0.0], [-81.721, 8.109, 0.0], [-82.131, 8.175, 0.0], [-82.391, 8.292, 0.0], [-82.82, 8.291, 0.0], [-82.851, 8.074, 0.0], [-82.966, 8.225, 0.0], [-82.913, 8.424, 0.0], [-82.83, 8.626, 0.0], [-82.869, 8.807, 0.0], [-82.719, 8.926, 0.0], [-82.927, 9.074, 0.0], [-82.933, 9.477, 0.0], [-82.546, 9.566, 0.0], [-82.187, 9.207, 0.0], [-82.208, 8.996, 0.0], [-81.809, 8.951, 0.0], [-81.714, 9.032, 0.0], [-81.439, 8.786, 0.0], [-80.947, 8.859, 0.0], [-80.522, 9.111, 0.0], [-79.915, 9.313, 0.0], [-79.573, 9.612, 0.0], [-79.021, 9.553, 0.0], [-79.058, 9.455, 0.0], [-78.501, 9.42, 0.0], [-78.056, 9.248, 0.0], [-77.73, 8.947, 0.0], [-77.353, 8.671, 0.0], [-77.475, 8.524, 0.0], [-77.243, 7.935, 0.0], [-77.431, 7.638, 0.0], [-77.753, 7.71, 0.0], [-77.882, 7.224, 0.0]
        ]]
      }
    },
    "PA",
    "PAN"
    ],
    [
      "Portugal",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-9.035, 41.881, 0.0], [-8.672, 42.135, 0.0], [-8.264, 42.28, 0.0], [-8.013, 41.791, 0.0], [-7.423, 41.792, 0.0], [-7.251, 41.918, 0.0], [-6.669, 41.883, 0.0], [-6.389, 41.382, 0.0], [-6.851, 41.111, 0.0], [-6.864, 40.331, 0.0], [-7.026, 40.185, 0.0], [-7.067, 39.712, 0.0], [-7.499, 39.63, 0.0], [-7.098, 39.03, 0.0], [-7.374, 38.373, 0.0], [-7.029, 38.076, 0.0], [-7.167, 37.804, 0.0], [-7.537, 37.429, 0.0], [-7.454, 37.098, 0.0], [-7.856, 36.838, 0.0], [-8.383, 36.979, 0.0], [-8.899, 36.869, 0.0], [-8.746, 37.651, 0.0], [-8.84, 38.266, 0.0], [-9.287, 38.358, 0.0], [-9.527, 38.737, 0.0], [-9.447, 39.392, 0.0], [-9.048, 39.755, 0.0], [-8.977, 40.159, 0.0], [-8.769, 40.761, 0.0], [-8.791, 41.184, 0.0], [-8.991, 41.543, 0.0], [-9.035, 41.881, 0.0]
        ]]
      }
    },
    "PT",
    "PRT"
    ],
    [
      "Qatar",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [50.81, 24.755, 0.0], [50.744, 25.482, 0.0], [51.013, 26.007, 0.0], [51.286, 26.115, 0.0], [51.589, 25.801, 0.0], [51.607, 25.216, 0.0], [51.39, 24.627, 0.0], [51.112, 24.556, 0.0], [50.81, 24.755, 0.0]
        ]]
      }
    },
    "QA",
    "QAT"
    ],
    [
      "Romania",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [22.711, 47.882, 0.0], [23.142, 48.096, 0.0], [23.761, 47.986, 0.0], [24.402, 47.982, 0.0], [24.866, 47.738, 0.0], [25.208, 47.891, 0.0], [25.946, 47.987, 0.0], [26.197, 48.221, 0.0], [26.619, 48.221, 0.0], [26.924, 48.123, 0.0], [27.234, 47.827, 0.0], [27.551, 47.405, 0.0], [28.128, 46.81, 0.0], [28.16, 46.372, 0.0], [28.054, 45.945, 0.0], [28.234, 45.488, 0.0], [28.68, 45.304, 0.0], [29.15, 45.465, 0.0], [29.603, 45.293, 0.0], [29.627, 45.035, 0.0], [29.142, 44.82, 0.0], [28.838, 44.914, 0.0], [28.558, 43.707, 0.0], [27.97, 43.812, 0.0], [27.242, 44.176, 0.0], [26.065, 43.943, 0.0], [25.569, 43.688, 0.0], [24.101, 43.741, 0.0], [23.332, 43.897, 0.0], [22.945, 43.824, 0.0], [22.657, 44.235, 0.0], [22.474, 44.409, 0.0], [22.706, 44.578, 0.0], [22.459, 44.703, 0.0], [22.145, 44.478, 0.0], [21.562, 44.769, 0.0], [21.484, 45.181, 0.0], [20.874, 45.416, 0.0], [20.762, 45.735, 0.0], [20.22, 46.127, 0.0], [21.022, 46.316, 0.0], [21.627, 46.994, 0.0], [22.1, 47.672, 0.0], [22.711, 47.882, 0.0]
        ]]
      }
    },
    "RO",
    "ROU"
    ],
    [
      "Solomon Is.",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [162.119, -10.483, 0.0], [162.399, -10.826, 0.0], [161.7, -10.82, 0.0], [161.32, -10.205, 0.0], [161.917, -10.447, 0.0], [162.119, -10.483, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [160.852, -9.873, 0.0], [160.463, -9.895, 0.0], [159.849, -9.794, 0.0], [159.64, -9.64, 0.0], [159.703, -9.243, 0.0], [160.363, -9.4, 0.0], [160.689, -9.61, 0.0], [160.852, -9.873, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [161.68, -9.6, 0.0], [161.529, -9.784, 0.0], [160.788, -8.918, 0.0], [160.58, -8.32, 0.0], [160.92, -8.32, 0.0], [161.28, -9.12, 0.0], [161.68, -9.6, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [159.875, -8.337, 0.0], [159.917, -8.538, 0.0], [159.134, -8.114, 0.0], [158.586, -7.755, 0.0], [158.211, -7.422, 0.0], [158.36, -7.32, 0.0], [158.82, -7.56, 0.0], [159.64, -8.02, 0.0], [159.875, -8.337, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [157.538, -7.348, 0.0], [157.339, -7.405, 0.0], [156.902, -7.177, 0.0], [156.491, -6.766, 0.0], [156.543, -6.599, 0.0], [157.14, -7.022, 0.0], [157.538, -7.348, 0.0]
       ]
      ]
     }
    ]
    },
    "SB",
    "SLB"
    ],
    [
      "Slovenia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [13.806, 46.509, 0.0], [14.632, 46.432, 0.0], [15.137, 46.659, 0.0], [16.012, 46.684, 0.0], [16.202, 46.852, 0.0], [16.371, 46.841, 0.0], [16.565, 46.504, 0.0], [15.769, 46.238, 0.0], [15.672, 45.834, 0.0], [15.324, 45.732, 0.0], [15.328, 45.452, 0.0], [14.935, 45.472, 0.0], [14.595, 45.635, 0.0], [14.412, 45.466, 0.0], [13.715, 45.5, 0.0], [13.938, 45.591, 0.0], [13.698, 46.017, 0.0], [13.806, 46.509, 0.0]
        ]]
      }
    },
    "SI",
    "SVN"
    ],
    [
      "Vietnam",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [108.05, 21.552, 0.0], [106.715, 20.697, 0.0], [105.882, 19.752, 0.0], [105.662, 19.058, 0.0], [106.427, 18.004, 0.0], [107.362, 16.697, 0.0], [108.269, 16.08, 0.0], [108.877, 15.277, 0.0], [109.335, 13.426, 0.0], [109.2, 11.667, 0.0], [108.366, 11.008, 0.0], [107.221, 10.364, 0.0], [106.405, 9.531, 0.0], [105.158, 8.6, 0.0], [104.795, 9.241, 0.0], [105.076, 9.918, 0.0], [104.334, 10.487, 0.0], [105.2, 10.889, 0.0], [106.25, 10.962, 0.0], [105.811, 11.568, 0.0], [107.491, 12.337, 0.0], [107.615, 13.536, 0.0], [107.383, 14.202, 0.0], [107.565, 15.202, 0.0], [107.313, 15.909, 0.0], [106.556, 16.604, 0.0], [105.926, 17.485, 0.0], [105.095, 18.667, 0.0], [103.897, 19.265, 0.0], [104.183, 19.625, 0.0], [104.823, 19.887, 0.0], [104.435, 20.759, 0.0], [103.204, 20.767, 0.0], [102.755, 21.675, 0.0], [102.17, 22.465, 0.0], [102.707, 22.709, 0.0], [103.505, 22.704, 0.0], [104.477, 22.819, 0.0], [105.329, 23.352, 0.0], [105.811, 22.977, 0.0], [106.725, 22.794, 0.0], [106.567, 22.218, 0.0], [107.043, 21.812, 0.0], [108.05, 21.552, 0.0]
        ]]
      }
    },
    "VN",
    "VNM"
    ],
    [
      "Albania",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [20.59, 41.855, 0.0], [20.463, 41.515, 0.0], [20.605, 41.086, 0.0], [21.02, 40.843, 0.0], [21.0, 40.58, 0.0], [20.675, 40.435, 0.0], [20.615, 40.11, 0.0], [20.15, 39.625, 0.0], [19.98, 39.695, 0.0], [19.96, 39.915, 0.0], [19.406, 40.251, 0.0], [19.319, 40.727, 0.0], [19.404, 41.41, 0.0], [19.54, 41.72, 0.0], [19.372, 41.878, 0.0], [19.304, 42.196, 0.0], [19.738, 42.688, 0.0], [19.802, 42.5, 0.0], [20.071, 42.589, 0.0], [20.284, 42.32, 0.0], [20.523, 42.218, 0.0], [20.59, 41.855, 0.0]
        ]]
      }
    },
    "AL",
    "ALB"
    ],
    [
      "Australia",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [145.398, -40.793, 0.0], [146.364, -41.138, 0.0], [146.909, -41.001, 0.0], [147.689, -40.808, 0.0], [148.289, -40.875, 0.0], [148.36, -42.062, 0.0], [148.017, -42.407, 0.0], [147.914, -43.212, 0.0], [147.565, -42.938, 0.0], [146.87, -43.635, 0.0], [146.663, -43.581, 0.0], [146.048, -43.55, 0.0], [145.432, -42.694, 0.0], [145.295, -42.034, 0.0], [144.718, -41.163, 0.0], [144.744, -40.704, 0.0], [145.398, -40.793, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [143.562, -13.764, 0.0], [143.922, -14.548, 0.0], [144.564, -14.171, 0.0], [144.895, -14.594, 0.0], [145.375, -14.985, 0.0], [145.272, -15.428, 0.0], [145.485, -16.286, 0.0], [145.637, -16.785, 0.0], [145.889, -16.907, 0.0], [146.16, -17.762, 0.0], [146.064, -18.28, 0.0], [146.387, -18.958, 0.0], [147.471, -19.481, 0.0], [148.178, -19.956, 0.0], [148.848, -20.391, 0.0], [148.717, -20.633, 0.0], [149.289, -21.261, 0.0], [149.678, -22.343, 0.0], [150.077, -22.123, 0.0], [150.483, -22.556, 0.0], [150.727, -22.402, 0.0], [150.9, -23.462, 0.0], [151.609, -24.076, 0.0], [152.074, -24.458, 0.0], [152.855, -25.268, 0.0], [153.136, -26.071, 0.0], [153.162, -26.641, 0.0], [153.093, -27.26, 0.0], [153.569, -28.11, 0.0], [153.512, -28.995, 0.0], [153.339, -29.458, 0.0], [153.069, -30.35, 0.0], [153.09, -30.924, 0.0], [152.892, -31.64, 0.0], [152.45, -32.55, 0.0], [151.709, -33.041, 0.0], [151.344, -33.816, 0.0], [151.011, -34.31, 0.0], [150.714, -35.173, 0.0], [150.328, -35.672, 0.0], [150.075, -36.42, 0.0], [149.946, -37.109, 0.0], [149.997, -37.425, 0.0], [149.424, -37.773, 0.0], [148.305, -37.809, 0.0], [147.382, -38.219, 0.0], [146.922, -38.607, 0.0], [146.318, -39.036, 0.0], [145.49, -38.594, 0.0], [144.877, -38.417, 0.0], [145.032, -37.896, 0.0], [144.486, -38.085, 0.0], [143.61, -38.809, 0.0], [142.745, -38.538, 0.0], [142.178, -38.38, 0.0], [141.607, -38.309, 0.0], [140.639, -38.019, 0.0], [139.992, -37.403, 0.0], [139.807, -36.644, 0.0], [139.574, -36.138, 0.0], [139.083, -35.733, 0.0], [138.121, -35.612, 0.0], [138.449, -35.127, 0.0], [138.208, -34.385, 0.0], [137.719, -35.077, 0.0], [136.829, -35.261, 0.0], [137.352, -34.707, 0.0], [137.504, -34.13, 0.0], [137.89, -33.64, 0.0], [137.81, -32.9, 0.0], [136.997, -33.753, 0.0], [136.372, -34.095, 0.0], [135.989, -34.89, 0.0], [135.208, -34.479, 0.0], [135.239, -33.948, 0.0], [134.613, -33.223, 0.0], [134.086, -32.848, 0.0], [134.274, -32.617, 0.0], [132.991, -32.011, 0.0], [132.288, -31.983, 0.0], [131.326, -31.496, 0.0], [129.536, -31.59, 0.0], [128.241, -31.948, 0.0], [127.103, -32.282, 0.0], [126.149, -32.216, 0.0], [125.089, -32.729, 0.0], [124.222, -32.959, 0.0], [124.029, -33.484, 0.0], [123.66, -33.89, 0.0], [122.811, -33.914, 0.0], [122.183, -34.003, 0.0], [121.299, -33.821, 0.0], [120.58, -33.93, 0.0], [119.894, -33.976, 0.0], [119.299, -34.509, 0.0], [119.007, -34.464, 0.0], [118.506, -34.747, 0.0], [118.025, -35.065, 0.0], [117.296, -35.025, 0.0], [116.625, -35.025, 0.0], [115.564, -34.386, 0.0], [115.027, -34.197, 0.0], [115.049, -33.623, 0.0], [115.545, -33.487, 0.0], [115.715, -33.26, 0.0], [115.679, -32.9, 0.0], [115.802, -32.205, 0.0], [115.69, -31.612, 0.0], [115.161, -30.602, 0.0], [114.997, -30.031, 0.0], [115.04, -29.461, 0.0], [114.642, -28.81, 0.0], [114.616, -28.516, 0.0], [114.174, -28.118, 0.0], [114.049, -27.335, 0.0], [113.477, -26.543, 0.0], [113.339, -26.117, 0.0], [113.778, -26.549, 0.0], [113.441, -25.621, 0.0], [113.937, -25.911, 0.0], [114.233, -26.298, 0.0], [114.216, -25.786, 0.0], [113.721, -24.999, 0.0], [113.625, -24.684, 0.0], [113.394, -24.385, 0.0], [113.502, -23.806, 0.0], [113.707, -23.56, 0.0], [113.843, -23.06, 0.0], [113.737, -22.475, 0.0], [114.15, -21.756, 0.0], [114.225, -22.517, 0.0], [114.648, -21.83, 0.0], [115.46, -21.495, 0.0], [115.947, -21.069, 0.0], [116.712, -20.702, 0.0], [117.166, -20.624, 0.0], [117.442, -20.747, 0.0], [118.23, -20.374, 0.0], [118.836, -20.263, 0.0], [118.988, -20.044, 0.0], [119.252, -19.953, 0.0], [119.805, -19.977, 0.0], [120.856, -19.684, 0.0], [121.4, -19.24, 0.0], [121.655, -18.705, 0.0], [122.242, -18.198, 0.0], [122.287, -17.799, 0.0], [122.313, -17.255, 0.0], [123.013, -16.405, 0.0], [123.434, -17.269, 0.0], [123.859, -17.069, 0.0], [123.503, -16.597, 0.0], [123.817, -16.111, 0.0], [124.258, -16.328, 0.0], [124.38, -15.567, 0.0], [124.926, -15.075, 0.0], [125.167, -14.68, 0.0], [125.67, -14.51, 0.0], [125.686, -14.231, 0.0], [126.125, -14.347, 0.0], [126.143, -14.096, 0.0], [126.583, -13.953, 0.0], [127.066, -13.818, 0.0], [127.805, -14.277, 0.0], [128.36, -14.869, 0.0], [128.986, -14.876, 0.0], [129.621, -14.97, 0.0], [129.41, -14.421, 0.0], [129.889, -13.619, 0.0], [130.339, -13.357, 0.0], [130.184, -13.108, 0.0], [130.618, -12.536, 0.0], [131.223, -12.184, 0.0], [131.735, -12.302, 0.0], [132.575, -12.114, 0.0], [132.557, -11.603, 0.0], [131.825, -11.274, 0.0], [132.357, -11.129, 0.0], [133.02, -11.376, 0.0], [133.551, -11.787, 0.0], [134.393, -12.042, 0.0], [134.679, -11.941, 0.0], [135.298, -12.249, 0.0], [135.883, -11.962, 0.0], [136.258, -12.049, 0.0], [136.492, -11.857, 0.0], [136.952, -12.352, 0.0], [136.685, -12.887, 0.0], [136.305, -13.291, 0.0], [135.962, -13.325, 0.0], [136.078, -13.724, 0.0], [135.784, -14.224, 0.0], [135.429, -14.715, 0.0], [135.5, -14.998, 0.0], [136.295, -15.55, 0.0], [137.065, -15.871, 0.0], [137.58, -16.215, 0.0], [138.303, -16.808, 0.0], [138.585, -16.807, 0.0], [139.109, -17.063, 0.0], [139.261, -17.372, 0.0], [140.215, -17.711, 0.0], [140.875, -17.369, 0.0], [141.071, -16.832, 0.0], [141.274, -16.389, 0.0], [141.398, -15.841, 0.0], [141.702, -15.045, 0.0], [141.563, -14.561, 0.0], [141.636, -14.27, 0.0], [141.52, -13.698, 0.0], [141.651, -12.945, 0.0], [141.843, -12.742, 0.0], [141.687, -12.408, 0.0], [141.929, -11.877, 0.0], [142.118, -11.328, 0.0], [142.144, -11.043, 0.0], [142.515, -10.668, 0.0], [142.797, -11.157, 0.0], [142.867, -11.785, 0.0], [143.116, -11.906, 0.0], [143.159, -12.326, 0.0], [143.522, -12.834, 0.0], [143.597, -13.4, 0.0], [143.562, -13.764, 0.0]
       ]
      ]
     }
    ]
    },
    "AU",
    "AUS"
    ],
    [
      "Azerbaijan",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [45.002, 39.74, 0.0], [45.298, 39.472, 0.0], [45.74, 39.474, 0.0], [45.735, 39.32, 0.0], [46.144, 38.741, 0.0], [45.458, 38.874, 0.0], [44.953, 39.336, 0.0], [44.794, 39.713, 0.0], [45.002, 39.74, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [47.373, 41.22, 0.0], [47.816, 41.151, 0.0], [47.987, 41.406, 0.0], [48.584, 41.809, 0.0], [49.11, 41.282, 0.0], [49.619, 40.573, 0.0], [50.085, 40.526, 0.0], [50.393, 40.257, 0.0], [49.569, 40.176, 0.0], [49.395, 39.399, 0.0], [49.223, 39.049, 0.0], [48.857, 38.815, 0.0], [48.883, 38.32, 0.0], [48.634, 38.27, 0.0], [48.011, 38.794, 0.0], [48.356, 39.289, 0.0], [48.06, 39.582, 0.0], [47.685, 39.508, 0.0], [46.506, 38.771, 0.0], [46.483, 39.464, 0.0], [46.035, 39.628, 0.0], [45.61, 39.9, 0.0], [45.892, 40.218, 0.0], [45.359, 40.562, 0.0], [45.56, 40.812, 0.0], [45.179, 40.985, 0.0], [44.972, 41.248, 0.0], [45.217, 41.411, 0.0], [45.963, 41.124, 0.0], [46.502, 41.064, 0.0], [46.638, 41.182, 0.0], [46.145, 41.723, 0.0], [46.405, 41.861, 0.0], [46.686, 41.827, 0.0], [47.373, 41.22, 0.0]
       ]
      ]
     }
    ]
    },
    "AZ",
    "AZE"
    ],
    [
      "Belgium",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [3.315, 51.346, 0.0], [4.047, 51.267, 0.0], [4.974, 51.475, 0.0], [5.607, 51.037, 0.0], [6.157, 50.804, 0.0], [6.043, 50.128, 0.0], [5.782, 50.09, 0.0], [5.674, 49.529, 0.0], [4.799, 49.985, 0.0], [4.286, 49.907, 0.0], [3.588, 50.379, 0.0], [3.123, 50.78, 0.0], [2.658, 50.797, 0.0], [2.514, 51.149, 0.0], [3.315, 51.346, 0.0]
        ]]
      }
    },
    "BE",
    "BEL"
    ],
    [
      "Switzerland",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [9.594, 47.525, 0.0], [9.633, 47.348, 0.0], [9.48, 47.103, 0.0], [9.932, 46.921, 0.0], [10.443, 46.894, 0.0], [10.363, 46.484, 0.0], [9.923, 46.315, 0.0], [9.183, 46.44, 0.0], [8.966, 46.037, 0.0], [8.49, 46.005, 0.0], [8.317, 46.164, 0.0], [7.756, 45.824, 0.0], [7.274, 45.777, 0.0], [6.844, 45.991, 0.0], [6.5, 46.43, 0.0], [6.023, 46.273, 0.0], [6.037, 46.726, 0.0], [6.769, 47.288, 0.0], [6.737, 47.542, 0.0], [7.192, 47.45, 0.0], [7.467, 47.621, 0.0], [8.317, 47.614, 0.0], [8.523, 47.831, 0.0], [9.594, 47.525, 0.0]
        ]]
      }
    },
    "CH",
    "CHE"
    ],
    [
      "Congo (Brazzaville)",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [12.996, -4.781, 0.0], [12.621, -4.438, 0.0], [12.319, -4.606, 0.0], [11.915, -5.038, 0.0], [11.094, -3.979, 0.0], [11.855, -3.427, 0.0], [11.478, -2.766, 0.0], [11.821, -2.514, 0.0], [12.496, -2.392, 0.0], [12.575, -1.949, 0.0], [13.11, -2.429, 0.0], [13.992, -2.471, 0.0], [14.299, -1.998, 0.0], [14.425, -1.333, 0.0], [14.316, -0.553, 0.0],[ 13.843, 0.039, 0.0], [14.276, 1.197, 0.0], [14.027, 1.396, 0.0], [13.283, 1.314, 0.0], [13.003, 1.831, 0.0], [13.076, 2.267, 0.0], [14.338, 2.228, 0.0], [15.146, 1.964, 0.0], [15.941, 1.728, 0.0], [16.013, 2.268, 0.0], [16.537, 3.198, 0.0], [17.133, 3.728, 0.0], [17.81, 3.56, 0.0], [18.453, 3.504, 0.0], [18.394, 2.9, 0.0], [18.094, 2.366, 0.0], [17.899, 1.742, 0.0], [17.774, 0.856, 0.0], [17.827, 0.289, 0.0], [17.664, -0.058, 0.0], [17.639, -0.425, 0.0], [17.524, -0.744, 0.0], [16.865, -1.226, 0.0], [16.407, -1.741, 0.0], [15.973, -2.712, 0.0], [16.006, -3.535, 0.0], [15.754, -3.855, 0.0], [15.171, -4.344, 0.0], [14.583, -4.97, 0.0], [14.209, -4.793, 0.0], [14.145, -4.51, 0.0], [13.6, -4.5, 0.0], [13.258, -4.883, 0.0], [12.996, -4.781, 0.0]
        ]]
      }
    },
    "CG",
    "COG"
    ],
    [
      "Costa Rica",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-82.966, 8.225, 0.0], [-83.508, 8.447, 0.0], [-83.711, 8.657, 0.0], [-83.596, 8.83, 0.0], [-83.633, 9.051, 0.0], [-83.91, 9.291, 0.0], [-84.303, 9.487, 0.0], [-84.648, 9.616, 0.0], [-84.713, 9.908, 0.0], [-84.976, 10.087, 0.0], [-84.911, 9.796, 0.0], [-85.111, 9.557, 0.0], [-85.339, 9.835, 0.0], [-85.661, 9.933, 0.0], [-85.797, 10.135, 0.0], [-85.792, 10.439, 0.0], [-85.659, 10.754, 0.0], [-85.942, 10.895, 0.0], [-85.713, 11.088, 0.0], [-85.562, 11.217, 0.0], [-84.903, 10.952, 0.0], [-84.673, 11.083, 0.0], [-84.356, 10.999, 0.0], [-84.19, 10.793, 0.0], [-83.895, 10.727, 0.0], [-83.656, 10.939, 0.0], [-83.402, 10.395, 0.0], [-83.016, 9.993, 0.0], [-82.546, 9.566, 0.0], [-82.933, 9.477, 0.0], [-82.927, 9.074, 0.0], [-82.719, 8.926, 0.0], [-82.869, 8.807, 0.0], [-82.83, 8.626, 0.0], [-82.913, 8.424, 0.0], [-82.966, 8.225, 0.0]
        ]]
      }
    },
    "CR",
    "CRI"
    ],
    [
      "N. Cyprus",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [32.732, 35.14, 0.0], [32.802, 35.146, 0.0], [32.947, 35.387, 0.0], [33.667, 35.373, 0.0], [34.576, 35.672, 0.0], [33.901, 35.246, 0.0], [33.974, 35.059, 0.0], [33.866, 35.094, 0.0], [33.675, 35.018, 0.0], [33.526, 35.039, 0.0], [33.476, 35.0, 0.0], [33.456, 35.101, 0.0], [33.384, 35.163, 0.0], [33.191, 35.173, 0.0], [32.92, 35.088, 0.0], [32.732, 35.14, 0.0]
        ]]
      }
    },
    "-99",
    "-99"
    ],
    [
      "France",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-52.556, 2.505, 0.0], [-52.94, 2.125, 0.0], [-53.418, 2.053, 0.0], [-53.555, 2.335, 0.0], [-53.779, 2.377, 0.0], [-54.088, 2.106, 0.0], [-54.525, 2.312, 0.0], [-54.271, 2.739, 0.0], [-54.184, 3.194, 0.0], [-54.012, 3.623, 0.0], [-54.4, 4.213, 0.0], [-54.479, 4.897, 0.0], [-53.958, 5.757, 0.0], [-53.618, 5.647, 0.0], [-52.882, 5.41, 0.0], [-51.823, 4.566, 0.0], [-51.658, 4.156, 0.0], [-52.249, 3.241, 0.0], [-52.556, 2.505, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [9.56, 42.152, 0.0], [9.23, 41.38, 0.0], [8.776, 41.584, 0.0], [8.544, 42.257, 0.0], [8.746, 42.628, 0.0], [9.39, 43.01, 0.0], [9.56, 42.152, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [3.588, 50.379, 0.0], [4.286, 49.907, 0.0], [4.799, 49.985, 0.0], [5.674, 49.529, 0.0], [5.898, 49.443, 0.0], [6.186, 49.464, 0.0], [6.658, 49.202, 0.0], [8.099, 49.018, 0.0], [7.594, 48.333, 0.0], [7.467, 47.621, 0.0], [7.192, 47.45, 0.0], [6.737, 47.542, 0.0], [6.769, 47.288, 0.0], [6.037, 46.726, 0.0], [6.023, 46.273, 0.0], [6.5, 46.43, 0.0], [6.844, 45.991, 0.0], [6.802, 45.709, 0.0], [7.097, 45.333, 0.0], [6.75, 45.029, 0.0], [7.008, 44.255, 0.0], [7.55, 44.128, 0.0], [7.435, 43.694, 0.0], [6.529, 43.129, 0.0], [4.557, 43.4, 0.0], [3.1, 43.075, 0.0], [2.986, 42.473, 0.0], [1.827, 42.343, 0.0], [0.702, 42.796, 0.0], [0.338, 42.58, 0.0], [-1.503, 43.034, 0.0], [-1.901, 43.423, 0.0], [-1.384, 44.023, 0.0], [-1.194, 46.015, 0.0], [-2.226, 47.064, 0.0], [-2.963, 47.57, 0.0], [-4.492, 47.955, 0.0], [-4.592, 48.684, 0.0], [-3.296, 48.902, 0.0], [-1.617, 48.644, 0.0], [-1.933, 49.776, 0.0], [-0.989, 49.347, 0.0], [1.339, 50.127, 0.0], [1.639, 50.947, 0.0], [2.514, 51.149, 0.0], [2.658, 50.797, 0.0], [3.123, 50.78, 0.0], [3.588, 50.379, 0.0]
       ]
      ]
     }
    ]
    },
    "FR",
    "FRA"
    ],
    [
      "Guyana",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-59.758, 8.367, 0.0], [-59.102, 7.999, 0.0], [-58.483, 7.348, 0.0], [-58.455, 6.833, 0.0], [-58.078, 6.809, 0.0], [-57.542, 6.321, 0.0], [-57.147, 5.973, 0.0], [-57.307, 5.074, 0.0], [-57.914, 4.813, 0.0], [-57.86, 4.577, 0.0], [-58.045, 4.061, 0.0], [-57.602, 3.335, 0.0], [-57.281, 3.333, 0.0], [-57.15, 2.769, 0.0], [-56.539, 1.9, 0.0], [-56.783, 1.864, 0.0], [-57.336, 1.949, 0.0], [-57.661, 1.683, 0.0], [-58.113, 1.507, 0.0], [-58.429, 1.464, 0.0], [-58.54, 1.268, 0.0], [-59.031, 1.318, 0.0], [-59.646, 1.787, 0.0], [-59.719, 2.25, 0.0], [-59.975, 2.755, 0.0], [-59.815, 3.606, 0.0], [-59.538, 3.959, 0.0], [-59.767, 4.424, 0.0], [-60.111, 4.575, 0.0], [-59.981, 5.014, 0.0], [-60.214, 5.244, 0.0], [-60.734, 5.2, 0.0], [-61.41, 5.959, 0.0], [-61.139, 6.234, 0.0], [-61.159, 6.696, 0.0], [-60.544, 6.857, 0.0], [-60.296, 7.044, 0.0], [-60.638, 7.415, 0.0], [-60.551, 7.78, 0.0], [-59.758, 8.367, 0.0]
        ]]
      }
    },
    "GY",
    "GUY"
    ],
    [
      "Luxembourg",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [6.043, 50.128, 0.0], [6.243, 49.902, 0.0], [6.186, 49.464, 0.0], [5.898, 49.443, 0.0], [5.674, 49.529, 0.0], [5.782, 50.09, 0.0], [6.043, 50.128, 0.0]
        ]]
      }
    },
    "LU",
    "LUX"
    ],
    [
      "Latvia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [21.056, 56.031, 0.0], [21.09, 56.784, 0.0], [21.582, 57.412, 0.0], [22.524, 57.753, 0.0], [23.318, 57.006, 0.0], [24.121, 57.026, 0.0], [24.313, 57.793, 0.0], [25.165, 57.97, 0.0], [25.603, 57.848, 0.0], [26.464, 57.476, 0.0], [27.288, 57.475, 0.0], [27.77, 57.244, 0.0], [27.855, 56.759, 0.0], [28.177, 56.169, 0.0], [27.102, 55.783, 0.0], [26.494, 55.615, 0.0], [25.533, 56.1, 0.0], [25.001, 56.165, 0.0], [24.861, 56.373, 0.0], [23.878, 56.274, 0.0], [22.201, 56.338, 0.0], [21.056, 56.031, 0.0]
        ]]
      }
    },
    "LV",
    "LVA"
    ],
    [
      "Madagascar",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [49.544, -12.47, 0.0], [49.809, -12.895, 0.0], [50.057, -13.556, 0.0], [50.217, -14.759, 0.0], [50.477, -15.227, 0.0], [50.377, -15.706, 0.0], [50.2, -16.0, 0.0], [49.861, -15.414, 0.0], [49.673, -15.71, 0.0], [49.863, -16.451, 0.0], [49.775, -16.875, 0.0], [49.499, -17.106, 0.0], [49.436, -17.953, 0.0], [49.042, -19.119, 0.0], [48.549, -20.497, 0.0], [47.931, -22.392, 0.0], [47.548, -23.782, 0.0], [47.096, -24.942, 0.0], [46.282, -25.178, 0.0], [45.41, -25.601, 0.0], [44.834, -25.346, 0.0], [44.04, -24.988, 0.0], [43.764, -24.461, 0.0], [43.698, -23.574, 0.0], [43.346, -22.777, 0.0], [43.254, -22.057, 0.0], [43.433, -21.336, 0.0], [43.894, -21.163, 0.0], [43.896, -20.83, 0.0], [44.374, -20.072, 0.0], [44.464, -19.435, 0.0], [44.232, -18.962, 0.0], [44.043, -18.331, 0.0], [43.963, -17.41, 0.0], [44.312, -16.85, 0.0], [44.447, -16.216, 0.0], [44.945, -16.179, 0.0], [45.503, -15.974, 0.0], [45.873, -15.793, 0.0], [46.312, -15.78, 0.0], [46.882, -15.21, 0.0], [47.705, -14.594, 0.0], [48.005, -14.091, 0.0], [47.869, -13.664, 0.0], [48.294, -13.784, 0.0], [48.845, -13.089, 0.0], [48.864, -12.488, 0.0], [49.195, -12.041, 0.0], [49.544, -12.47, 0.0]
        ]]
      }
    },
    "MG",
    "MDG"
    ],
    [
      "Mali",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-12.171, 14.617, 0.0], [-11.834, 14.799, 0.0], [-11.666, 15.388, 0.0], [-11.349, 15.411, 0.0], [-10.651, 15.133, 0.0], [-10.087, 15.33, 0.0], [-9.7, 15.264, 0.0], [-9.55, 15.486, 0.0], [-5.538, 15.502, 0.0], [-5.315, 16.202, 0.0], [-5.489, 16.325, 0.0], [-5.971, 20.641, 0.0], [-6.454, 24.957, 0.0], [-4.923, 24.975, 0.0], [-1.55, 22.793, 0.0], [1.823, 20.611, 0.0], [2.061, 20.142, 0.0], [2.684, 19.856, 0.0], [3.147, 19.694, 0.0], [3.158, 19.057, 0.0], [4.267, 19.155, 0.0], [4.27, 16.852, 0.0], [3.723, 16.184, 0.0], [3.638, 15.568, 0.0], [2.75, 15.41, 0.0], [1.386, 15.324, 0.0], [1.016, 14.968, 0.0], [0.375, 14.929, 0.0], [-0.266, 14.924, 0.0], [-0.516, 15.116, 0.0], [-1.066, 14.974, 0.0], [-2.001, 14.559, 0.0], [-2.192, 14.246, 0.0], [-2.968, 13.798, 0.0], [-3.104, 13.541, 0.0], [-3.523, 13.338, 0.0], [-4.006, 13.472, 0.0], [-4.28, 13.228, 0.0], [-4.427, 12.543, 0.0], [-5.221, 11.714, 0.0], [-5.198, 11.375, 0.0], [-5.471, 10.951, 0.0], [-5.404, 10.371, 0.0], [-5.817, 10.223, 0.0], [-6.05, 10.096, 0.0], [-6.205, 10.524, 0.0], [-6.494, 10.411, 0.0], [-6.666, 10.431, 0.0], [-6.851, 10.139, 0.0], [-7.623, 10.147, 0.0], [-7.9, 10.297, 0.0], [-8.03, 10.207, 0.0], [-8.335, 10.495, 0.0], [-8.282, 10.793, 0.0], [-8.407, 10.909, 0.0], [-8.62, 10.811, 0.0], [-8.581, 11.136, 0.0], [-8.376, 11.394, 0.0], [-8.786, 11.813, 0.0], [-8.905, 12.088, 0.0], [-9.127, 12.308, 0.0], [-9.328, 12.334, 0.0], [-9.568, 12.194, 0.0], [-9.891, 12.06, 0.0], [-10.165, 11.844, 0.0], [-10.593, 11.924, 0.0], [-10.871, 12.178, 0.0], [-11.037, 12.211, 0.0], [-11.298, 12.078, 0.0], [-11.456, 12.077, 0.0], [-11.514, 12.443, 0.0], [-11.468, 12.755, 0.0], [-11.553, 13.141, 0.0], [-11.928, 13.422, 0.0], [-12.125, 13.995, 0.0], [-12.171, 14.617, 0.0]
        ]]
      }
    },
    "ML",
    "MLI"
    ],
    [
      "Mozambique",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [34.56, -11.52, 0.0], [35.312, -11.439, 0.0], [36.514, -11.721, 0.0], [36.775, -11.595, 0.0], [37.471, -11.569, 0.0], [37.828, -11.269, 0.0], [38.428, -11.285, 0.0], [39.521, -10.897, 0.0], [40.317, -10.317, 0.0], [40.478, -10.765, 0.0], [40.437, -11.762, 0.0], [40.561, -12.639, 0.0], [40.6, -14.202, 0.0], [40.775, -14.692, 0.0], [40.477, -15.406, 0.0], [40.089, -16.101, 0.0], [39.453, -16.721, 0.0], [38.538, -17.101, 0.0], [37.411, -17.586, 0.0], [36.281, -18.66, 0.0], [35.896, -18.842, 0.0], [35.198, -19.553, 0.0], [34.786, -19.784, 0.0], [34.702, -20.497, 0.0], [35.176, -21.254, 0.0], [35.373, -21.841, 0.0], [35.386, -22.14, 0.0], [35.563, -22.09, 0.0], [35.534, -23.071, 0.0], [35.372, -23.535, 0.0], [35.607, -23.707, 0.0], [35.459, -24.123, 0.0], [35.041, -24.478, 0.0], [34.216, -24.816, 0.0], [33.013, -25.358, 0.0], [32.575, -25.727, 0.0], [32.66, -26.149, 0.0], [32.916, -26.216, 0.0], [32.83, -26.742, 0.0], [32.072, -26.734, 0.0], [31.986, -26.292, 0.0], [31.838, -25.843, 0.0], [31.752, -25.484, 0.0], [31.931, -24.369, 0.0], [31.67, -23.659, 0.0], [31.191, -22.252, 0.0], [32.245, -21.116, 0.0], [32.509, -20.395, 0.0], [32.66, -20.304, 0.0], [32.773, -19.716, 0.0], [32.612, -19.419, 0.0], [32.655, -18.672, 0.0], [32.85, -17.979, 0.0], [32.848, -16.713, 0.0], [32.328, -16.392, 0.0], [31.852, -16.319, 0.0], [31.636, -16.072, 0.0], [31.173, -15.861, 0.0], [30.339, -15.881, 0.0], [30.274, -15.508, 0.0], [30.179, -14.796, 0.0], [33.214, -13.972, 0.0], [33.79, -14.452, 0.0], [34.065, -14.36, 0.0], [34.46, -14.613, 0.0], [34.518, -15.014, 0.0], [34.307, -15.479, 0.0], [34.381, -16.184, 0.0], [35.034, -16.801, 0.0], [35.339, -16.107, 0.0], [35.772, -15.897, 0.0], [35.687, -14.611, 0.0], [35.268, -13.888, 0.0], [34.907, -13.565, 0.0], [34.56, -13.58, 0.0], [34.28, -12.28, 0.0], [34.56, -11.52, 0.0]
        ]]
      }
    },
    "MZ",
    "MOZ"
    ],
    [
      "Saudi Arabia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [42.779, 16.348, 0.0], [42.65, 16.775, 0.0], [42.348, 17.076, 0.0], [42.271, 17.475, 0.0], [41.754, 17.833, 0.0], [41.221, 18.672, 0.0], [40.939, 19.486, 0.0], [40.248, 20.175, 0.0], [39.802, 20.339, 0.0], [39.139, 21.292, 0.0], [39.024, 21.987, 0.0], [39.066, 22.58, 0.0], [38.493, 23.688, 0.0], [38.024, 24.079, 0.0], [37.484, 24.285, 0.0], [37.155, 24.858, 0.0], [37.209, 25.085, 0.0], [36.932, 25.603, 0.0], [36.64, 25.826, 0.0], [36.249, 26.57, 0.0], [35.64, 27.377, 0.0], [35.13, 28.063, 0.0], [34.632, 28.059, 0.0], [34.788, 28.607, 0.0], [34.832, 28.957, 0.0], [34.956, 29.357, 0.0], [36.069, 29.197, 0.0], [36.501, 29.505, 0.0], [36.741, 29.865, 0.0], [37.504, 30.004, 0.0], [37.668, 30.339, 0.0], [37.999, 30.508, 0.0], [37.002, 31.508, 0.0], [39.005, 32.01, 0.0], [39.195, 32.161, 0.0], [40.4, 31.89, 0.0], [41.89, 31.19, 0.0], [44.709, 29.179, 0.0], [46.569, 29.099, 0.0], [47.46, 29.003, 0.0], [47.709, 28.526, 0.0], [48.416, 28.552, 0.0], [48.808, 27.69, 0.0], [49.3, 27.461, 0.0], [49.471, 27.11, 0.0], [50.152, 26.69, 0.0], [50.213, 26.277, 0.0], [50.113, 25.944, 0.0], [50.24, 25.608, 0.0], [50.527, 25.328, 0.0], [50.661, 25.0, 0.0], [50.81, 24.755, 0.0], [51.112, 24.556, 0.0], [51.39, 24.627, 0.0], [51.58, 24.245, 0.0], [51.618, 24.014, 0.0], [52.001, 23.001, 0.0], [55.007, 22.497, 0.0], [55.208, 22.708, 0.0], [55.667, 22.0, 0.0], [55.0, 20.0, 0.0], [52.0, 19.0, 0.0], [49.117, 18.617, 0.0], [48.183, 18.167, 0.0], [47.467, 17.117, 0.0], [47.0, 16.95, 0.0], [46.75, 17.283, 0.0], [46.367, 17.233, 0.0], [45.4, 17.333, 0.0], [45.217, 17.433, 0.0], [44.063, 17.41, 0.0], [43.792, 17.32, 0.0], [43.381, 17.58, 0.0], [43.116, 17.088, 0.0], [43.218, 16.667, 0.0], [42.779, 16.348, 0.0]
        ]]
      }
    },
    "SA",
    "SAU"
    ],
    [
      "Slovakia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [18.853, 49.496, 0.0], [18.91, 49.436, 0.0], [19.321, 49.572, 0.0], [19.825, 49.217, 0.0], [20.416, 49.431, 0.0], [20.888, 49.329, 0.0], [21.608, 49.47, 0.0], [22.558, 49.086, 0.0], [22.281, 48.825, 0.0], [22.086, 48.422, 0.0], [21.872, 48.32, 0.0], [20.801, 48.624, 0.0], [20.474, 48.563, 0.0], [20.239, 48.328, 0.0], [19.769, 48.203, 0.0], [19.661, 48.267, 0.0], [19.174, 48.111, 0.0], [18.777, 48.082, 0.0], [18.697, 47.881, 0.0], [17.857, 47.758, 0.0], [17.488, 47.867, 0.0], [16.98, 48.123, 0.0], [16.88, 48.47, 0.0], [16.96, 48.597, 0.0], [17.102, 48.817, 0.0], [17.545, 48.8, 0.0], [17.886, 48.903, 0.0], [17.914, 48.996, 0.0], [18.105, 49.044, 0.0], [18.17, 49.272, 0.0], [18.4, 49.315, 0.0], [18.555, 49.495, 0.0], [18.853, 49.496, 0.0]
        ]]
      }
    },
    "SK",
    "SVK"
    ],
    [
      "Syria",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [38.792, 33.379, 0.0], [36.834, 32.313, 0.0], [35.72, 32.709, 0.0], [35.701, 32.716, 0.0], [35.836, 32.868, 0.0], [35.821, 33.277, 0.0], [36.066, 33.825, 0.0], [36.612, 34.202, 0.0], [36.448, 34.594, 0.0], [35.998, 34.645, 0.0], [35.905, 35.41, 0.0], [36.15, 35.822, 0.0], [36.418, 36.041, 0.0], [36.685, 36.26, 0.0], [36.739, 36.818, 0.0], [37.067, 36.623, 0.0], [38.168, 36.901, 0.0], [38.7, 36.713, 0.0], [39.523, 36.716, 0.0], [40.673, 37.091, 0.0], [41.212, 37.074, 0.0], [42.35, 37.23, 0.0], [41.837, 36.606, 0.0], [41.29, 36.359, 0.0], [41.384, 35.628, 0.0], [41.006, 34.419, 0.0], [38.792, 33.379, 0.0]
        ]]
      }
    },
    "SY",
    "SYR"
    ],
    [
      "Thailand",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [102.585, 12.187, 0.0], [101.687, 12.646, 0.0], [100.832, 12.627, 0.0], [100.978, 13.413, 0.0], [100.098, 13.407, 0.0], [100.019, 12.307, 0.0], [99.479, 10.846, 0.0], [99.154, 9.963, 0.0], [99.222, 9.239, 0.0], [99.874, 9.208, 0.0], [100.28, 8.295, 0.0], [100.459, 7.43, 0.0], [101.017, 6.857, 0.0], [101.623, 6.741, 0.0], [102.141, 6.222, 0.0], [101.814, 5.811, 0.0], [101.154, 5.691, 0.0], [101.076, 6.205, 0.0], [100.26, 6.643, 0.0], [100.086, 6.464, 0.0], [99.691, 6.848, 0.0], [99.52, 7.343, 0.0], [98.988, 7.908, 0.0], [98.504, 8.382, 0.0], [98.34, 7.795, 0.0], [98.15, 8.35, 0.0], [98.259, 8.974, 0.0], [98.554, 9.933, 0.0], [99.038, 10.961, 0.0], [99.587, 11.893, 0.0], [99.196, 12.805, 0.0], [99.212, 13.269, 0.0], [99.098, 13.828, 0.0], [98.431, 14.622, 0.0], [98.192, 15.124, 0.0], [98.537, 15.308, 0.0], [98.903, 16.178, 0.0], [98.494, 16.838, 0.0], [97.859, 17.568, 0.0], [97.376, 18.445, 0.0], [97.798, 18.627, 0.0], [98.254, 19.708, 0.0], [98.96, 19.753, 0.0], [99.543, 20.187, 0.0], [100.116, 20.418, 0.0], [100.549, 20.109, 0.0], [100.606, 19.508, 0.0], [101.282, 19.463, 0.0], [101.036, 18.409, 0.0], [101.06, 17.512, 0.0], [102.114, 18.109, 0.0], [102.413, 17.933, 0.0], [102.999, 17.962, 0.0], [103.2, 18.31, 0.0], [103.956, 18.241, 0.0], [104.717, 17.429, 0.0], [104.779, 16.442, 0.0], [105.589, 15.57, 0.0], [105.544, 14.724, 0.0], [105.219, 14.273, 0.0], [104.281, 14.417, 0.0], [102.988, 14.226, 0.0], [102.348, 13.394, 0.0], [102.585, 12.187, 0.0]
        ]]
      }
    },
    "TH",
    "THA"
    ],
    [
      "Uzbekistan",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [66.519, 37.363, 0.0], [66.546, 37.975, 0.0], [65.216, 38.403, 0.0], [64.17, 38.892, 0.0], [63.518, 39.363, 0.0], [62.374, 40.054, 0.0], [61.883, 41.085, 0.0], [61.547, 41.266, 0.0], [60.466, 41.22, 0.0], [60.083, 41.425, 0.0], [59.976, 42.223, 0.0], [58.629, 42.752, 0.0], [57.787, 42.171, 0.0], [56.932, 41.826, 0.0], [57.096, 41.322, 0.0], [55.968, 41.309, 0.0], [55.929, 44.996, 0.0], [58.503, 45.587, 0.0], [58.69, 45.5, 0.0], [60.24, 44.784, 0.0], [61.058, 44.406, 0.0], [62.013, 43.504, 0.0], [63.186, 43.65, 0.0], [64.901, 43.728, 0.0], [66.098, 42.998, 0.0], [66.023, 41.995, 0.0], [66.511, 41.988, 0.0], [66.714, 41.168, 0.0], [67.986, 41.136, 0.0], [68.26, 40.662, 0.0], [68.632, 40.669, 0.0], [69.07, 41.384, 0.0], [70.389, 42.081, 0.0], [70.962, 42.266, 0.0], [71.259, 42.168, 0.0], [70.42, 41.52, 0.0], [71.158, 41.144, 0.0], [71.87, 41.393, 0.0], [73.055, 40.866, 0.0], [71.775, 40.146, 0.0], [71.014, 40.244, 0.0], [70.601, 40.219, 0.0], [70.458, 40.496, 0.0], [70.667, 40.96, 0.0], [69.329, 40.728, 0.0], [69.012, 40.086, 0.0], [68.536, 39.533, 0.0], [67.701, 39.58, 0.0], [67.442, 39.14, 0.0], [68.176, 38.902, 0.0], [68.392, 38.157, 0.0], [67.83, 37.145, 0.0], [67.076, 37.356, 0.0], [66.519, 37.363, 0.0]
        ]]
      }
    },
    "UZ",
    "UZB"
    ],
    [
      "South Africa",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [31.521, -29.257, 0.0], [31.326, -29.402, 0.0], [30.902, -29.91, 0.0], [30.623, -30.424, 0.0], [30.056, -31.14, 0.0], [28.926, -32.172, 0.0], [28.22, -32.772, 0.0], [27.465, -33.227, 0.0], [26.419, -33.615, 0.0], [25.91, -33.667, 0.0], [25.781, -33.945, 0.0], [25.173, -33.797, 0.0], [24.678, -33.987, 0.0], [23.594, -33.794, 0.0], [22.988, -33.916, 0.0], [22.574, -33.864, 0.0], [21.543, -34.259, 0.0], [20.689, -34.417, 0.0], [20.071, -34.795, 0.0], [19.616, -34.819, 0.0], [19.193, -34.463, 0.0], [18.855, -34.444, 0.0], [18.425, -33.998, 0.0], [18.377, -34.137, 0.0], [18.244, -33.868, 0.0], [18.25, -33.281, 0.0], [17.925, -32.611, 0.0], [18.248, -32.429, 0.0], [18.222, -31.662, 0.0], [17.567, -30.726, 0.0], [17.064, -29.879, 0.0], [17.063, -29.876, 0.0], [16.345, -28.577, 0.0], [16.824, -28.082, 0.0], [17.219, -28.356, 0.0], [17.387, -28.784, 0.0], [17.836, -28.856, 0.0], [18.465, -29.045, 0.0], [19.002, -28.972, 0.0], [19.895, -28.461, 0.0], [19.896, -24.768, 0.0], [20.166, -24.918, 0.0], [20.759, -25.868, 0.0], [20.666, -26.477, 0.0], [20.89, -26.829, 0.0], [21.606, -26.727, 0.0], [22.106, -26.28, 0.0], [22.58, -25.979, 0.0], [22.824, -25.5, 0.0], [23.312, -25.269, 0.0], [23.734, -25.39, 0.0], [24.211, -25.67, 0.0], [25.025, -25.72, 0.0], [25.665, -25.487, 0.0], [25.766, -25.175, 0.0], [25.942, -24.696, 0.0], [26.486, -24.616, 0.0], [26.786, -24.241, 0.0], [27.119, -23.574, 0.0], [28.017, -22.828, 0.0], [29.432, -22.091, 0.0], [29.839, -22.102, 0.0], [30.323, -22.272, 0.0], [30.66, -22.152, 0.0], [31.191, -22.252, 0.0], [31.67, -23.659, 0.0], [31.931, -24.369, 0.0], [31.752, -25.484, 0.0], [31.838, -25.843, 0.0], [31.333, -25.66, 0.0], [31.044, -25.731, 0.0], [30.95, -26.023, 0.0], [30.677, -26.398, 0.0], [30.686, -26.744, 0.0], [31.283, -27.286, 0.0], [31.868, -27.178, 0.0], [32.072, -26.734, 0.0], [32.83, -26.742, 0.0], [32.58, -27.47, 0.0], [32.462, -28.301, 0.0], [32.203, -28.752, 0.0], [31.521, -29.257, 0.0]
      ], [
          [28.978, -28.956, 0.0], [28.542, -28.648, 0.0], [28.074, -28.851, 0.0], [27.533, -29.243, 0.0], [26.999, -29.876, 0.0], [27.749, -30.645, 0.0], [28.107, -30.546, 0.0], [28.291, -30.226, 0.0], [28.848, -30.07, 0.0], [29.018, -29.744, 0.0], [29.325, -29.257, 0.0], [28.978, -28.956, 0.0]
        ]]
      }
    },
    "ZA",
    "ZAF"
    ],
    [
      "Argentina",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-65.5, -55.2, 0.0], [-66.45, -55.25, 0.0], [-66.96, -54.897, 0.0], [-67.562, -54.87, 0.0], [-68.633, -54.869, 0.0], [-68.634, -52.636, 0.0], [-68.25, -53.1, 0.0], [-67.75, -53.85, 0.0], [-66.45, -54.45, 0.0], [-65.05, -54.7, 0.0], [-65.5, -55.2, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-64.965, -22.076, 0.0], [-64.377, -22.798, 0.0], [-63.987, -21.994, 0.0], [-62.846, -22.035, 0.0], [-62.685, -22.249, 0.0], [-60.847, -23.881, 0.0], [-60.029, -24.033, 0.0], [-58.807, -24.771, 0.0], [-57.777, -25.162, 0.0], [-57.634, -25.604, 0.0], [-58.618, -27.124, 0.0], [-57.61, -27.396, 0.0], [-56.487, -27.548, 0.0], [-55.696, -27.388, 0.0], [-54.789, -26.622, 0.0], [-54.625, -25.739, 0.0], [-54.13, -25.548, 0.0], [-53.628, -26.125, 0.0], [-53.649, -26.923, 0.0], [-54.491, -27.475, 0.0], [-55.162, -27.882, 0.0], [-56.291, -28.853, 0.0], [-57.625, -30.216, 0.0], [-57.875, -31.017, 0.0], [-58.142, -32.045, 0.0], [-58.133, -33.041, 0.0], [-58.35, -33.263, 0.0], [-58.427, -33.909, 0.0], [-58.495, -34.431, 0.0], [-57.226, -35.288, 0.0], [-57.362, -35.977, 0.0], [-56.737, -36.413, 0.0], [-56.788, -36.902, 0.0], [-57.749, -38.184, 0.0], [-59.232, -38.72, 0.0], [-61.237, -38.928, 0.0], [-62.336, -38.828, 0.0], [-62.126, -39.424, 0.0], [-62.331, -40.173, 0.0], [-62.146, -40.677, 0.0], [-62.746, -41.029, 0.0], [-63.77, -41.167, 0.0], [-64.732, -40.803, 0.0], [-65.118, -41.064, 0.0], [-64.979, -42.058, 0.0], [-64.303, -42.359, 0.0], [-63.756, -42.044, 0.0], [-63.458, -42.563, 0.0], [-64.379, -42.874, 0.0], [-65.182, -43.495, 0.0], [-65.329, -44.501, 0.0], [-65.565, -45.037, 0.0], [-66.51, -45.04, 0.0], [-67.294, -45.552, 0.0], [-67.581, -46.302, 0.0], [-66.597, -47.034, 0.0], [-65.641, -47.236, 0.0], [-65.985, -48.133, 0.0], [-67.166, -48.697, 0.0], [-67.816, -49.87, 0.0], [-68.729, -50.264, 0.0], [-69.139, -50.733, 0.0], [-68.816, -51.771, 0.0], [-68.15, -52.35, 0.0], [-68.572, -52.299, 0.0], [-69.498, -52.143, 0.0], [-71.915, -52.009, 0.0], [-72.329, -51.426, 0.0], [-72.31, -50.677, 0.0], [-72.976, -50.741, 0.0], [-73.328, -50.379, 0.0], [-73.415, -49.318, 0.0], [-72.648, -48.879, 0.0], [-72.331, -48.244, 0.0], [-72.447, -47.739, 0.0], [-71.917, -46.885, 0.0], [-71.552, -45.561, 0.0], [-71.659, -44.974, 0.0], [-71.223, -44.784, 0.0], [-71.33, -44.408, 0.0], [-71.794, -44.207, 0.0], [-71.464, -43.788, 0.0], [-71.915, -43.409, 0.0], [-72.149, -42.255, 0.0], [-71.747, -42.051, 0.0], [-71.916, -40.832, 0.0], [-71.681, -39.808, 0.0], [-71.414, -38.916, 0.0], [-70.815, -38.553, 0.0], [-71.119, -37.577, 0.0], [-71.122, -36.658, 0.0], [-70.365, -36.005, 0.0], [-70.388, -35.17, 0.0], [-69.817, -34.194, 0.0], [-69.815, -33.274, 0.0], [-70.074, -33.091, 0.0], [-70.535, -31.365, 0.0], [-69.919, -30.336, 0.0], [-70.014, -29.368, 0.0], [-69.656, -28.459, 0.0], [-69.001, -27.521, 0.0], [-68.296, -26.899, 0.0], [-68.595, -26.507, 0.0], [-68.386, -26.185, 0.0], [-68.418, -24.519, 0.0], [-67.328, -24.025, 0.0], [-66.985, -22.986, 0.0], [-67.107, -22.736, 0.0], [-66.273, -21.832, 0.0], [-64.965, -22.076, 0.0]
       ]
      ]
     }
    ]
    },
    "AR",
    "ARG"
    ],
    [
      "Brunei",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [114.204, 4.526, 0.0], [114.6, 4.9, 0.0], [115.451, 5.448, 0.0], [115.406, 4.955, 0.0], [115.347, 4.317, 0.0], [114.87, 4.348, 0.0], [114.66, 4.008, 0.0], [114.204, 4.526, 0.0]
        ]]
      }
    },
    "BN",
    "BRN"
    ],
    [
      "Botswana",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [25.649, -18.536, 0.0], [25.85, -18.714, 0.0], [26.165, -19.293, 0.0], [27.297, -20.392, 0.0], [27.725, -20.499, 0.0], [27.727, -20.852, 0.0], [28.021, -21.486, 0.0], [28.795, -21.639, 0.0], [29.432, -22.091, 0.0], [28.017, -22.828, 0.0], [27.119, -23.574, 0.0], [26.786, -24.241, 0.0], [26.486, -24.616, 0.0], [25.942, -24.696, 0.0], [25.766, -25.175, 0.0], [25.665, -25.487, 0.0], [25.025, -25.72, 0.0], [24.211, -25.67, 0.0], [23.734, -25.39, 0.0], [23.312, -25.269, 0.0], [22.824, -25.5, 0.0], [22.58, -25.979, 0.0], [22.106, -26.28, 0.0], [21.606, -26.727, 0.0], [20.89, -26.829, 0.0], [20.666, -26.477, 0.0], [20.759, -25.868, 0.0], [20.166, -24.918, 0.0], [19.896, -24.768, 0.0], [19.895, -21.849, 0.0], [20.881, -21.814, 0.0], [20.911, -18.252, 0.0], [21.655, -18.219, 0.0], [23.197, -17.869, 0.0], [23.579, -18.281, 0.0], [24.217, -17.889, 0.0], [24.521, -17.887, 0.0], [25.084, -17.662, 0.0], [25.264, -17.737, 0.0], [25.649, -18.536, 0.0]
        ]]
      }
    },
    "BW",
    "BWA"
    ],
    [
      "Canada",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-63.665, 46.55, 0.0], [-62.939, 46.416, 0.0], [-62.012, 46.443, 0.0], [-62.504, 46.033, 0.0], [-62.874, 45.968, 0.0], [-64.143, 46.393, 0.0], [-64.393, 46.727, 0.0], [-64.015, 47.036, 0.0], [-63.665, 46.55, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-61.806, 49.105, 0.0], [-62.293, 49.087, 0.0], [-63.589, 49.401, 0.0], [-64.519, 49.873, 0.0], [-64.173, 49.957, 0.0], [-62.858, 49.706, 0.0], [-61.836, 49.289, 0.0], [-61.806, 49.105, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-123.51, 48.51, 0.0], [-124.013, 48.371, 0.0], [-125.655, 48.825, 0.0], [-125.955, 49.18, 0.0], [-126.85, 49.53, 0.0], [-127.03, 49.815, 0.0], [-128.059, 49.995, 0.0], [-128.445, 50.539, 0.0], [-128.358, 50.771, 0.0], [-127.309, 50.553, 0.0], [-126.695, 50.401, 0.0], [-125.755, 50.295, 0.0], [-125.415, 49.95, 0.0], [-124.921, 49.475, 0.0], [-123.923, 49.062, 0.0], [-123.51, 48.51, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-56.134, 50.687, 0.0], [-56.796, 49.812, 0.0], [-56.143, 50.15, 0.0], [-55.471, 49.936, 0.0], [-55.822, 49.587, 0.0], [-54.935, 49.313, 0.0], [-54.474, 49.557, 0.0], [-53.477, 49.249, 0.0], [-53.786, 48.517, 0.0], [-53.086, 48.688, 0.0], [-52.959, 48.157, 0.0], [-52.648, 47.536, 0.0], [-53.069, 46.655, 0.0], [-53.521, 46.618, 0.0], [-54.179, 46.807, 0.0], [-53.962, 47.625, 0.0], [-54.24, 47.752, 0.0], [-55.401, 46.885, 0.0], [-55.997, 46.92, 0.0], [-55.291, 47.39, 0.0], [-56.251, 47.633, 0.0], [-57.325, 47.573, 0.0], [-59.266, 47.603, 0.0], [-59.419, 47.899, 0.0], [-58.797, 48.252, 0.0], [-59.232, 48.523, 0.0], [-58.392, 49.126, 0.0], [-57.359, 50.718, 0.0], [-56.739, 51.287, 0.0], [-55.871, 51.632, 0.0], [-55.407, 51.588, 0.0], [-55.6, 51.317, 0.0], [-56.134, 50.687, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-132.71, 54.04, 0.0], [-132.71, 54.04, 0.0], [-132.71, 54.04, 0.0], [-132.71, 54.04, 0.0], [-131.75, 54.12, 0.0], [-132.049, 52.985, 0.0], [-131.179, 52.18, 0.0], [-131.578, 52.182, 0.0], [-132.18, 52.64, 0.0], [-132.55, 53.1, 0.0], [-133.055, 53.411, 0.0], [-133.24, 53.851, 0.0], [-133.18, 54.17, 0.0], [-132.71, 54.04, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-79.266, 62.159, 0.0], [-79.658, 61.633, 0.0], [-80.1, 61.718, 0.0], [-80.362, 62.016, 0.0], [-80.315, 62.086, 0.0], [-79.929, 62.386, 0.0], [-79.52, 62.364, 0.0], [-79.266, 62.159, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-81.898, 62.711, 0.0], [-83.069, 62.159, 0.0], [-83.775, 62.182, 0.0], [-83.994, 62.453, 0.0], [-83.25, 62.914, 0.0], [-81.877, 62.905, 0.0], [-81.898, 62.711, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-85.161, 65.657, 0.0], [-84.976, 65.218, 0.0], [-84.464, 65.372, 0.0], [-83.883, 65.11, 0.0], [-82.788, 64.767, 0.0], [-81.642, 64.455, 0.0], [-81.553, 63.98, 0.0], [-80.817, 64.057, 0.0], [-80.103, 63.726, 0.0], [-80.991, 63.411, 0.0], [-82.547, 63.652, 0.0], [-83.109, 64.102, 0.0], [-84.1, 63.57, 0.0], [-85.523, 63.052, 0.0], [-85.867, 63.637, 0.0], [-87.222, 63.541, 0.0], [-86.353, 64.036, 0.0], [-86.225, 64.823, 0.0], [-85.884, 65.739, 0.0], [-85.161, 65.657, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-75.866, 67.149, 0.0], [-76.987, 67.099, 0.0], [-77.236, 67.588, 0.0], [-76.812, 68.149, 0.0], [-75.895, 68.287, 0.0], [-75.115, 68.01, 0.0], [-75.103, 67.582, 0.0], [-75.216, 67.444, 0.0], [-75.866, 67.149, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-95.648, 69.108, 0.0], [-96.27, 68.757, 0.0], [-97.617, 69.06, 0.0], [-98.432, 68.951, 0.0], [-99.797, 69.4, 0.0], [-98.917, 69.71, 0.0], [-98.218, 70.144, 0.0], [-97.157, 69.86, 0.0], [-96.557, 69.68, 0.0], [-96.257, 69.49, 0.0], [-95.648, 69.108, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-90.547, 69.498, 0.0], [-90.552, 68.475, 0.0], [-89.215, 69.259, 0.0], [-88.02, 68.615, 0.0], [-88.317, 67.873, 0.0], [-87.35, 67.199, 0.0], [-86.306, 67.921, 0.0], [-85.577, 68.785, 0.0], [-85.522, 69.882, 0.0], [-84.101, 69.805, 0.0], [-82.623, 69.658, 0.0], [-81.28, 69.162, 0.0], [-81.22, 68.666, 0.0], [-81.964, 68.133, 0.0], [-81.259, 67.597, 0.0], [-81.387, 67.111, 0.0], [-83.345, 66.412, 0.0], [-84.735, 66.257, 0.0], [-85.769, 66.558, 0.0], [-86.068, 66.056, 0.0], [-87.031, 65.213, 0.0], [-87.323, 64.776, 0.0], [-88.483, 64.099, 0.0], [-89.914, 64.033, 0.0], [-90.704, 63.61, 0.0], [-90.77, 62.96, 0.0], [-91.933, 62.835, 0.0], [-93.157, 62.025, 0.0], [-94.242, 60.899, 0.0], [-94.629, 60.11, 0.0], [-94.685, 58.949, 0.0], [-93.215, 58.782, 0.0], [-92.765, 57.846, 0.0], [-92.297, 57.087, 0.0], [-90.898, 57.285, 0.0], [-89.04, 56.852, 0.0], [-88.04, 56.472, 0.0], [-87.324, 55.999, 0.0], [-86.071, 55.724, 0.0], [-85.012, 55.303, 0.0], [-83.361, 55.245, 0.0], [-82.273, 55.148, 0.0], [-82.436, 54.282, 0.0], [-82.125, 53.277, 0.0], [-81.401, 52.158, 0.0], [-79.913, 51.208, 0.0], [-79.143, 51.534, 0.0], [-78.602, 52.562, 0.0], [-79.124, 54.141, 0.0], [-79.83, 54.668, 0.0], [-78.229, 55.136, 0.0], [-77.096, 55.837, 0.0], [-76.541, 56.534, 0.0], [-76.623, 57.203, 0.0], [-77.302, 58.052, 0.0], [-78.517, 58.805, 0.0], [-77.337, 59.853, 0.0], [-77.773, 60.758, 0.0], [-78.107, 62.32, 0.0], [-77.411, 62.551, 0.0], [-75.696, 62.278, 0.0], [-74.668, 62.181, 0.0], [-73.84, 62.444, 0.0], [-72.909, 62.105, 0.0], [-71.677, 61.525, 0.0], [-71.374, 61.137, 0.0], [-69.59, 61.061, 0.0], [-69.62, 60.221, 0.0], [-69.288, 58.957, 0.0], [-68.375, 58.801, 0.0], [-67.65, 58.212, 0.0], [-66.202, 58.767, 0.0], [-65.245, 59.871, 0.0], [-64.584, 60.336, 0.0], [-63.805, 59.443, 0.0], [-62.502, 58.167, 0.0], [-61.397, 56.967, 0.0], [-61.799, 56.339, 0.0], [-60.469, 55.775, 0.0], [-59.57, 55.204, 0.0], [-57.975, 54.945, 0.0], [-57.333, 54.627, 0.0], [-56.937, 53.78, 0.0], [-56.158, 53.647, 0.0], [-55.756, 53.27, 0.0], [-55.683, 52.147, 0.0], [-56.409, 51.771, 0.0], [-57.127, 51.42, 0.0], [-58.775, 51.064, 0.0], [-60.033, 50.243, 0.0], [-61.724, 50.08, 0.0], [-63.863, 50.291, 0.0], [-65.363, 50.298, 0.0], [-66.399, 50.229, 0.0], [-67.236, 49.512, 0.0], [-68.511, 49.068, 0.0], [-69.954, 47.745, 0.0], [-71.105, 46.822, 0.0], [-70.255, 46.986, 0.0], [-68.65, 48.3, 0.0], [-66.552, 49.133, 0.0], [-65.056, 49.233, 0.0], [-64.171, 48.742, 0.0], [-65.115, 48.071, 0.0], [-64.799, 46.993, 0.0], [-64.472, 46.238, 0.0], [-63.173, 45.739, 0.0], [-61.521, 45.884, 0.0], [-60.518, 47.008, 0.0], [-60.449, 46.283, 0.0], [-59.803, 45.92, 0.0], [-61.04, 45.265, 0.0], [-63.255, 44.67, 0.0], [-64.247, 44.266, 0.0], [-65.364, 43.545, 0.0], [-66.123, 43.619, 0.0], [-66.162, 44.465, 0.0], [-64.425, 45.292, 0.0], [-66.026, 45.259, 0.0], [-67.137, 45.138, 0.0], [-67.791, 45.703, 0.0], [-67.79, 47.066, 0.0], [-68.234, 47.355, 0.0], [-68.905, 47.185, 0.0], [-69.237, 47.448, 0.0], [-70.0, 46.693, 0.0], [-70.305, 45.915, 0.0], [-70.66, 45.46, 0.0], [-71.085, 45.305, 0.0], [-71.405, 45.255, 0.0], [-71.505, 45.008, 0.0], [-73.348, 45.007, 0.0], [-74.867, 45.0, 0.0], [-75.318, 44.816, 0.0], [-76.375, 44.096, 0.0], [-76.5, 44.018, 0.0], [-76.82, 43.629, 0.0], [-77.738, 43.629, 0.0], [-78.72, 43.625, 0.0], [-79.172, 43.466, 0.0], [-79.01, 43.27, 0.0], [-78.92, 42.965, 0.0], [-78.939, 42.864, 0.0], [-80.247, 42.366, 0.0], [-81.278, 42.209, 0.0], [-82.439, 41.675, 0.0], [-82.69, 41.675, 0.0], [-83.03, 41.833, 0.0], [-83.142, 41.976, 0.0], [-83.12, 42.08, 0.0], [-82.9, 42.43, 0.0], [-82.43, 42.98, 0.0], [-82.138, 43.571, 0.0], [-82.338, 44.44, 0.0], [-82.551, 45.348, 0.0], [-83.593, 45.817, 0.0], [-83.47, 45.995, 0.0], [-83.616, 46.117, 0.0], [-83.891, 46.117, 0.0], [-84.092, 46.275, 0.0], [-84.142, 46.512, 0.0], [-84.337, 46.409, 0.0], [-84.605, 46.44, 0.0], [-84.544, 46.539, 0.0], [-84.779, 46.637, 0.0], [-84.876, 46.9, 0.0], [-85.652, 47.22, 0.0], [-86.462, 47.553, 0.0], [-87.44, 47.94, 0.0], [-88.378, 48.303, 0.0], [-89.273, 48.02, 0.0], [-89.6, 48.01, 0.0], [-90.83, 48.27, 0.0], [-91.64, 48.14, 0.0], [-92.61, 48.45, 0.0], [-93.631, 48.609, 0.0], [-94.329, 48.671, 0.0], [-94.64, 48.84, 0.0], [-94.818, 49.389, 0.0], [-95.156, 49.384, 0.0], [-95.159, 49.0, 0.0], [-97.229, 49.001, 0.0], [-100.65, 49.0, 0.0], [-104.048, 49.0, 0.0], [-107.05, 49.0, 0.0], [-110.05, 49.0, 0.0], [-113.0, 49.0, 0.0], [-116.048, 49.0, 0.0], [-117.031, 49.0, 0.0], [-120.0, 49.0, 0.0], [-122.84, 49.0, 0.0], [-122.974, 49.003, 0.0], [-124.91, 49.985, 0.0], [-125.625, 50.417, 0.0], [-127.436, 50.831, 0.0], [-127.993, 51.716, 0.0], [-127.85, 52.33, 0.0], [-129.13, 52.755, 0.0], [-129.305, 53.562, 0.0], [-130.515, 54.288, 0.0], [-130.536, 54.803, 0.0], [-129.98, 55.285, 0.0], [-130.008, 55.916, 0.0], [-131.708, 56.552, 0.0], [-132.73, 57.693, 0.0], [-133.356, 58.41, 0.0], [-134.271, 58.861, 0.0], [-134.945, 59.271, 0.0], [-135.476, 59.788, 0.0], [-136.48, 59.464, 0.0], [-137.453, 58.905, 0.0], [-138.341, 59.562, 0.0], [-139.039, 60.0, 0.0], [-140.013, 60.277, 0.0], [-140.998, 60.306, 0.0], [-140.993, 66.0, 0.0], [-140.986, 69.712, 0.0], [-139.121, 69.471, 0.0], [-137.546, 68.99, 0.0], [-136.504, 68.898, 0.0], [-135.626, 69.315, 0.0], [-134.415, 69.627, 0.0], [-132.929, 69.505, 0.0], [-131.431, 69.945, 0.0], [-129.795, 70.194, 0.0], [-129.108, 69.779, 0.0], [-128.362, 70.013, 0.0], [-128.138, 70.484, 0.0], [-127.447, 70.377, 0.0], [-125.756, 69.481, 0.0], [-124.425, 70.158, 0.0], [-124.29, 69.4, 0.0], [-123.061, 69.564, 0.0], [-122.684, 69.856, 0.0], [-121.472, 69.798, 0.0], [-119.943, 69.378, 0.0], [-117.603, 69.011, 0.0], [-116.226, 68.842, 0.0], [-115.247, 68.906, 0.0], [-113.898, 68.399, 0.0], [-115.305, 67.903, 0.0], [-113.497, 67.688, 0.0], [-110.798, 67.806, 0.0], [-109.946, 67.981, 0.0], [-108.88, 67.381, 0.0], [-107.792, 67.887, 0.0], [-108.813, 68.312, 0.0], [-108.167, 68.654, 0.0], [-106.95, 68.7, 0.0], [-106.15, 68.8, 0.0], [-105.343, 68.561, 0.0], [-104.338, 68.018, 0.0], [-103.221, 68.098, 0.0], [-101.454, 67.647, 0.0], [-99.902, 67.806, 0.0], [-98.443, 67.782, 0.0], [-98.559, 68.404, 0.0], [-97.669, 68.579, 0.0], [-96.12, 68.239, 0.0], [-96.126, 67.293, 0.0], [-95.489, 68.091, 0.0], [-94.685, 68.064, 0.0], [-94.233, 69.069, 0.0], [-95.304, 69.686, 0.0], [-96.471, 70.09, 0.0], [-96.391, 71.195, 0.0], [-95.209, 71.921, 0.0], [-93.89, 71.76, 0.0], [-92.878, 71.319, 0.0], [-91.52, 70.191, 0.0], [-92.407, 69.7, 0.0], [-90.547, 69.498, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-114.167, 73.121, 0.0], [-114.666, 72.653, 0.0], [-112.441, 72.955, 0.0], [-111.05, 72.45, 0.0], [-109.92, 72.961, 0.0], [-109.007, 72.633, 0.0], [-108.188, 71.651, 0.0], [-107.686, 72.065, 0.0], [-108.396, 73.09, 0.0], [-107.516, 73.236, 0.0], [-106.523, 73.076, 0.0], [-105.402, 72.673, 0.0], [-104.775, 71.698, 0.0], [-104.465, 70.993, 0.0], [-102.785, 70.498, 0.0], [-100.981, 70.024, 0.0], [-101.089, 69.584, 0.0], [-102.731, 69.504, 0.0], [-102.093, 69.12, 0.0], [-102.43, 68.753, 0.0], [-104.24, 68.91, 0.0], [-105.96, 69.18, 0.0], [-107.123, 69.119, 0.0], [-109.0, 68.78, 0.0], [-111.534, 68.63, 0.0], [-113.313, 68.536, 0.0], [-113.855, 69.007, 0.0], [-115.22, 69.28, 0.0], [-116.108, 69.168, 0.0], [-117.34, 69.96, 0.0], [-116.675, 70.067, 0.0], [-115.131, 70.237, 0.0], [-113.721, 70.192, 0.0], [-112.416, 70.366, 0.0], [-114.35, 70.6, 0.0], [-116.487, 70.52, 0.0], [-117.905, 70.541, 0.0], [-118.432, 70.909, 0.0], [-116.113, 71.309, 0.0], [-117.656, 71.295, 0.0], [-119.402, 71.559, 0.0], [-118.563, 72.308, 0.0], [-117.866, 72.706, 0.0], [-115.189, 73.315, 0.0], [-114.167, 73.121, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-104.5, 73.42, 0.0], [-105.38, 72.76, 0.0], [-106.94, 73.46, 0.0], [-106.6, 73.6, 0.0], [-105.26, 73.64, 0.0], [-104.5, 73.42, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-76.34, 73.103, 0.0], [-76.251, 72.826, 0.0], [-77.314, 72.856, 0.0], [-78.392, 72.877, 0.0], [-79.486, 72.742, 0.0], [-79.776, 72.803, 0.0], [-80.876, 73.333, 0.0], [-80.834, 73.693, 0.0], [-80.353, 73.76, 0.0], [-78.064, 73.652, 0.0], [-76.34, 73.103, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-86.562, 73.157, 0.0], [-85.774, 72.534, 0.0], [-84.85, 73.34, 0.0], [-82.316, 73.751, 0.0], [-80.6, 72.717, 0.0], [-80.749, 72.062, 0.0], [-78.771, 72.352, 0.0], [-77.825, 72.75, 0.0], [-75.606, 72.244, 0.0], [-74.229, 71.767, 0.0], [-74.099, 71.331, 0.0], [-72.242, 71.557, 0.0], [-71.2, 70.92, 0.0], [-68.786, 70.525, 0.0], [-67.915, 70.122, 0.0], [-66.969, 69.186, 0.0], [-68.805, 68.72, 0.0], [-66.45, 68.067, 0.0], [-64.862, 67.848, 0.0], [-63.425, 66.928, 0.0], [-61.852, 66.862, 0.0], [-62.163, 66.16, 0.0], [-63.918, 64.999, 0.0], [-65.149, 65.426, 0.0], [-66.721, 66.388, 0.0], [-68.015, 66.263, 0.0], [-68.141, 65.69, 0.0], [-67.09, 65.108, 0.0], [-65.732, 64.648, 0.0], [-65.32, 64.383, 0.0], [-64.669, 63.393, 0.0], [-65.014, 62.674, 0.0], [-66.275, 62.945, 0.0], [-68.783, 63.746, 0.0], [-67.37, 62.884, 0.0], [-66.328, 62.28, 0.0], [-66.166, 61.931, 0.0], [-68.877, 62.33, 0.0], [-71.023, 62.911, 0.0], [-72.235, 63.398, 0.0], [-71.886, 63.68, 0.0], [-73.378, 64.194, 0.0], [-74.834, 64.679, 0.0], [-74.819, 64.389, 0.0], [-77.71, 64.23, 0.0], [-78.556, 64.573, 0.0], [-77.897, 65.309, 0.0], [-76.018, 65.327, 0.0], [-73.96, 65.455, 0.0], [-74.294, 65.812, 0.0], [-73.945, 66.311, 0.0], [-72.651, 67.285, 0.0], [-72.926, 67.727, 0.0], [-73.312, 68.069, 0.0], [-74.843, 68.555, 0.0], [-76.869, 68.895, 0.0], [-76.229, 69.148, 0.0], [-77.287, 69.77, 0.0], [-78.169, 69.826, 0.0], [-78.957, 70.167, 0.0], [-79.492, 69.872, 0.0], [-81.305, 69.743, 0.0], [-84.945, 69.967, 0.0], [-87.06, 70.26, 0.0], [-88.682, 70.411, 0.0], [-89.513, 70.762, 0.0], [-88.468, 71.218, 0.0], [-89.888, 71.223, 0.0], [-90.205, 72.235, 0.0], [-89.437, 73.129, 0.0], [-88.408, 73.538, 0.0], [-85.826, 73.804, 0.0], [-86.562, 73.157, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-100.356, 73.844, 0.0], [-99.164, 73.633, 0.0], [-97.38, 73.76, 0.0], [-97.12, 73.47, 0.0], [-98.054, 72.991, 0.0], [-96.54, 72.56, 0.0], [-96.72, 71.66, 0.0], [-98.36, 71.273, 0.0], [-99.323, 71.356, 0.0], [-100.015, 71.738, 0.0], [-102.5, 72.51, 0.0], [-102.48, 72.83, 0.0], [-100.438, 72.706, 0.0], [-101.54, 73.36, 0.0], [-100.356, 73.844, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-93.196, 72.772, 0.0], [-94.269, 72.025, 0.0], [-95.41, 72.062, 0.0], [-96.034, 72.94, 0.0], [-96.018, 73.437, 0.0], [-95.496, 73.862, 0.0], [-94.504, 74.135, 0.0], [-92.42, 74.1, 0.0], [-90.51, 73.857, 0.0], [-92.004, 72.966, 0.0], [-93.196, 72.772, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-120.46, 71.384, 0.0], [-123.092, 70.902, 0.0], [-123.62, 71.34, 0.0], [-125.929, 71.869, 0.0], [-125.5, 72.292, 0.0], [-124.807, 73.023, 0.0], [-123.94, 73.68, 0.0], [-124.918, 74.293, 0.0], [-121.538, 74.449, 0.0], [-120.11, 74.241, 0.0], [-117.556, 74.186, 0.0], [-116.584, 73.896, 0.0], [-115.511, 73.475, 0.0], [-116.768, 73.223, 0.0], [-119.22, 72.52, 0.0], [-120.46, 71.82, 0.0], [-120.46, 71.384, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-93.613, 74.98, 0.0], [-94.157, 74.592, 0.0], [-95.609, 74.667, 0.0], [-96.821, 74.928, 0.0], [-96.289, 75.378, 0.0], [-94.851, 75.647, 0.0], [-93.978, 75.296, 0.0], [-93.613, 74.98, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-98.5, 76.72, 0.0], [-97.736, 76.257, 0.0], [-97.704, 75.743, 0.0], [-98.16, 75.0, 0.0], [-99.809, 74.897, 0.0], [-100.884, 75.057, 0.0], [-100.863, 75.641, 0.0], [-102.502, 75.564, 0.0], [-102.566, 76.337, 0.0], [-101.49, 76.305, 0.0], [-99.983, 76.646, 0.0], [-98.577, 76.589, 0.0], [-98.5, 76.72, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-108.211, 76.202, 0.0], [-107.819, 75.846, 0.0], [-106.929, 76.013, 0.0], [-105.881, 75.969, 0.0], [-105.705, 75.48, 0.0], [-106.313, 75.005, 0.0], [-109.7, 74.85, 0.0], [-112.223, 74.417, 0.0], [-113.744, 74.394, 0.0], [-113.871, 74.72, 0.0], [-111.794, 75.163, 0.0], [-116.312, 75.043, 0.0], [-117.71, 75.222, 0.0], [-116.346, 76.199, 0.0], [-115.405, 76.479, 0.0], [-112.591, 76.141, 0.0], [-110.814, 75.549, 0.0], [-109.067, 75.473, 0.0], [-110.497, 76.43, 0.0], [-109.581, 76.794, 0.0], [-108.549, 76.678, 0.0], [-108.211, 76.202, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-94.684, 77.098, 0.0], [-93.574, 76.776, 0.0], [-91.605, 76.779, 0.0], [-90.742, 76.45, 0.0], [-90.97, 76.074, 0.0], [-89.822, 75.848, 0.0], [-89.187, 75.61, 0.0], [-87.838, 75.566, 0.0], [-86.379, 75.482, 0.0], [-84.79, 75.699, 0.0], [-82.753, 75.784, 0.0], [-81.129, 75.714, 0.0], [-80.058, 75.337, 0.0], [-79.834, 74.923, 0.0], [-80.458, 74.657, 0.0], [-81.949, 74.442, 0.0], [-83.229, 74.564, 0.0], [-86.097, 74.41, 0.0], [-88.15, 74.392, 0.0], [-89.765, 74.516, 0.0], [-92.422, 74.838, 0.0], [-92.768, 75.387, 0.0], [-92.89, 75.883, 0.0], [-93.894, 76.319, 0.0], [-95.962, 76.441, 0.0], [-97.121, 76.751, 0.0], [-96.745, 77.161, 0.0], [-94.684, 77.098, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-116.199, 77.645, 0.0], [-116.336, 76.877, 0.0], [-117.106, 76.53, 0.0], [-118.04, 76.481, 0.0], [-119.899, 76.053, 0.0], [-121.5, 75.9, 0.0], [-122.855, 76.117, 0.0], [-122.855, 76.117, 0.0], [-121.158, 76.865, 0.0], [-119.104, 77.512, 0.0], [-117.57, 77.498, 0.0], [-116.199, 77.645, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-93.84, 77.52, 0.0], [-94.296, 77.491, 0.0], [-96.17, 77.555, 0.0], [-96.436, 77.835, 0.0], [-94.423, 77.82, 0.0], [-93.721, 77.634, 0.0], [-93.84, 77.52, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-110.187, 77.697, 0.0], [-112.051, 77.409, 0.0], [-113.534, 77.732, 0.0], [-112.725, 78.051, 0.0], [-111.264, 78.153, 0.0], [-109.854, 77.996, 0.0], [-110.187, 77.697, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-109.663, 78.602, 0.0], [-110.881, 78.407, 0.0], [-112.542, 78.408, 0.0], [-112.526, 78.551, 0.0], [-111.5, 78.85, 0.0], [-110.964, 78.804, 0.0], [-109.663, 78.602, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-95.83, 78.057, 0.0], [-97.31, 77.851, 0.0], [-98.124, 78.083, 0.0], [-98.553, 78.458, 0.0], [-98.632, 78.872, 0.0], [-97.337, 78.832, 0.0], [-96.754, 78.766, 0.0], [-95.559, 78.418, 0.0], [-95.83, 78.057, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-100.06, 78.325, 0.0], [-99.671, 77.908, 0.0], [-101.304, 78.019, 0.0], [-102.95, 78.343, 0.0], [-105.176, 78.38, 0.0], [-104.21, 78.677, 0.0], [-105.42, 78.918, 0.0], [-105.492, 79.302, 0.0], [-103.529, 79.165, 0.0], [-100.825, 78.8, 0.0], [-100.06, 78.325, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-87.02, 79.66, 0.0], [-85.814, 79.337, 0.0], [-87.188, 79.039, 0.0], [-89.035, 78.287, 0.0], [-90.804, 78.215, 0.0], [-92.877, 78.343, 0.0], [-93.951, 78.751, 0.0], [-93.936, 79.114, 0.0], [-93.145, 79.38, 0.0], [-94.974, 79.372, 0.0], [-96.076, 79.705, 0.0], [-96.71, 80.158, 0.0], [-96.016, 80.602, 0.0], [-95.323, 80.907, 0.0], [-94.298, 80.977, 0.0], [-94.735, 81.206, 0.0], [-92.41, 81.257, 0.0], [-91.133, 80.723, 0.0], [-89.45, 80.509, 0.0], [-87.81, 80.32, 0.0], [-87.02, 79.66, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-68.5, 83.106, 0.0], [-65.827, 83.028, 0.0], [-63.68, 82.9, 0.0], [-61.85, 82.629, 0.0], [-61.894, 82.362, 0.0], [-64.334, 81.928, 0.0], [-66.753, 81.725, 0.0], [-67.658, 81.501, 0.0], [-65.48, 81.507, 0.0], [-67.84, 80.9, 0.0], [-69.47, 80.617, 0.0], [-71.18, 79.8, 0.0], [-73.243, 79.634, 0.0], [-73.88, 79.43, 0.0], [-76.908, 79.323, 0.0], [-75.529, 79.198, 0.0], [-76.22, 79.019, 0.0], [-75.393, 78.526, 0.0], [-76.344, 78.183, 0.0], [-77.889, 77.9, 0.0], [-78.363, 77.509, 0.0], [-79.76, 77.21, 0.0], [-79.62, 76.983, 0.0], [-77.911, 77.022, 0.0], [-77.889, 76.778, 0.0], [-80.561, 76.178, 0.0], [-83.174, 76.454, 0.0], [-86.112, 76.299, 0.0], [-87.6, 76.42, 0.0], [-89.491, 76.472, 0.0], [-89.616, 76.952, 0.0], [-87.767, 77.178, 0.0], [-88.26, 77.9, 0.0], [-87.65, 77.97, 0.0], [-84.976, 77.539, 0.0], [-86.34, 78.18, 0.0], [-87.962, 78.372, 0.0], [-87.152, 78.759, 0.0], [-85.379, 78.997, 0.0], [-85.095, 79.345, 0.0], [-86.507, 79.736, 0.0], [-86.932, 80.251, 0.0], [-84.198, 80.208, 0.0], [-83.409, 80.1, 0.0], [-81.848, 80.464, 0.0], [-84.1, 80.58, 0.0], [-87.599, 80.516, 0.0], [-89.367, 80.856, 0.0], [-90.2, 81.26, 0.0], [-91.368, 81.553, 0.0], [-91.587, 81.894, 0.0], [-90.1, 82.085, 0.0], [-88.932, 82.118, 0.0], [-86.97, 82.28, 0.0], [-85.5, 82.652, 0.0], [-84.26, 82.6, 0.0], [-83.18, 82.32, 0.0], [-82.42, 82.86, 0.0], [-81.1, 83.02, 0.0], [-79.307, 83.131, 0.0], [-76.25, 83.172, 0.0], [-75.719, 83.064, 0.0], [-72.832, 83.233, 0.0], [-70.666, 83.17, 0.0], [-68.5, 83.106, 0.0]
       ]
      ]
     }
    ]
    },
    "CA",
    "CAN"
    ],
    [
      "China",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [110.339, 18.678, 0.0], [109.475, 18.198, 0.0], [108.655, 18.508, 0.0], [108.626, 19.368, 0.0], [109.119, 19.821, 0.0], [110.212, 20.101, 0.0], [110.787, 20.078, 0.0], [111.01, 19.696, 0.0], [110.571, 19.256, 0.0], [110.339, 18.678, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [127.657, 49.76, 0.0], [129.398, 49.441, 0.0], [130.582, 48.73, 0.0], [130.987, 47.79, 0.0], [132.507, 47.789, 0.0], [133.374, 48.183, 0.0], [135.026, 48.478, 0.0], [134.501, 47.578, 0.0], [134.112, 47.212, 0.0], [133.77, 46.117, 0.0], [133.097, 45.144, 0.0], [131.883, 45.321, 0.0], [131.025, 44.968, 0.0], [131.289, 44.112, 0.0], [131.145, 42.93, 0.0], [130.634, 42.903, 0.0], [130.64, 42.395, 0.0], [129.994, 42.985, 0.0], [129.597, 42.425, 0.0], [128.052, 41.994, 0.0], [128.208, 41.467, 0.0], [127.344, 41.503, 0.0], [126.869, 41.817, 0.0], [126.182, 41.107, 0.0], [125.08, 40.57, 0.0], [124.266, 39.928, 0.0], [122.868, 39.638, 0.0], [122.131, 39.17, 0.0], [121.055, 38.897, 0.0], [121.586, 39.361, 0.0], [121.377, 39.75, 0.0], [122.169, 40.422, 0.0], [121.64, 40.946, 0.0], [120.769, 40.593, 0.0], [119.64, 39.898, 0.0], [119.023, 39.252, 0.0], [118.043, 39.204, 0.0], [117.533, 38.738, 0.0], [118.06, 38.061, 0.0], [118.878, 37.897, 0.0], [118.912, 37.448, 0.0], [119.703, 37.156, 0.0], [120.823, 37.87, 0.0], [121.711, 37.481, 0.0], [122.358, 37.454, 0.0], [122.52, 36.931, 0.0], [121.104, 36.651, 0.0], [120.637, 36.111, 0.0], [119.665, 35.61, 0.0], [119.151, 34.91, 0.0], [120.228, 34.36, 0.0], [120.62, 33.377, 0.0], [121.229, 32.46, 0.0], [121.908, 31.692, 0.0], [121.892, 30.949, 0.0], [121.264, 30.676, 0.0], [121.504, 30.143, 0.0], [122.092, 29.833, 0.0], [121.938, 29.018, 0.0], [121.684, 28.226, 0.0], [121.126, 28.136, 0.0], [120.395, 27.053, 0.0], [119.585, 25.741, 0.0], [118.657, 24.547, 0.0], [117.282, 23.625, 0.0], [115.891, 22.783, 0.0], [114.764, 22.668, 0.0], [114.153, 22.224, 0.0], [113.807, 22.548, 0.0], [113.241, 22.051, 0.0], [111.844, 21.55, 0.0], [110.785, 21.397, 0.0], [110.444, 20.341, 0.0], [109.89, 20.282, 0.0], [109.628, 21.008, 0.0], [109.864, 21.395, 0.0], [108.523, 21.715, 0.0], [108.05, 21.552, 0.0], [107.043, 21.812, 0.0], [106.567, 22.218, 0.0], [106.725, 22.794, 0.0], [105.811, 22.977, 0.0], [105.329, 23.352, 0.0], [104.477, 22.819, 0.0], [103.505, 22.704, 0.0], [102.707, 22.709, 0.0], [102.17, 22.465, 0.0], [101.652, 22.318, 0.0], [101.803, 21.174, 0.0], [101.27, 21.202, 0.0], [101.18, 21.437, 0.0], [101.15, 21.85, 0.0], [100.417, 21.559, 0.0], [99.983, 21.743, 0.0], [99.241, 22.118, 0.0], [99.532, 22.949, 0.0], [98.899, 23.143, 0.0], [98.66, 24.063, 0.0], [97.605, 23.897, 0.0], [97.725, 25.084, 0.0], [98.672, 25.919, 0.0], [98.712, 26.744, 0.0], [98.683, 27.509, 0.0], [98.246, 27.747, 0.0], [97.912, 28.336, 0.0], [97.327, 28.262, 0.0], [96.249, 28.411, 0.0], [96.587, 28.831, 0.0], [96.118, 29.453, 0.0], [95.405, 29.032, 0.0], [94.566, 29.277, 0.0], [93.413, 28.641, 0.0], [92.503, 27.897, 0.0], [91.697, 27.772, 0.0], [91.259, 28.041, 0.0], [90.731, 28.065, 0.0], [90.016, 28.296, 0.0], [89.476, 28.043, 0.0], [88.814, 27.299, 0.0], [88.73, 28.087, 0.0], [88.12, 27.877, 0.0], [86.955, 27.974, 0.0], [85.823, 28.204, 0.0], [85.012, 28.643, 0.0], [84.235, 28.84, 0.0], [83.899, 29.32, 0.0], [83.337, 29.464, 0.0], [82.328, 30.115, 0.0], [81.526, 30.423, 0.0], [81.111, 30.183, 0.0], [79.721, 30.883, 0.0], [78.739, 31.516, 0.0], [78.458, 32.618, 0.0], [79.176, 32.484, 0.0], [79.209, 32.994, 0.0], [78.811, 33.506, 0.0], [78.912, 34.322, 0.0], [77.837, 35.494, 0.0], [76.193, 35.898, 0.0], [75.897, 36.667, 0.0], [75.158, 37.133, 0.0], [74.98, 37.42, 0.0], [74.83, 37.99, 0.0], [74.865, 38.379, 0.0], [74.258, 38.607, 0.0], [73.929, 38.506, 0.0], [73.675, 39.431, 0.0], [73.96, 39.66, 0.0], [73.822, 39.894, 0.0], [74.777, 40.366, 0.0], [75.468, 40.562, 0.0], [76.526, 40.428, 0.0], [76.904, 41.066, 0.0], [78.187, 41.185, 0.0], [78.544, 41.582, 0.0], [80.119, 42.124, 0.0], [80.26, 42.35, 0.0], [80.18, 42.92, 0.0], [80.866, 43.18, 0.0], [79.966, 44.918, 0.0], [81.947, 45.317, 0.0], [82.459, 45.54, 0.0], [83.18, 47.33, 0.0], [85.164, 47.001, 0.0], [85.72, 47.453, 0.0], [85.768, 48.456, 0.0], [86.599, 48.549, 0.0], [87.36, 49.215, 0.0], [87.751, 49.297, 0.0], [88.014, 48.599, 0.0], [88.854, 48.069, 0.0], [90.281, 47.694, 0.0], [90.971, 46.888, 0.0], [90.586, 45.72, 0.0], [90.946, 45.286, 0.0], [92.134, 45.115, 0.0], [93.481, 44.975, 0.0], [94.689, 44.352, 0.0], [95.307, 44.241, 0.0], [95.762, 43.319, 0.0], [96.349, 42.726, 0.0], [97.452, 42.749, 0.0], [99.516, 42.525, 0.0], [100.846, 42.664, 0.0], [101.833, 42.515, 0.0], [103.312, 41.907, 0.0], [104.522, 41.908, 0.0], [104.965, 41.597, 0.0], [106.129, 42.134, 0.0], [107.745, 42.482, 0.0], [109.244, 42.519, 0.0], [110.412, 42.871, 0.0], [111.13, 43.407, 0.0], [111.83, 43.743, 0.0], [111.668, 44.073, 0.0], [111.348, 44.457, 0.0], [111.873, 45.102, 0.0], [112.436, 45.012, 0.0], [113.464, 44.809, 0.0], [114.46, 45.34, 0.0], [115.985, 45.727, 0.0], [116.718, 46.388, 0.0], [117.422, 46.673, 0.0], [118.874, 46.805, 0.0], [119.663, 46.693, 0.0], [119.773, 47.048, 0.0], [118.867, 47.747, 0.0], [118.064, 48.067, 0.0], [117.296, 47.698, 0.0], [116.309, 47.853, 0.0], [115.743, 47.727, 0.0], [115.485, 48.135, 0.0], [116.192, 49.135, 0.0], [116.679, 49.889, 0.0], [117.879, 49.511, 0.0], [119.288, 50.143, 0.0], [119.279, 50.583, 0.0], [120.182, 51.644, 0.0], [120.738, 51.964, 0.0], [120.726, 52.516, 0.0], [120.177, 52.754, 0.0], [121.003, 53.251, 0.0], [122.246, 53.432, 0.0], [123.572, 53.459, 0.0], [125.068, 53.161, 0.0], [125.946, 52.793, 0.0], [126.564, 51.784, 0.0], [126.939, 51.354, 0.0], [127.287, 50.74, 0.0], [127.657, 49.76, 0.0]
       ]
      ]
     }
    ]
    },
    "CN",
    "CHN"
    ],
    [
      "Ivory Coast",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-2.856, 4.994, 0.0], [-3.311, 4.984, 0.0], [-4.009, 5.18, 0.0], [-4.65, 5.168, 0.0], [-5.834, 4.994, 0.0], [-6.529, 4.705, 0.0], [-7.519, 4.338, 0.0], [-7.712, 4.365, 0.0], [-7.635, 5.188, 0.0], [-7.54, 5.313, 0.0], [-7.57, 5.707, 0.0], [-7.994, 6.126, 0.0], [-8.311, 6.193, 0.0], [-8.603, 6.468, 0.0], [-8.385, 6.912, 0.0], [-8.485, 7.395, 0.0], [-8.439, 7.686, 0.0], [-8.281, 7.687, 0.0], [-8.222, 8.123, 0.0], [-8.299, 8.316, 0.0], [-8.203, 8.455, 0.0], [-7.832, 8.576, 0.0], [-8.079, 9.376, 0.0], [-8.31, 9.79, 0.0], [-8.229, 10.129, 0.0], [-8.03, 10.207, 0.0], [-7.9, 10.297, 0.0], [-7.623, 10.147, 0.0], [-6.851, 10.139, 0.0], [-6.666, 10.431, 0.0], [-6.494, 10.411, 0.0], [-6.205, 10.524, 0.0], [-6.05, 10.096, 0.0], [-5.817, 10.223, 0.0], [-5.404, 10.371, 0.0], [-4.955, 10.153, 0.0], [-4.78, 9.822, 0.0], [-4.33, 9.611, 0.0], [-3.98, 9.862, 0.0], [-3.512, 9.9, 0.0], [-2.827, 9.642, 0.0], [-2.562, 8.22, 0.0], [-2.984, 7.38, 0.0], [-3.244, 6.25, 0.0], [-2.811, 5.389, 0.0], [-2.856, 4.994, 0.0]
        ]]
      }
    },
    "CI",
    "CIV"
    ],
    [
      "Germany",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [9.922, 54.983, 0.0], [9.94, 54.597, 0.0], [10.95, 54.364, 0.0], [10.939, 54.009, 0.0], [11.956, 54.196, 0.0], [12.518, 54.47, 0.0], [13.647, 54.076, 0.0], [14.12, 53.757, 0.0], [14.353, 53.248, 0.0], [14.075, 52.981, 0.0], [14.438, 52.625, 0.0], [14.685, 52.09, 0.0], [14.607, 51.745, 0.0], [15.017, 51.107, 0.0], [14.571, 51.002, 0.0], [14.307, 51.117, 0.0], [14.056, 50.927, 0.0], [13.338, 50.733, 0.0], [12.967, 50.484, 0.0], [12.24, 50.266, 0.0], [12.415, 49.969, 0.0], [12.521, 49.547, 0.0], [13.031, 49.307, 0.0], [13.596, 48.877, 0.0], [13.243, 48.416, 0.0], [12.884, 48.289, 0.0], [13.026, 47.638, 0.0], [12.933, 47.468, 0.0], [12.621, 47.672, 0.0], [12.141, 47.703, 0.0], [11.426, 47.524, 0.0], [10.545, 47.566, 0.0], [10.402, 47.302, 0.0], [9.896, 47.58, 0.0], [9.594, 47.525, 0.0], [8.523, 47.831, 0.0], [8.317, 47.614, 0.0], [7.467, 47.621, 0.0], [7.594, 48.333, 0.0], [8.099, 49.018, 0.0], [6.658, 49.202, 0.0], [6.186, 49.464, 0.0], [6.243, 49.902, 0.0], [6.043, 50.128, 0.0], [6.157, 50.804, 0.0], [5.989, 51.852, 0.0], [6.589, 51.852, 0.0], [6.843, 52.228, 0.0], [7.092, 53.144, 0.0], [6.905, 53.482, 0.0], [7.1, 53.694, 0.0], [7.936, 53.748, 0.0], [8.122, 53.528, 0.0], [8.801, 54.021, 0.0], [8.572, 54.396, 0.0], [8.526, 54.963, 0.0], [9.282, 54.831, 0.0], [9.922, 54.983, 0.0]
        ]]
      }
    },
    "DE",
    "DEU"
    ],
    [
      "Egypt",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [34.923, 29.501, 0.0], [34.642, 29.099, 0.0], [34.427, 28.344, 0.0], [34.155, 27.823, 0.0], [33.921, 27.649, 0.0], [33.588, 27.971, 0.0], [33.137, 28.418, 0.0], [32.423, 29.851, 0.0], [32.32, 29.76, 0.0], [32.735, 28.705, 0.0], [33.349, 27.7, 0.0], [34.105, 26.142, 0.0], [34.474, 25.599, 0.0], [34.795, 25.034, 0.0], [35.692, 23.927, 0.0], [35.494, 23.752, 0.0], [35.526, 23.102, 0.0], [36.691, 22.205, 0.0], [36.866, 22.0, 0.0], [32.9, 22.0, 0.0], [29.02, 22.0, 0.0], [25.0, 22.0, 0.0], [25.0, 25.682, 0.0], [25.0, 29.239, 0.0], [24.7, 30.044, 0.0], [24.958, 30.662, 0.0], [24.803, 31.089, 0.0], [25.165, 31.569, 0.0], [26.495, 31.586, 0.0], [27.458, 31.321, 0.0], [28.45, 31.026, 0.0], [28.914, 30.87, 0.0], [29.683, 31.187, 0.0], [30.095, 31.473, 0.0], [30.977, 31.556, 0.0], [31.688, 31.43, 0.0], [31.96, 30.934, 0.0], [32.192, 31.26, 0.0], [32.994, 31.024, 0.0], [33.773, 30.967, 0.0], [34.265, 31.219, 0.0], [34.923, 29.501, 0.0]
        ]]
      }
    },
    "EG",
    "EGY"
    ],
    [
      "Spain",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-9.035, 41.881, 0.0], [-8.984, 42.593, 0.0], [-9.393, 43.027, 0.0], [-7.978, 43.748, 0.0], [-6.754, 43.568, 0.0], [-5.412, 43.574, 0.0], [-4.348, 43.403, 0.0], [-3.518, 43.456, 0.0], [-1.901, 43.423, 0.0], [-1.503, 43.034, 0.0], [0.338, 42.58, 0.0], [0.702, 42.796, 0.0], [1.827, 42.343, 0.0], [2.986, 42.473, 0.0], [3.039, 41.892, 0.0], [2.092, 41.226, 0.0], [0.811, 41.015, 0.0], [0.721, 40.678, 0.0], [0.107, 40.124, 0.0], [-0.279, 39.31, 0.0], [0.111, 38.739, 0.0], [-0.467, 38.292, 0.0], [-0.683, 37.642, 0.0], [-1.438, 37.443, 0.0], [-2.146, 36.674, 0.0], [-3.416, 36.659, 0.0], [-4.369, 36.678, 0.0], [-4.995, 36.325, 0.0], [-5.377, 35.947, 0.0], [-5.866, 36.03, 0.0], [-6.237, 36.368, 0.0], [-6.52, 36.943, 0.0], [-7.454, 37.098, 0.0], [-7.537, 37.429, 0.0], [-7.167, 37.804, 0.0], [-7.029, 38.076, 0.0], [-7.374, 38.373, 0.0], [-7.098, 39.03, 0.0], [-7.499, 39.63, 0.0], [-7.067, 39.712, 0.0], [-7.026, 40.185, 0.0], [-6.864, 40.331, 0.0], [-6.851, 41.111, 0.0], [-6.389, 41.382, 0.0], [-6.669, 41.883, 0.0], [-7.251, 41.918, 0.0], [-7.423, 41.792, 0.0], [-8.013, 41.791, 0.0], [-8.264, 42.28, 0.0], [-8.672, 42.135, 0.0], [-9.035, 41.881, 0.0]
        ]]
      }
    },
    "ES",
    "ESP"
    ],
    [
      "Finland",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [28.592, 69.065, 0.0], [28.446, 68.365, 0.0], [29.977, 67.698, 0.0], [29.055, 66.944, 0.0], [30.218, 65.806, 0.0], [29.544, 64.949, 0.0], [30.445, 64.204, 0.0], [30.036, 63.553, 0.0], [31.516, 62.868, 0.0], [31.14, 62.358, 0.0], [30.211, 61.78, 0.0], [28.07, 60.504, 0.0], [26.255, 60.424, 0.0], [24.497, 60.057, 0.0], [22.87, 59.846, 0.0], [22.291, 60.392, 0.0], [21.322, 60.72, 0.0], [21.545, 61.705, 0.0], [21.059, 62.607, 0.0], [21.536, 63.19, 0.0], [22.443, 63.818, 0.0], [24.731, 64.902, 0.0], [25.398, 65.111, 0.0], [25.294, 65.534, 0.0], [23.903, 66.007, 0.0], [23.566, 66.396, 0.0], [23.539, 67.936, 0.0], [21.979, 68.617, 0.0], [20.646, 69.106, 0.0], [21.245, 69.37, 0.0], [22.356, 68.842, 0.0], [23.662, 68.891, 0.0], [24.736, 68.65, 0.0], [25.689, 69.092, 0.0], [26.18, 69.825, 0.0], [27.732, 70.164, 0.0], [29.016, 69.766, 0.0], [28.592, 69.065, 0.0]
        ]]
      }
    },
    "FI",
    "FIN"
    ],
    [
      "Gambia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-16.842, 13.151, 0.0], [-16.714, 13.595, 0.0], [-15.625, 13.624, 0.0], [-15.399, 13.86, 0.0], [-15.082, 13.876, 0.0], [-14.687, 13.63, 0.0], [-14.377, 13.626, 0.0], [-14.047, 13.794, 0.0], [-13.845, 13.505, 0.0], [-14.278, 13.281, 0.0], [-14.712, 13.298, 0.0], [-15.141, 13.51, 0.0], [-15.512, 13.279, 0.0], [-15.691, 13.27, 0.0], [-15.931, 13.13, 0.0], [-16.842, 13.151, 0.0]
        ]]
      }
    },
    "GM",
    "GMB"
    ],
    [
      "Greenland",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-46.764, 82.628, 0.0], [-43.406, 83.225, 0.0], [-39.898, 83.18, 0.0], [-38.622, 83.549, 0.0], [-35.088, 83.645, 0.0], [-27.1, 83.52, 0.0], [-20.845, 82.727, 0.0], [-22.692, 82.342, 0.0], [-26.518, 82.298, 0.0], [-31.9, 82.2, 0.0], [-31.396, 82.022, 0.0], [-27.857, 82.132, 0.0], [-24.844, 81.787, 0.0], [-22.903, 82.093, 0.0], [-22.072, 81.734, 0.0], [-23.17, 81.153, 0.0], [-20.624, 81.525, 0.0], [-15.768, 81.912, 0.0], [-12.77, 81.719, 0.0], [-12.209, 81.292, 0.0], [-16.285, 80.58, 0.0], [-16.85, 80.35, 0.0], [-20.046, 80.177, 0.0], [-17.73, 80.129, 0.0], [-18.9, 79.4, 0.0], [-19.705, 78.751, 0.0], [-19.674, 77.639, 0.0], [-18.473, 76.986, 0.0], [-20.035, 76.944, 0.0], [-21.679, 76.628, 0.0], [-19.834, 76.098, 0.0], [-19.599, 75.248, 0.0], [-20.668, 75.156, 0.0], [-19.373, 74.296, 0.0], [-21.594, 74.224, 0.0], [-20.435, 73.817, 0.0], [-20.762, 73.464, 0.0], [-22.172, 73.31, 0.0], [-23.566, 73.307, 0.0], [-22.313, 72.629, 0.0], [-22.3, 72.184, 0.0], [-24.278, 72.598, 0.0], [-24.793, 72.33, 0.0], [-23.443, 72.08, 0.0], [-22.133, 71.469, 0.0], [-21.754, 70.664, 0.0], [-23.536, 70.471, 0.0], [-24.307, 70.856, 0.0], [-25.543, 71.431, 0.0], [-25.201, 70.752, 0.0], [-26.363, 70.226, 0.0], [-23.727, 70.184, 0.0], [-22.349, 70.129, 0.0], [-25.029, 69.259, 0.0], [-27.747, 68.47, 0.0], [-30.674, 68.125, 0.0], [-31.777, 68.121, 0.0], [-32.811, 67.735, 0.0], [-34.202, 66.68, 0.0], [-36.353, 65.979, 0.0], [-37.044, 65.938, 0.0], [-38.375, 65.692, 0.0], [-39.812, 65.458, 0.0], [-40.669, 64.84, 0.0], [-40.683, 64.139, 0.0], [-41.189, 63.482, 0.0], [-42.819, 62.682, 0.0], [-42.417, 61.901, 0.0], [-42.866, 61.074, 0.0], [-43.378, 60.098, 0.0], [-44.788, 60.037, 0.0], [-46.264, 60.853, 0.0], [-48.263, 60.858, 0.0], [-49.233, 61.407, 0.0], [-49.9, 62.383, 0.0], [-51.633, 63.627, 0.0], [-52.14, 64.278, 0.0], [-52.277, 65.177, 0.0], [-53.662, 66.1, 0.0], [-53.302, 66.837, 0.0], [-53.969, 67.189, 0.0], [-52.98, 68.358, 0.0], [-51.475, 68.73, 0.0], [-51.08, 69.148, 0.0], [-50.871, 69.929, 0.0], [-52.014, 69.575, 0.0], [-52.558, 69.426, 0.0], [-53.456, 69.284, 0.0], [-54.683, 69.61, 0.0], [-54.75, 70.289, 0.0], [-54.359, 70.821, 0.0], [-53.431, 70.836, 0.0], [-51.39, 70.57, 0.0], [-53.109, 71.205, 0.0], [-54.004, 71.547, 0.0], [-55.0, 71.407, 0.0], [-55.835, 71.654, 0.0], [-54.718, 72.586, 0.0], [-55.326, 72.959, 0.0], [-56.12, 73.65, 0.0], [-57.324, 74.71, 0.0], [-58.597, 75.099, 0.0], [-58.585, 75.517, 0.0], [-61.269, 76.102, 0.0], [-63.392, 76.175, 0.0], [-66.064, 76.135, 0.0], [-68.504, 76.061, 0.0], [-69.665, 76.38, 0.0], [-71.403, 77.009, 0.0], [-68.777, 77.323, 0.0], [-66.764, 77.376, 0.0], [-71.043, 77.636, 0.0], [-73.297, 78.044, 0.0], [-73.159, 78.433, 0.0], [-69.373, 78.914, 0.0], [-65.711, 79.394, 0.0], [-65.324, 79.758, 0.0], [-68.023, 80.117, 0.0], [-67.151, 80.516, 0.0], [-63.689, 81.214, 0.0], [-62.234, 81.321, 0.0], [-62.651, 81.77, 0.0], [-60.282, 82.034, 0.0], [-57.207, 82.191, 0.0], [-54.134, 82.2, 0.0], [-53.043, 81.888, 0.0], [-50.391, 82.439, 0.0], [-48.004, 82.065, 0.0], [-46.6, 81.986, 0.0], [-44.523, 81.661, 0.0], [-46.901, 82.2, 0.0], [-46.764, 82.628, 0.0]
        ]]
      }
    },
    "GL",
    "GRL"
    ],
    [
      "Iraq",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [45.421, 35.978, 0.0], [46.076, 35.677, 0.0], [46.152, 35.093, 0.0], [45.648, 34.748, 0.0], [45.417, 33.968, 0.0], [46.109, 33.017, 0.0], [47.335, 32.469, 0.0], [47.849, 31.709, 0.0], [47.685, 30.985, 0.0], [48.005, 30.985, 0.0], [48.015, 30.452, 0.0], [48.568, 29.927, 0.0], [47.975, 29.976, 0.0], [47.303, 30.059, 0.0], [46.569, 29.099, 0.0], [44.709, 29.179, 0.0], [41.89, 31.19, 0.0], [40.4, 31.89, 0.0], [39.195, 32.161, 0.0], [38.792, 33.379, 0.0], [41.006, 34.419, 0.0], [41.384, 35.628, 0.0], [41.29, 36.359, 0.0], [41.837, 36.606, 0.0], [42.35, 37.23, 0.0], [42.779, 37.385, 0.0], [43.942, 37.256, 0.0], [44.293, 37.002, 0.0], [44.773, 37.17, 0.0], [45.421, 35.978, 0.0]
        ]]
      }
    },
    "IQ",
    "IRQ"
    ],
    [
      "S. Korea",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [128.35, 38.612, 0.0], [129.213, 37.432, 0.0], [129.46, 36.784, 0.0], [129.468, 35.632, 0.0], [129.091, 35.082, 0.0], [128.186, 34.89, 0.0], [127.387, 34.476, 0.0], [126.486, 34.39, 0.0], [126.374, 34.935, 0.0], [126.559, 35.685, 0.0], [126.117, 36.725, 0.0], [126.86, 36.894, 0.0], [126.175, 37.75, 0.0], [126.237, 37.84, 0.0], [126.684, 37.805, 0.0], [127.073, 38.256, 0.0], [127.78, 38.305, 0.0], [128.206, 38.37, 0.0], [128.35, 38.612, 0.0]
        ]]
      }
    },
    "KR",
    "KOR"
    ],
    [
      "Kosovo",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [20.762, 42.052, 0.0], [20.717, 41.847, 0.0], [20.59, 41.855, 0.0], [20.523, 42.218, 0.0], [20.284, 42.32, 0.0], [20.071, 42.589, 0.0], [20.258, 42.813, 0.0], [20.497, 42.885, 0.0], [20.635, 43.217, 0.0], [20.814, 43.272, 0.0], [20.957, 43.131, 0.0], [21.143, 43.069, 0.0], [21.274, 42.91, 0.0], [21.439, 42.863, 0.0], [21.633, 42.677, 0.0], [21.775, 42.683, 0.0], [21.663, 42.439, 0.0], [21.543, 42.32, 0.0], [21.577, 42.245, 0.0], [21.353, 42.207, 0.0], [20.762, 42.052, 0.0]
        ]]
      }
    },
    "-99",
    "-99"
    ],
    [
      "Malaysia",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [101.076, 6.205, 0.0], [101.154, 5.691, 0.0], [101.814, 5.811, 0.0], [102.141, 6.222, 0.0], [102.371, 6.128, 0.0], [102.962, 5.524, 0.0], [103.381, 4.855, 0.0], [103.439, 4.182, 0.0], [103.332, 3.727, 0.0], [103.429, 3.383, 0.0], [103.502, 2.791, 0.0], [103.855, 2.515, 0.0], [104.248, 1.631, 0.0], [104.229, 1.293, 0.0], [103.52, 1.226, 0.0], [102.574, 1.967, 0.0], [101.391, 2.761, 0.0], [101.274, 3.27, 0.0], [100.695, 3.939, 0.0], [100.557, 4.767, 0.0], [100.197, 5.312, 0.0], [100.306, 6.041, 0.0], [100.086, 6.464, 0.0], [100.26, 6.643, 0.0], [101.076, 6.205, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [118.618, 4.478, 0.0], [117.882, 4.138, 0.0], [117.015, 4.306, 0.0], [115.866, 4.307, 0.0], [115.519, 3.169, 0.0], [115.134, 2.821, 0.0], [114.621, 1.431, 0.0], [113.806, 1.218, 0.0], [112.86, 1.498, 0.0], [112.38, 1.41, 0.0], [111.798, 0.904, 0.0], [111.159, 0.976, 0.0], [110.514, 0.773, 0.0], [109.83, 1.338, 0.0], [109.663, 2.006, 0.0], [110.396, 1.664, 0.0], [111.169, 1.851, 0.0], [111.37, 2.697, 0.0], [111.797, 2.886, 0.0], [112.996, 3.102, 0.0], [113.713, 3.894, 0.0], [114.204, 4.526, 0.0], [114.66, 4.008, 0.0], [114.87, 4.348, 0.0], [115.347, 4.317, 0.0], [115.406, 4.955, 0.0], [115.451, 5.448, 0.0], [116.221, 6.143, 0.0], [116.725, 6.925, 0.0], [117.13, 6.928, 0.0], [117.643, 6.422, 0.0], [117.689, 5.987, 0.0], [118.348, 5.709, 0.0], [119.182, 5.408, 0.0], [119.111, 5.016, 0.0], [118.44, 4.967, 0.0], [118.618, 4.478, 0.0]
       ]
      ]
     }
    ]
    },
    "MY",
    "MYS"
    ],
    [
      "Namibia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [16.345, -28.577, 0.0], [15.602, -27.821, 0.0], [15.21, -27.091, 0.0], [14.99, -26.117, 0.0], [14.743, -25.393, 0.0], [14.408, -23.853, 0.0], [14.386, -22.657, 0.0], [14.258, -22.111, 0.0], [13.869, -21.699, 0.0], [13.352, -20.873, 0.0], [12.827, -19.673, 0.0], [12.609, -19.045, 0.0], [11.795, -18.069, 0.0], [11.734, -17.302, 0.0], [12.215, -17.112, 0.0], [12.814, -16.941, 0.0], [13.462, -16.971, 0.0], [14.059, -17.423, 0.0], [14.21, -17.353, 0.0], [18.263, -17.31, 0.0], [18.956, -17.789, 0.0], [21.377, -17.931, 0.0], [23.215, -17.523, 0.0], [24.034, -17.296, 0.0], [24.682, -17.353, 0.0], [25.077, -17.579, 0.0], [25.084, -17.662, 0.0], [24.521, -17.887, 0.0], [24.217, -17.889, 0.0], [23.579, -18.281, 0.0], [23.197, -17.869, 0.0], [21.655, -18.219, 0.0], [20.911, -18.252, 0.0], [20.881, -21.814, 0.0], [19.895, -21.849, 0.0], [19.896, -24.768, 0.0], [19.895, -28.461, 0.0], [19.002, -28.972, 0.0], [18.465, -29.045, 0.0], [17.836, -28.856, 0.0], [17.387, -28.784, 0.0], [17.219, -28.356, 0.0], [16.824, -28.082, 0.0], [16.345, -28.577, 0.0]
        ]]
      }
    },
    "NA",
    "NAM"
    ],
    [
      "Norway",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [28.166, 71.185, 0.0], [31.293, 70.454, 0.0], [30.005, 70.186, 0.0], [31.101, 69.558, 0.0], [29.4, 69.157, 0.0], [28.592, 69.065, 0.0], [29.016, 69.766, 0.0], [27.732, 70.164, 0.0], [26.18, 69.825, 0.0], [25.689, 69.092, 0.0], [24.736, 68.65, 0.0], [23.662, 68.891, 0.0], [22.356, 68.842, 0.0], [21.245, 69.37, 0.0], [20.646, 69.106, 0.0], [20.025, 69.065, 0.0], [19.879, 68.407, 0.0], [17.994, 68.567, 0.0], [17.729, 68.011, 0.0], [16.769, 68.014, 0.0], [16.109, 67.302, 0.0], [15.108, 66.194, 0.0], [13.556, 64.787, 0.0], [13.92, 64.445, 0.0], [13.572, 64.049, 0.0], [12.58, 64.066, 0.0], [11.931, 63.128, 0.0], [11.992, 61.8, 0.0], [12.631, 61.294, 0.0], [12.3, 60.118, 0.0], [11.468, 59.432, 0.0], [11.027, 58.856, 0.0], [10.357, 59.47, 0.0], [8.382, 58.313, 0.0], [7.049, 58.079, 0.0], [5.666, 58.588, 0.0], [5.308, 59.663, 0.0], [4.992, 61.971, 0.0], [5.913, 62.614, 0.0], [8.553, 63.454, 0.0], [10.528, 64.486, 0.0], [12.358, 65.88, 0.0], [14.761, 67.811, 0.0], [16.436, 68.563, 0.0], [19.184, 69.817, 0.0], [21.378, 70.255, 0.0], [23.024, 70.202, 0.0], [24.547, 71.03, 0.0], [26.37, 70.986, 0.0], [28.166, 71.185, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [24.724, 77.854, 0.0], [22.49, 77.445, 0.0], [20.726, 77.677, 0.0], [21.416, 77.935, 0.0], [20.812, 78.255, 0.0], [22.884, 78.455, 0.0], [23.281, 78.08, 0.0], [24.724, 77.854, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [18.252, 79.702, 0.0], [21.544, 78.956, 0.0], [19.027, 78.563, 0.0], [18.472, 77.827, 0.0], [17.594, 77.638, 0.0], [17.118, 76.809, 0.0], [15.913, 76.77, 0.0], [13.763, 77.38, 0.0], [14.67, 77.736, 0.0], [13.171, 78.025, 0.0], [11.222, 78.869, 0.0], [10.445, 79.652, 0.0], [13.171, 80.01, 0.0], [13.719, 79.66, 0.0], [15.143, 79.674, 0.0], [15.523, 80.016, 0.0], [16.991, 80.051, 0.0], [18.252, 79.702, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [25.448, 80.407, 0.0], [27.408, 80.056, 0.0], [25.925, 79.518, 0.0], [23.024, 79.4, 0.0], [20.075, 79.567, 0.0], [19.897, 79.842, 0.0], [18.462, 79.86, 0.0], [17.368, 80.319, 0.0], [20.456, 80.598, 0.0], [21.908, 80.358, 0.0], [22.919, 80.657, 0.0], [25.448, 80.407, 0.0]
       ]
      ]
     }
    ]
    },
    "NO",
    "NOR"
    ],
    [
      "N. Korea",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [130.64, 42.395, 0.0], [130.78, 42.22, 0.0], [130.4, 42.28, 0.0], [129.966, 41.941, 0.0], [129.667, 41.601, 0.0], [129.705, 40.883, 0.0], [129.188, 40.662, 0.0], [129.01, 40.485, 0.0], [128.633, 40.19, 0.0], [127.967, 40.025, 0.0], [127.533, 39.757, 0.0], [127.502, 39.324, 0.0], [127.385, 39.213, 0.0], [127.783, 39.051, 0.0], [128.35, 38.612, 0.0], [128.206, 38.37, 0.0], [127.78, 38.305, 0.0], [127.073, 38.256, 0.0], [126.684, 37.805, 0.0], [126.237, 37.84, 0.0], [126.175, 37.75, 0.0], [125.689, 37.94, 0.0], [125.568, 37.752, 0.0], [125.275, 37.669, 0.0], [125.24, 37.857, 0.0], [124.981, 37.949, 0.0], [124.712, 38.108, 0.0], [124.986, 38.548, 0.0], [125.222, 38.666, 0.0], [125.133, 38.849, 0.0], [125.387, 39.388, 0.0], [125.321, 39.551, 0.0], [124.737, 39.66, 0.0], [124.266, 39.928, 0.0], [125.08, 40.57, 0.0], [126.182, 41.107, 0.0], [126.869, 41.817, 0.0], [127.344, 41.503, 0.0], [128.208, 41.467, 0.0], [128.052, 41.994, 0.0], [129.597, 42.425, 0.0], [129.994, 42.985, 0.0], [130.64, 42.395, 0.0]
        ]]
      }
    },
    "KP",
    "PRK"
    ],
    [
      "Somaliland",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [48.938, 9.452, 0.0], [48.487, 8.838, 0.0], [47.789, 8.003, 0.0], [46.948, 7.997, 0.0], [43.679, 9.184, 0.0], [43.297, 9.54, 0.0], [42.928, 10.022, 0.0], [42.559, 10.573, 0.0], [42.777, 10.927, 0.0], [43.145, 11.462, 0.0], [43.471, 11.278, 0.0], [43.667, 10.864, 0.0], [44.118, 10.446, 0.0], [44.614, 10.442, 0.0], [45.557, 10.698, 0.0], [46.645, 10.817, 0.0], [47.526, 11.127, 0.0], [48.022, 11.193, 0.0], [48.379, 11.375, 0.0], [48.948, 11.411, 0.0], [48.942, 11.394, 0.0], [48.938, 10.982, 0.0], [48.938, 9.974, 0.0], [48.938, 9.452, 0.0]
        ]]
      }
    },
    "-99",
    "-99"
    ],
    [
      "Turkmenistan",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [61.211, 35.65, 0.0], [61.123, 36.492, 0.0], [60.378, 36.527, 0.0], [59.235, 37.413, 0.0], [58.436, 37.522, 0.0], [57.33, 38.029, 0.0], [56.619, 38.121, 0.0], [56.18, 37.935, 0.0], [55.512, 37.964, 0.0], [54.8, 37.392, 0.0], [53.922, 37.199, 0.0], [53.736, 37.906, 0.0], [53.881, 38.952, 0.0], [53.101, 39.291, 0.0], [53.358, 39.975, 0.0], [52.694, 40.034, 0.0], [52.915, 40.877, 0.0], [53.858, 40.631, 0.0], [54.737, 40.951, 0.0], [54.008, 41.551, 0.0], [53.722, 42.123, 0.0], [52.917, 41.868, 0.0], [52.815, 41.135, 0.0], [52.502, 41.783, 0.0], [52.944, 42.116, 0.0], [54.079, 42.324, 0.0], [54.755, 42.044, 0.0], [55.455, 41.26, 0.0], [55.968, 41.309, 0.0], [57.096, 41.322, 0.0], [56.932, 41.826, 0.0], [57.787, 42.171, 0.0], [58.629, 42.752, 0.0], [59.976, 42.223, 0.0], [60.083, 41.425, 0.0], [60.466, 41.22, 0.0], [61.547, 41.266, 0.0], [61.883, 41.085, 0.0], [62.374, 40.054, 0.0], [63.518, 39.363, 0.0], [64.17, 38.892, 0.0], [65.216, 38.403, 0.0], [66.546, 37.975, 0.0], [66.519, 37.363, 0.0], [66.217, 37.394, 0.0], [65.746, 37.661, 0.0], [65.589, 37.305, 0.0], [64.746, 37.112, 0.0], [64.546, 36.312, 0.0], [63.983, 36.008, 0.0], [63.194, 35.857, 0.0], [62.985, 35.404, 0.0], [62.231, 35.271, 0.0], [61.211, 35.65, 0.0]
        ]]
      }
    },
    "TM",
    "TKM"
    ],
    [
      "Taiwan",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [121.778, 24.394, 0.0], [121.176, 22.791, 0.0], [120.747, 21.971, 0.0], [120.22, 22.815, 0.0], [120.106, 23.556, 0.0], [120.695, 24.538, 0.0], [121.495, 25.295, 0.0], [121.951, 24.998, 0.0], [121.778, 24.394, 0.0]
        ]]
      }
    },
    "TW",
    "TWN"
    ],
    [
      "Tanzania",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [33.904, -0.95, 0.0], [34.073, -1.06, 0.0], [37.699, -3.097, 0.0], [37.767, -3.677, 0.0], [39.202, -4.677, 0.0], [38.741, -5.909, 0.0], [38.8, -6.476, 0.0], [39.44, -6.84, 0.0], [39.47, -7.1, 0.0], [39.195, -7.704, 0.0], [39.252, -8.008, 0.0], [39.187, -8.486, 0.0], [39.536, -9.112, 0.0], [39.95, -10.098, 0.0], [40.317, -10.317, 0.0], [39.521, -10.897, 0.0], [38.428, -11.285, 0.0], [37.828, -11.269, 0.0], [37.471, -11.569, 0.0], [36.775, -11.595, 0.0], [36.514, -11.721, 0.0], [35.312, -11.439, 0.0], [34.56, -11.52, 0.0], [34.28, -10.16, 0.0], [33.941, -9.694, 0.0], [33.74, -9.417, 0.0], [32.759, -9.231, 0.0], [32.192, -8.93, 0.0], [31.556, -8.762, 0.0], [31.158, -8.595, 0.0], [30.74, -8.34, 0.0], [30.2, -7.08, 0.0], [29.62, -6.52, 0.0], [29.42, -5.94, 0.0], [29.52, -5.42, 0.0], [29.34, -4.5, 0.0], [29.754, -4.452, 0.0], [30.116, -4.09, 0.0], [30.506, -3.569, 0.0], [30.752, -3.359, 0.0], [30.743, -3.034, 0.0], [30.528, -2.808, 0.0], [30.47, -2.414, 0.0], [30.758, -2.287, 0.0], [30.816, -1.699, 0.0], [30.419, -1.135, 0.0], [30.77, -1.015, 0.0], [31.866, -1.027, 0.0], [33.904, -0.95, 0.0]
        ]]
      }
    },
    "TZ",
    "TZA"
    ],
    [
      "Venezuela",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-71.332, 11.776, 0.0], [-71.36, 11.54, 0.0], [-71.947, 11.423, 0.0], [-71.621, 10.969, 0.0], [-71.633, 10.446, 0.0], [-72.074, 9.866, 0.0], [-71.696, 9.072, 0.0], [-71.265, 9.137, 0.0], [-71.04, 9.86, 0.0], [-71.35, 10.212, 0.0], [-71.401, 10.969, 0.0], [-70.155, 11.375, 0.0], [-70.294, 11.847, 0.0], [-69.943, 12.162, 0.0], [-69.584, 11.46, 0.0], [-68.883, 11.443, 0.0], [-68.233, 10.886, 0.0], [-68.194, 10.555, 0.0], [-67.296, 10.546, 0.0], [-66.228, 10.649, 0.0], [-65.655, 10.201, 0.0], [-64.89, 10.077, 0.0], [-64.329, 10.39, 0.0], [-64.318, 10.641, 0.0], [-63.079, 10.702, 0.0], [-61.881, 10.716, 0.0], [-62.73, 10.42, 0.0], [-62.389, 9.948, 0.0], [-61.589, 9.873, 0.0], [-60.831, 9.381, 0.0], [-60.671, 8.58, 0.0], [-60.15, 8.603, 0.0], [-59.758, 8.367, 0.0], [-60.551, 7.78, 0.0], [-60.638, 7.415, 0.0], [-60.296, 7.044, 0.0], [-60.544, 6.857, 0.0], [-61.159, 6.696, 0.0], [-61.139, 6.234, 0.0], [-61.41, 5.959, 0.0], [-60.734, 5.2, 0.0], [-60.601, 4.918, 0.0], [-60.967, 4.536, 0.0], [-62.085, 4.162, 0.0], [-62.805, 4.007, 0.0], [-63.093, 3.771, 0.0], [-63.888, 4.021, 0.0], [-64.629, 4.148, 0.0], [-64.816, 4.056, 0.0], [-64.368, 3.797, 0.0], [-64.409, 3.127, 0.0], [-64.27, 2.497, 0.0], [-63.423, 2.411, 0.0], [-63.369, 2.201, 0.0], [-64.083, 1.916, 0.0], [-64.199, 1.493, 0.0], [-64.611, 1.329, 0.0], [-65.355, 1.095, 0.0], [-65.548, 0.789, 0.0], [-66.326, 0.724, 0.0], [-66.876, 1.253, 0.0], [-67.181, 2.251, 0.0], [-67.447, 2.6, 0.0], [-67.81, 2.821, 0.0], [-67.303, 3.318, 0.0], [-67.338, 3.542, 0.0], [-67.622, 3.839, 0.0], [-67.823, 4.504, 0.0], [-67.745, 5.221, 0.0], [-67.522, 5.557, 0.0], [-67.341, 6.095, 0.0], [-67.695, 6.267, 0.0], [-68.265, 6.153, 0.0], [-68.985, 6.207, 0.0], [-69.389, 6.1, 0.0], [-70.093, 6.96, 0.0], [-70.674, 7.088, 0.0], [-71.96, 6.992, 0.0], [-72.198, 7.34, 0.0], [-72.444, 7.424, 0.0], [-72.48, 7.633, 0.0], [-72.361, 8.003, 0.0], [-72.44, 8.405, 0.0], [-72.66, 8.625, 0.0], [-72.789, 9.085, 0.0], [-73.305, 9.152, 0.0], [-73.028, 9.737, 0.0], [-72.905, 10.45, 0.0], [-72.615, 10.822, 0.0], [-72.228, 11.109, 0.0], [-71.974, 11.609, 0.0], [-71.332, 11.776, 0.0]
        ]]
      }
    },
    "VE",
    "VEN"
    ],
    [
      "Vanuatu",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [167.845, -16.466, 0.0], [167.515, -16.598, 0.0], [167.18, -16.16, 0.0], [167.217, -15.892, 0.0], [167.845, -16.466, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [167.108, -14.934, 0.0], [167.27, -15.74, 0.0], [167.001, -15.615, 0.0], [166.793, -15.669, 0.0], [166.65, -15.393, 0.0], [166.629, -14.626, 0.0], [167.108, -14.934, 0.0]
       ]
      ]
     }
    ]
    },
    "VU",
    "VUT"
    ],
    [
      "Antarctica",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-59.572, -80.04, 0.0], [-59.866, -80.55, 0.0], [-60.16, -81.0, 0.0], [-62.255, -80.863, 0.0], [-64.488, -80.922, 0.0], [-65.742, -80.589, 0.0], [-65.742, -80.55, 0.0], [-66.29, -80.256, 0.0], [-64.038, -80.295, 0.0], [-61.883, -80.393, 0.0], [-61.139, -79.981, 0.0], [-60.61, -79.629, 0.0], [-59.572, -80.04, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-159.208, -79.497, 0.0], [-161.128, -79.634, 0.0], [-162.44, -79.281, 0.0], [-163.027, -78.929, 0.0], [-163.067, -78.87, 0.0], [-163.713, -78.596, 0.0], [-163.713, -78.596, 0.0], [-163.106, -78.223, 0.0], [-161.245, -78.38, 0.0], [-160.246, -78.694, 0.0], [-159.482, -79.046, 0.0], [-159.208, -79.497, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-45.155, -78.047, 0.0], [-43.921, -78.478, 0.0], [-43.49, -79.086, 0.0], [-43.372, -79.517, 0.0], [-43.333, -80.026, 0.0], [-44.881, -80.34, 0.0], [-46.506, -80.594, 0.0], [-48.386, -80.829, 0.0], [-50.482, -81.025, 0.0], [-52.852, -80.967, 0.0], [-54.164, -80.634, 0.0], [-53.988, -80.222, 0.0], [-51.853, -79.948, 0.0], [-50.991, -79.615, 0.0], [-50.365, -79.183, 0.0], [-49.914, -78.811, 0.0], [-49.307, -78.459, 0.0], [-48.661, -78.047, 0.0], [-48.661, -78.047, 0.0], [-48.151, -78.047, 0.0], [-46.663, -77.831, 0.0], [-45.155, -78.047, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-121.212, -73.501, 0.0], [-119.919, -73.658, 0.0], [-118.724, -73.481, 0.0], [-119.292, -73.834, 0.0], [-120.232, -74.089, 0.0], [-121.623, -74.01, 0.0], [-122.622, -73.658, 0.0], [-122.622, -73.658, 0.0], [-122.406, -73.325, 0.0], [-121.212, -73.501, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-125.56, -73.481, 0.0], [-124.032, -73.873, 0.0], [-124.619, -73.834, 0.0], [-125.912, -73.736, 0.0], [-127.283, -73.462, 0.0], [-127.283, -73.462, 0.0], [-126.558, -73.246, 0.0], [-125.56, -73.481, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-98.982, -71.933, 0.0], [-97.885, -72.071, 0.0], [-96.788, -71.953, 0.0], [-96.2, -72.521, 0.0], [-96.984, -72.443, 0.0], [-98.198, -72.482, 0.0], [-99.432, -72.443, 0.0], [-100.783, -72.502, 0.0], [-101.802, -72.306, 0.0], [-102.331, -71.894, 0.0], [-102.331, -71.894, 0.0], [-101.704, -71.718, 0.0], [-100.431, -71.855, 0.0], [-98.982, -71.933, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-68.451, -70.956, 0.0], [-68.334, -71.406, 0.0], [-68.51, -71.798, 0.0], [-68.784, -72.171, 0.0], [-69.959, -72.308, 0.0], [-71.076, -72.504, 0.0], [-72.388, -72.484, 0.0], [-71.898, -72.092, 0.0], [-73.074, -72.229, 0.0], [-74.19, -72.367, 0.0], [-74.954, -72.073, 0.0], [-75.013, -71.661, 0.0], [-73.916, -71.269, 0.0], [-73.916, -71.269, 0.0], [-73.23, -71.152, 0.0], [-72.075, -71.191, 0.0], [-71.781, -70.681, 0.0], [-71.722, -70.309, 0.0], [-71.742, -69.506, 0.0], [-71.174, -69.035, 0.0], [-70.253, -68.879, 0.0], [-69.724, -69.251, 0.0], [-69.489, -69.623, 0.0], [-69.059, -70.074, 0.0], [-68.726, -70.505, 0.0], [-68.451, -70.956, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-58.614, -64.152, 0.0], [-59.045, -64.368, 0.0], [-59.789, -64.211, 0.0], [-60.612, -64.309, 0.0], [-61.297, -64.544, 0.0], [-62.022, -64.799, 0.0], [-62.512, -65.093, 0.0], [-62.649, -65.485, 0.0], [-62.59, -65.857, 0.0], [-62.12, -66.19, 0.0], [-62.806, -66.426, 0.0], [-63.746, -66.504, 0.0], [-64.294, -66.837, 0.0], [-64.882, -67.15, 0.0], [-65.508, -67.582, 0.0], [-65.665, -67.954, 0.0], [-65.313, -68.365, 0.0], [-64.784, -68.679, 0.0], [-63.961, -68.914, 0.0], [-63.197, -69.228, 0.0], [-62.786, -69.619, 0.0], [-62.571, -69.992, 0.0], [-62.277, -70.384, 0.0], [-61.807, -70.717, 0.0], [-61.513, -71.089, 0.0], [-61.376, -72.01, 0.0], [-61.082, -72.382, 0.0], [-61.004, -72.774, 0.0], [-60.69, -73.166, 0.0], [-60.827, -73.695, 0.0], [-61.376, -74.107, 0.0], [-61.963, -74.44, 0.0], [-63.295, -74.577, 0.0], [-63.746, -74.93, 0.0], [-64.353, -75.263, 0.0], [-65.861, -75.635, 0.0], [-67.193, -75.792, 0.0], [-68.446, -76.007, 0.0], [-69.798, -76.223, 0.0], [-70.601, -76.634, 0.0], [-72.207, -76.674, 0.0], [-73.97, -76.634, 0.0], [-75.556, -76.713, 0.0], [-77.24, -76.713, 0.0], [-76.927, -77.105, 0.0], [-75.399, -77.281, 0.0], [-74.283, -77.555, 0.0], [-73.656, -77.908, 0.0], [-74.773, -78.222, 0.0], [-76.496, -78.124, 0.0], [-77.926, -78.378, 0.0], [-77.985, -78.79, 0.0], [-78.024, -79.182, 0.0], [-76.849, -79.515, 0.0], [-76.633, -79.887, 0.0], [-75.36, -80.26, 0.0], [-73.245, -80.416, 0.0], [-71.443, -80.691, 0.0], [-70.013, -81.004, 0.0], [-68.192, -81.318, 0.0], [-65.704, -81.474, 0.0], [-63.256, -81.749, 0.0], [-61.552, -82.043, 0.0], [-59.691, -82.376, 0.0], [-58.712, -82.846, 0.0], [-58.222, -83.218, 0.0], [-57.008, -82.866, 0.0], [-55.363, -82.572, 0.0], [-53.62, -82.258, 0.0], [-51.544, -82.004, 0.0], [-49.761, -81.729, 0.0], [-47.274, -81.71, 0.0], [-44.826, -81.847, 0.0], [-42.808, -82.082, 0.0], [-42.162, -81.651, 0.0], [-40.771, -81.357, 0.0], [-38.245, -81.337, 0.0], [-36.267, -81.122, 0.0], [-34.386, -80.906, 0.0], [-32.31, -80.769, 0.0], [-30.097, -80.593, 0.0], [-28.55, -80.338, 0.0], [-29.255, -79.985, 0.0], [-29.686, -79.633, 0.0], [-29.686, -79.26, 0.0], [-31.625, -79.299, 0.0], [-33.681, -79.456, 0.0], [-35.64, -79.456, 0.0], [-35.914, -79.084, 0.0], [-35.777, -78.339, 0.0], [-35.327, -78.124, 0.0], [-33.897, -77.889, 0.0], [-32.212, -77.653, 0.0], [-30.998, -77.36, 0.0], [-29.784, -77.066, 0.0], [-28.883, -76.674, 0.0], [-27.512, -76.497, 0.0], [-26.16, -76.36, 0.0], [-25.475, -76.282, 0.0], [-23.928, -76.243, 0.0], [-22.459, -76.105, 0.0], [-21.225, -75.909, 0.0], [-20.01, -75.674, 0.0], [-18.914, -75.439, 0.0], [-17.523, -75.126, 0.0], [-16.642, -74.793, 0.0], [-15.701, -74.499, 0.0], [-15.408, -74.107, 0.0], [-16.465, -73.872, 0.0], [-16.113, -73.46, 0.0], [-15.447, -73.147, 0.0], [-14.409, -72.951, 0.0], [-13.312, -72.715, 0.0], [-12.294, -72.402, 0.0], [-11.51, -72.01, 0.0], [-11.02, -71.54, 0.0], [-10.296, -71.265, 0.0], [-9.101, -71.324, 0.0], [-8.611, -71.657, 0.0], [-7.417, -71.697, 0.0], [-7.377, -71.324, 0.0], [-6.868, -70.932, 0.0], [-5.791, -71.03, 0.0], [-5.536, -71.403, 0.0], [-4.342, -71.461, 0.0], [-3.049, -71.285, 0.0], [-1.795, -71.167, 0.0], [-0.659, -71.226, 0.0], [-0.229, -71.638, 0.0], [0.868, -71.305, 0.0], [1.887, -71.128, 0.0], [3.023, -70.991, 0.0], [4.139, -70.854, 0.0], [5.158, -70.619, 0.0], [6.274, -70.462, 0.0], [7.136, -70.247, 0.0], [7.743, -69.894, 0.0], [8.487, -70.149, 0.0], [9.525, -70.011, 0.0], [10.25, -70.482, 0.0], [10.818, -70.834, 0.0], [11.954, -70.638, 0.0], [12.404, -70.247, 0.0], [13.423, -69.972, 0.0], [14.735, -70.031, 0.0], [15.127, -70.403, 0.0], [15.949, -70.031, 0.0], [17.027, -69.913, 0.0], [18.202, -69.874, 0.0], [19.259, -69.894, 0.0], [20.376, -70.011, 0.0], [21.453, -70.07, 0.0], [21.923, -70.403, 0.0], [22.569, -70.697, 0.0], [23.666, -70.521, 0.0], [24.841, -70.482, 0.0], [25.977, -70.482, 0.0], [27.094, -70.462, 0.0], [28.093, -70.325, 0.0], [29.15, -70.207, 0.0], [30.032, -69.933, 0.0], [30.972, -69.757, 0.0], [31.99, -69.659, 0.0], [32.754, -69.384, 0.0], [33.302, -68.836, 0.0], [33.87, -68.503, 0.0], [34.908, -68.659, 0.0], [35.3, -69.012, 0.0], [36.162, -69.247, 0.0], [37.2, -69.169, 0.0], [37.905, -69.521, 0.0], [38.649, -69.776, 0.0], [39.668, -69.541, 0.0], [40.02, -69.11, 0.0], [40.921, -68.934, 0.0], [41.959, -68.601, 0.0], [42.939, -68.463, 0.0], [44.114, -68.267, 0.0], [44.897, -68.052, 0.0], [45.72, -67.817, 0.0], [46.503, -67.601, 0.0], [47.443, -67.719, 0.0], [48.344, -67.366, 0.0], [48.991, -67.092, 0.0], [49.931, -67.111, 0.0], [50.753, -66.876, 0.0], [50.949, -66.523, 0.0], [51.792, -66.249, 0.0], [52.614, -66.053, 0.0], [53.613, -65.896, 0.0], [54.534, -65.818, 0.0], [55.415, -65.877, 0.0], [56.355, -65.975, 0.0], [57.158, -66.249, 0.0], [57.256, -66.68, 0.0], [58.137, -67.013, 0.0], [58.745, -67.288, 0.0], [59.939, -67.405, 0.0], [60.605, -67.68, 0.0], [61.428, -67.954, 0.0], [62.387, -68.013, 0.0], [63.19, -67.817, 0.0], [64.052, -67.405, 0.0], [64.992, -67.621, 0.0], [65.972, -67.738, 0.0], [66.912, -67.856, 0.0], [67.891, -67.934, 0.0], [68.89, -67.934, 0.0], [69.713, -68.973, 0.0], [69.673, -69.228, 0.0], [69.556, -69.678, 0.0], [68.596, -69.933, 0.0], [67.813, -70.305, 0.0], [67.95, -70.697, 0.0], [69.066, -70.678, 0.0], [68.929, -71.069, 0.0], [68.42, -71.442, 0.0], [67.95, -71.853, 0.0], [68.714, -72.167, 0.0], [69.869, -72.265, 0.0], [71.025, -72.088, 0.0], [71.573, -71.697, 0.0], [71.906, -71.324, 0.0], [72.455, -71.011, 0.0], [73.081, -70.717, 0.0], [73.336, -70.364, 0.0], [73.865, -69.874, 0.0], [74.492, -69.776, 0.0], [75.628, -69.737, 0.0], [76.626, -69.619, 0.0], [77.645, -69.463, 0.0], [78.135, -69.071, 0.0], [78.428, -68.698, 0.0], [79.114, -68.326, 0.0], [80.093, -68.072, 0.0], [80.935, -67.876, 0.0], [81.484, -67.542, 0.0], [82.052, -67.366, 0.0], [82.776, -67.209, 0.0], [83.775, -67.307, 0.0], [84.676, -67.209, 0.0], [85.656, -67.092, 0.0], [86.752, -67.15, 0.0], [87.477, -66.876, 0.0], [87.986, -66.21, 0.0], [88.358, -66.484, 0.0], [88.828, -66.955, 0.0], [89.671, -67.15, 0.0], [90.63, -67.229, 0.0], [91.59, -67.111, 0.0], [92.609, -67.19, 0.0], [93.549, -67.209, 0.0], [94.175, -67.111, 0.0], [95.018, -67.17, 0.0], [95.781, -67.386, 0.0], [96.682, -67.249, 0.0], [97.76, -67.249, 0.0], [98.68, -67.111, 0.0], [99.718, -67.249, 0.0], [100.384, -66.915, 0.0], [100.893, -66.582, 0.0], [101.579, -66.308, 0.0], [102.832, -65.563, 0.0], [103.479, -65.7, 0.0], [104.243, -65.975, 0.0], [104.908, -66.328, 0.0], [106.182, -66.935, 0.0], [107.161, -66.955, 0.0], [108.081, -66.955, 0.0], [109.159, -66.837, 0.0], [110.236, -66.7, 0.0], [111.058, -66.426, 0.0], [111.744, -66.132, 0.0], [112.86, -66.092, 0.0], [113.605, -65.877, 0.0], [114.388, -66.073, 0.0], [114.897, -66.386, 0.0], [115.602, -66.7, 0.0], [116.699, -66.661, 0.0], [117.385, -66.915, 0.0], [118.579, -67.17, 0.0], [119.833, -67.268, 0.0], [120.871, -67.19, 0.0], [121.654, -66.876, 0.0], [122.32, -66.563, 0.0], [123.221, -66.484, 0.0], [124.122, -66.621, 0.0], [125.16, -66.719, 0.0], [126.1, -66.563, 0.0], [127.001, -66.563, 0.0], [127.883, -66.661, 0.0], [128.803, -66.759, 0.0], [129.704, -66.582, 0.0], [130.781, -66.426, 0.0], [131.8, -66.386, 0.0], [132.936, -66.386, 0.0], [133.856, -66.288, 0.0], [134.757, -66.21, 0.0], [135.032, -65.72, 0.0], [135.071, -65.309, 0.0], [135.697, -65.583, 0.0], [135.874, -66.034, 0.0], [136.207, -66.445, 0.0], [136.618, -66.778, 0.0], [137.46, -66.955, 0.0], [138.596, -66.896, 0.0], [139.908, -66.876, 0.0], [140.809, -66.817, 0.0], [142.122, -66.817, 0.0], [143.062, -66.798, 0.0], [144.374, -66.837, 0.0], [145.49, -66.915, 0.0], [146.196, -67.229, 0.0], [146.0, -67.601, 0.0], [146.646, -67.895, 0.0], [147.723, -68.13, 0.0], [148.84, -68.385, 0.0], [150.132, -68.561, 0.0], [151.484, -68.718, 0.0], [152.502, -68.875, 0.0], [153.638, -68.895, 0.0], [154.285, -68.561, 0.0], [155.166, -68.836, 0.0], [155.93, -69.149, 0.0], [156.811, -69.384, 0.0], [158.026, -69.482, 0.0], [159.181, -69.6, 0.0], [159.671, -69.992, 0.0], [160.807, -70.227, 0.0], [161.57, -70.58, 0.0], [162.687, -70.736, 0.0], [163.842, -70.717, 0.0], [164.92, -70.776, 0.0], [166.114, -70.756, 0.0], [167.309, -70.834, 0.0], [168.426, -70.971, 0.0], [169.464, -71.207, 0.0], [170.502, -71.403, 0.0], [171.207, -71.697, 0.0], [171.089, -72.088, 0.0], [170.56, -72.441, 0.0], [170.11, -72.892, 0.0], [169.757, -73.245, 0.0], [169.287, -73.656, 0.0], [167.975, -73.813, 0.0], [167.387, -74.165, 0.0], [166.095, -74.381, 0.0], [165.644, -74.773, 0.0], [164.959, -75.145, 0.0], [164.234, -75.459, 0.0], [163.823, -75.87, 0.0], [163.568, -76.243, 0.0], [163.47, -76.693, 0.0], [163.49, -77.066, 0.0], [164.058, -77.457, 0.0], [164.273, -77.83, 0.0], [164.743, -78.183, 0.0], [166.604, -78.32, 0.0], [166.996, -78.751, 0.0], [165.194, -78.907, 0.0], [163.666, -79.123, 0.0], [161.766, -79.162, 0.0], [160.924, -79.73, 0.0], [160.748, -80.201, 0.0], [160.317, -80.573, 0.0], [159.788, -80.945, 0.0], [161.12, -81.279, 0.0], [161.629, -81.69, 0.0], [162.491, -82.062, 0.0], [163.705, -82.395, 0.0], [165.096, -82.709, 0.0], [166.604, -83.022, 0.0], [168.896, -83.336, 0.0], [169.405, -83.826, 0.0], [172.284, -84.041, 0.0], [172.477, -84.118, 0.0], [173.224, -84.414, 0.0], [175.986, -84.159, 0.0], [178.277, -84.473, 0.0], [180.0, -84.713, 0.0], [180.0, -90.0, 0.0], [-180.0, -90.0, 0.0], [-180.0, -84.713, 0.0], [-179.942, -84.721, 0.0], [-179.059, -84.139, 0.0], [-177.257, -84.453, 0.0], [-177.141, -84.418, 0.0], [-176.085, -84.099, 0.0], [-175.947, -84.11, 0.0], [-175.83, -84.118, 0.0], [-174.383, -84.534, 0.0], [-173.117, -84.118, 0.0], [-172.889, -84.061, 0.0], [-169.951, -83.885, 0.0], [-169.0, -84.118, 0.0], [-168.53, -84.237, 0.0], [-167.022, -84.57, 0.0], [-164.182, -84.825, 0.0], [-161.93, -85.139, 0.0], [-158.071, -85.374, 0.0], [-155.192, -85.1, 0.0], [-150.942, -85.296, 0.0], [-148.533, -85.609, 0.0], [-145.889, -85.315, 0.0], [-143.108, -85.041, 0.0], [-142.892, -84.57, 0.0], [-146.829, -84.531, 0.0], [-150.061, -84.296, 0.0], [-150.903, -83.904, 0.0], [-153.586, -83.689, 0.0], [-153.41, -83.238, 0.0], [-153.038, -82.827, 0.0], [-152.666, -82.454, 0.0], [-152.862, -82.043, 0.0], [-154.526, -81.768, 0.0], [-155.29, -81.416, 0.0], [-156.837, -81.102, 0.0], [-154.409, -81.161, 0.0], [-152.098, -81.004, 0.0], [-150.648, -81.337, 0.0], [-148.866, -81.043, 0.0], [-147.221, -80.671, 0.0], [-146.418, -80.338, 0.0], [-146.77, -79.926, 0.0], [-148.063, -79.652, 0.0], [-149.532, -79.358, 0.0], [-151.588, -79.299, 0.0], [-153.39, -79.162, 0.0], [-155.329, -79.064, 0.0], [-155.976, -78.692, 0.0], [-157.268, -78.378, 0.0], [-158.052, -78.026, 0.0], [-158.365, -76.889, 0.0], [-157.875, -76.987, 0.0], [-156.975, -77.301, 0.0], [-155.329, -77.203, 0.0], [-153.743, -77.066, 0.0], [-152.92, -77.497, 0.0], [-151.334, -77.399, 0.0], [-150.002, -77.183, 0.0], [-148.748, -76.909, 0.0], [-147.612, -76.576, 0.0], [-146.104, -76.478, 0.0], [-146.144, -76.105, 0.0], [-146.496, -75.733, 0.0], [-146.202, -75.38, 0.0], [-144.91, -75.204, 0.0], [-144.322, -75.537, 0.0], [-142.794, -75.341, 0.0], [-141.639, -75.086, 0.0], [-140.209, -75.067, 0.0], [-138.858, -74.969, 0.0], [-137.506, -74.734, 0.0], [-136.429, -74.518, 0.0], [-135.215, -74.303, 0.0], [-134.431, -74.361, 0.0], [-133.746, -74.44, 0.0], [-132.257, -74.303, 0.0], [-130.925, -74.479, 0.0], [-129.554, -74.459, 0.0], [-128.242, -74.322, 0.0], [-126.891, -74.42, 0.0], [-125.402, -74.518, 0.0], [-124.011, -74.479, 0.0], [-122.562, -74.499, 0.0], [-121.074, -74.518, 0.0], [-119.703, -74.479, 0.0], [-118.684, -74.185, 0.0], [-117.47, -74.028, 0.0], [-116.216, -74.244, 0.0], [-115.022, -74.068, 0.0], [-113.944, -73.715, 0.0], [-113.298, -74.028, 0.0], [-112.945, -74.381, 0.0], [-112.299, -74.714, 0.0], [-111.261, -74.42, 0.0], [-110.066, -74.793, 0.0], [-108.715, -74.91, 0.0], [-107.559, -75.184, 0.0], [-106.149, -75.126, 0.0], [-104.876, -74.949, 0.0], [-103.368, -74.988, 0.0], [-102.017, -75.126, 0.0], [-100.646, -75.302, 0.0], [-100.117, -74.871, 0.0], [-100.763, -74.538, 0.0], [-101.253, -74.185, 0.0], [-102.545, -74.107, 0.0], [-103.113, -73.734, 0.0], [-103.329, -73.362, 0.0], [-103.681, -72.618, 0.0], [-102.917, -72.755, 0.0], [-101.605, -72.813, 0.0], [-100.313, -72.755, 0.0], [-99.137, -72.911, 0.0], [-98.119, -73.205, 0.0], [-97.688, -73.558, 0.0], [-96.337, -73.617, 0.0], [-95.044, -73.48, 0.0], [-93.673, -73.284, 0.0], [-92.439, -73.166, 0.0], [-91.421, -73.401, 0.0], [-90.089, -73.323, 0.0], [-89.227, -72.559, 0.0], [-88.424, -73.009, 0.0], [-87.268, -73.186, 0.0], [-86.015, -73.088, 0.0], [-85.192, -73.48, 0.0], [-83.88, -73.519, 0.0], [-82.666, -73.636, 0.0], [-81.471, -73.852, 0.0], [-80.687, -73.48, 0.0], [-80.296, -73.127, 0.0], [-79.297, -73.519, 0.0], [-77.926, -73.421, 0.0], [-76.907, -73.636, 0.0], [-76.222, -73.97, 0.0], [-74.89, -73.872, 0.0], [-73.852, -73.656, 0.0], [-72.834, -73.401, 0.0], [-71.619, -73.264, 0.0], [-70.209, -73.147, 0.0], [-68.936, -73.009, 0.0], [-67.957, -72.794, 0.0], [-67.369, -72.48, 0.0], [-67.134, -72.049, 0.0], [-67.252, -71.638, 0.0], [-67.565, -71.246, 0.0], [-67.917, -70.854, 0.0], [-68.231, -70.462, 0.0], [-68.485, -70.109, 0.0], [-68.544, -69.717, 0.0], [-68.446, -69.326, 0.0], [-67.976, -68.953, 0.0], [-67.584, -68.542, 0.0], [-67.428, -68.15, 0.0], [-67.624, -67.719, 0.0], [-67.741, -67.327, 0.0], [-67.252, -66.876, 0.0], [-66.703, -66.582, 0.0], [-66.057, -66.21, 0.0], [-65.371, -65.896, 0.0], [-64.568, -65.603, 0.0], [-64.177, -65.171, 0.0], [-63.628, -64.897, 0.0], [-63.001, -64.642, 0.0], [-62.042, -64.584, 0.0], [-61.415, -64.27, 0.0], [-60.71, -64.074, 0.0], [-59.887, -63.957, 0.0], [-59.163, -63.702, 0.0], [-58.595, -63.388, 0.0], [-57.811, -63.271, 0.0], [-57.224, -63.525, 0.0], [-57.596, -63.859, 0.0], [-58.614, -64.152, 0.0]
       ]
      ]
     }
    ]
    },
    "AQ",
    "ATA"
    ],
    [
      "Benin",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [2.692, 6.259, 0.0], [1.865, 6.142, 0.0], [1.619, 6.832, 0.0], [1.664, 9.129, 0.0], [1.463, 9.335, 0.0], [1.425, 9.825, 0.0], [1.078, 10.176, 0.0], [0.772, 10.471, 0.0], [0.9, 10.997, 0.0], [1.243, 11.111, 0.0], [1.447, 11.548, 0.0], [1.936, 11.641, 0.0], [2.154, 11.94, 0.0], [2.49, 12.233, 0.0], [2.849, 12.236, 0.0], [3.611, 11.66, 0.0], [3.572, 11.328, 0.0], [3.797, 10.735, 0.0], [3.6, 10.332, 0.0], [3.705, 10.063, 0.0], [3.22, 9.444, 0.0], [2.912, 9.138, 0.0], [2.724, 8.507, 0.0], [2.749, 7.871, 0.0], [2.692, 6.259, 0.0]
        ]]
      }
    },
    "BJ",
    "BEN"
    ],
    [
      "Belarus",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [23.484, 53.912, 0.0], [24.451, 53.906, 0.0], [25.536, 54.282, 0.0], [25.768, 54.847, 0.0], [26.588, 55.167, 0.0], [26.494, 55.615, 0.0], [27.102, 55.783, 0.0], [28.177, 56.169, 0.0], [29.23, 55.918, 0.0], [29.372, 55.67, 0.0], [29.896, 55.789, 0.0], [30.874, 55.551, 0.0], [30.972, 55.082, 0.0], [30.758, 54.812, 0.0], [31.384, 54.157, 0.0], [31.791, 53.975, 0.0], [31.731, 53.794, 0.0], [32.406, 53.618, 0.0], [32.694, 53.351, 0.0], [32.305, 53.133, 0.0], [31.498, 53.167, 0.0], [31.305, 53.074, 0.0], [31.54, 52.742, 0.0], [31.786, 52.102, 0.0], [30.928, 52.042, 0.0], [30.619, 51.823, 0.0], [30.555, 51.32, 0.0], [30.157, 51.416, 0.0], [29.255, 51.368, 0.0], [28.993, 51.602, 0.0], [28.618, 51.428, 0.0], [28.242, 51.572, 0.0], [27.454, 51.592, 0.0], [26.338, 51.832, 0.0], [25.328, 51.911, 0.0], [24.553, 51.888, 0.0], [24.005, 51.617, 0.0], [23.527, 51.578, 0.0], [23.508, 52.024, 0.0], [23.199, 52.487, 0.0], [23.799, 52.691, 0.0], [23.805, 53.09, 0.0], [23.528, 53.47, 0.0], [23.484, 53.912, 0.0]
        ]]
      }
    },
    "BY",
    "BLR"
    ],
    [
      "Belize",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-89.143, 17.808, 0.0], [-89.151, 17.955, 0.0], [-89.03, 18.002, 0.0], [-88.848, 17.883, 0.0], [-88.49, 18.487, 0.0], [-88.3, 18.5, 0.0], [-88.296, 18.353, 0.0], [-88.107, 18.349, 0.0], [-88.123, 18.077, 0.0], [-88.285, 17.644, 0.0], [-88.198, 17.489, 0.0], [-88.303, 17.132, 0.0], [-88.24, 17.036, 0.0], [-88.355, 16.531, 0.0], [-88.552, 16.265, 0.0], [-88.732, 16.234, 0.0], [-88.931, 15.887, 0.0], [-89.229, 15.887, 0.0], [-89.151, 17.016, 0.0], [-89.143, 17.808, 0.0]
        ]]
      }
    },
    "BZ",
    "BLZ"
    ],
    [
      "Bolivia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-62.846, -22.035, 0.0], [-63.987, -21.994, 0.0], [-64.377, -22.798, 0.0], [-64.965, -22.076, 0.0], [-66.273, -21.832, 0.0], [-67.107, -22.736, 0.0], [-67.828, -22.873, 0.0], [-68.22, -21.494, 0.0], [-68.757, -20.373, 0.0], [-68.442, -19.405, 0.0], [-68.967, -18.982, 0.0], [-69.1, -18.26, 0.0], [-69.59, -17.58, 0.0], [-68.96, -16.501, 0.0], [-69.39, -15.66, 0.0], [-69.16, -15.324, 0.0], [-69.34, -14.953, 0.0], [-68.949, -14.454, 0.0], [-68.929, -13.603, 0.0], [-68.88, -12.9, 0.0], [-68.665, -12.561, 0.0], [-69.53, -10.952, 0.0], [-68.786, -11.036, 0.0], [-68.271, -11.015, 0.0], [-68.048, -10.712, 0.0], [-67.174, -10.307, 0.0], [-66.647, -9.931, 0.0], [-65.338, -9.762, 0.0], [-65.445, -10.511, 0.0], [-65.322, -10.896, 0.0], [-65.402, -11.566, 0.0], [-64.316, -12.462, 0.0], [-63.196, -12.627, 0.0], [-62.803, -13.001, 0.0], [-62.127, -13.199, 0.0], [-61.713, -13.489, 0.0], [-61.084, -13.479, 0.0], [-60.503, -13.776, 0.0], [-60.459, -14.354, 0.0], [-60.264, -14.646, 0.0], [-60.251, -15.077, 0.0], [-60.543, -15.094, 0.0], [-60.158, -16.258, 0.0], [-58.241, -16.3, 0.0], [-58.388, -16.877, 0.0], [-58.281, -17.272, 0.0], [-57.735, -17.552, 0.0], [-57.498, -18.174, 0.0], [-57.676, -18.962, 0.0], [-57.95, -19.4, 0.0], [-57.854, -19.97, 0.0], [-58.166, -20.177, 0.0], [-58.183, -19.868, 0.0], [-59.115, -19.357, 0.0], [-60.044, -19.343, 0.0], [-61.786, -19.634, 0.0], [-62.266, -20.514, 0.0], [-62.291, -21.052, 0.0], [-62.685, -22.249, 0.0], [-62.846, -22.035, 0.0]
        ]]
      }
    },
    "BO",
    "BOL"
    ],
    [
      "Brazil",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-57.625, -30.216, 0.0], [-56.291, -28.853, 0.0], [-55.162, -27.882, 0.0], [-54.491, -27.475, 0.0], [-53.649, -26.923, 0.0], [-53.628, -26.125, 0.0], [-54.13, -25.548, 0.0], [-54.625, -25.739, 0.0], [-54.429, -25.162, 0.0], [-54.293, -24.571, 0.0], [-54.293, -24.021, 0.0], [-54.653, -23.84, 0.0], [-55.028, -24.001, 0.0], [-55.401, -23.957, 0.0], [-55.518, -23.572, 0.0], [-55.611, -22.656, 0.0], [-55.798, -22.357, 0.0], [-56.473, -22.086, 0.0], [-56.882, -22.282, 0.0], [-57.937, -22.09, 0.0], [-57.871, -20.733, 0.0], [-58.166, -20.177, 0.0], [-57.854, -19.97, 0.0], [-57.95, -19.4, 0.0], [-57.676, -18.962, 0.0], [-57.498, -18.174, 0.0], [-57.735, -17.552, 0.0], [-58.281, -17.272, 0.0], [-58.388, -16.877, 0.0], [-58.241, -16.3, 0.0], [-60.158, -16.258, 0.0], [-60.543, -15.094, 0.0], [-60.251, -15.077, 0.0], [-60.264, -14.646, 0.0], [-60.459, -14.354, 0.0], [-60.503, -13.776, 0.0], [-61.084, -13.479, 0.0], [-61.713, -13.489, 0.0], [-62.127, -13.199, 0.0], [-62.803, -13.001, 0.0], [-63.196, -12.627, 0.0], [-64.316, -12.462, 0.0], [-65.402, -11.566, 0.0], [-65.322, -10.896, 0.0], [-65.445, -10.511, 0.0], [-65.338, -9.762, 0.0], [-66.647, -9.931, 0.0], [-67.174, -10.307, 0.0], [-68.048, -10.712, 0.0], [-68.271, -11.015, 0.0], [-68.786, -11.036, 0.0], [-69.53, -10.952, 0.0], [-70.094, -11.124, 0.0], [-70.549, -11.009, 0.0], [-70.482, -9.49, 0.0], [-71.302, -10.079, 0.0], [-72.185, -10.054, 0.0], [-72.563, -9.52, 0.0], [-73.227, -9.462, 0.0], [-73.015, -9.033, 0.0], [-73.571, -8.424, 0.0], [-73.987, -7.524, 0.0], [-73.723, -7.341, 0.0], [-73.724, -6.919, 0.0], [-73.12, -6.63, 0.0], [-73.22, -6.089, 0.0], [-72.965, -5.741, 0.0], [-72.892, -5.275, 0.0], [-71.748, -4.594, 0.0], [-70.929, -4.402, 0.0], [-70.795, -4.251, 0.0], [-69.894, -4.298, 0.0], [-69.444, -1.556, 0.0], [-69.42, -1.123, 0.0], [-69.577, -0.55, 0.0], [-70.021, -0.185, 0.0], [-70.016, 0.541, 0.0], [-69.452, 0.706, 0.0], [-69.252, 0.603, 0.0], [-69.219, 0.986, 0.0], [-69.805, 1.089, 0.0], [-69.817, 1.715, 0.0], [-67.869, 1.692, 0.0], [-67.538, 2.037, 0.0], [-67.26, 1.72, 0.0], [-67.065, 1.13, 0.0], [-66.876, 1.253, 0.0], [-66.326, 0.724, 0.0], [-65.548, 0.789, 0.0], [-65.355, 1.095, 0.0], [-64.611, 1.329, 0.0], [-64.199, 1.493, 0.0], [-64.083, 1.916, 0.0], [-63.369, 2.201, 0.0], [-63.423, 2.411, 0.0], [-64.27, 2.497, 0.0], [-64.409, 3.127, 0.0], [-64.368, 3.797, 0.0], [-64.816, 4.056, 0.0], [-64.629, 4.148, 0.0], [-63.888, 4.021, 0.0], [-63.093, 3.771, 0.0], [-62.805, 4.007, 0.0], [-62.085, 4.162, 0.0], [-60.967, 4.536, 0.0], [-60.601, 4.918, 0.0], [-60.734, 5.2, 0.0], [-60.214, 5.244, 0.0], [-59.981, 5.014, 0.0], [-60.111, 4.575, 0.0], [-59.767, 4.424, 0.0], [-59.538, 3.959, 0.0], [-59.815, 3.606, 0.0], [-59.975, 2.755, 0.0], [-59.719, 2.25, 0.0], [-59.646, 1.787, 0.0], [-59.031, 1.318, 0.0], [-58.54, 1.268, 0.0], [-58.429, 1.464, 0.0], [-58.113, 1.507, 0.0], [-57.661, 1.683, 0.0], [-57.336, 1.949, 0.0], [-56.783, 1.864, 0.0], [-56.539, 1.9, 0.0], [-55.996, 1.818, 0.0], [-55.906, 2.022, 0.0], [-56.073, 2.221, 0.0], [-55.973, 2.51, 0.0], [-55.57, 2.422, 0.0], [-55.098, 2.524, 0.0], [-54.525, 2.312, 0.0], [-54.088, 2.106, 0.0], [-53.779, 2.377, 0.0], [-53.555, 2.335, 0.0], [-53.418, 2.053, 0.0], [-52.94, 2.125, 0.0], [-52.556, 2.505, 0.0], [-52.249, 3.241, 0.0], [-51.658, 4.156, 0.0], [-51.317, 4.203, 0.0], [-51.07, 3.65, 0.0], [-50.509, 1.902, 0.0], [-49.974, 1.736, 0.0], [-49.947, 1.046, 0.0], [-50.699, 0.223, 0.0], [-50.388, -0.078, 0.0], [-48.621, -0.235, 0.0], [-48.584, -1.238, 0.0], [-47.825, -0.582, 0.0], [-46.567, -0.941, 0.0], [-44.906, -1.552, 0.0], [-44.418, -2.138, 0.0], [-44.582, -2.691, 0.0], [-43.419, -2.383, 0.0], [-41.473, -2.912, 0.0], [-39.979, -2.873, 0.0], [-38.5, -3.701, 0.0], [-37.223, -4.821, 0.0], [-36.453, -5.109, 0.0], [-35.598, -5.15, 0.0], [-35.235, -5.465, 0.0], [-34.896, -6.738, 0.0], [-34.73, -7.343, 0.0], [-35.128, -8.996, 0.0], [-35.637, -9.649, 0.0], [-37.047, -11.041, 0.0], [-37.684, -12.171, 0.0], [-38.424, -13.038, 0.0], [-38.674, -13.058, 0.0], [-38.953, -13.793, 0.0], [-38.882, -15.667, 0.0], [-39.161, -17.208, 0.0], [-39.267, -17.868, 0.0], [-39.584, -18.262, 0.0], [-39.761, -19.599, 0.0], [-40.775, -20.905, 0.0], [-40.945, -21.937, 0.0], [-41.754, -22.371, 0.0], [-41.988, -22.97, 0.0], [-43.075, -22.968, 0.0], [-44.648, -23.352, 0.0], [-45.352, -23.797, 0.0], [-46.472, -24.089, 0.0], [-47.649, -24.885, 0.0], [-48.495, -25.877, 0.0], [-48.641, -26.624, 0.0], [-48.475, -27.176, 0.0], [-48.662, -28.186, 0.0], [-48.888, -28.674, 0.0], [-49.587, -29.224, 0.0], [-50.697, -30.984, 0.0], [-51.576, -31.778, 0.0], [-52.256, -32.245, 0.0], [-52.712, -33.197, 0.0], [-53.374, -33.768, 0.0], [-53.651, -33.202, 0.0], [-53.21, -32.728, 0.0], [-53.788, -32.047, 0.0], [-54.572, -31.495, 0.0], [-55.602, -30.854, 0.0], [-55.973, -30.883, 0.0], [-56.976, -30.11, 0.0], [-57.625, -30.216, 0.0]
        ]]
      }
    },
    "BR",
    "BRA"
    ],
    [
      "Bhutan",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [91.697, 27.772, 0.0], [92.104, 27.453, 0.0], [92.033, 26.838, 0.0], [91.218, 26.809, 0.0], [90.373, 26.876, 0.0], [89.745, 26.719, 0.0], [88.836, 27.099, 0.0], [88.814, 27.299, 0.0], [89.476, 28.043, 0.0], [90.016, 28.296, 0.0], [90.731, 28.065, 0.0], [91.259, 28.041, 0.0], [91.697, 27.772, 0.0]
        ]]
      }
    },
    "BT",
    "BTN"
    ],
    [
      "Central African Rep.",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [15.279, 7.422, 0.0], [16.106, 7.497, 0.0], [16.291, 7.754, 0.0], [16.456, 7.735, 0.0], [16.706, 7.508, 0.0], [17.965, 7.891, 0.0], [18.39, 8.281, 0.0], [18.911, 8.631, 0.0], [18.812, 8.983, 0.0], [19.094, 9.075, 0.0], [20.06, 9.013, 0.0], [21.001, 9.476, 0.0], [21.724, 10.567, 0.0], [22.231, 10.972, 0.0], [22.864, 11.142, 0.0], [22.978, 10.714, 0.0], [23.554, 10.089, 0.0], [23.557, 9.681, 0.0], [23.395, 9.265, 0.0], [23.459, 8.954, 0.0], [23.806, 8.666, 0.0], [24.567, 8.229, 0.0], [25.115, 7.825, 0.0], [25.124, 7.5, 0.0], [25.797, 6.979, 0.0], [26.213, 6.547, 0.0], [26.466, 5.947, 0.0], [27.213, 5.551, 0.0], [27.374, 5.234, 0.0], [27.044, 5.128, 0.0], [26.403, 5.151, 0.0], [25.65, 5.256, 0.0], [25.279, 5.17, 0.0], [25.129, 4.927, 0.0], [24.805, 4.897, 0.0], [24.411, 5.109, 0.0], [23.297, 4.61, 0.0], [22.841, 4.71, 0.0], [22.704, 4.633, 0.0], [22.405, 4.029, 0.0], [21.659, 4.224, 0.0], [20.928, 4.323, 0.0], [20.291, 4.692, 0.0], [19.468, 5.032, 0.0], [18.932, 4.71, 0.0], [18.543, 4.202, 0.0], [18.453, 3.504, 0.0], [17.81, 3.56, 0.0], [17.133, 3.728, 0.0], [16.537, 3.198, 0.0], [16.013, 2.268, 0.0], [15.907, 2.557, 0.0], [15.863, 3.014, 0.0], [15.405, 3.335, 0.0], [15.036, 3.851, 0.0], [14.951, 4.21, 0.0], [14.478, 4.733, 0.0], [14.559, 5.031, 0.0], [14.459, 5.452, 0.0], [14.537, 6.227, 0.0], [14.777, 6.408, 0.0], [15.279, 7.422, 0.0]
        ]]
      }
    },
    "CF",
    "CAF"
    ],
    [
      "Chile",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-68.634, -52.636, 0.0], [-68.633, -54.869, 0.0], [-67.562, -54.87, 0.0], [-66.96, -54.897, 0.0], [-67.291, -55.301, 0.0], [-68.149, -55.612, 0.0], [-68.64, -55.58, 0.0], [-69.232, -55.499, 0.0], [-69.958, -55.198, 0.0], [-71.006, -55.054, 0.0], [-72.264, -54.495, 0.0], [-73.285, -53.958, 0.0], [-74.663, -52.837, 0.0], [-73.838, -53.047, 0.0], [-72.434, -53.715, 0.0], [-71.108, -54.074, 0.0], [-70.592, -53.616, 0.0], [-70.267, -52.931, 0.0], [-69.346, -52.518, 0.0], [-68.634, -52.636, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-68.22, -21.494, 0.0], [-67.828, -22.873, 0.0], [-67.107, -22.736, 0.0], [-66.985, -22.986, 0.0], [-67.328, -24.025, 0.0], [-68.418, -24.519, 0.0], [-68.386, -26.185, 0.0], [-68.595, -26.507, 0.0], [-68.296, -26.899, 0.0], [-69.001, -27.521, 0.0], [-69.656, -28.459, 0.0], [-70.014, -29.368, 0.0], [-69.919, -30.336, 0.0], [-70.535, -31.365, 0.0], [-70.074, -33.091, 0.0], [-69.815, -33.274, 0.0], [-69.817, -34.194, 0.0], [-70.388, -35.17, 0.0], [-70.365, -36.005, 0.0], [-71.122, -36.658, 0.0], [-71.119, -37.577, 0.0], [-70.815, -38.553, 0.0], [-71.414, -38.916, 0.0], [-71.681, -39.808, 0.0], [-71.916, -40.832, 0.0], [-71.747, -42.051, 0.0], [-72.149, -42.255, 0.0], [-71.915, -43.409, 0.0], [-71.464, -43.788, 0.0], [-71.794, -44.207, 0.0], [-71.33, -44.408, 0.0], [-71.223, -44.784, 0.0], [-71.659, -44.974, 0.0], [-71.552, -45.561, 0.0], [-71.917, -46.885, 0.0], [-72.447, -47.739, 0.0], [-72.331, -48.244, 0.0], [-72.648, -48.879, 0.0], [-73.415, -49.318, 0.0], [-73.328, -50.379, 0.0], [-72.976, -50.741, 0.0], [-72.31, -50.677, 0.0], [-72.329, -51.426, 0.0], [-71.915, -52.009, 0.0], [-69.498, -52.143, 0.0], [-68.572, -52.299, 0.0], [-69.461, -52.292, 0.0], [-69.943, -52.538, 0.0], [-70.845, -52.899, 0.0], [-71.006, -53.833, 0.0], [-71.43, -53.856, 0.0], [-72.558, -53.531, 0.0], [-73.703, -52.835, 0.0], [-73.703, -52.835, 0.0], [-74.947, -52.263, 0.0], [-75.26, -51.629, 0.0], [-74.977, -51.043, 0.0], [-75.48, -50.378, 0.0], [-75.608, -48.674, 0.0], [-75.183, -47.712, 0.0], [-74.127, -46.939, 0.0], [-75.644, -46.648, 0.0], [-74.692, -45.764, 0.0], [-74.352, -44.103, 0.0], [-73.24, -44.455, 0.0], [-72.718, -42.383, 0.0], [-73.389, -42.118, 0.0], [-73.701, -43.366, 0.0], [-74.332, -43.225, 0.0], [-74.018, -41.795, 0.0], [-73.677, -39.942, 0.0], [-73.218, -39.259, 0.0], [-73.506, -38.283, 0.0], [-73.588, -37.156, 0.0], [-73.167, -37.124, 0.0], [-72.553, -35.509, 0.0], [-71.862, -33.909, 0.0], [-71.438, -32.419, 0.0], [-71.669, -30.921, 0.0], [-71.37, -30.096, 0.0], [-71.49, -28.861, 0.0], [-70.905, -27.64, 0.0], [-70.725, -25.706, 0.0], [-70.404, -23.629, 0.0], [-70.091, -21.393, 0.0], [-70.164, -19.756, 0.0], [-70.373, -18.348, 0.0], [-69.858, -18.093, 0.0], [-69.59, -17.58, 0.0], [-69.1, -18.26, 0.0], [-68.967, -18.982, 0.0], [-68.442, -19.405, 0.0], [-68.757, -20.373, 0.0], [-68.22, -21.494, 0.0]
       ]
      ]
     }
    ]
    },
    "CL",
    "CHL"
    ],
    [
      "Fiji",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [178.374, -17.34, 0.0], [178.718, -17.628, 0.0], [178.553, -18.151, 0.0], [177.933, -18.288, 0.0], [177.381, -18.164, 0.0], [177.285, -17.725, 0.0], [177.671, -17.381, 0.0], [178.126, -17.505, 0.0], [178.374, -17.34, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [179.364, -16.801, 0.0], [178.725, -17.012, 0.0], [178.597, -16.639, 0.0], [179.097, -16.434, 0.0], [179.414, -16.379, 0.0], [180.0, -16.067, 0.0], [180.0, -16.555, 0.0], [179.364, -16.801, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-179.917, -16.502, 0.0], [-180.0, -16.555, 0.0], [-180.0, -16.067, 0.0], [-179.793, -16.021, 0.0], [-179.917, -16.502, 0.0]
       ]
      ]
     }
    ]
    },
    "FJ",
    "FJI"
    ],
    [
      "Georgia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [41.554, 41.536, 0.0], [41.703, 41.963, 0.0], [41.453, 42.645, 0.0], [40.875, 43.014, 0.0], [40.321, 43.129, 0.0], [39.955, 43.435, 0.0], [40.077, 43.553, 0.0], [40.922, 43.382, 0.0], [42.394, 43.22, 0.0], [43.756, 42.741, 0.0], [43.931, 42.555, 0.0], [44.538, 42.712, 0.0], [45.47, 42.503, 0.0], [45.776, 42.092, 0.0], [46.405, 41.861, 0.0], [46.145, 41.723, 0.0], [46.638, 41.182, 0.0], [46.502, 41.064, 0.0], [45.963, 41.124, 0.0], [45.217, 41.411, 0.0], [44.972, 41.248, 0.0], [43.583, 41.092, 0.0], [42.62, 41.583, 0.0], [41.554, 41.536, 0.0]
        ]]
      }
    },
    "GE",
    "GEO"
    ],
    [
      "Hungary",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [16.202, 46.852, 0.0], [16.534, 47.496, 0.0], [16.341, 47.713, 0.0], [16.904, 47.715, 0.0], [16.98, 48.123, 0.0], [17.488, 47.867, 0.0], [17.857, 47.758, 0.0], [18.697, 47.881, 0.0], [18.777, 48.082, 0.0], [19.174, 48.111, 0.0], [19.661, 48.267, 0.0], [19.769, 48.203, 0.0], [20.239, 48.328, 0.0], [20.474, 48.563, 0.0], [20.801, 48.624, 0.0], [21.872, 48.32, 0.0], [22.086, 48.422, 0.0], [22.641, 48.15, 0.0], [22.711, 47.882, 0.0], [22.1, 47.672, 0.0], [21.627, 46.994, 0.0], [21.022, 46.316, 0.0], [20.22, 46.127, 0.0], [19.596, 46.172, 0.0], [18.83, 45.909, 0.0], [18.456, 45.759, 0.0], [17.63, 45.952, 0.0], [16.883, 46.381, 0.0], [16.565, 46.504, 0.0], [16.371, 46.841, 0.0], [16.202, 46.852, 0.0]
        ]]
      }
    },
    "HU",
    "HUN"
    ],
    [
      "Ireland",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-6.198, 53.868, 0.0], [-6.033, 53.153, 0.0], [-6.789, 52.26, 0.0], [-8.562, 51.669, 0.0], [-9.977, 51.82, 0.0], [-9.166, 52.865, 0.0], [-9.689, 53.881, 0.0], [-8.328, 54.665, 0.0], [-7.572, 55.132, 0.0], [-7.366, 54.596, 0.0], [-7.572, 54.06, 0.0], [-6.954, 54.074, 0.0], [-6.198, 53.868, 0.0]
        ]]
      }
    },
    "IE",
    "IRL"
    ],
    [
      "Italy",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [15.52, 38.231, 0.0], [15.16, 37.444, 0.0], [15.31, 37.134, 0.0], [15.1, 36.62, 0.0], [14.335, 36.997, 0.0], [13.827, 37.105, 0.0], [12.431, 37.613, 0.0], [12.571, 38.126, 0.0], [13.741, 38.035, 0.0], [14.761, 38.144, 0.0], [15.52, 38.231, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [9.21, 41.21, 0.0], [9.81, 40.5, 0.0], [9.67, 39.177, 0.0], [9.215, 39.24, 0.0], [8.807, 38.907, 0.0], [8.428, 39.172, 0.0], [8.388, 40.378, 0.0], [8.16, 40.95, 0.0], [8.71, 40.9, 0.0], [9.21, 41.21, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [12.376, 46.768, 0.0], [13.806, 46.509, 0.0], [13.698, 46.017, 0.0], [13.938, 45.591, 0.0], [13.142, 45.737, 0.0], [12.329, 45.382, 0.0], [12.384, 44.885, 0.0], [12.261, 44.6, 0.0], [12.589, 44.091, 0.0], [13.527, 43.588, 0.0], [14.03, 42.761, 0.0], [15.143, 41.955, 0.0], [15.926, 41.961, 0.0], [16.17, 41.74, 0.0], [15.889, 41.541, 0.0], [16.785, 41.18, 0.0], [17.519, 40.877, 0.0], [18.377, 40.356, 0.0], [18.48, 40.169, 0.0], [18.293, 39.811, 0.0], [17.738, 40.278, 0.0], [16.87, 40.442, 0.0], [16.449, 39.795, 0.0], [17.171, 39.425, 0.0], [17.053, 38.903, 0.0], [16.635, 38.844, 0.0], [16.101, 37.986, 0.0], [15.684, 37.909, 0.0], [15.688, 38.215, 0.0], [15.892, 38.751, 0.0], [16.109, 38.965, 0.0], [15.719, 39.544, 0.0], [15.414, 40.048, 0.0], [14.998, 40.173, 0.0], [14.703, 40.605, 0.0], [14.061, 40.786, 0.0], [13.628, 41.188, 0.0], [12.888, 41.253, 0.0], [12.107, 41.705, 0.0], [11.192, 42.355, 0.0], [10.512, 42.931, 0.0], [10.2, 43.92, 0.0], [9.702, 44.036, 0.0], [8.889, 44.366, 0.0], [8.429, 44.231, 0.0], [7.851, 43.767, 0.0], [7.435, 43.694, 0.0], [7.55, 44.128, 0.0], [7.008, 44.255, 0.0], [6.75, 45.029, 0.0], [7.097, 45.333, 0.0], [6.802, 45.709, 0.0], [6.844, 45.991, 0.0], [7.274, 45.777, 0.0], [7.756, 45.824, 0.0], [8.317, 46.164, 0.0], [8.49, 46.005, 0.0], [8.966, 46.037, 0.0], [9.183, 46.44, 0.0], [9.923, 46.315, 0.0], [10.363, 46.484, 0.0], [10.443, 46.894, 0.0], [11.049, 46.751, 0.0], [11.165, 46.942, 0.0], [12.153, 47.115, 0.0], [12.376, 46.768, 0.0]
       ]
      ]
     }
    ]
    },
    "IT",
    "ITA"
    ],
    [
      "Jamaica",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-77.57, 18.491, 0.0], [-76.897, 18.401, 0.0], [-76.365, 18.161, 0.0], [-76.2, 17.887, 0.0], [-76.903, 17.868, 0.0], [-77.206, 17.701, 0.0], [-77.766, 17.862, 0.0], [-78.338, 18.226, 0.0], [-78.218, 18.455, 0.0], [-77.797, 18.524, 0.0], [-77.57, 18.491, 0.0]
        ]]
      }
    },
    "JM",
    "JAM"
    ],
    [
      "Japan",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [134.638, 34.149, 0.0], [134.766, 33.806, 0.0], [134.203, 33.201, 0.0], [133.793, 33.522, 0.0], [133.28, 33.29, 0.0], [133.015, 32.705, 0.0], [132.363, 32.989, 0.0], [132.371, 33.464, 0.0], [132.924, 34.06, 0.0], [133.493, 33.945, 0.0], [133.904, 34.365, 0.0], [134.638, 34.149, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [140.976, 37.142, 0.0], [140.6, 36.344, 0.0], [140.774, 35.843, 0.0], [140.253, 35.138, 0.0], [138.976, 34.668, 0.0], [137.218, 34.606, 0.0], [135.793, 33.465, 0.0], [135.121, 33.849, 0.0], [135.079, 34.597, 0.0], [133.34, 34.376, 0.0], [132.157, 33.905, 0.0], [130.986, 33.886, 0.0], [132.0, 33.15, 0.0], [131.333, 31.45, 0.0], [130.686, 31.03, 0.0], [130.202, 31.418, 0.0], [130.448, 32.319, 0.0], [129.815, 32.61, 0.0], [129.408, 33.296, 0.0], [130.354, 33.604, 0.0], [130.878, 34.233, 0.0], [131.884, 34.75, 0.0], [132.618, 35.433, 0.0], [134.608, 35.732, 0.0], [135.678, 35.527, 0.0], [136.724, 37.305, 0.0], [137.391, 36.827, 0.0], [138.858, 37.827, 0.0], [139.426, 38.216, 0.0], [140.055, 39.439, 0.0], [139.883, 40.563, 0.0], [140.306, 41.195, 0.0], [141.369, 41.379, 0.0], [141.914, 39.992, 0.0], [141.885, 39.181, 0.0], [140.959, 38.174, 0.0], [140.976, 37.142, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [143.91, 44.174, 0.0], [144.613, 43.961, 0.0], [145.321, 44.385, 0.0], [145.543, 43.262, 0.0], [144.06, 42.988, 0.0], [143.184, 41.995, 0.0], [141.611, 42.679, 0.0], [141.067, 41.585, 0.0], [139.955, 41.57, 0.0], [139.818, 42.564, 0.0], [140.312, 43.333, 0.0], [141.381, 43.389, 0.0], [141.672, 44.772, 0.0], [141.968, 45.551, 0.0], [143.143, 44.51, 0.0], [143.91, 44.174, 0.0]
       ]
      ]
     }
    ]
    },
    "JP",
    "JPN"
    ],
    [
      "Kyrgyzstan",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [70.962, 42.266, 0.0], [71.186, 42.704, 0.0], [71.845, 42.845, 0.0], [73.49, 42.501, 0.0], [73.645, 43.091, 0.0], [74.213, 43.298, 0.0], [75.637, 42.878, 0.0], [76.0, 42.988, 0.0], [77.658, 42.961, 0.0], [79.142, 42.856, 0.0], [79.644, 42.497, 0.0], [80.26, 42.35, 0.0], [80.119, 42.124, 0.0], [78.544, 41.582, 0.0], [78.187, 41.185, 0.0], [76.904, 41.066, 0.0], [76.526, 40.428, 0.0], [75.468, 40.562, 0.0], [74.777, 40.366, 0.0], [73.822, 39.894, 0.0], [73.96, 39.66, 0.0], [73.675, 39.431, 0.0], [71.785, 39.279, 0.0], [70.549, 39.604, 0.0], [69.465, 39.527, 0.0], [69.56, 40.103, 0.0], [70.648, 39.936, 0.0], [71.014, 40.244, 0.0], [71.775, 40.146, 0.0], [73.055, 40.866, 0.0], [71.87, 41.393, 0.0], [71.158, 41.144, 0.0], [70.42, 41.52, 0.0], [71.259, 42.168, 0.0], [70.962, 42.266, 0.0]
        ]]
      }
    },
    "KG",
    "KGZ"
    ],
    [
      "Morocco",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-5.194, 35.755, 0.0], [-4.591, 35.331, 0.0], [-3.64, 35.4, 0.0], [-2.604, 35.179, 0.0], [-2.17, 35.168, 0.0], [-1.793, 34.528, 0.0], [-1.733, 33.92, 0.0], [-1.388, 32.864, 0.0], [-1.125, 32.652, 0.0], [-1.308, 32.263, 0.0], [-2.617, 32.094, 0.0], [-3.069, 31.724, 0.0], [-3.647, 31.637, 0.0], [-3.69, 30.897, 0.0], [-4.86, 30.501, 0.0], [-5.242, 30.0, 0.0], [-6.061, 29.732, 0.0], [-7.059, 29.579, 0.0], [-8.674, 28.841, 0.0], [-8.666, 27.656, 0.0], [-8.818, 27.656, 0.0], [-8.818, 27.656, 0.0], [-8.795, 27.121, 0.0], [-9.413, 27.088, 0.0], [-9.735, 26.861, 0.0], [-10.189, 26.861, 0.0], [-10.551, 26.991, 0.0], [-11.393, 26.883, 0.0], [-11.718, 26.104, 0.0], [-12.031, 26.031, 0.0], [-12.501, 24.77, 0.0], [-13.891, 23.691, 0.0], [-14.221, 22.31, 0.0], [-14.631, 21.861, 0.0], [-14.751, 21.501, 0.0], [-17.003, 21.421, 0.0], [-17.02, 21.422, 0.0], [-16.973, 21.886, 0.0], [-16.589, 22.158, 0.0], [-16.262, 22.679, 0.0], [-16.326, 23.018, 0.0], [-15.983, 23.723, 0.0], [-15.426, 24.359, 0.0], [-15.089, 24.52, 0.0], [-14.825, 25.104, 0.0], [-14.801, 25.636, 0.0], [-14.44, 26.254, 0.0], [-13.774, 26.619, 0.0], [-13.14, 27.64, 0.0], [-13.122, 27.654, 0.0], [-12.619, 28.038, 0.0], [-11.689, 28.149, 0.0], [-10.901, 28.832, 0.0], [-10.4, 29.099, 0.0], [-9.565, 29.934, 0.0], [-9.815, 31.178, 0.0], [-9.435, 32.038, 0.0], [-9.301, 32.565, 0.0], [-8.657, 33.24, 0.0], [-7.654, 33.697, 0.0], [-6.913, 34.11, 0.0], [-6.244, 35.146, 0.0], [-5.93, 35.76, 0.0], [-5.194, 35.755, 0.0]
        ]]
      }
    },
    "MA",
    "MAR"
    ],
    [
      "Macedonia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [20.59, 41.855, 0.0], [20.717, 41.847, 0.0], [20.762, 42.052, 0.0], [21.353, 42.207, 0.0], [21.577, 42.245, 0.0], [21.917, 42.304, 0.0], [22.381, 42.32, 0.0], [22.881, 41.999, 0.0], [22.952, 41.338, 0.0], [22.762, 41.305, 0.0], [22.597, 41.13, 0.0], [22.055, 41.15, 0.0], [21.674, 40.931, 0.0], [21.02, 40.843, 0.0], [20.605, 41.086, 0.0], [20.463, 41.515, 0.0], [20.59, 41.855, 0.0]
        ]]
      }
    },
    "MK",
    "MKD"
    ],
    [
      "Malawi",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [34.56, -11.52, 0.0], [34.28, -12.28, 0.0], [34.56, -13.58, 0.0], [34.907, -13.565, 0.0], [35.268, -13.888, 0.0], [35.687, -14.611, 0.0], [35.772, -15.897, 0.0], [35.339, -16.107, 0.0], [35.034, -16.801, 0.0], [34.381, -16.184, 0.0], [34.307, -15.479, 0.0], [34.518, -15.014, 0.0], [34.46, -14.613, 0.0], [34.065, -14.36, 0.0], [33.79, -14.452, 0.0], [33.214, -13.972, 0.0], [32.688, -13.713, 0.0], [32.992, -12.784, 0.0], [33.306, -12.436, 0.0], [33.114, -11.607, 0.0], [33.315, -10.797, 0.0], [33.486, -10.526, 0.0], [33.231, -9.677, 0.0], [32.759, -9.231, 0.0], [33.74, -9.417, 0.0], [33.941, -9.694, 0.0], [34.28, -10.16, 0.0], [34.56, -11.52, 0.0]
        ]]
      }
    },
    "MW",
    "MWI"
    ],
    [
      "Suriname",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-57.147, 5.973, 0.0], [-55.949, 5.773, 0.0], [-55.842, 5.953, 0.0], [-55.033, 6.025, 0.0], [-53.958, 5.757, 0.0], [-54.479, 4.897, 0.0], [-54.4, 4.213, 0.0], [-54.007, 3.62, 0.0], [-54.182, 3.19, 0.0], [-54.27, 2.732, 0.0], [-54.525, 2.312, 0.0], [-55.098, 2.524, 0.0], [-55.57, 2.422, 0.0], [-55.973, 2.51, 0.0], [-56.073, 2.221, 0.0], [-55.906, 2.022, 0.0], [-55.996, 1.818, 0.0], [-56.539, 1.9, 0.0], [-57.15, 2.769, 0.0], [-57.281, 3.333, 0.0], [-57.602, 3.335, 0.0], [-58.045, 4.061, 0.0], [-57.86, 4.577, 0.0], [-57.914, 4.813, 0.0], [-57.307, 5.074, 0.0], [-57.147, 5.973, 0.0]
        ]]
      }
    },
    "SR",
    "SUR"
    ],
    [
      "Sweden",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [22.183, 65.724, 0.0], [21.214, 65.026, 0.0], [21.37, 64.414, 0.0], [19.779, 63.61, 0.0], [17.848, 62.749, 0.0], [17.12, 61.341, 0.0], [17.831, 60.637, 0.0], [18.788, 60.082, 0.0], [17.869, 58.954, 0.0], [16.829, 58.72, 0.0], [16.448, 57.041, 0.0], [15.88, 56.104, 0.0], [14.667, 56.201, 0.0], [14.101, 55.408, 0.0], [12.943, 55.362, 0.0], [12.625, 56.307, 0.0], [11.788, 57.442, 0.0], [11.027, 58.856, 0.0], [11.468, 59.432, 0.0], [12.3, 60.118, 0.0], [12.631, 61.294, 0.0], [11.992, 61.8, 0.0], [11.931, 63.128, 0.0], [12.58, 64.066, 0.0], [13.572, 64.049, 0.0], [13.92, 64.445, 0.0], [13.556, 64.787, 0.0], [15.108, 66.194, 0.0], [16.109, 67.302, 0.0], [16.769, 68.014, 0.0], [17.729, 68.011, 0.0], [17.994, 68.567, 0.0], [19.879, 68.407, 0.0], [20.025, 69.065, 0.0], [20.646, 69.106, 0.0], [21.979, 68.617, 0.0], [23.539, 67.936, 0.0], [23.566, 66.396, 0.0], [23.903, 66.007, 0.0], [22.183, 65.724, 0.0]
        ]]
      }
    },
    "SE",
    "SWE"
    ],
    [
      "East Timor",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [124.969, -8.893, 0.0], [125.086, -8.657, 0.0], [125.947, -8.432, 0.0], [126.645, -8.398, 0.0], [126.957, -8.273, 0.0], [127.336, -8.397, 0.0], [126.968, -8.668, 0.0], [125.926, -9.106, 0.0], [125.089, -9.393, 0.0], [125.07, -9.09, 0.0], [124.969, -8.893, 0.0]
        ]]
      }
    },
    "TL",
    "TLS"
    ],
    [
      "Turkey",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [36.913, 41.335, 0.0], [38.348, 40.949, 0.0], [39.513, 41.103, 0.0], [40.373, 41.014, 0.0], [41.554, 41.536, 0.0], [42.62, 41.583, 0.0], [43.583, 41.092, 0.0], [43.753, 40.74, 0.0], [43.656, 40.254, 0.0], [44.4, 40.005, 0.0], [44.794, 39.713, 0.0], [44.109, 39.428, 0.0], [44.421, 38.281, 0.0], [44.226, 37.972, 0.0], [44.773, 37.17, 0.0], [44.293, 37.002, 0.0], [43.942, 37.256, 0.0], [42.779, 37.385, 0.0], [42.35, 37.23, 0.0], [41.212, 37.074, 0.0], [40.673, 37.091, 0.0], [39.523, 36.716, 0.0], [38.7, 36.713, 0.0], [38.168, 36.901, 0.0], [37.067, 36.623, 0.0], [36.739, 36.818, 0.0], [36.685, 36.26, 0.0], [36.418, 36.041, 0.0], [36.15, 35.822, 0.0], [35.782, 36.275, 0.0], [36.161, 36.651, 0.0], [35.551, 36.565, 0.0], [34.715, 36.796, 0.0], [34.027, 36.22, 0.0], [32.509, 36.108, 0.0], [31.7, 36.644, 0.0], [30.622, 36.678, 0.0], [30.391, 36.263, 0.0], [29.7, 36.144, 0.0], [28.733, 36.677, 0.0], [27.641, 36.659, 0.0], [27.049, 37.653, 0.0], [26.318, 38.208, 0.0], [26.805, 38.986, 0.0], [26.171, 39.464, 0.0], [27.28, 40.42, 0.0], [28.82, 40.46, 0.0], [29.24, 41.22, 0.0], [31.146, 41.088, 0.0], [32.348, 41.736, 0.0], [33.513, 42.019, 0.0], [35.168, 42.04, 0.0], [36.913, 41.335, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [27.192, 40.691, 0.0], [26.358, 40.152, 0.0], [26.043, 40.618, 0.0], [26.057, 40.824, 0.0], [26.295, 40.936, 0.0], [26.604, 41.562, 0.0], [26.117, 41.827, 0.0], [27.136, 42.141, 0.0], [27.997, 42.007, 0.0], [28.116, 41.623, 0.0], [28.988, 41.3, 0.0], [28.806, 41.055, 0.0], [27.619, 41.0, 0.0], [27.192, 40.691, 0.0]
       ]
      ]
     }
    ]
    },
    "TR",
    "TUR"
    ],
    [
      "United States",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-155.542, 19.083, 0.0], [-155.688, 18.916, 0.0], [-155.937, 19.059, 0.0], [-155.908, 19.339, 0.0], [-156.073, 19.703, 0.0], [-156.024, 19.814, 0.0], [-155.85, 19.977, 0.0], [-155.919, 20.174, 0.0], [-155.861, 20.267, 0.0], [-155.785, 20.249, 0.0], [-155.402, 20.08, 0.0], [-155.225, 19.993, 0.0], [-155.062, 19.859, 0.0], [-154.807, 19.509, 0.0], [-154.831, 19.453, 0.0], [-155.222, 19.24, 0.0], [-155.542, 19.083, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-156.079, 20.644, 0.0], [-156.414, 20.572, 0.0], [-156.587, 20.783, 0.0], [-156.702, 20.864, 0.0], [-156.711, 20.927, 0.0], [-156.613, 21.012, 0.0], [-156.257, 20.917, 0.0], [-155.996, 20.764, 0.0], [-156.079, 20.644, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-156.758, 21.177, 0.0], [-156.789, 21.069, 0.0], [-157.325, 21.098, 0.0], [-157.25, 21.22, 0.0], [-156.758, 21.177, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-157.653, 21.322, 0.0], [-157.707, 21.264, 0.0], [-157.779, 21.277, 0.0], [-158.127, 21.312, 0.0], [-158.254, 21.539, 0.0], [-158.293, 21.579, 0.0], [-158.025, 21.717, 0.0], [-157.942, 21.653, 0.0], [-157.653, 21.322, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-159.345, 21.982, 0.0], [-159.464, 21.883, 0.0], [-159.801, 22.065, 0.0], [-159.749, 22.138, 0.0], [-159.596, 22.236, 0.0], [-159.366, 22.215, 0.0], [-159.345, 21.982, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-94.818, 49.389, 0.0], [-94.64, 48.84, 0.0], [-94.329, 48.671, 0.0], [-93.631, 48.609, 0.0], [-92.61, 48.45, 0.0], [-91.64, 48.14, 0.0], [-90.83, 48.27, 0.0], [-89.6, 48.01, 0.0], [-89.273, 48.02, 0.0], [-88.378, 48.303, 0.0], [-87.44, 47.94, 0.0], [-86.462, 47.553, 0.0], [-85.652, 47.22, 0.0], [-84.876, 46.9, 0.0], [-84.779, 46.637, 0.0], [-84.544, 46.539, 0.0], [-84.605, 46.44, 0.0], [-84.337, 46.409, 0.0], [-84.142, 46.512, 0.0], [-84.092, 46.275, 0.0], [-83.891, 46.117, 0.0], [-83.616, 46.117, 0.0], [-83.47, 45.995, 0.0], [-83.593, 45.817, 0.0], [-82.551, 45.348, 0.0], [-82.338, 44.44, 0.0], [-82.138, 43.571, 0.0], [-82.43, 42.98, 0.0], [-82.9, 42.43, 0.0], [-83.12, 42.08, 0.0], [-83.142, 41.976, 0.0], [-83.03, 41.833, 0.0], [-82.69, 41.675, 0.0], [-82.439, 41.675, 0.0], [-81.278, 42.209, 0.0], [-80.247, 42.366, 0.0], [-78.939, 42.864, 0.0], [-78.92, 42.965, 0.0], [-79.01, 43.27, 0.0], [-79.172, 43.466, 0.0], [-78.72, 43.625, 0.0], [-77.738, 43.629, 0.0], [-76.82, 43.629, 0.0], [-76.5, 44.018, 0.0], [-76.375, 44.096, 0.0], [-75.318, 44.816, 0.0], [-74.867, 45.0, 0.0], [-73.348, 45.007, 0.0], [-71.505, 45.008, 0.0], [-71.405, 45.255, 0.0], [-71.085, 45.305, 0.0], [-70.66, 45.46, 0.0], [-70.305, 45.915, 0.0], [-70.0, 46.693, 0.0], [-69.237, 47.448, 0.0], [-68.905, 47.185, 0.0], [-68.234, 47.355, 0.0], [-67.79, 47.066, 0.0], [-67.791, 45.703, 0.0], [-67.137, 45.138, 0.0], [-66.965, 44.81, 0.0], [-68.033, 44.325, 0.0], [-69.06, 43.98, 0.0], [-70.116, 43.684, 0.0], [-70.645, 43.09, 0.0], [-70.815, 42.865, 0.0], [-70.825, 42.335, 0.0], [-70.495, 41.805, 0.0], [-70.08, 41.78, 0.0], [-70.185, 42.145, 0.0], [-69.885, 41.923, 0.0], [-69.965, 41.637, 0.0], [-70.64, 41.475, 0.0], [-71.12, 41.494, 0.0], [-71.86, 41.32, 0.0], [-72.295, 41.27, 0.0], [-72.876, 41.221, 0.0], [-73.71, 40.931, 0.0], [-72.241, 41.119, 0.0], [-71.945, 40.93, 0.0], [-73.345, 40.63, 0.0], [-73.982, 40.628, 0.0], [-73.952, 40.751, 0.0], [-74.257, 40.474, 0.0], [-73.962, 40.428, 0.0], [-74.178, 39.709, 0.0], [-74.906, 38.94, 0.0], [-74.98, 39.196, 0.0], [-75.2, 39.248, 0.0], [-75.528, 39.499, 0.0], [-75.32, 38.96, 0.0], [-75.072, 38.782, 0.0], [-75.057, 38.404, 0.0], [-75.377, 38.016, 0.0], [-75.94, 37.217, 0.0], [-76.031, 37.257, 0.0], [-75.722, 37.937, 0.0], [-76.233, 38.319, 0.0], [-76.35, 39.15, 0.0], [-76.543, 38.718, 0.0], [-76.329, 38.083, 0.0], [-76.99, 38.24, 0.0], [-76.302, 37.918, 0.0], [-76.259, 36.966, 0.0], [-75.972, 36.897, 0.0], [-75.868, 36.551, 0.0], [-75.727, 35.551, 0.0], [-76.363, 34.809, 0.0], [-77.398, 34.512, 0.0], [-78.055, 33.925, 0.0], [-78.554, 33.861, 0.0], [-79.061, 33.494, 0.0], [-79.204, 33.158, 0.0], [-80.301, 32.509, 0.0], [-80.865, 32.033, 0.0], [-81.336, 31.44, 0.0], [-81.49, 30.73, 0.0], [-81.314, 30.036, 0.0], [-80.98, 29.18, 0.0], [-80.536, 28.472, 0.0], [-80.53, 28.04, 0.0], [-80.057, 26.88, 0.0], [-80.088, 26.206, 0.0], [-80.132, 25.817, 0.0], [-80.381, 25.206, 0.0], [-80.68, 25.08, 0.0], [-81.172, 25.201, 0.0], [-81.33, 25.64, 0.0], [-81.71, 25.87, 0.0], [-82.24, 26.73, 0.0], [-82.705, 27.495, 0.0], [-82.855, 27.886, 0.0], [-82.65, 28.55, 0.0], [-82.93, 29.1, 0.0], [-83.71, 29.937, 0.0], [-84.1, 30.09, 0.0], [-85.109, 29.636, 0.0], [-85.288, 29.686, 0.0], [-85.773, 30.153, 0.0], [-86.4, 30.4, 0.0], [-87.53, 30.274, 0.0], [-88.418, 30.385, 0.0], [-89.18, 30.316, 0.0], [-89.594, 30.16, 0.0], [-89.414, 29.894, 0.0], [-89.43, 29.489, 0.0], [-89.218, 29.291, 0.0], [-89.408, 29.16, 0.0], [-89.779, 29.307, 0.0], [-90.155, 29.117, 0.0], [-90.88, 29.149, 0.0], [-91.627, 29.677, 0.0], [-92.499, 29.552, 0.0], [-93.226, 29.784, 0.0], [-93.848, 29.714, 0.0], [-94.69, 29.48, 0.0], [-95.6, 28.739, 0.0], [-96.594, 28.307, 0.0], [-97.14, 27.83, 0.0], [-97.37, 27.38, 0.0], [-97.38, 26.69, 0.0], [-97.33, 26.21, 0.0], [-97.14, 25.87, 0.0], [-97.53, 25.84, 0.0], [-98.24, 26.06, 0.0], [-99.02, 26.37, 0.0], [-99.3, 26.84, 0.0], [-99.52, 27.54, 0.0], [-100.11, 28.11, 0.0], [-100.456, 28.696, 0.0], [-100.958, 29.381, 0.0], [-101.662, 29.779, 0.0], [-102.48, 29.76, 0.0], [-103.11, 28.97, 0.0], [-103.94, 29.27, 0.0], [-104.457, 29.572, 0.0], [-104.706, 30.122, 0.0], [-105.037, 30.644, 0.0], [-105.632, 31.084, 0.0], [-106.143, 31.4, 0.0], [-106.508, 31.755, 0.0], [-108.24, 31.755, 0.0], [-108.242, 31.342, 0.0], [-109.035, 31.342, 0.0], [-111.024, 31.335, 0.0], [-113.305, 32.039, 0.0], [-114.815, 32.525, 0.0], [-114.721, 32.721, 0.0], [-115.991, 32.612, 0.0], [-117.128, 32.535, 0.0], [-117.296, 33.046, 0.0], [-117.944, 33.621, 0.0], [-118.411, 33.741, 0.0], [-118.52, 34.028, 0.0], [-119.081, 34.078, 0.0], [-119.439, 34.348, 0.0], [-120.368, 34.447, 0.0], [-120.623, 34.609, 0.0], [-120.744, 35.157, 0.0], [-121.715, 36.162, 0.0], [-122.547, 37.552, 0.0], [-122.512, 37.783, 0.0], [-122.953, 38.114, 0.0], [-123.727, 38.952, 0.0], [-123.865, 39.767, 0.0], [-124.398, 40.313, 0.0], [-124.179, 41.142, 0.0], [-124.214, 42.0, 0.0], [-124.533, 42.766, 0.0], [-124.142, 43.708, 0.0], [-124.021, 44.616, 0.0], [-123.899, 45.523, 0.0], [-124.08, 46.865, 0.0], [-124.396, 47.72, 0.0], [-124.687, 48.184, 0.0], [-124.566, 48.38, 0.0], [-123.12, 48.04, 0.0], [-122.587, 47.096, 0.0], [-122.34, 47.36, 0.0], [-122.5, 48.18, 0.0], [-122.84, 49.0, 0.0], [-120.0, 49.0, 0.0], [-117.031, 49.0, 0.0], [-116.048, 49.0, 0.0], [-113.0, 49.0, 0.0], [-110.05, 49.0, 0.0], [-107.05, 49.0, 0.0], [-104.048, 49.0, 0.0], [-100.65, 49.0, 0.0], [-97.229, 49.001, 0.0], [-95.159, 49.0, 0.0], [-95.156, 49.384, 0.0], [-94.818, 49.389, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-153.006, 57.116, 0.0], [-154.005, 56.735, 0.0], [-154.516, 56.993, 0.0], [-154.671, 57.461, 0.0], [-153.763, 57.817, 0.0], [-153.229, 57.969, 0.0], [-152.565, 57.901, 0.0], [-152.141, 57.591, 0.0], [-153.006, 57.116, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-165.579, 59.91, 0.0], [-166.193, 59.754, 0.0], [-166.848, 59.941, 0.0], [-167.455, 60.213, 0.0], [-166.468, 60.384, 0.0], [-165.674, 60.294, 0.0], [-165.579, 59.91, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-171.732, 63.783, 0.0], [-171.114, 63.592, 0.0], [-170.491, 63.695, 0.0], [-169.683, 63.431, 0.0], [-168.689, 63.298, 0.0], [-168.772, 63.189, 0.0], [-169.529, 62.977, 0.0], [-170.291, 63.194, 0.0], [-170.671, 63.376, 0.0], [-171.553, 63.318, 0.0], [-171.791, 63.406, 0.0], [-171.732, 63.783, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-155.068, 71.148, 0.0], [-154.344, 70.696, 0.0], [-153.9, 70.89, 0.0], [-152.21, 70.83, 0.0], [-152.27, 70.6, 0.0], [-150.74, 70.43, 0.0], [-149.72, 70.53, 0.0], [-147.613, 70.214, 0.0], [-145.69, 70.12, 0.0], [-144.92, 69.99, 0.0], [-143.589, 70.153, 0.0], [-142.073, 69.852, 0.0], [-140.986, 69.712, 0.0], [-140.986, 69.712, 0.0], [-140.992, 66.0, 0.0], [-140.998, 60.306, 0.0], [-140.013, 60.277, 0.0], [-139.039, 60.0, 0.0], [-138.341, 59.562, 0.0], [-137.453, 58.905, 0.0], [-136.48, 59.464, 0.0], [-135.476, 59.788, 0.0], [-134.945, 59.271, 0.0], [-134.271, 58.861, 0.0], [-133.356, 58.41, 0.0], [-132.73, 57.693, 0.0], [-131.708, 56.552, 0.0], [-130.008, 55.916, 0.0], [-129.98, 55.285, 0.0], [-130.536, 54.803, 0.0], [-131.086, 55.179, 0.0], [-131.967, 55.498, 0.0], [-132.25, 56.37, 0.0], [-133.539, 57.179, 0.0], [-134.078, 58.123, 0.0], [-135.038, 58.188, 0.0], [-136.628, 58.212, 0.0], [-137.8, 58.5, 0.0], [-139.868, 59.538, 0.0], [-140.825, 59.728, 0.0], [-142.574, 60.084, 0.0], [-143.959, 59.999, 0.0], [-145.926, 60.459, 0.0], [-147.114, 60.885, 0.0], [-148.224, 60.673, 0.0], [-148.018, 59.978, 0.0], [-148.571, 59.914, 0.0], [-149.728, 59.706, 0.0], [-150.608, 59.368, 0.0], [-151.716, 59.156, 0.0], [-151.859, 59.745, 0.0], [-151.41, 60.726, 0.0], [-150.347, 61.034, 0.0], [-150.621, 61.284, 0.0], [-151.896, 60.727, 0.0], [-152.578, 60.062, 0.0], [-154.019, 59.35, 0.0], [-153.288, 58.865, 0.0], [-154.232, 58.146, 0.0], [-155.307, 57.728, 0.0], [-156.308, 57.423, 0.0], [-156.556, 56.98, 0.0], [-158.117, 56.464, 0.0], [-158.433, 55.994, 0.0], [-159.603, 55.567, 0.0], [-160.29, 55.644, 0.0], [-161.223, 55.365, 0.0], [-162.238, 55.024, 0.0], [-163.069, 54.69, 0.0], [-164.786, 54.404, 0.0], [-164.942, 54.572, 0.0], [-163.848, 55.039, 0.0], [-162.87, 55.348, 0.0], [-161.804, 55.895, 0.0], [-160.564, 56.008, 0.0], [-160.071, 56.418, 0.0], [-158.684, 57.017, 0.0], [-158.461, 57.217, 0.0], [-157.723, 57.57, 0.0], [-157.55, 58.328, 0.0], [-157.042, 58.919, 0.0], [-158.195, 58.616, 0.0], [-158.517, 58.788, 0.0], [-159.059, 58.424, 0.0], [-159.712, 58.931, 0.0], [-159.981, 58.573, 0.0], [-160.355, 59.071, 0.0], [-161.355, 58.671, 0.0], [-161.969, 58.672, 0.0], [-162.055, 59.267, 0.0], [-161.874, 59.634, 0.0], [-162.518, 59.99, 0.0], [-163.818, 59.798, 0.0], [-164.662, 60.267, 0.0], [-165.346, 60.507, 0.0], [-165.351, 61.074, 0.0], [-166.121, 61.5, 0.0], [-165.734, 62.075, 0.0], [-164.919, 62.633, 0.0], [-164.563, 63.146, 0.0], [-163.753, 63.219, 0.0], [-163.067, 63.059, 0.0], [-162.261, 63.542, 0.0], [-161.534, 63.456, 0.0], [-160.773, 63.766, 0.0], [-160.958, 64.223, 0.0], [-161.518, 64.403, 0.0], [-160.778, 64.789, 0.0], [-161.392, 64.777, 0.0], [-162.453, 64.559, 0.0], [-162.758, 64.339, 0.0], [-163.546, 64.559, 0.0], [-164.961, 64.447, 0.0], [-166.425, 64.687, 0.0], [-166.845, 65.089, 0.0], [-168.111, 65.67, 0.0], [-166.705, 66.088, 0.0], [-164.475, 66.577, 0.0], [-163.653, 66.577, 0.0], [-163.789, 66.077, 0.0], [-161.678, 66.116, 0.0], [-162.49, 66.736, 0.0], [-163.72, 67.116, 0.0], [-164.431, 67.616, 0.0], [-165.39, 68.043, 0.0], [-166.764, 68.359, 0.0], [-166.205, 68.883, 0.0], [-164.431, 68.916, 0.0], [-163.169, 69.371, 0.0], [-162.931, 69.858, 0.0], [-161.909, 70.333, 0.0], [-160.935, 70.448, 0.0], [-159.039, 70.892, 0.0], [-158.12, 70.825, 0.0], [-156.581, 71.358, 0.0], [-155.068, 71.148, 0.0]
       ]
      ]
     }
    ]
    },
    "US",
    "USA"
    ],
    [
      "Austria",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [16.98, 48.123, 0.0], [16.904, 47.715, 0.0], [16.341, 47.713, 0.0], [16.534, 47.496, 0.0], [16.202, 46.852, 0.0], [16.012, 46.684, 0.0], [15.137, 46.659, 0.0], [14.632, 46.432, 0.0], [13.806, 46.509, 0.0], [12.376, 46.768, 0.0], [12.153, 47.115, 0.0], [11.165, 46.942, 0.0], [11.049, 46.751, 0.0], [10.443, 46.894, 0.0], [9.932, 46.921, 0.0], [9.48, 47.103, 0.0], [9.633, 47.348, 0.0], [9.594, 47.525, 0.0], [9.896, 47.58, 0.0], [10.402, 47.302, 0.0], [10.545, 47.566, 0.0], [11.426, 47.524, 0.0], [12.141, 47.703, 0.0], [12.621, 47.672, 0.0], [12.933, 47.468, 0.0], [13.026, 47.638, 0.0], [12.884, 48.289, 0.0], [13.243, 48.416, 0.0], [13.596, 48.877, 0.0], [14.339, 48.555, 0.0], [14.901, 48.964, 0.0], [15.253, 49.039, 0.0], [16.03, 48.734, 0.0], [16.499, 48.786, 0.0], [16.96, 48.597, 0.0], [16.88, 48.47, 0.0], [16.98, 48.123, 0.0]
        ]]
      }
    },
    "AT",
    "AUT"
    ],
    [
      "Cameroon",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [13.076, 2.267, 0.0], [12.951, 2.322, 0.0], [12.359, 2.193, 0.0], [11.752, 2.327, 0.0], [11.276, 2.261, 0.0], [9.649, 2.284, 0.0], [9.795, 3.073, 0.0], [9.404, 3.735, 0.0], [8.948, 3.904, 0.0], [8.745, 4.352, 0.0], [8.489, 4.496, 0.0], [8.5, 4.772, 0.0], [8.758, 5.48, 0.0], [9.233, 6.444, 0.0], [9.523, 6.453, 0.0], [10.118, 7.039, 0.0], [10.497, 7.055, 0.0], [11.059, 6.644, 0.0], [11.746, 6.981, 0.0], [11.839, 7.397, 0.0], [12.064, 7.8, 0.0], [12.219, 8.306, 0.0], [12.754, 8.718, 0.0], [12.955, 9.418, 0.0], [13.168, 9.641, 0.0], [13.309, 10.16, 0.0], [13.573, 10.799, 0.0], [14.415, 11.572, 0.0], [14.468, 11.905, 0.0], [14.577, 12.085, 0.0], [14.181, 12.484, 0.0], [14.214, 12.802, 0.0], [14.496, 12.859, 0.0], [14.893, 12.219, 0.0], [14.96, 11.556, 0.0], [14.924, 10.891, 0.0], [15.468, 9.982, 0.0], [14.909, 9.992, 0.0], [14.627, 9.921, 0.0], [14.171, 10.021, 0.0], [13.954, 9.549, 0.0], [14.544, 8.966, 0.0], [14.98, 8.796, 0.0], [15.121, 8.382, 0.0], [15.436, 7.693, 0.0], [15.279, 7.422, 0.0], [14.777, 6.408, 0.0], [14.537, 6.227, 0.0], [14.459, 5.452, 0.0], [14.559, 5.031, 0.0], [14.478, 4.733, 0.0], [14.951, 4.21, 0.0], [15.036, 3.851, 0.0], [15.405, 3.335, 0.0], [15.863, 3.014, 0.0], [15.907, 2.557, 0.0], [16.013, 2.268, 0.0], [15.941, 1.728, 0.0], [15.146, 1.964, 0.0], [14.338, 2.228, 0.0], [13.076, 2.267, 0.0]
        ]]
      }
    },
    "CM",
    "CMR"
    ],
    [
      "Djibouti",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [43.081, 12.7, 0.0], [43.318, 12.39, 0.0], [43.286, 11.975, 0.0], [42.716, 11.736, 0.0], [43.145, 11.462, 0.0], [42.777, 10.927, 0.0], [42.555, 11.105, 0.0], [42.314, 11.034, 0.0], [41.756, 11.051, 0.0], [41.74, 11.355, 0.0], [41.662, 11.631, 0.0], [42.0, 12.1, 0.0], [42.352, 12.542, 0.0], [42.78, 12.455, 0.0], [43.081, 12.7, 0.0]
        ]]
      }
    },
    "DJ",
    "DJI"
    ],
    [
      "Dominican Rep.",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-71.712, 19.714, 0.0], [-71.587, 19.885, 0.0], [-70.807, 19.88, 0.0], [-70.214, 19.623, 0.0], [-69.951, 19.648, 0.0], [-69.769, 19.293, 0.0], [-69.222, 19.313, 0.0], [-69.254, 19.015, 0.0], [-68.809, 18.979, 0.0], [-68.318, 18.612, 0.0], [-68.689, 18.205, 0.0], [-69.165, 18.423, 0.0], [-69.624, 18.381, 0.0], [-69.953, 18.428, 0.0], [-70.133, 18.246, 0.0], [-70.517, 18.184, 0.0], [-70.669, 18.427, 0.0], [-71.0, 18.283, 0.0], [-71.4, 17.599, 0.0], [-71.658, 17.758, 0.0], [-71.708, 18.045, 0.0], [-71.688, 18.317, 0.0], [-71.945, 18.617, 0.0], [-71.701, 18.785, 0.0], [-71.625, 19.17, 0.0], [-71.712, 19.714, 0.0]
        ]]
      }
    },
    "DO",
    "DOM"
    ],
    [
      "Falkland Is.",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-61.2, -51.85, 0.0], [-60.0, -51.25, 0.0], [-59.15, -51.5, 0.0], [-58.55, -51.1, 0.0], [-57.75, -51.55, 0.0], [-58.05, -51.9, 0.0], [-59.4, -52.2, 0.0], [-59.85, -51.85, 0.0], [-60.7, -52.3, 0.0], [-61.2, -51.85, 0.0]
        ]]
      }
    },
    "FK",
    "FLK"
    ],
    [
      "Gabon",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [11.094, -3.979, 0.0], [10.066, -2.969, 0.0], [9.405, -2.144, 0.0], [8.798, -1.111, 0.0], [8.83, -0.779, 0.0], [9.048, -0.459, 0.0], [9.291, 0.269, 0.0], [9.493, 1.01, 0.0], [9.83, 1.068, 0.0], [11.285, 1.058, 0.0], [11.276, 2.261, 0.0], [11.752, 2.327, 0.0], [12.359, 2.193, 0.0], [12.951, 2.322, 0.0], [13.076, 2.267, 0.0], [13.003, 1.831, 0.0], [13.283, 1.314, 0.0], [14.027, 1.396, 0.0], [14.276, 1.197, 0.0],[ 13.843, 0.039, 0.0], [14.316, -0.553, 0.0], [14.425, -1.333, 0.0], [14.299, -1.998, 0.0], [13.992, -2.471, 0.0], [13.11, -2.429, 0.0], [12.575, -1.949, 0.0], [12.496, -2.392, 0.0], [11.821, -2.514, 0.0], [11.478, -2.766, 0.0], [11.855, -3.427, 0.0], [11.094, -3.979, 0.0]
        ]]
      }
    },
    "GA",
    "GAB"
    ],
    [
      "United Kingdom",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-5.662, 54.555, 0.0], [-6.198, 53.868, 0.0], [-6.954, 54.074, 0.0], [-7.572, 54.06, 0.0], [-7.366, 54.596, 0.0], [-7.572, 55.132, 0.0], [-6.734, 55.173, 0.0], [-5.662, 54.555, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-3.005, 58.635, 0.0], [-4.074, 57.553, 0.0], [-3.055, 57.69, 0.0], [-1.959, 57.685, 0.0], [-2.22, 56.87, 0.0], [-3.119, 55.974, 0.0], [-2.085, 55.91, 0.0], [-2.006, 55.805, 0.0], [-1.115, 54.625, 0.0], [-0.43, 54.464, 0.0], [0.185, 53.325, 0.0], [0.47, 52.93, 0.0], [1.682, 52.74, 0.0], [1.56, 52.1, 0.0], [1.051, 51.807, 0.0], [1.45, 51.289, 0.0], [0.55, 50.766, 0.0], [-0.788, 50.775, 0.0], [-2.49, 50.5, 0.0], [-2.956, 50.697, 0.0], [-3.617, 50.228, 0.0], [-4.543, 50.342, 0.0], [-5.245, 49.96, 0.0], [-5.777, 50.16, 0.0], [-4.31, 51.21, 0.0], [-3.415, 51.426, 0.0], [-3.423, 51.427, 0.0], [-4.984, 51.593, 0.0], [-5.267, 51.991, 0.0], [-4.222, 52.301, 0.0], [-4.77, 52.84, 0.0], [-4.58, 53.495, 0.0], [-3.094, 53.405, 0.0], [-3.092, 53.404, 0.0], [-2.945, 53.985, 0.0], [-3.615, 54.601, 0.0], [-3.63, 54.615, 0.0], [-4.844, 54.791, 0.0], [-5.083, 55.062, 0.0], [-4.719, 55.508, 0.0], [-5.048, 55.784, 0.0], [-5.586, 55.311, 0.0], [-5.645, 56.275, 0.0], [-6.15, 56.785, 0.0], [-5.787, 57.819, 0.0], [-5.01, 58.63, 0.0], [-4.211, 58.551, 0.0], [-3.005, 58.635, 0.0]
       ]
      ]
     }
    ]
    },
    "GB",
    "GBR"
    ],
    [
      "Ghana",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [1.06, 5.929, 0.0], [-0.508, 5.343, 0.0], [-1.064, 5.001, 0.0], [-1.965, 4.71, 0.0], [-2.856, 4.994, 0.0], [-2.811, 5.389, 0.0], [-3.244, 6.25, 0.0], [-2.984, 7.38, 0.0], [-2.562, 8.22, 0.0], [-2.827, 9.642, 0.0], [-2.964, 10.395, 0.0], [-2.94, 10.963, 0.0], [-1.203, 11.01, 0.0], [-0.762, 10.937, 0.0], [-0.439, 11.098, 0.0], [0.024, 11.019, 0.0], [-0.05, 10.707, 0.0], [0.368, 10.191, 0.0], [0.366, 9.465, 0.0], [0.461, 8.677, 0.0], [0.712, 8.312, 0.0], [0.491, 7.412, 0.0], [0.57, 6.914, 0.0], [0.837, 6.28, 0.0], [1.06, 5.929, 0.0]
        ]]
      }
    },
    "GH",
    "GHA"
    ],
    [
      "Greece",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [23.7, 35.705, 0.0], [24.247, 35.368, 0.0], [25.025, 35.425, 0.0], [25.769, 35.354, 0.0], [25.745, 35.18, 0.0], [26.29, 35.3, 0.0], [26.165, 35.005, 0.0], [24.725, 34.92, 0.0], [24.735, 35.085, 0.0], [23.515, 35.28, 0.0], [23.7, 35.705, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [26.604, 41.562, 0.0], [26.295, 40.936, 0.0], [26.057, 40.824, 0.0], [25.448, 40.853, 0.0], [24.926, 40.947, 0.0], [23.715, 40.687, 0.0], [24.408, 40.125, 0.0], [23.9, 39.962, 0.0], [23.343, 39.961, 0.0], [22.814, 40.476, 0.0], [22.626, 40.257, 0.0], [22.85, 39.659, 0.0], [23.35, 39.19, 0.0], [22.973, 38.971, 0.0], [23.53, 38.51, 0.0], [24.025, 38.22, 0.0], [24.04, 37.655, 0.0], [23.115, 37.92, 0.0], [23.41, 37.41, 0.0], [22.775, 37.305, 0.0], [23.154, 36.423, 0.0], [22.49, 36.41, 0.0], [21.67, 36.845, 0.0], [21.295, 37.645, 0.0], [21.12, 38.31, 0.0], [20.73, 38.77, 0.0], [20.218, 39.34, 0.0], [20.15, 39.625, 0.0], [20.615, 40.11, 0.0], [20.675, 40.435, 0.0], [21.0, 40.58, 0.0], [21.02, 40.843, 0.0], [21.674, 40.931, 0.0], [22.055, 41.15, 0.0], [22.597, 41.13, 0.0], [22.762, 41.305, 0.0], [22.952, 41.338, 0.0], [23.692, 41.309, 0.0], [24.493, 41.584, 0.0], [25.197, 41.234, 0.0], [26.106, 41.329, 0.0], [26.117, 41.827, 0.0], [26.604, 41.562, 0.0]
       ]
      ]
     }
    ]
    },
    "GR",
    "GRC"
    ],
    [
      "Iceland",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-14.509, 66.456, 0.0], [-14.74, 65.809, 0.0], [-13.61, 65.127, 0.0], [-14.91, 64.364, 0.0], [-17.794, 63.679, 0.0], [-18.656, 63.496, 0.0], [-19.973, 63.644, 0.0], [-22.763, 63.96, 0.0], [-21.778, 64.402, 0.0], [-23.955, 64.891, 0.0], [-22.184, 65.085, 0.0], [-22.227, 65.379, 0.0], [-24.326, 65.611, 0.0], [-23.651, 66.263, 0.0], [-22.135, 66.41, 0.0], [-20.576, 65.732, 0.0], [-19.057, 66.277, 0.0], [-17.799, 65.994, 0.0], [-16.168, 66.527, 0.0], [-14.509, 66.456, 0.0]
        ]]
      }
    },
    "IS",
    "ISL"
    ],
    [
      "Lebanon",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [35.821, 33.277, 0.0], [35.553, 33.264, 0.0], [35.461, 33.089, 0.0], [35.126, 33.091, 0.0], [35.482, 33.905, 0.0], [35.98, 34.61, 0.0], [35.998, 34.645, 0.0], [36.448, 34.594, 0.0], [36.612, 34.202, 0.0], [36.066, 33.825, 0.0], [35.821, 33.277, 0.0]
        ]]
      }
    },
    "LB",
    "LBN"
    ],
    [
      "Libya",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [14.851, 22.863, 0.0], [14.144, 22.491, 0.0], [13.581, 23.041, 0.0], [12.0, 23.472, 0.0], [11.561, 24.098, 0.0], [10.771, 24.563, 0.0], [10.304, 24.379, 0.0], [9.948, 24.937, 0.0], [9.911, 25.365, 0.0], [9.319, 26.094, 0.0], [9.716, 26.512, 0.0], [9.629, 27.141, 0.0], [9.756, 27.688, 0.0], [9.684, 28.144, 0.0], [9.86, 28.96, 0.0], [9.806, 29.425, 0.0], [9.482, 30.308, 0.0], [9.97, 30.539, 0.0], [10.057, 30.962, 0.0], [9.95, 31.376, 0.0], [10.637, 31.761, 0.0], [10.945, 32.082, 0.0], [11.432, 32.369, 0.0], [11.489, 33.137, 0.0], [12.663, 32.793, 0.0], [13.083, 32.879, 0.0], [13.919, 32.712, 0.0], [15.246, 32.265, 0.0], [15.714, 31.376, 0.0], [16.612, 31.182, 0.0], [18.021, 30.764, 0.0], [19.086, 30.266, 0.0], [19.574, 30.526, 0.0], [20.053, 30.986, 0.0], [19.82, 31.752, 0.0], [20.134, 32.238, 0.0], [20.855, 32.707, 0.0], [21.543, 32.843, 0.0], [22.896, 32.639, 0.0], [23.237, 32.191, 0.0], [23.609, 32.187, 0.0], [23.928, 32.017, 0.0], [24.921, 31.899, 0.0], [25.165, 31.569, 0.0], [24.803, 31.089, 0.0], [24.958, 30.662, 0.0], [24.7, 30.044, 0.0], [25.0, 29.239, 0.0], [25.0, 25.682, 0.0], [25.0, 22.0, 0.0], [25.0, 20.003, 0.0], [23.85, 20.0, 0.0], [23.838, 19.58, 0.0], [19.849, 21.495, 0.0], [15.861, 23.41, 0.0], [14.851, 22.863, 0.0]
        ]]
      }
    },
    "LY",
    "LBY"
    ],
    [
      "Lesotho",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [28.978, -28.956, 0.0], [29.325, -29.257, 0.0], [29.018, -29.744, 0.0], [28.848, -30.07, 0.0], [28.291, -30.226, 0.0], [28.107, -30.546, 0.0], [27.749, -30.645, 0.0], [26.999, -29.876, 0.0], [27.533, -29.243, 0.0], [28.074, -28.851, 0.0], [28.542, -28.648, 0.0], [28.978, -28.956, 0.0]
        ]]
      }
    },
    "LS",
    "LSO"
    ],
    [
      "Mexico",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-97.14, 25.87, 0.0], [-97.528, 24.992, 0.0], [-97.703, 24.272, 0.0], [-97.776, 22.933, 0.0], [-97.872, 22.444, 0.0], [-97.699, 21.899, 0.0], [-97.389, 21.411, 0.0], [-97.189, 20.635, 0.0], [-96.526, 19.891, 0.0], [-96.292, 19.32, 0.0], [-95.901, 18.828, 0.0], [-94.839, 18.563, 0.0], [-94.426, 18.144, 0.0], [-93.549, 18.424, 0.0], [-92.786, 18.525, 0.0], [-92.037, 18.705, 0.0], [-91.408, 18.876, 0.0], [-90.772, 19.284, 0.0], [-90.534, 19.867, 0.0], [-90.451, 20.708, 0.0], [-90.279, 21.0, 0.0], [-89.601, 21.262, 0.0], [-88.544, 21.494, 0.0], [-87.658, 21.459, 0.0], [-87.052, 21.544, 0.0], [-86.812, 21.332, 0.0], [-86.846, 20.85, 0.0], [-87.383, 20.255, 0.0], [-87.621, 19.647, 0.0], [-87.437, 19.472, 0.0], [-87.587, 19.04, 0.0], [-87.837, 18.26, 0.0], [-88.091, 18.517, 0.0], [-88.3, 18.5, 0.0], [-88.49, 18.487, 0.0], [-88.848, 17.883, 0.0], [-89.03, 18.002, 0.0], [-89.151, 17.955, 0.0], [-89.143, 17.808, 0.0], [-90.068, 17.819, 0.0], [-91.002, 17.818, 0.0], [-91.002, 17.255, 0.0], [-91.454, 17.252, 0.0], [-91.082, 16.918, 0.0], [-90.712, 16.687, 0.0], [-90.601, 16.471, 0.0], [-90.439, 16.41, 0.0], [-90.464, 16.07, 0.0], [-91.748, 16.067, 0.0], [-92.229, 15.251, 0.0], [-92.087, 15.065, 0.0], [-92.203, 14.83, 0.0], [-92.228, 14.539, 0.0], [-93.359, 15.615, 0.0], [-93.875, 15.94, 0.0], [-94.692, 16.201, 0.0], [-95.25, 16.128, 0.0], [-96.053, 15.752, 0.0], [-96.557, 15.654, 0.0], [-97.264, 15.917, 0.0], [-98.013, 16.107, 0.0], [-98.948, 16.566, 0.0], [-99.697, 16.706, 0.0], [-100.829, 17.171, 0.0], [-101.666, 17.649, 0.0], [-101.919, 17.916, 0.0], [-102.478, 17.976, 0.0], [-103.501, 18.292, 0.0], [-103.918, 18.749, 0.0], [-104.992, 19.316, 0.0], [-105.493, 19.947, 0.0], [-105.731, 20.434, 0.0], [-105.398, 20.532, 0.0], [-105.501, 20.817, 0.0], [-105.271, 21.076, 0.0], [-105.266, 21.422, 0.0], [-105.603, 21.871, 0.0], [-105.693, 22.269, 0.0], [-106.029, 22.774, 0.0], [-106.91, 23.768, 0.0], [-107.915, 24.549, 0.0], [-108.402, 25.172, 0.0], [-109.26, 25.581, 0.0], [-109.444, 25.825, 0.0], [-109.292, 26.443, 0.0], [-109.801, 26.676, 0.0], [-110.392, 27.162, 0.0], [-110.641, 27.86, 0.0], [-111.179, 27.941, 0.0], [-111.76, 28.468, 0.0], [-112.228, 28.954, 0.0], [-112.272, 29.267, 0.0], [-112.81, 30.021, 0.0], [-113.164, 30.787, 0.0], [-113.149, 31.171, 0.0], [-113.872, 31.568, 0.0], [-114.206, 31.524, 0.0], [-114.776, 31.8, 0.0], [-114.937, 31.393, 0.0], [-114.771, 30.914, 0.0], [-114.674, 30.163, 0.0], [-114.331, 29.75, 0.0], [-113.589, 29.062, 0.0], [-113.424, 28.826, 0.0], [-113.272, 28.755, 0.0], [-113.14, 28.411, 0.0], [-112.962, 28.425, 0.0], [-112.762, 27.78, 0.0], [-112.458, 27.526, 0.0], [-112.245, 27.172, 0.0], [-111.616, 26.663, 0.0], [-111.285, 25.733, 0.0], [-110.988, 25.295, 0.0], [-110.71, 24.826, 0.0], [-110.655, 24.299, 0.0], [-110.173, 24.266, 0.0], [-109.772, 23.811, 0.0], [-109.409, 23.365, 0.0], [-109.433, 23.186, 0.0], [-109.854, 22.818, 0.0], [-110.031, 22.823, 0.0], [-110.295, 23.431, 0.0], [-110.95, 24.001, 0.0], [-111.671, 24.484, 0.0], [-112.182, 24.738, 0.0], [-112.149, 25.47, 0.0], [-112.301, 26.012, 0.0], [-112.777, 26.322, 0.0], [-113.465, 26.768, 0.0], [-113.597, 26.639, 0.0], [-113.849, 26.9, 0.0], [-114.466, 27.142, 0.0], [-115.055, 27.723, 0.0], [-114.982, 27.798, 0.0], [-114.57, 27.741, 0.0], [-114.199, 28.115, 0.0], [-114.162, 28.566, 0.0], [-114.932, 29.279, 0.0], [-115.519, 29.556, 0.0], [-115.887, 30.181, 0.0], [-116.258, 30.836, 0.0], [-116.722, 31.636, 0.0], [-117.128, 32.535, 0.0], [-115.991, 32.612, 0.0], [-114.721, 32.721, 0.0], [-114.815, 32.525, 0.0], [-113.305, 32.039, 0.0], [-111.024, 31.335, 0.0], [-109.035, 31.342, 0.0], [-108.242, 31.342, 0.0], [-108.24, 31.755, 0.0], [-106.508, 31.755, 0.0], [-106.143, 31.4, 0.0], [-105.632, 31.084, 0.0], [-105.037, 30.644, 0.0], [-104.706, 30.122, 0.0], [-104.457, 29.572, 0.0], [-103.94, 29.27, 0.0], [-103.11, 28.97, 0.0], [-102.48, 29.76, 0.0], [-101.662, 29.779, 0.0], [-100.958, 29.381, 0.0], [-100.456, 28.696, 0.0], [-100.11, 28.11, 0.0], [-99.52, 27.54, 0.0], [-99.3, 26.84, 0.0], [-99.02, 26.37, 0.0], [-98.24, 26.06, 0.0], [-97.53, 25.84, 0.0], [-97.14, 25.87, 0.0]
        ]]
      }
    },
    "MX",
    "MEX"
    ],
    [
      "Myanmar",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [99.543, 20.187, 0.0], [98.96, 19.753, 0.0], [98.254, 19.708, 0.0], [97.798, 18.627, 0.0], [97.376, 18.445, 0.0], [97.859, 17.568, 0.0], [98.494, 16.838, 0.0], [98.903, 16.178, 0.0], [98.537, 15.308, 0.0], [98.192, 15.124, 0.0], [98.431, 14.622, 0.0], [99.098, 13.828, 0.0], [99.212, 13.269, 0.0], [99.196, 12.805, 0.0], [99.587, 11.893, 0.0], [99.038, 10.961, 0.0], [98.554, 9.933, 0.0], [98.457, 10.675, 0.0], [98.765, 11.441, 0.0], [98.428, 12.033, 0.0], [98.51, 13.122, 0.0], [98.104, 13.64, 0.0], [97.778, 14.837, 0.0], [97.597, 16.101, 0.0], [97.165, 16.929, 0.0], [96.506, 16.427, 0.0], [95.369, 15.714, 0.0], [94.808, 15.803, 0.0], [94.189, 16.038, 0.0], [94.533, 17.277, 0.0], [94.325, 18.214, 0.0], [93.541, 19.366, 0.0], [93.663, 19.727, 0.0], [93.078, 19.855, 0.0], [92.369, 20.671, 0.0], [92.303, 21.475, 0.0], [92.652, 21.324, 0.0], [92.673, 22.041, 0.0], [93.166, 22.278, 0.0], [93.06, 22.703, 0.0], [93.286, 23.044, 0.0], [93.325, 24.079, 0.0], [94.107, 23.851, 0.0], [94.553, 24.675, 0.0], [94.603, 25.162, 0.0], [95.155, 26.001, 0.0], [95.125, 26.574, 0.0], [96.419, 27.265, 0.0], [97.134, 27.084, 0.0], [97.052, 27.699, 0.0], [97.403, 27.883, 0.0], [97.327, 28.262, 0.0], [97.912, 28.336, 0.0], [98.246, 27.747, 0.0], [98.683, 27.509, 0.0], [98.712, 26.744, 0.0], [98.672, 25.919, 0.0], [97.725, 25.084, 0.0], [97.605, 23.897, 0.0], [98.66, 24.063, 0.0], [98.899, 23.143, 0.0], [99.532, 22.949, 0.0], [99.241, 22.118, 0.0], [99.983, 21.743, 0.0], [100.417, 21.559, 0.0], [101.15, 21.85, 0.0], [101.18, 21.437, 0.0], [100.329, 20.786, 0.0], [100.116, 20.418, 0.0], [99.543, 20.187, 0.0]
        ]]
      }
    },
    "MM",
    "MMR"
    ],
    [
      "Montenegro",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [19.802, 42.5, 0.0], [19.738, 42.688, 0.0], [19.304, 42.196, 0.0], [19.372, 41.878, 0.0], [19.162, 41.955, 0.0], [18.882, 42.282, 0.0], [18.45, 42.48, 0.0], [18.56, 42.65, 0.0], [18.706, 43.2, 0.0], [19.032, 43.433, 0.0], [19.219, 43.524, 0.0], [19.484, 43.352, 0.0], [19.63, 43.214, 0.0], [19.959, 43.106, 0.0], [20.34, 42.899, 0.0], [20.258, 42.813, 0.0], [20.071, 42.589, 0.0], [19.802, 42.5, 0.0]
        ]]
      }
    },
    "ME",
    "MNE"
    ],
    [
      "Mongolia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [87.751, 49.297, 0.0], [88.806, 49.471, 0.0], [90.714, 50.332, 0.0], [92.235, 50.802, 0.0], [93.104, 50.495, 0.0], [94.148, 50.481, 0.0], [94.816, 50.013, 0.0], [95.814, 49.977, 0.0], [97.26, 49.726, 0.0], [98.232, 50.422, 0.0], [97.826, 51.011, 0.0], [98.861, 52.047, 0.0], [99.982, 51.634, 0.0], [100.889, 51.517, 0.0], [102.065, 51.26, 0.0], [102.256, 50.511, 0.0], [103.677, 50.09, 0.0], [104.622, 50.275, 0.0], [105.887, 50.406, 0.0], [106.889, 50.274, 0.0], [107.868, 49.794, 0.0], [108.475, 49.283, 0.0], [109.402, 49.293, 0.0], [110.662, 49.13, 0.0], [111.581, 49.378, 0.0], [112.898, 49.544, 0.0], [114.362, 50.248, 0.0], [114.962, 50.14, 0.0], [115.486, 49.805, 0.0], [116.679, 49.889, 0.0], [116.192, 49.135, 0.0], [115.485, 48.135, 0.0], [115.743, 47.727, 0.0], [116.309, 47.853, 0.0], [117.296, 47.698, 0.0], [118.064, 48.067, 0.0], [118.867, 47.747, 0.0], [119.773, 47.048, 0.0], [119.663, 46.693, 0.0], [118.874, 46.805, 0.0], [117.422, 46.673, 0.0], [116.718, 46.388, 0.0], [115.985, 45.727, 0.0], [114.46, 45.34, 0.0], [113.464, 44.809, 0.0], [112.436, 45.012, 0.0], [111.873, 45.102, 0.0], [111.348, 44.457, 0.0], [111.668, 44.073, 0.0], [111.83, 43.743, 0.0], [111.13, 43.407, 0.0], [110.412, 42.871, 0.0], [109.244, 42.519, 0.0], [107.745, 42.482, 0.0], [106.129, 42.134, 0.0], [104.965, 41.597, 0.0], [104.522, 41.908, 0.0], [103.312, 41.907, 0.0], [101.833, 42.515, 0.0], [100.846, 42.664, 0.0], [99.516, 42.525, 0.0], [97.452, 42.749, 0.0], [96.349, 42.726, 0.0], [95.762, 43.319, 0.0], [95.307, 44.241, 0.0], [94.689, 44.352, 0.0], [93.481, 44.975, 0.0], [92.134, 45.115, 0.0], [90.946, 45.286, 0.0], [90.586, 45.72, 0.0], [90.971, 46.888, 0.0], [90.281, 47.694, 0.0], [88.854, 48.069, 0.0], [88.014, 48.599, 0.0], [87.751, 49.297, 0.0]
        ]]
      }
    },
    "MN",
    "MNG"
    ],
    [
      "Niger",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [2.154, 11.94, 0.0], [2.177, 12.625, 0.0], [1.024, 12.852, 0.0], [0.993, 13.336, 0.0], [0.43, 13.989, 0.0], [0.296, 14.444, 0.0], [0.375, 14.929, 0.0], [1.016, 14.968, 0.0], [1.386, 15.324, 0.0], [2.75, 15.41, 0.0], [3.638, 15.568, 0.0], [3.723, 16.184, 0.0], [4.27, 16.852, 0.0], [4.267, 19.155, 0.0], [5.678, 19.601, 0.0], [8.573, 21.566, 0.0], [12.0, 23.472, 0.0], [13.581, 23.041, 0.0], [14.144, 22.491, 0.0], [14.851, 22.863, 0.0], [15.097, 21.309, 0.0], [15.471, 21.048, 0.0], [15.487, 20.73, 0.0], [15.903, 20.388, 0.0], [15.686, 19.957, 0.0], [15.3, 17.928, 0.0], [15.248, 16.627, 0.0], [13.972, 15.684, 0.0], [13.54, 14.367, 0.0], [13.957, 13.997, 0.0], [13.954, 13.353, 0.0], [14.596, 13.33, 0.0], [14.496, 12.859, 0.0], [14.214, 12.802, 0.0], [14.181, 12.484, 0.0], [13.995, 12.462, 0.0], [13.319, 13.556, 0.0], [13.084, 13.596, 0.0], [12.302, 13.037, 0.0], [11.528, 13.329, 0.0], [10.99, 13.387, 0.0], [10.701, 13.247, 0.0], [10.115, 13.277, 0.0], [9.525, 12.851, 0.0], [9.015, 12.827, 0.0], [7.805, 13.344, 0.0], [7.331, 13.098, 0.0], [6.82, 13.115, 0.0], [6.445, 13.493, 0.0], [5.443, 13.866, 0.0], [4.368, 13.747, 0.0], [4.108, 13.531, 0.0], [3.967, 12.956, 0.0], [3.681, 12.553, 0.0], [3.611, 11.66, 0.0], [2.849, 12.236, 0.0], [2.49, 12.233, 0.0], [2.154, 11.94, 0.0]
        ]]
      }
    },
    "NE",
    "NER"
    ],
    [
      "Nigeria",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [8.5, 4.772, 0.0], [7.462, 4.412, 0.0], [7.083, 4.465, 0.0], [6.698, 4.241, 0.0], [5.898, 4.262, 0.0], [5.363, 4.888, 0.0], [5.034, 5.612, 0.0], [4.326, 6.271, 0.0], [3.574, 6.258, 0.0], [2.692, 6.259, 0.0], [2.749, 7.871, 0.0], [2.724, 8.507, 0.0], [2.912, 9.138, 0.0], [3.22, 9.444, 0.0], [3.705, 10.063, 0.0], [3.6, 10.332, 0.0], [3.797, 10.735, 0.0], [3.572, 11.328, 0.0], [3.611, 11.66, 0.0], [3.681, 12.553, 0.0], [3.967, 12.956, 0.0], [4.108, 13.531, 0.0], [4.368, 13.747, 0.0], [5.443, 13.866, 0.0], [6.445, 13.493, 0.0], [6.82, 13.115, 0.0], [7.331, 13.098, 0.0], [7.805, 13.344, 0.0], [9.015, 12.827, 0.0], [9.525, 12.851, 0.0], [10.115, 13.277, 0.0], [10.701, 13.247, 0.0], [10.99, 13.387, 0.0], [11.528, 13.329, 0.0], [12.302, 13.037, 0.0], [13.084, 13.596, 0.0], [13.319, 13.556, 0.0], [13.995, 12.462, 0.0], [14.181, 12.484, 0.0], [14.577, 12.085, 0.0], [14.468, 11.905, 0.0], [14.415, 11.572, 0.0], [13.573, 10.799, 0.0], [13.309, 10.16, 0.0], [13.168, 9.641, 0.0], [12.955, 9.418, 0.0], [12.754, 8.718, 0.0], [12.219, 8.306, 0.0], [12.064, 7.8, 0.0], [11.839, 7.397, 0.0], [11.746, 6.981, 0.0], [11.059, 6.644, 0.0], [10.497, 7.055, 0.0], [10.118, 7.039, 0.0], [9.523, 6.453, 0.0], [9.233, 6.444, 0.0], [8.758, 5.48, 0.0], [8.5, 4.772, 0.0]
        ]]
      }
    },
    "NG",
    "NGA"
    ],
    [
      "Netherlands",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [6.074, 53.51, 0.0], [6.905, 53.482, 0.0], [7.092, 53.144, 0.0], [6.843, 52.228, 0.0], [6.589, 51.852, 0.0], [5.989, 51.852, 0.0], [6.157, 50.804, 0.0], [5.607, 51.037, 0.0], [4.974, 51.475, 0.0], [4.047, 51.267, 0.0], [3.315, 51.346, 0.0], [3.83, 51.621, 0.0], [4.706, 53.092, 0.0], [6.074, 53.51, 0.0]
        ]]
      }
    },
    "NL",
    "NLD"
    ],
    [
      "Sudan",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [33.963, 9.464, 0.0], [33.825, 9.484, 0.0], [33.842, 9.982, 0.0], [33.722, 10.325, 0.0], [33.207, 10.72, 0.0], [33.087, 11.441, 0.0], [33.207, 12.179, 0.0], [32.743, 12.248, 0.0], [32.675, 12.025, 0.0], [32.074, 11.973, 0.0], [32.314, 11.681, 0.0], [32.4, 11.081, 0.0], [31.851, 10.531, 0.0], [31.353, 9.81, 0.0], [30.838, 9.707, 0.0], [29.997, 10.291, 0.0], [29.619, 10.085, 0.0], [29.516, 9.793, 0.0], [29.001, 9.604, 0.0], [28.967, 9.398, 0.0], [27.971, 9.398, 0.0], [27.834, 9.604, 0.0], [27.113, 9.639, 0.0], [26.752, 9.467, 0.0], [26.477, 9.553, 0.0], [25.962, 10.136, 0.0], [25.791, 10.411, 0.0], [25.07, 10.274, 0.0], [24.795, 9.81, 0.0], [24.537, 8.918, 0.0], [24.194, 8.729, 0.0], [23.887, 8.62, 0.0], [23.806, 8.666, 0.0], [23.459, 8.954, 0.0], [23.395, 9.265, 0.0], [23.557, 9.681, 0.0], [23.554, 10.089, 0.0], [22.978, 10.714, 0.0], [22.864, 11.142, 0.0], [22.876, 11.385, 0.0], [22.509, 11.679, 0.0], [22.498, 12.26, 0.0], [22.288, 12.646, 0.0], [21.937, 12.588, 0.0], [22.038, 12.955, 0.0], [22.297, 13.372, 0.0], [22.183, 13.786, 0.0], [22.512, 14.093, 0.0], [22.304, 14.327, 0.0], [22.568, 14.944, 0.0], [23.025, 15.681, 0.0], [23.887, 15.611, 0.0], [23.838, 19.58, 0.0], [23.85, 20.0, 0.0], [25.0, 20.003, 0.0], [25.0, 22.0, 0.0], [29.02, 22.0, 0.0], [32.9, 22.0, 0.0], [36.866, 22.0, 0.0], [37.189, 21.019, 0.0], [36.969, 20.837, 0.0], [37.115, 19.808, 0.0], [37.482, 18.614, 0.0], [37.863, 18.368, 0.0], [38.41, 17.998, 0.0], [37.904, 17.428, 0.0], [37.167, 17.263, 0.0], [36.853, 16.957, 0.0], [36.754, 16.292, 0.0], [36.323, 14.822, 0.0], [36.43, 14.422, 0.0], [36.27, 13.563, 0.0], [35.864, 12.578, 0.0], [35.26, 12.083, 0.0], [34.832, 11.319, 0.0], [34.731, 10.91, 0.0], [34.257, 10.63, 0.0], [33.962, 9.584, 0.0], [33.963, 9.464, 0.0]
        ]]
      }
    },
    "SD",
    "SDN"
    ],
    [
      "S. Sudan",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [33.963, 9.464, 0.0], [33.975, 8.685, 0.0], [33.826, 8.379, 0.0], [33.295, 8.355, 0.0], [32.954, 7.785, 0.0], [33.568, 7.713, 0.0], [34.075, 7.226, 0.0], [34.25, 6.826, 0.0], [34.707, 6.594, 0.0], [35.298, 5.506, 0.0], [34.62, 4.847, 0.0], [34.005, 4.25, 0.0], [33.39, 3.79, 0.0], [32.686, 3.792, 0.0], [31.881, 3.558, 0.0], [31.246, 3.782, 0.0], [30.834, 3.509, 0.0], [29.953, 4.174, 0.0], [29.716, 4.601, 0.0], [29.159, 4.389, 0.0], [28.697, 4.455, 0.0], [28.429, 4.287, 0.0], [27.98, 4.408, 0.0], [27.374, 5.234, 0.0], [27.213, 5.551, 0.0], [26.466, 5.947, 0.0], [26.213, 6.547, 0.0], [25.797, 6.979, 0.0], [25.124, 7.5, 0.0], [25.115, 7.825, 0.0], [24.567, 8.229, 0.0], [23.887, 8.62, 0.0], [24.194, 8.729, 0.0], [24.537, 8.918, 0.0], [24.795, 9.81, 0.0], [25.07, 10.274, 0.0], [25.791, 10.411, 0.0], [25.962, 10.136, 0.0], [26.477, 9.553, 0.0], [26.752, 9.467, 0.0], [27.113, 9.639, 0.0], [27.834, 9.604, 0.0], [27.971, 9.398, 0.0], [28.967, 9.398, 0.0], [29.001, 9.604, 0.0], [29.516, 9.793, 0.0], [29.619, 10.085, 0.0], [29.997, 10.291, 0.0], [30.838, 9.707, 0.0], [31.353, 9.81, 0.0], [31.851, 10.531, 0.0], [32.4, 11.081, 0.0], [32.314, 11.681, 0.0], [32.074, 11.973, 0.0], [32.675, 12.025, 0.0], [32.743, 12.248, 0.0], [33.207, 12.179, 0.0], [33.087, 11.441, 0.0], [33.207, 10.72, 0.0], [33.722, 10.325, 0.0], [33.842, 9.982, 0.0], [33.825, 9.484, 0.0], [33.963, 9.464, 0.0]
        ]]
      }
    },
    "-99",
    "-99"
    ],
    [
      "Senegal",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-16.714, 13.595, 0.0], [-17.126, 14.374, 0.0], [-17.625, 14.73, 0.0], [-17.185, 14.919, 0.0], [-16.701, 15.622, 0.0], [-16.463, 16.135, 0.0], [-16.121, 16.456, 0.0], [-15.624, 16.369, 0.0], [-15.136, 16.587, 0.0], [-14.577, 16.598, 0.0], [-14.1, 16.304, 0.0], [-13.436, 16.039, 0.0], [-12.831, 15.304, 0.0], [-12.171, 14.617, 0.0], [-12.125, 13.995, 0.0], [-11.928, 13.422, 0.0], [-11.553, 13.141, 0.0], [-11.468, 12.755, 0.0], [-11.514, 12.443, 0.0], [-11.658, 12.387, 0.0], [-12.204, 12.466, 0.0], [-12.279, 12.354, 0.0], [-12.499, 12.332, 0.0], [-13.218, 12.576, 0.0], [-13.7, 12.586, 0.0], [-15.548, 12.628, 0.0], [-15.817, 12.516, 0.0], [-16.148, 12.548, 0.0], [-16.677, 12.385, 0.0], [-16.842, 13.151, 0.0], [-15.931, 13.13, 0.0], [-15.691, 13.27, 0.0], [-15.512, 13.279, 0.0], [-15.141, 13.51, 0.0], [-14.712, 13.298, 0.0], [-14.278, 13.281, 0.0], [-13.845, 13.505, 0.0], [-14.047, 13.794, 0.0], [-14.377, 13.626, 0.0], [-14.687, 13.63, 0.0], [-15.082, 13.876, 0.0], [-15.399, 13.86, 0.0], [-15.625, 13.624, 0.0], [-16.714, 13.595, 0.0]
        ]]
      }
    },
    "SN",
    "SEN"
    ],
    [
      "Sierra Leone",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-11.439, 6.786, 0.0], [-11.708, 6.86, 0.0], [-12.428, 7.263, 0.0], [-12.949, 7.799, 0.0], [-13.124, 8.164, 0.0], [-13.247, 8.903, 0.0], [-12.712, 9.343, 0.0], [-12.597, 9.62, 0.0], [-12.426, 9.836, 0.0], [-12.15, 9.859, 0.0], [-11.917, 10.047, 0.0], [-11.117, 10.046, 0.0], [-10.839, 9.688, 0.0], [-10.622, 9.268, 0.0], [-10.655, 8.977, 0.0], [-10.494, 8.716, 0.0], [-10.505, 8.349, 0.0], [-10.23, 8.406, 0.0], [-10.696, 7.939, 0.0], [-11.147, 7.397, 0.0], [-11.2, 7.106, 0.0], [-11.439, 6.786, 0.0]
        ]]
      }
    },
    "SL",
    "SLE"
    ],
    [
      "El Salvador",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-87.793, 13.384, 0.0], [-87.904, 13.149, 0.0], [-88.483, 13.164, 0.0], [-88.843, 13.26, 0.0], [-89.257, 13.459, 0.0], [-89.812, 13.521, 0.0], [-90.096, 13.735, 0.0], [-90.065, 13.882, 0.0], [-89.722, 14.134, 0.0], [-89.534, 14.245, 0.0], [-89.587, 14.363, 0.0], [-89.353, 14.424, 0.0], [-89.059, 14.34, 0.0], [-88.843, 14.141, 0.0], [-88.541, 13.98, 0.0], [-88.504, 13.845, 0.0], [-88.065, 13.965, 0.0], [-87.86, 13.893, 0.0], [-87.724, 13.785, 0.0], [-87.793, 13.384, 0.0]
        ]]
      }
    },
    "SV",
    "SLV"
    ],
    [
      "Chad",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [14.496, 12.859, 0.0], [14.596, 13.33, 0.0], [13.954, 13.353, 0.0], [13.957, 13.997, 0.0], [13.54, 14.367, 0.0], [13.972, 15.684, 0.0], [15.248, 16.627, 0.0], [15.3, 17.928, 0.0], [15.686, 19.957, 0.0], [15.903, 20.388, 0.0], [15.487, 20.73, 0.0], [15.471, 21.048, 0.0], [15.097, 21.309, 0.0], [14.851, 22.863, 0.0], [15.861, 23.41, 0.0], [19.849, 21.495, 0.0], [23.838, 19.58, 0.0], [23.887, 15.611, 0.0], [23.025, 15.681, 0.0], [22.568, 14.944, 0.0], [22.304, 14.327, 0.0], [22.512, 14.093, 0.0], [22.183, 13.786, 0.0], [22.297, 13.372, 0.0], [22.038, 12.955, 0.0], [21.937, 12.588, 0.0], [22.288, 12.646, 0.0], [22.498, 12.26, 0.0], [22.509, 11.679, 0.0], [22.876, 11.385, 0.0], [22.864, 11.142, 0.0], [22.231, 10.972, 0.0], [21.724, 10.567, 0.0], [21.001, 9.476, 0.0], [20.06, 9.013, 0.0], [19.094, 9.075, 0.0], [18.812, 8.983, 0.0], [18.911, 8.631, 0.0], [18.39, 8.281, 0.0], [17.965, 7.891, 0.0], [16.706, 7.508, 0.0], [16.456, 7.735, 0.0], [16.291, 7.754, 0.0], [16.106, 7.497, 0.0], [15.279, 7.422, 0.0], [15.436, 7.693, 0.0], [15.121, 8.382, 0.0], [14.98, 8.796, 0.0], [14.544, 8.966, 0.0], [13.954, 9.549, 0.0], [14.171, 10.021, 0.0], [14.627, 9.921, 0.0], [14.909, 9.992, 0.0], [15.468, 9.982, 0.0], [14.924, 10.891, 0.0], [14.96, 11.556, 0.0], [14.893, 12.219, 0.0], [14.496, 12.859, 0.0]
        ]]
      }
    },
    "TD",
    "TCD"
    ],
    [
      "Tajikistan",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [71.014, 40.244, 0.0], [70.648, 39.936, 0.0], [69.56, 40.103, 0.0], [69.465, 39.527, 0.0], [70.549, 39.604, 0.0], [71.785, 39.279, 0.0], [73.675, 39.431, 0.0], [73.929, 38.506, 0.0], [74.258, 38.607, 0.0], [74.865, 38.379, 0.0], [74.83, 37.99, 0.0], [74.98, 37.42, 0.0], [73.949, 37.422, 0.0], [73.26, 37.495, 0.0], [72.637, 37.048, 0.0], [72.193, 36.948, 0.0], [71.845, 36.738, 0.0], [71.449, 37.066, 0.0], [71.542, 37.906, 0.0], [71.239, 37.953, 0.0], [71.348, 38.259, 0.0], [70.807, 38.486, 0.0], [70.376, 38.138, 0.0], [70.271, 37.735, 0.0], [70.117, 37.588, 0.0], [69.519, 37.609, 0.0], [69.196, 37.151, 0.0], [68.859, 37.344, 0.0], [68.136, 37.023, 0.0], [67.83, 37.145, 0.0], [68.392, 38.157, 0.0], [68.176, 38.902, 0.0], [67.442, 39.14, 0.0], [67.701, 39.58, 0.0], [68.536, 39.533, 0.0], [69.012, 40.086, 0.0], [69.329, 40.728, 0.0], [70.667, 40.96, 0.0], [70.458, 40.496, 0.0], [70.601, 40.219, 0.0], [71.014, 40.244, 0.0]
        ]]
      }
    },
    "TJ",
    "TJK"
    ],
    [
      "Uganda",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [31.866, -1.027, 0.0], [30.77, -1.015, 0.0], [30.419, -1.135, 0.0], [29.822, -1.443, 0.0], [29.579, -1.341, 0.0], [29.588, -0.587, 0.0], [29.82, -0.205, 0.0], [29.876, 0.597, 0.0], [30.086, 1.062, 0.0], [30.469, 1.584, 0.0], [30.853, 1.849, 0.0], [31.174, 2.204, 0.0], [30.773, 2.34, 0.0], [30.834, 3.509, 0.0], [31.246, 3.782, 0.0], [31.881, 3.558, 0.0], [32.686, 3.792, 0.0], [33.39, 3.79, 0.0], [34.005, 4.25, 0.0], [34.479, 3.556, 0.0], [34.596, 3.054, 0.0], [35.036, 1.906, 0.0], [34.672, 1.177, 0.0], [34.18, 0.515, 0.0], [33.894, 0.11, 0.0], [33.904, -0.95, 0.0], [31.866, -1.027, 0.0]
        ]]
      }
    },
    "UG",
    "UGA"
    ],
    [
      "Ukraine",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [31.786, 52.102, 0.0], [32.159, 52.061, 0.0], [32.412, 52.289, 0.0], [32.716, 52.238, 0.0], [33.753, 52.335, 0.0], [34.392, 51.769, 0.0], [34.142, 51.566, 0.0], [34.225, 51.256, 0.0], [35.022, 51.208, 0.0], [35.378, 50.774, 0.0], [35.356, 50.577, 0.0], [36.626, 50.226, 0.0], [37.393, 50.384, 0.0], [38.011, 49.916, 0.0], [38.595, 49.926, 0.0], [40.069, 49.601, 0.0], [40.081, 49.307, 0.0], [39.675, 48.784, 0.0], [39.896, 48.232, 0.0], [39.738, 47.899, 0.0], [38.771, 47.826, 0.0], [38.255, 47.546, 0.0], [38.224, 47.102, 0.0], [37.425, 47.022, 0.0], [36.76, 46.699, 0.0], [35.824, 46.646, 0.0], [34.962, 46.273, 0.0], [35.021, 45.651, 0.0], [35.51, 45.41, 0.0], [36.53, 45.47, 0.0], [36.335, 45.113, 0.0], [35.24, 44.94, 0.0], [33.883, 44.361, 0.0], [33.326, 44.565, 0.0], [33.547, 45.035, 0.0], [32.454, 45.327, 0.0], [32.631, 45.519, 0.0], [33.588, 45.852, 0.0], [33.299, 46.081, 0.0], [31.744, 46.333, 0.0], [31.675, 46.706, 0.0], [30.749, 46.583, 0.0], [30.378, 46.032, 0.0], [29.603, 45.293, 0.0], [29.15, 45.465, 0.0], [28.68, 45.304, 0.0], [28.234, 45.488, 0.0], [28.485, 45.597, 0.0], [28.66, 45.94, 0.0], [28.934, 46.259, 0.0], [28.863, 46.438, 0.0], [29.072, 46.518, 0.0], [29.171, 46.379, 0.0], [29.76, 46.35, 0.0], [30.025, 46.424, 0.0], [29.838, 46.525, 0.0], [29.909, 46.674, 0.0], [29.56, 46.929, 0.0], [29.415, 47.347, 0.0], [29.051, 47.51, 0.0], [29.123, 47.849, 0.0], [28.671, 48.118, 0.0], [28.26, 48.156, 0.0], [27.523, 48.467, 0.0], [26.858, 48.368, 0.0], [26.619, 48.221, 0.0], [26.197, 48.221, 0.0], [25.946, 47.987, 0.0], [25.208, 47.891, 0.0], [24.866, 47.738, 0.0], [24.402, 47.982, 0.0], [23.761, 47.986, 0.0], [23.142, 48.096, 0.0], [22.711, 47.882, 0.0], [22.641, 48.15, 0.0], [22.086, 48.422, 0.0], [22.281, 48.825, 0.0], [22.558, 49.086, 0.0], [22.776, 49.027, 0.0], [22.518, 49.477, 0.0], [23.427, 50.309, 0.0], [23.923, 50.425, 0.0], [24.03, 50.705, 0.0], [23.527, 51.578, 0.0], [24.005, 51.617, 0.0], [24.553, 51.888, 0.0], [25.328, 51.911, 0.0], [26.338, 51.832, 0.0], [27.454, 51.592, 0.0], [28.242, 51.572, 0.0], [28.618, 51.428, 0.0], [28.993, 51.602, 0.0], [29.255, 51.368, 0.0], [30.157, 51.416, 0.0], [30.555, 51.32, 0.0], [30.619, 51.823, 0.0], [30.928, 52.042, 0.0], [31.786, 52.102, 0.0]
        ]]
      }
    },
    "UA",
    "UKR"
    ],
    [
      "Uruguay",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-57.625, -30.216, 0.0], [-56.976, -30.11, 0.0], [-55.973, -30.883, 0.0], [-55.602, -30.854, 0.0], [-54.572, -31.495, 0.0], [-53.788, -32.047, 0.0], [-53.21, -32.728, 0.0], [-53.651, -33.202, 0.0], [-53.374, -33.768, 0.0], [-53.806, -34.397, 0.0], [-54.936, -34.953, 0.0], [-55.674, -34.753, 0.0], [-56.215, -34.86, 0.0], [-57.14, -34.43, 0.0], [-57.818, -34.463, 0.0], [-58.427, -33.909, 0.0], [-58.35, -33.263, 0.0], [-58.133, -33.041, 0.0], [-58.142, -32.045, 0.0], [-57.875, -31.017, 0.0], [-57.625, -30.216, 0.0]
        ]]
      }
    },
    "UY",
    "URY"
    ],
    [
      "Zambia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [32.759, -9.231, 0.0], [33.231, -9.677, 0.0], [33.486, -10.526, 0.0], [33.315, -10.797, 0.0], [33.114, -11.607, 0.0], [33.306, -12.436, 0.0], [32.992, -12.784, 0.0], [32.688, -13.713, 0.0], [33.214, -13.972, 0.0], [30.179, -14.796, 0.0], [30.274, -15.508, 0.0], [29.517, -15.645, 0.0], [28.947, -16.043, 0.0], [28.826, -16.39, 0.0], [28.468, -16.468, 0.0], [27.598, -17.291, 0.0], [27.044, -17.938, 0.0], [26.707, -17.961, 0.0], [26.382, -17.846, 0.0], [25.264, -17.737, 0.0], [25.084, -17.662, 0.0], [25.077, -17.579, 0.0], [24.682, -17.353, 0.0], [24.034, -17.296, 0.0], [23.215, -17.523, 0.0], [22.562, -16.898, 0.0], [21.888, -16.08, 0.0], [21.934, -12.898, 0.0], [24.016, -12.911, 0.0], [23.931, -12.566, 0.0], [24.08, -12.191, 0.0], [23.904, -11.722, 0.0], [24.018, -11.237, 0.0], [23.912, -10.927, 0.0], [24.257, -10.952, 0.0], [24.315, -11.263, 0.0], [24.783, -11.239, 0.0], [25.418, -11.331, 0.0], [25.752, -11.785, 0.0], [26.553, -11.924, 0.0], [27.164, -11.609, 0.0], [27.389, -12.133, 0.0], [28.155, -12.272, 0.0], [28.524, -12.699, 0.0], [28.934, -13.249, 0.0], [29.7, -13.257, 0.0], [29.616, -12.179, 0.0], [29.342, -12.361, 0.0], [28.642, -11.972, 0.0], [28.372, -11.794, 0.0], [28.496, -10.79, 0.0], [28.674, -9.606, 0.0], [28.45, -9.165, 0.0], [28.735, -8.527, 0.0], [29.003, -8.407, 0.0], [30.346, -8.238, 0.0], [30.74, -8.34, 0.0], [31.158, -8.595, 0.0], [31.556, -8.762, 0.0], [32.192, -8.93, 0.0], [32.759, -9.231, 0.0]
        ]]
      }
    },
    "ZM",
    "ZMB"
    ],
    [
      "Bulgaria",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [22.657, 44.235, 0.0], [22.945, 43.824, 0.0], [23.332, 43.897, 0.0], [24.101, 43.741, 0.0], [25.569, 43.688, 0.0], [26.065, 43.943, 0.0], [27.242, 44.176, 0.0], [27.97, 43.812, 0.0], [28.558, 43.707, 0.0], [28.039, 43.293, 0.0], [27.674, 42.578, 0.0], [27.997, 42.007, 0.0], [27.136, 42.141, 0.0], [26.117, 41.827, 0.0], [26.106, 41.329, 0.0], [25.197, 41.234, 0.0], [24.493, 41.584, 0.0], [23.692, 41.309, 0.0], [22.952, 41.338, 0.0], [22.881, 41.999, 0.0], [22.381, 42.32, 0.0], [22.545, 42.461, 0.0], [22.437, 42.58, 0.0], [22.605, 42.899, 0.0], [22.986, 43.211, 0.0], [22.5, 43.643, 0.0], [22.41, 44.008, 0.0], [22.657, 44.235, 0.0]
        ]]
      }
    },
    "BG",
    "BGR"
    ],
    [
      "Algeria",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [12.0, 23.472, 0.0], [8.573, 21.566, 0.0], [5.678, 19.601, 0.0], [4.267, 19.155, 0.0], [3.158, 19.057, 0.0], [3.147, 19.694, 0.0], [2.684, 19.856, 0.0], [2.061, 20.142, 0.0], [1.823, 20.611, 0.0], [-1.55, 22.793, 0.0], [-4.923, 24.975, 0.0], [-8.684, 27.396, 0.0], [-8.665, 27.589, 0.0], [-8.666, 27.656, 0.0], [-8.674, 28.841, 0.0], [-7.059, 29.579, 0.0], [-6.061, 29.732, 0.0], [-5.242, 30.0, 0.0], [-4.86, 30.501, 0.0], [-3.69, 30.897, 0.0], [-3.647, 31.637, 0.0], [-3.069, 31.724, 0.0], [-2.617, 32.094, 0.0], [-1.308, 32.263, 0.0], [-1.125, 32.652, 0.0], [-1.388, 32.864, 0.0], [-1.733, 33.92, 0.0], [-1.793, 34.528, 0.0], [-2.17, 35.168, 0.0], [-1.209, 35.715, 0.0], [-0.127, 35.889, 0.0], [0.504, 36.301, 0.0], [1.467, 36.606, 0.0], [3.162, 36.784, 0.0], [4.816, 36.865, 0.0], [5.32, 36.717, 0.0], [6.262, 37.111, 0.0], [7.33, 37.118, 0.0], [7.737, 36.886, 0.0], [8.421, 36.946, 0.0], [8.218, 36.433, 0.0], [8.376, 35.48, 0.0], [8.141, 34.655, 0.0], [7.524, 34.097, 0.0], [7.613, 33.344, 0.0], [8.43, 32.748, 0.0], [8.439, 32.506, 0.0], [9.056, 32.103, 0.0], [9.482, 30.308, 0.0], [9.806, 29.425, 0.0], [9.86, 28.96, 0.0], [9.684, 28.144, 0.0], [9.756, 27.688, 0.0], [9.629, 27.141, 0.0], [9.716, 26.512, 0.0], [9.319, 26.094, 0.0], [9.911, 25.365, 0.0], [9.948, 24.937, 0.0], [10.304, 24.379, 0.0], [10.771, 24.563, 0.0], [11.561, 24.098, 0.0], [12.0, 23.472, 0.0]
        ]]
      }
    },
    "DZ",
    "DZA"
    ],
    [
      "Estonia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [24.313, 57.793, 0.0], [24.429, 58.383, 0.0], [24.061, 58.257, 0.0], [23.427, 58.613, 0.0], [23.34, 59.187, 0.0], [24.604, 59.466, 0.0], [25.864, 59.611, 0.0], [26.949, 59.446, 0.0], [27.981, 59.475, 0.0], [28.132, 59.301, 0.0], [27.42, 58.725, 0.0], [27.717, 57.792, 0.0], [27.288, 57.475, 0.0], [26.464, 57.476, 0.0], [25.603, 57.848, 0.0], [25.165, 57.97, 0.0], [24.313, 57.793, 0.0]
        ]]
      }
    },
    "EE",
    "EST"
    ],
    [
      "Haiti",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-73.19, 19.916, 0.0], [-72.58, 19.872, 0.0], [-71.712, 19.714, 0.0], [-71.625, 19.17, 0.0], [-71.701, 18.785, 0.0], [-71.945, 18.617, 0.0], [-71.688, 18.317, 0.0], [-71.708, 18.045, 0.0], [-72.372, 18.215, 0.0], [-72.844, 18.146, 0.0], [-73.455, 18.218, 0.0], [-73.922, 18.031, 0.0], [-74.458, 18.343, 0.0], [-74.37, 18.665, 0.0], [-73.45, 18.526, 0.0], [-72.695, 18.446, 0.0], [-72.335, 18.668, 0.0], [-72.792, 19.102, 0.0], [-72.784, 19.484, 0.0], [-73.415, 19.64, 0.0], [-73.19, 19.916, 0.0]
        ]]
      }
    },
    "HT",
    "HTI"
    ],
    [
      "India",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [77.837, 35.494, 0.0], [78.912, 34.322, 0.0], [78.811, 33.506, 0.0], [79.209, 32.994, 0.0], [79.176, 32.484, 0.0], [78.458, 32.618, 0.0], [78.739, 31.516, 0.0], [79.721, 30.883, 0.0], [81.111, 30.183, 0.0], [80.477, 29.73, 0.0], [80.088, 28.794, 0.0], [81.057, 28.416, 0.0], [82.0, 27.925, 0.0], [83.304, 27.365, 0.0], [84.675, 27.235, 0.0], [85.252, 26.726, 0.0], [86.024, 26.631, 0.0], [87.227, 26.398, 0.0], [88.06, 26.415, 0.0], [88.175, 26.81, 0.0], [88.043, 27.446, 0.0], [88.12, 27.877, 0.0], [88.73, 28.087, 0.0], [88.814, 27.299, 0.0], [88.836, 27.099, 0.0], [89.745, 26.719, 0.0], [90.373, 26.876, 0.0], [91.218, 26.809, 0.0], [92.033, 26.838, 0.0], [92.104, 27.453, 0.0], [91.697, 27.772, 0.0], [92.503, 27.897, 0.0], [93.413, 28.641, 0.0], [94.566, 29.277, 0.0], [95.405, 29.032, 0.0], [96.118, 29.453, 0.0], [96.587, 28.831, 0.0], [96.249, 28.411, 0.0], [97.327, 28.262, 0.0], [97.403, 27.883, 0.0], [97.052, 27.699, 0.0], [97.134, 27.084, 0.0], [96.419, 27.265, 0.0], [95.125, 26.574, 0.0], [95.155, 26.001, 0.0], [94.603, 25.162, 0.0], [94.553, 24.675, 0.0], [94.107, 23.851, 0.0], [93.325, 24.079, 0.0], [93.286, 23.044, 0.0], [93.06, 22.703, 0.0], [93.166, 22.278, 0.0], [92.673, 22.041, 0.0], [92.146, 23.627, 0.0], [91.87, 23.624, 0.0], [91.706, 22.985, 0.0], [91.159, 23.504, 0.0], [91.468, 24.073, 0.0], [91.915, 24.13, 0.0], [92.376, 24.977, 0.0], [91.8, 25.147, 0.0], [90.872, 25.133, 0.0], [89.921, 25.27, 0.0], [89.832, 25.965, 0.0], [89.355, 26.014, 0.0], [88.563, 26.447, 0.0], [88.21, 25.768, 0.0], [88.932, 25.239, 0.0], [88.306, 24.866, 0.0], [88.084, 24.502, 0.0], [88.7, 24.234, 0.0], [88.53, 23.631, 0.0], [88.876, 22.879, 0.0], [89.032, 22.056, 0.0], [88.889, 21.691, 0.0], [88.208, 21.703, 0.0], [86.976, 21.496, 0.0], [87.033, 20.743, 0.0], [86.499, 20.152, 0.0], [85.06, 19.479, 0.0], [83.941, 18.302, 0.0], [83.189, 17.671, 0.0], [82.193, 17.017, 0.0], [82.191, 16.557, 0.0], [81.693, 16.31, 0.0], [80.792, 15.952, 0.0], [80.325, 15.899, 0.0], [80.025, 15.136, 0.0], [80.233, 13.836, 0.0], [80.286, 13.006, 0.0], [79.863, 12.056, 0.0], [79.858, 10.357, 0.0], [79.341, 10.309, 0.0], [78.885, 9.546, 0.0], [79.19, 9.217, 0.0], [78.278, 8.933, 0.0], [77.941, 8.253, 0.0], [77.54, 7.966, 0.0], [76.593, 8.899, 0.0], [76.13, 10.3, 0.0], [75.746, 11.308, 0.0], [75.396, 11.781, 0.0], [74.865, 12.742, 0.0], [74.617, 13.993, 0.0], [74.444, 14.617, 0.0], [73.534, 15.991, 0.0], [73.12, 17.929, 0.0], [72.821, 19.208, 0.0], [72.824, 20.42, 0.0], [72.631, 21.356, 0.0], [71.175, 20.757, 0.0], [70.47, 20.877, 0.0], [69.164, 22.089, 0.0], [69.645, 22.451, 0.0], [69.35, 22.843, 0.0], [68.177, 23.692, 0.0], [68.843, 24.359, 0.0], [71.043, 24.357, 0.0], [70.845, 25.215, 0.0], [70.283, 25.722, 0.0], [70.169, 26.492, 0.0], [69.514, 26.941, 0.0], [70.616, 27.989, 0.0], [71.778, 27.913, 0.0], [72.824, 28.962, 0.0], [73.451, 29.976, 0.0], [74.421, 30.98, 0.0], [74.406, 31.693, 0.0], [75.259, 32.271, 0.0], [74.452, 32.765, 0.0], [74.104, 33.441, 0.0], [73.75, 34.318, 0.0], [74.24, 34.749, 0.0], [75.757, 34.505, 0.0], [76.872, 34.654, 0.0], [77.837, 35.494, 0.0]
        ]]
      }
    },
    "IN",
    "IND"
    ],
    [
      "Kenya",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [40.993, -0.858, 0.0], [41.585, -1.683, 0.0], [40.885, -2.083, 0.0], [40.638, -2.5, 0.0], [40.263, -2.573, 0.0], [40.121, -3.278, 0.0], [39.8, -3.681, 0.0], [39.605, -4.347, 0.0], [39.202, -4.677, 0.0], [37.767, -3.677, 0.0], [37.699, -3.097, 0.0], [34.073, -1.06, 0.0], [33.904, -0.95, 0.0], [33.894, 0.11, 0.0], [34.18, 0.515, 0.0], [34.672, 1.177, 0.0], [35.036, 1.906, 0.0], [34.596, 3.054, 0.0], [34.479, 3.556, 0.0], [34.005, 4.25, 0.0], [34.62, 4.847, 0.0], [35.298, 5.506, 0.0], [35.817, 5.338, 0.0], [35.817, 4.777, 0.0], [36.159, 4.448, 0.0], [36.855, 4.448, 0.0], [38.121, 3.599, 0.0], [38.437, 3.589, 0.0], [38.671, 3.616, 0.0], [38.893, 3.501, 0.0], [39.559, 3.422, 0.0], [39.855, 3.839, 0.0], [40.768, 4.257, 0.0], [41.172, 3.919, 0.0], [41.855, 3.919, 0.0], [40.981, 2.785, 0.0], [40.993, -0.858, 0.0]
        ]]
      }
    },
    "KE",
    "KEN"
    ],
    [
      "Liberia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-7.712, 4.365, 0.0], [-7.974, 4.356, 0.0], [-9.005, 4.832, 0.0], [-9.913, 5.594, 0.0], [-10.765, 6.141, 0.0], [-11.439, 6.786, 0.0], [-11.2, 7.106, 0.0], [-11.147, 7.397, 0.0], [-10.696, 7.939, 0.0], [-10.23, 8.406, 0.0], [-10.017, 8.429, 0.0], [-9.755, 8.541, 0.0], [-9.337, 7.929, 0.0], [-9.403, 7.527, 0.0], [-9.209, 7.314, 0.0], [-8.926, 7.309, 0.0], [-8.722, 7.712, 0.0], [-8.439, 7.686, 0.0], [-8.485, 7.395, 0.0], [-8.385, 6.912, 0.0], [-8.603, 6.468, 0.0], [-8.311, 6.193, 0.0], [-7.994, 6.126, 0.0], [-7.57, 5.707, 0.0], [-7.54, 5.313, 0.0], [-7.635, 5.188, 0.0], [-7.712, 4.365, 0.0]
        ]]
      }
    },
    "LR",
    "LBR"
    ],
    [
      "Mauritania",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-12.171, 14.617, 0.0], [-12.831, 15.304, 0.0], [-13.436, 16.039, 0.0], [-14.1, 16.304, 0.0], [-14.577, 16.598, 0.0], [-15.136, 16.587, 0.0], [-15.624, 16.369, 0.0], [-16.121, 16.456, 0.0], [-16.463, 16.135, 0.0], [-16.55, 16.674, 0.0], [-16.271, 17.167, 0.0], [-16.146, 18.108, 0.0], [-16.257, 19.097, 0.0], [-16.378, 19.594, 0.0], [-16.278, 20.093, 0.0], [-16.536, 20.568, 0.0], [-17.063, 21.0, 0.0], [-16.845, 21.333, 0.0], [-12.929, 21.327, 0.0], [-13.119, 22.771, 0.0], [-12.874, 23.285, 0.0], [-11.937, 23.375, 0.0], [-11.969, 25.933, 0.0], [-8.687, 25.881, 0.0], [-8.684, 27.396, 0.0], [-4.923, 24.975, 0.0], [-6.454, 24.957, 0.0], [-5.971, 20.641, 0.0], [-5.489, 16.325, 0.0], [-5.315, 16.202, 0.0], [-5.538, 15.502, 0.0], [-9.55, 15.486, 0.0], [-9.7, 15.264, 0.0], [-10.087, 15.33, 0.0], [-10.651, 15.133, 0.0], [-11.349, 15.411, 0.0], [-11.666, 15.388, 0.0], [-11.834, 14.799, 0.0], [-12.171, 14.617, 0.0]
        ]]
      }
    },
    "MR",
    "MRT"
    ],
    [
      "New Caledonia",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [165.78, -21.08, 0.0], [166.6, -21.7, 0.0], [167.12, -22.16, 0.0], [166.74, -22.4, 0.0], [166.19, -22.13, 0.0], [165.474, -21.68, 0.0], [164.83, -21.15, 0.0], [164.168, -20.445, 0.0], [164.03, -20.106, 0.0], [164.46, -20.12, 0.0], [165.02, -20.46, 0.0], [165.46, -20.8, 0.0], [165.78, -21.08, 0.0]
        ]]
      }
    },
    "NC",
    "NCL"
    ],
    [
      "Pakistan",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [75.158, 37.133, 0.0], [75.897, 36.667, 0.0], [76.193, 35.898, 0.0], [77.837, 35.494, 0.0], [76.872, 34.654, 0.0], [75.757, 34.505, 0.0], [74.24, 34.749, 0.0], [73.75, 34.318, 0.0], [74.104, 33.441, 0.0], [74.452, 32.765, 0.0], [75.259, 32.271, 0.0], [74.406, 31.693, 0.0], [74.421, 30.98, 0.0], [73.451, 29.976, 0.0], [72.824, 28.962, 0.0], [71.778, 27.913, 0.0], [70.616, 27.989, 0.0], [69.514, 26.941, 0.0], [70.169, 26.492, 0.0], [70.283, 25.722, 0.0], [70.845, 25.215, 0.0], [71.043, 24.357, 0.0], [68.843, 24.359, 0.0], [68.177, 23.692, 0.0], [67.444, 23.945, 0.0], [67.145, 24.664, 0.0], [66.373, 25.425, 0.0], [64.53, 25.237, 0.0], [62.906, 25.218, 0.0], [61.497, 25.078, 0.0], [61.874, 26.24, 0.0], [63.317, 26.757, 0.0], [63.234, 27.217, 0.0], [62.755, 27.379, 0.0], [62.728, 28.26, 0.0], [61.772, 28.699, 0.0], [61.369, 29.303, 0.0], [60.874, 29.829, 0.0], [62.55, 29.319, 0.0], [63.55, 29.468, 0.0], [64.148, 29.341, 0.0], [64.35, 29.56, 0.0], [65.047, 29.472, 0.0], [66.346, 29.888, 0.0], [66.381, 30.739, 0.0], [66.939, 31.305, 0.0], [67.683, 31.303, 0.0], [67.793, 31.583, 0.0], [68.557, 31.713, 0.0], [68.927, 31.62, 0.0], [69.318, 31.901, 0.0], [69.263, 32.502, 0.0], [69.687, 33.105, 0.0], [70.324, 33.359, 0.0], [69.931, 34.02, 0.0], [70.882, 33.989, 0.0], [71.157, 34.349, 0.0], [71.115, 34.733, 0.0], [71.613, 35.153, 0.0], [71.499, 35.651, 0.0], [71.262, 36.074, 0.0], [71.846, 36.51, 0.0], [72.92, 36.72, 0.0], [74.068, 36.836, 0.0], [74.576, 37.021, 0.0], [75.158, 37.133, 0.0]
        ]]
      }
    },
    "PK",
    "PAK"
    ],
    [
      "Peru",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-69.59, -17.58, 0.0], [-69.858, -18.093, 0.0], [-70.373, -18.348, 0.0], [-71.375, -17.774, 0.0], [-71.462, -17.363, 0.0], [-73.445, -16.359, 0.0], [-75.238, -15.266, 0.0], [-76.009, -14.649, 0.0], [-76.423, -13.823, 0.0], [-76.259, -13.535, 0.0], [-77.106, -12.223, 0.0], [-78.092, -10.378, 0.0], [-79.037, -8.387, 0.0], [-79.446, -7.931, 0.0], [-79.761, -7.194, 0.0], [-80.537, -6.542, 0.0], [-81.25, -6.137, 0.0], [-80.926, -5.691, 0.0], [-81.411, -4.737, 0.0], [-81.1, -4.036, 0.0], [-80.303, -3.405, 0.0], [-80.184, -3.821, 0.0], [-80.469, -4.059, 0.0], [-80.442, -4.426, 0.0], [-80.029, -4.346, 0.0], [-79.625, -4.454, 0.0], [-79.205, -4.959, 0.0], [-78.64, -4.548, 0.0], [-78.451, -3.873, 0.0], [-77.838, -3.003, 0.0], [-76.635, -2.609, 0.0], [-75.545, -1.562, 0.0], [-75.234, -0.911, 0.0], [-75.373, -0.152, 0.0], [-75.107, -0.057, 0.0], [-74.442, -0.531, 0.0], [-74.122, -1.003, 0.0], [-73.66, -1.26, 0.0], [-73.07, -2.309, 0.0], [-72.326, -2.434, 0.0], [-71.775, -2.17, 0.0], [-71.414, -2.343, 0.0], [-70.813, -2.257, 0.0], [-70.048, -2.725, 0.0], [-70.693, -3.743, 0.0], [-70.394, -3.767, 0.0], [-69.894, -4.298, 0.0], [-70.795, -4.251, 0.0], [-70.929, -4.402, 0.0], [-71.748, -4.594, 0.0], [-72.892, -5.275, 0.0], [-72.965, -5.741, 0.0], [-73.22, -6.089, 0.0], [-73.12, -6.63, 0.0], [-73.724, -6.919, 0.0], [-73.723, -7.341, 0.0], [-73.987, -7.524, 0.0], [-73.571, -8.424, 0.0], [-73.015, -9.033, 0.0], [-73.227, -9.462, 0.0], [-72.563, -9.52, 0.0], [-72.185, -10.054, 0.0], [-71.302, -10.079, 0.0], [-70.482, -9.49, 0.0], [-70.549, -11.009, 0.0], [-70.094, -11.124, 0.0], [-69.53, -10.952, 0.0], [-68.665, -12.561, 0.0], [-68.88, -12.9, 0.0], [-68.929, -13.603, 0.0], [-68.949, -14.454, 0.0], [-69.34, -14.953, 0.0], [-69.16, -15.324, 0.0], [-69.39, -15.66, 0.0], [-68.96, -16.501, 0.0], [-69.59, -17.58, 0.0]
        ]]
      }
    },
    "PE",
    "PER"
    ],
    [
      "Philippines",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [126.377, 8.415, 0.0], [126.479, 7.75, 0.0], [126.537, 7.189, 0.0], [126.197, 6.274, 0.0], [125.831, 7.294, 0.0], [125.364, 6.786, 0.0], [125.683, 6.05, 0.0], [125.397, 5.581, 0.0], [124.22, 6.161, 0.0], [123.939, 6.885, 0.0], [124.244, 7.361, 0.0], [123.61, 7.834, 0.0], [123.296, 7.419, 0.0], [122.826, 7.457, 0.0], [122.085, 6.899, 0.0], [121.92, 7.192, 0.0], [122.312, 8.035, 0.0], [122.942, 8.316, 0.0], [123.488, 8.693, 0.0], [123.841, 8.24, 0.0], [124.601, 8.514, 0.0], [124.765, 8.96, 0.0], [125.471, 8.987, 0.0], [125.412, 9.76, 0.0], [126.223, 9.286, 0.0], [126.307, 8.782, 0.0], [126.377, 8.415, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [123.982, 10.279, 0.0], [123.623, 9.95, 0.0], [123.31, 9.318, 0.0], [122.996, 9.022, 0.0], [122.38, 9.713, 0.0], [122.586, 9.981, 0.0], [122.837, 10.261, 0.0], [122.947, 10.882, 0.0], [123.499, 10.941, 0.0], [123.338, 10.267, 0.0], [124.078, 11.233, 0.0], [123.982, 10.279, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [118.505, 9.316, 0.0], [117.174, 8.367, 0.0], [117.664, 9.067, 0.0], [118.387, 9.684, 0.0], [118.987, 10.376, 0.0], [119.511, 11.37, 0.0], [119.69, 10.554, 0.0], [119.029, 10.004, 0.0], [118.505, 9.316, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [121.884, 11.892, 0.0], [122.484, 11.582, 0.0], [123.12, 11.584, 0.0], [123.101, 11.166, 0.0], [122.638, 10.741, 0.0], [122.003, 10.441, 0.0], [121.967, 10.906, 0.0], [122.038, 11.416, 0.0], [121.884, 11.892, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [125.503, 12.163, 0.0], [125.783, 11.046, 0.0], [125.012, 11.311, 0.0], [125.033, 10.976, 0.0], [125.277, 10.359, 0.0], [124.802, 10.135, 0.0], [124.76, 10.838, 0.0], [124.459, 10.89, 0.0], [124.303, 11.495, 0.0], [124.891, 11.416, 0.0], [124.878, 11.794, 0.0], [124.267, 12.558, 0.0], [125.227, 12.536, 0.0], [125.503, 12.163, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [121.527, 13.07, 0.0], [121.262, 12.206, 0.0], [120.834, 12.704, 0.0], [120.323, 13.466, 0.0], [121.18, 13.43, 0.0], [121.527, 13.07, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [121.321, 18.504, 0.0], [121.938, 18.219, 0.0], [122.246, 18.479, 0.0], [122.337, 18.225, 0.0], [122.174, 17.81, 0.0], [122.516, 17.094, 0.0], [122.252, 16.262, 0.0], [121.663, 15.931, 0.0], [121.505, 15.125, 0.0], [121.729, 14.328, 0.0], [122.259, 14.218, 0.0], [122.701, 14.337, 0.0], [123.95, 13.782, 0.0], [123.855, 13.238, 0.0], [124.181, 12.998, 0.0], [124.077, 12.537, 0.0], [123.298, 13.028, 0.0], [122.929, 13.553, 0.0], [122.671, 13.186, 0.0], [122.035, 13.784, 0.0], [121.126, 13.637, 0.0], [120.629, 13.858, 0.0], [120.679, 14.271, 0.0], [120.992, 14.525, 0.0], [120.693, 14.757, 0.0], [120.564, 14.396, 0.0], [120.07, 14.971, 0.0], [119.921, 15.406, 0.0], [119.884, 16.364, 0.0], [120.286, 16.035, 0.0], [120.39, 17.599, 0.0], [120.716, 18.505, 0.0], [121.321, 18.504, 0.0]
       ]
      ]
     }
    ]
    },
    "PH",
    "PHL"
    ],
    [
      "Paraguay",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-62.685, -22.249, 0.0], [-62.291, -21.052, 0.0], [-62.266, -20.514, 0.0], [-61.786, -19.634, 0.0], [-60.044, -19.343, 0.0], [-59.115, -19.357, 0.0], [-58.183, -19.868, 0.0], [-58.166, -20.177, 0.0], [-57.871, -20.733, 0.0], [-57.937, -22.09, 0.0], [-56.882, -22.282, 0.0], [-56.473, -22.086, 0.0], [-55.798, -22.357, 0.0], [-55.611, -22.656, 0.0], [-55.518, -23.572, 0.0], [-55.401, -23.957, 0.0], [-55.028, -24.001, 0.0], [-54.653, -23.84, 0.0], [-54.293, -24.021, 0.0], [-54.293, -24.571, 0.0], [-54.429, -25.162, 0.0], [-54.625, -25.739, 0.0], [-54.789, -26.622, 0.0], [-55.696, -27.388, 0.0], [-56.487, -27.548, 0.0], [-57.61, -27.396, 0.0], [-58.618, -27.124, 0.0], [-57.634, -25.604, 0.0], [-57.777, -25.162, 0.0], [-58.807, -24.771, 0.0], [-60.029, -24.033, 0.0], [-60.847, -23.881, 0.0], [-62.685, -22.249, 0.0]
        ]]
      }
    },
    "PY",
    "PRY"
    ],
    [
      "Swaziland",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [32.072, -26.734, 0.0], [31.868, -27.178, 0.0], [31.283, -27.286, 0.0], [30.686, -26.744, 0.0], [30.677, -26.398, 0.0], [30.95, -26.023, 0.0], [31.044, -25.731, 0.0], [31.333, -25.66, 0.0], [31.838, -25.843, 0.0], [31.986, -26.292, 0.0], [32.072, -26.734, 0.0]
        ]]
      }
    },
    "SZ",
    "SWZ"
    ],
    [
      "West Bank",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [35.546, 32.394, 0.0], [35.545, 31.783, 0.0], [35.398, 31.489, 0.0], [34.927, 31.353, 0.0], [34.971, 31.617, 0.0], [35.226, 31.754, 0.0], [34.975, 31.867, 0.0], [35.184, 32.533, 0.0], [35.546, 32.394, 0.0]
        ]]
      }
    },
    "PS",
    "PSE"
    ],
    [
      "Bahamas",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-77.535, 23.76, 0.0], [-77.78, 23.71, 0.0], [-78.034, 24.286, 0.0], [-78.408, 24.576, 0.0], [-78.191, 25.21, 0.0], [-77.89, 25.17, 0.0], [-77.54, 24.34, 0.0], [-77.535, 23.76, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-77.82, 26.58, 0.0], [-78.91, 26.42, 0.0], [-78.98, 26.79, 0.0], [-78.51, 26.87, 0.0], [-77.85, 26.84, 0.0], [-77.82, 26.58, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [-77.0, 26.59, 0.0], [-77.173, 25.879, 0.0], [-77.356, 26.007, 0.0], [-77.34, 26.53, 0.0], [-77.788, 26.925, 0.0], [-77.79, 27.04, 0.0], [-77.0, 26.59, 0.0]
       ]
      ]
     }
    ]
    },
    "BS",
    "BHS"
    ],
    [
      "Guinea",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-8.439, 7.686, 0.0], [-8.722, 7.712, 0.0], [-8.926, 7.309, 0.0], [-9.209, 7.314, 0.0], [-9.403, 7.527, 0.0], [-9.337, 7.929, 0.0], [-9.755, 8.541, 0.0], [-10.017, 8.429, 0.0], [-10.23, 8.406, 0.0], [-10.505, 8.349, 0.0], [-10.494, 8.716, 0.0], [-10.655, 8.977, 0.0], [-10.622, 9.268, 0.0], [-10.839, 9.688, 0.0], [-11.117, 10.046, 0.0], [-11.917, 10.047, 0.0], [-12.15, 9.859, 0.0], [-12.426, 9.836, 0.0], [-12.597, 9.62, 0.0], [-12.712, 9.343, 0.0], [-13.247, 8.903, 0.0], [-13.685, 9.495, 0.0], [-14.074, 9.886, 0.0], [-14.33, 10.016, 0.0], [-14.58, 10.214, 0.0], [-14.693, 10.656, 0.0], [-14.84, 10.877, 0.0], [-15.13, 11.04, 0.0], [-14.686, 11.528, 0.0], [-14.382, 11.509, 0.0], [-14.121, 11.677, 0.0], [-13.901, 11.679, 0.0], [-13.743, 11.811, 0.0], [-13.828, 12.143, 0.0], [-13.719, 12.247, 0.0], [-13.7, 12.586, 0.0], [-13.218, 12.576, 0.0], [-12.499, 12.332, 0.0], [-12.279, 12.354, 0.0], [-12.204, 12.466, 0.0], [-11.658, 12.387, 0.0], [-11.514, 12.443, 0.0], [-11.456, 12.077, 0.0], [-11.298, 12.078, 0.0], [-11.037, 12.211, 0.0], [-10.871, 12.178, 0.0], [-10.593, 11.924, 0.0], [-10.165, 11.844, 0.0], [-9.891, 12.06, 0.0], [-9.568, 12.194, 0.0], [-9.328, 12.334, 0.0], [-9.127, 12.308, 0.0], [-8.905, 12.088, 0.0], [-8.786, 11.813, 0.0], [-8.376, 11.394, 0.0], [-8.581, 11.136, 0.0], [-8.62, 10.811, 0.0], [-8.407, 10.909, 0.0], [-8.282, 10.793, 0.0], [-8.335, 10.495, 0.0], [-8.03, 10.207, 0.0], [-8.229, 10.129, 0.0], [-8.31, 9.79, 0.0], [-8.079, 9.376, 0.0], [-7.832, 8.576, 0.0], [-8.203, 8.455, 0.0], [-8.299, 8.316, 0.0], [-8.222, 8.123, 0.0], [-8.281, 7.687, 0.0], [-8.439, 7.686, 0.0]
        ]]
      }
    },
    "GN",
    "GIN"
    ],
    [
      "Guatemala",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-90.096, 13.735, 0.0], [-90.609, 13.91, 0.0], [-91.232, 13.928, 0.0], [-91.69, 14.126, 0.0], [-92.228, 14.539, 0.0], [-92.203, 14.83, 0.0], [-92.087, 15.065, 0.0], [-92.229, 15.251, 0.0], [-91.748, 16.067, 0.0], [-90.464, 16.07, 0.0], [-90.439, 16.41, 0.0], [-90.601, 16.471, 0.0], [-90.712, 16.687, 0.0], [-91.082, 16.918, 0.0], [-91.454, 17.252, 0.0], [-91.002, 17.255, 0.0], [-91.002, 17.818, 0.0], [-90.068, 17.819, 0.0], [-89.143, 17.808, 0.0], [-89.151, 17.016, 0.0], [-89.229, 15.887, 0.0], [-88.931, 15.887, 0.0], [-88.605, 15.706, 0.0], [-88.518, 15.855, 0.0], [-88.225, 15.728, 0.0], [-88.681, 15.346, 0.0], [-89.155, 15.066, 0.0], [-89.225, 14.874, 0.0], [-89.146, 14.678, 0.0], [-89.353, 14.424, 0.0], [-89.587, 14.363, 0.0], [-89.534, 14.245, 0.0], [-89.722, 14.134, 0.0], [-90.065, 13.882, 0.0], [-90.096, 13.735, 0.0]
        ]]
      }
    },
    "GT",
    "GTM"
    ],
    [
      "Israel",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [35.72, 32.709, 0.0], [35.546, 32.394, 0.0], [35.184, 32.533, 0.0], [34.975, 31.867, 0.0], [35.226, 31.754, 0.0], [34.971, 31.617, 0.0], [34.927, 31.353, 0.0], [35.398, 31.489, 0.0], [35.421, 31.1, 0.0], [34.923, 29.501, 0.0], [34.265, 31.219, 0.0], [34.556, 31.549, 0.0], [34.488, 31.606, 0.0], [34.753, 32.073, 0.0], [34.955, 32.827, 0.0], [35.098, 33.081, 0.0], [35.126, 33.091, 0.0], [35.461, 33.089, 0.0], [35.553, 33.264, 0.0], [35.821, 33.277, 0.0], [35.836, 32.868, 0.0], [35.701, 32.716, 0.0], [35.72, 32.709, 0.0]
        ]]
      }
    },
    "IL",
    "ISR"
    ],
    [
      "Oman",
      {
        "type": "GeometryCollection",
    "geometries": [
     {
      "type": "Polygon",
      "coordinates": [
       [
        [58.861, 21.114, 0.0], [58.488, 20.429, 0.0], [58.034, 20.481, 0.0], [57.826, 20.243, 0.0], [57.666, 19.736, 0.0], [57.789, 19.068, 0.0], [57.694, 18.945, 0.0], [57.234, 18.948, 0.0], [56.61, 18.574, 0.0], [56.512, 18.087, 0.0], [56.284, 17.876, 0.0], [55.661, 17.884, 0.0], [55.27, 17.632, 0.0], [55.275, 17.228, 0.0], [54.791, 16.951, 0.0], [54.239, 17.045, 0.0], [53.571, 16.708, 0.0], [53.109, 16.651, 0.0], [52.782, 17.35, 0.0], [52.0, 19.0, 0.0], [55.0, 20.0, 0.0], [55.667, 22.0, 0.0], [55.208, 22.708, 0.0], [55.234, 23.111, 0.0], [55.526, 23.525, 0.0], [55.529, 23.934, 0.0], [55.981, 24.131, 0.0], [55.804, 24.27, 0.0], [55.886, 24.921, 0.0], [56.397, 24.925, 0.0], [56.845, 24.242, 0.0], [57.403, 23.879, 0.0], [58.137, 23.748, 0.0], [58.729, 23.566, 0.0], [59.181, 22.992, 0.0], [59.45, 22.66, 0.0], [59.808, 22.534, 0.0], [59.806, 22.311, 0.0], [59.442, 21.715, 0.0], [59.282, 21.434, 0.0], [58.861, 21.114, 0.0]
       ]
      ]
     },
     {
      "type": "Polygon",
      "coordinates": [
       [
        [56.391, 25.896, 0.0], [56.261, 25.715, 0.0], [56.071, 26.055, 0.0], [56.362, 26.396, 0.0], [56.486, 26.309, 0.0], [56.391, 25.896, 0.0]
       ]
      ]
     }
    ]
    },
    "OM",
    "OMN"
    ],
    [
      "Poland",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [15.017, 51.107, 0.0], [14.607, 51.745, 0.0], [14.685, 52.09, 0.0], [14.438, 52.625, 0.0], [14.075, 52.981, 0.0], [14.353, 53.248, 0.0], [14.12, 53.757, 0.0], [14.803, 54.051, 0.0], [16.363, 54.513, 0.0], [17.623, 54.852, 0.0], [18.621, 54.683, 0.0], [18.696, 54.439, 0.0], [19.661, 54.426, 0.0], [20.892, 54.313, 0.0], [22.731, 54.328, 0.0], [23.244, 54.221, 0.0], [23.484, 53.912, 0.0], [23.528, 53.47, 0.0], [23.805, 53.09, 0.0], [23.799, 52.691, 0.0], [23.199, 52.487, 0.0], [23.508, 52.024, 0.0], [23.527, 51.578, 0.0], [24.03, 50.705, 0.0], [23.923, 50.425, 0.0], [23.427, 50.309, 0.0], [22.518, 49.477, 0.0], [22.776, 49.027, 0.0], [22.558, 49.086, 0.0], [21.608, 49.47, 0.0], [20.888, 49.329, 0.0], [20.416, 49.431, 0.0], [19.825, 49.217, 0.0], [19.321, 49.572, 0.0], [18.91, 49.436, 0.0], [18.853, 49.496, 0.0], [18.393, 49.989, 0.0], [17.649, 50.049, 0.0], [17.555, 50.362, 0.0], [16.869, 50.474, 0.0], [16.719, 50.216, 0.0], [16.176, 50.423, 0.0], [16.239, 50.698, 0.0], [15.491, 50.785, 0.0], [15.017, 51.107, 0.0]
        ]]
      }
    },
    "PL",
    "POL"
    ],
    [
      "Puerto Rico",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-66.282, 18.515, 0.0], [-65.771, 18.427, 0.0], [-65.591, 18.228, 0.0], [-65.847, 17.976, 0.0], [-66.6, 17.982, 0.0], [-67.184, 17.947, 0.0], [-67.242, 18.374, 0.0], [-67.101, 18.521, 0.0], [-66.282, 18.515, 0.0]
        ]]
      }
    },
    "PR",
    "PRI"
    ],
    [
      "W. Sahara",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-8.795, 27.121, 0.0], [-8.818, 27.656, 0.0], [-8.666, 27.656, 0.0], [-8.665, 27.589, 0.0], [-8.684, 27.396, 0.0], [-8.687, 25.881, 0.0], [-11.969, 25.933, 0.0], [-11.937, 23.375, 0.0], [-12.874, 23.285, 0.0], [-13.119, 22.771, 0.0], [-12.929, 21.327, 0.0], [-16.845, 21.333, 0.0], [-17.063, 21.0, 0.0], [-17.02, 21.422, 0.0], [-17.003, 21.421, 0.0], [-14.751, 21.501, 0.0], [-14.631, 21.861, 0.0], [-14.221, 22.31, 0.0], [-13.891, 23.691, 0.0], [-12.501, 24.77, 0.0], [-12.031, 26.031, 0.0], [-11.718, 26.104, 0.0], [-11.393, 26.883, 0.0], [-10.551, 26.991, 0.0], [-10.189, 26.861, 0.0], [-9.735, 26.861, 0.0], [-9.413, 27.088, 0.0], [-8.795, 27.121, 0.0]
        ]]
      }
    },
    "-99",
    "-99"
    ],
    [
      "Togo",
      {
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [1.865, 6.142, 0.0], [1.06, 5.929, 0.0], [0.837, 6.28, 0.0], [0.57, 6.914, 0.0], [0.491, 7.412, 0.0], [0.712, 8.312, 0.0], [0.461, 8.677, 0.0], [0.366, 9.465, 0.0], [0.368, 10.191, 0.0], [-0.05, 10.707, 0.0], [0.024, 11.019, 0.0], [0.9, 10.997, 0.0], [0.772, 10.471, 0.0], [1.078, 10.176, 0.0], [1.425, 9.825, 0.0], [1.463, 9.335, 0.0], [1.664, 9.129, 0.0], [1.619, 6.832, 0.0], [1.865, 6.142, 0.0]
        ]]
      }
    },
    "TG",
    "TGO"
  ]
 ]
};

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

var Country, _;

_ = __webpack_require__(0);

module.exports = Country = (function() {
  function Country(options) {
    if (options == null) {
      options = {};
    }
    this.util = options.util;
    this.geometries = options.geometries;
    this.iso_3166_2 = options.iso_3166_2;
    this.name = options.name;
    this.active = options.active === true;
    this.hovered = false;
    this.polygons = [];
    this._buildCountryPolygons();
  }

  Country.prototype.render = function() {
    return _.each(this.polygons, function(polygon) {
      return polygon.render();
    });
  };

  Country.prototype.isLatLngInside = function(latLng) {
    return _.some(this.polygons, function(polygon) {
      return polygon.isLatLngInside(latLng);
    });
  };

  Country.prototype.isHovered = function() {
    return this.hovered === true;
  };

  Country.prototype.onMouseHoveredLatLng = function(latLng) {
    this.hovered = _.some(this.polygons, function(polygon) {
      return polygon.isLatLngInside(latLng);
    });
    return this.render();
  };

  Country.prototype._buildCountryPolygons = function() {
    return _.each(this.geometries, (function(_this) {
      return function(geometry) {
        var coords;
        coords = _.map(geometry['coordinates'][0], function(coord) {
          return {
            lng: coord[0],
            lat: coord[1]
          };
        });
        return _this.polygons.push(new (__webpack_require__(683))({
          util: _this.util,
          country: _this,
          active: _this.active,
          coordinates: coords
        }));
      };
    })(this));
  };

  return Country;

})();


/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

var CountryPolygon, LatLng, _;

_ = __webpack_require__(0);

LatLng = __webpack_require__(684);

module.exports = CountryPolygon = (function() {
  function CountryPolygon(options) {
    if (options == null) {
      options = {};
    }
    this.util = options.util;
    this.country = options.country;
    this.coordinates = _.map(options.coordinates, function(latLng) {
      return LatLng(latLng.lat, latLng.lng);
    });
    this.active = options.active;
    this.ctx = this.util.context;
    this._coordinates = _.map(this.coordinates, function(coord) {
      return [coord.lng, coord.lat];
    });
  }

  CountryPolygon.prototype.getFillStyle = function() {
    if (this.active === true) {
      if (this.country.hovered === true) {
        return '#ef885d';
      } else {
        return '#ea662f';
      }
    } else {
      if (this.country.hovered === true) {
        return '#7a807f';
      } else {
        return '#707675';
      }
    }
  };

  CountryPolygon.prototype.getStrokeStyle = function() {
    return '#ffffff';
  };

  CountryPolygon.prototype.render = function() {
    var first;
    first = true;
    this.ctx.save();
    this.ctx.fillStyle = this.getFillStyle();
    this.ctx.strokeStyle = this.getStrokeStyle();
    this.ctx.lineWidth = 1;
    this.ctx.beginPath();
    _.each(this.coordinates, (function(_this) {
      return function(latLng) {
        var coord;
        coord = _this.util.latLngToCoordinates(latLng);
        if (first) {
          first = false;
          return _this.ctx.moveTo(coord.x, coord.y);
        } else {
          return _this.ctx.lineTo(coord.x, coord.y);
        }
      };
    })(this));
    this.ctx.closePath();
    this.ctx.fill();
    this.ctx.stroke();
    return this.ctx.restore();
  };

  CountryPolygon.prototype.isLatLngInside = function(latLng) {
    return __webpack_require__(686)([latLng.lng, latLng.lat], this._coordinates);
  };

  return CountryPolygon;

})();


/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

var kavrayskiy7;

kavrayskiy7 = __webpack_require__(201);

module.exports = function(lat, lng) {
  var coords;
  coords = {
    x: 0,
    y: 0
  };
  if ((lat != null) && (lng != null)) {
    coords = kavrayskiy7({
      lon: lng,
      lat: lat
    });
  }
  return {
    lng: lng,
    lat: lat,
    lngX: coords.x,
    latY: coords.y,
    hasKavrayskiy7: true
  };
};


/***/ }),

/***/ 686:
/***/ (function(module, exports) {

module.exports = function (point, vs) {
  // ray-casting algorithm based on
  // http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html

  var x = point[0], y = point[1];

  var inside = false;
  for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
      var xi = vs[i][0], yi = vs[i][1];
      var xj = vs[j][0], yj = vs[j][1];

      var intersect = ((yi > y) != (yj > y))
          && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
  }

  return inside;
};

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-countries-map-map\">\n  <canvas v-if=\"isInteractive\" ref=\"canvas\" style=\"width: 100%; height: 100%;\" @mousedown.prevent=\"onMouseDown\" @touchstart.prevent=\"onTouchStart\" @mouseup.prevent=\"onMouseUp\" @touchend.prevent=\"onTouchEnd\" @mousemove.prevent=\"onMouseMove\" @touchmove.prevent=\"onTouchMove\" @mousewheel.prevent=\"onMousewheel\" @mouseleave=\"onMouseLeave\"></canvas>\n  <canvas v-else ref=\"canvas\" style=\"width: 100%; height: 100%;\"></canvas>\n  <div class=\"controls\" v-if=\"isInteractive\"><a href=\"#\" v-on:click.prevent=\"onClickZoomIn\"><i class=\"mdi mdi-plus\"></i></a><a href=\"#\" v-on:click.prevent=\"onClickZoomOut\"><i class=\"mdi mdi-minus\"></i></a></div>\n</div>";

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

var Util, _, kavrayskiy7;

_ = __webpack_require__(0);

kavrayskiy7 = __webpack_require__(201);

Math.radians = function(degrees) {
  return degrees * Math.PI / 180;
};

module.exports = Util = (function() {
  function Util() {
    this.resetCaches();
    this.setCenterLatLng({
      lng: 13.0,
      lat: 52.0
    });
    this.canvasSize = {
      width: 0,
      height: 0
    };
    this.zoomStep = 1;
    this.context = null;
  }

  Util.prototype.setCanvasSize = function(width, height) {
    this.canvasSize.width = width;
    return this.canvasSize.height = height;
  };

  Util.prototype.setContext = function(context) {
    return this.context = context;
  };

  Util.prototype.setZoomStep = function(step) {
    this.resetCaches();
    this.zoomStep = parseInt(step);
    if (!(_.isNumber(this.zoomStep) && !_.isNaN(this.zoomStep) && this.zoomStep > 0)) {
      this.zoomStep = 1;
    }
    if (!(this.zoomStep <= 6)) {
      this.zoomStep = 6;
    }
    return this.zoomStep;
  };

  Util.prototype.setCenterLatLng = function(latLng) {
    if (!((latLng.lat != null) && (latLng.lng != null))) {
      return;
    }
    this.resetCaches();
    this.centerCoords = kavrayskiy7({
      lon: latLng.lng,
      lat: latLng.lat
    });
    return this.center = latLng;
  };

  Util.prototype.resetCaches = function() {
    this._latLngToCoordinatesCache = {};
    return this._coordinatesToLatLngCache = {};
  };

  Util.prototype.zoomIn = function() {
    return this.setZoomStep(this.zoomStep - 1);
  };

  Util.prototype.zoomOut = function() {
    return this.setZoomStep(this.zoomStep + 1);
  };

  Util.prototype.latLngToCoordinates = function(latLng) {
    var base, cache, name;
    cache = (this._latLngToCoordinatesCache[latLng.lat] || {})[latLng.lng] || null;
    if (cache != null) {
      return cache;
    }
    cache = this._latLngToKavrayskiy7Coords(latLng);
    cache = this._kavrayskiy7CoordsToCoords(cache);
    (base = this._latLngToCoordinatesCache)[name = latLng.lat] || (base[name] = {});
    this._latLngToCoordinatesCache[latLng.lat][latLng.lng] = cache;
    return cache;
  };

  Util.prototype.coordinatesToLatLng = function(coords) {
    var base, cache, name;
    cache = (this._coordinatesToLatLngCache[coords.x] || {})[coords.y] || null;
    if (cache != null) {
      return cache;
    }
    cache = this._coordsToKavrayskiy7Coords(coords);
    cache = this._kavrayskiy7CoordsToLatLng(cache);
    if (cache != null) {
      (base = this._latLngToCoordinatesCache)[name = coords.x] || (base[name] = {});
      this._latLngToCoordinatesCache[coords.x][coords.y] = cache;
    }
    return cache;
  };

  Util.prototype.changeCenterByLatLng = function(latLng) {
    return this.setCenterLatLng({
      lat: this.center.lat + latLng.lat,
      lng: this.center.lng + latLng.lng
    });
  };

  Util.prototype._getScaleRatio = function() {
    switch (this.zoomStep) {
      case 1:
        return 8000;
      case 2:
        return 6000;
      case 3:
        return 3500;
      case 4:
        return 2000;
      case 5:
        return 1300;
      case 6:
        return 800;
      default:
        return 2000;
    }
  };

  Util.prototype._latLngToKavrayskiy7Coords = function(latLng) {
    if (latLng.hasKavrayskiy7 === true) {
      return {
        x: latLng.lngX,
        y: latLng.latY
      };
    }
    return kavrayskiy7({
      lat: latLng.lat,
      lon: latLng.lng
    });
  };

  Util.prototype._kavrayskiy7CoordsToCoords = function(kav7Coords) {
    return {
      x: (kav7Coords.x * this._getScaleRatio()) + (this.canvasSize.width / 2) - (this.centerCoords.x * this._getScaleRatio()),
      y: (kav7Coords.y * this._getScaleRatio()) + (this.canvasSize.height / 2) - (this.centerCoords.y * this._getScaleRatio())
    };
  };

  Util.prototype._coordsToKavrayskiy7Coords = function(coords) {
    return {
      x: (coords.x - (this.canvasSize.width / 2) + (this.centerCoords.x * this._getScaleRatio())) / this._getScaleRatio(),
      y: (coords.y - (this.canvasSize.height / 2) + (this.centerCoords.y * this._getScaleRatio())) / this._getScaleRatio()
    };
  };

  Util.prototype._kavrayskiy7CoordsToLatLng = function(kav7Coords) {
    var e, latLng;
    try {
      latLng = kavrayskiy7({
        x: kav7Coords.x,
        y: kav7Coords.y
      });
    } catch (error) {
      e = error;
      if (/(Invalid input point)/.test(e.message)) {
        return null;
      } else {
        throw e;
      }
    }
    return {
      lat: latLng.lat,
      lng: latLng.lon
    };
  };

  return Util;

})();


/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(690),
  props: {
    active_country_codes: {
      "default": null
    },
    country_links: {
      "default": null
    },
    zoom_state: {
      "default": 'world'
    },
    center_lat: {
      "default": null
    },
    center_lng: {
      "default": null
    }
  },
  methods: {
    loadMapPopup: function() {
      return this.$store.dispatch('popups/show', {
        name: 'countries-map',
        active_country_codes: this.active_country_codes,
        country_links: this.country_links,
        zoom_state: this.zoom_state,
        center_lat: this.center_lat,
        center_lng: this.center_lng
      });
    },
    onClick: function() {
      return this.loadMapPopup();
    }
  }
});


/***/ }),

/***/ 690:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-countries-map-container\" @click.prevent=\"onClick\" @touch.prevent=\"onClick\">\n  <countries-map :active_country_codes=\"active_country_codes\" :country_links=\"country_links\" :zoom_state=\"zoom_state\" :center_lat=\"center_lat\" :center_lng=\"center_lng\" interactive=\"false\"></countries-map>\n  <div class=\"interactive-map-info-overlay\"><i class=\"mdi mdi-arrow-expand-all\"></i><span>Interaktive Karte öffnen</span></div>\n</div>";

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

var Q, _, axios;

Q = __webpack_require__(2);

axios = __webpack_require__(13);

_ = __webpack_require__(0);

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(692),
  components: {
    'prevented-form': __webpack_require__(117),
    'loading-indicator': __webpack_require__(118),
    'form-input': __webpack_require__(119),
    'form-textarea': __webpack_require__(188),
    'form-select': __webpack_require__(189),
    'form-checkbox': __webpack_require__(697)
  },
  data: function() {
    return {
      done: false,
      formData: {},
      errors: {}
    };
  },
  computed: {
    isFinancingSelf: function() {
      return this.formData.financing === 'self';
    },
    isFinancingExternal: function() {
      return this.formData.financing === 'external';
    },
    isFinancingNone: function() {
      return this.formData.financing === 'none';
    },
    isFinancingSelected: function() {
      return _.contains(['self', 'external', 'none'], this.formData.financing);
    },
    termsCheckboxContent: function() {
      return this.$t('school_registration_form.terms_accept', {
        url: this.$store.state.settings.urls.terms_url
      });
    }
  },
  methods: {
    onClickSubmit: function() {
      return this.$refs.form.submit();
    },
    onClickFinancing: function(option) {
      return this.$set(this.formData, 'financing', option);
    },
    resetDataToDefaults: function() {
      this.$set(this, 'formData', {
        salutation: null,
        firstname: null,
        lastname: null,
        phone: null,
        mail: null,
        school_name: null,
        school_phone: null,
        school_mail: null,
        school_website: null,
        school_country: null,
        school_city: null,
        school_address: null,
        participating_classes: null,
        participating_pupils: null,
        financing: null,
        financing_self_name: null,
        financing_self_email: null,
        financing_self_address: null,
        financing_external_sponsor_name: null,
        financing_external_sponsor_address: null,
        financing_external_sponsor_country: null,
        financing_external_sponsor_website: null,
        financing_external_contact_salutation: null,
        financing_external_sponsor_firstname: null,
        financing_external_sponsor_lastname: null,
        financing_external_sponsor_phone: null,
        financing_external_sponsor_fax: null,
        financing_external_sponsor_mail: null
      });
      return this.$set(this, 'errors', {});
    },
    showLoadingIndicator: function() {
      return this.$refs.loadingIndicator.show();
    },
    hideLoadingIndicator: function() {
      return this.$refs.loadingIndicator.hide();
    },
    getCsrfToken: function() {
      return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    },
    getErrorMessage: function(attrName) {
      if (!_.any(this.errors[attrName] || [])) {
        return null;
      }
      return _.first(this.errors[attrName]);
    },
    submit: function() {
      var errorFunc, gRecaptchaResponse, signInData;
      gRecaptchaResponse = this.$refs.recaptcha.getRecaptchaResponse();
      if (!(_.isString(gRecaptchaResponse) && _.size(gRecaptchaResponse) > 0)) {
        return;
      }
      if (this.formData.terms_accepted !== true) {
        this.$set(this.errors, 'terms_accepted', ['AGB müssen akzeptiert werden.']);
        return;
      } else {
        this.$set(this.errors, 'terms_accepted', null);
      }
      this.showLoadingIndicator();
      signInData = {
        method: 'post',
        url: '/api/school_registrations',
        data: {
          data: this.formData,
          g_recaptcha_response: gRecaptchaResponse
        },
        headers: {
          'X-CSRF-Token': this.getCsrfToken()
        }
      };
      errorFunc = (function(_this) {
        return function(error) {
          var ref;
          window.error = error;
          if (((ref = error.response) != null ? ref.data : void 0) != null) {
            _this.$set(_this, 'error', error.response.data.error);
          } else {
            _this.$set(_this, 'error', 'Fehler bei der Registrierung');
          }
          return _this.hideLoadingIndicator();
        };
      })(this);
      return axios(signInData).then((function(_this) {
        return function(response) {
          var data, ref;
          data = ((ref = response.data) != null ? ref.data : void 0) || {};
          _this.$set(_this, 'errors', data.errors || {});
          if (!(_.size(_this.errors) > 0)) {
            _this.$set(_this, 'done', true);
          }
          return _this.hideLoadingIndicator();
        };
      })(this))["catch"](errorFunc);
    }
  },
  created: function() {
    return this.resetDataToDefaults();
  }
});


/***/ }),

/***/ 692:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-contact-form-registration\">\n  <loading-indicator ref=\"loadingIndicator\"></loading-indicator>\n  <prevented-form v-if=\"!done\" ref=\"form\" v-on:submit=\"submit\">\n    <div class=\"form-control-group\">\n      <p class=\"group-label\" v-t=\"'school_registration_form.contact_person.headline'\"></p>\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <form-select id=\"school-registration-salutation\" v-model=\"formData.salutation\" :label=\"$t('contact_form.salutation')\" :error=\"getErrorMessage('salutation')\" required=\"true\">\n            <option value=\"\"></option>\n            <option value=\"f\" v-t=\"'contact_form.salutation_f'\"></option>\n            <option value=\"m\" v-t=\"'contact_form.salutation_m'\"></option>\n          </form-select>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <form-input id=\"school-registration-firstname\" v-model=\"formData.firstname\" :label=\"$t('contact_form.firstname')\" :error=\"getErrorMessage('firstname')\" required=\"true\"></form-input>\n          <form-input id=\"school-registration-lastname\" v-model=\"formData.lastname\" :label=\"$t('contact_form.lastname')\" :error=\"getErrorMessage('lastname')\" required=\"true\"></form-input>\n        </div>\n        <div class=\"col-sm-6\">\n          <form-input id=\"school-registration-phone\" v-model=\"formData.phone\" :label=\"$t('contact_form.phone')\" :error=\"getErrorMessage('phone')\"></form-input>\n          <form-input id=\"school-registration-mail\" v-model=\"formData.mail\" :label=\"$t('contact_form.email')\" :error=\"getErrorMessage('mail')\" required=\"true\"></form-input>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-control-group\">\n      <p class=\"group-label\" v-t=\"'school_registration_form.school_data.headline'\"></p>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <form-input id=\"school-registration-school-name\" v-model=\"formData.school_name\" :label=\"$t('school_registration_form.school_data.name')\" :error=\"getErrorMessage('school_name')\" required=\"true\"></form-input>\n          <form-input id=\"school-registration-school-phone\" v-model=\"formData.school_phone\" :label=\"$t('contact_form.phone')\" :error=\"getErrorMessage('school_phone')\"></form-input>\n          <form-input id=\"school-registration-school-mail\" v-model=\"formData.school_mail\" :label=\"$t('contact_form.email')\" :error=\"getErrorMessage('school_mail')\"></form-input>\n          <form-input id=\"school-registration-school-website\" v-model=\"formData.school_website\" :label=\"$t('contact_form.website')\" :error=\"getErrorMessage('school_website')\"></form-input>\n        </div>\n        <div class=\"col-sm-6\">\n          <form-input id=\"school-registration-school-country\" v-model=\"formData.school_country\" :label=\"$t('contact_form.country')\" :error=\"getErrorMessage('school_country')\" required=\"true\"></form-input>\n          <form-input id=\"school-registration-school-city\" v-model=\"formData.school_city\" :label=\"$t('contact_form.city')\" :error=\"getErrorMessage('school_city')\" required=\"true\"></form-input>\n          <form-textarea id=\"school-registration-school-address\" v-model=\"formData.school_address\" :label=\"$t('school_registration_form.school_data.international')\" :error=\"getErrorMessage('school_address')\" required=\"true\"></form-textarea>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-control-group\">\n      <p class=\"group-label\" v-t=\"'school_registration_form.participators_data.headline'\"></p>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <form-input id=\"school-registration-participation-classes\" v-model=\"formData.participating_classes\" :label=\"$t('school_registration_form.participators_data.amount_classes')\" :error=\"getErrorMessage('participating_classes')\"></form-input>\n        </div>\n        <div class=\"col-sm-6\">\n          <form-input id=\"school-registration-participation-pupils\" v-model=\"formData.participating_pupils\" :label=\"$t('school_registration_form.participators_data.amount_students')\" :error=\"getErrorMessage('participating_pupils')\"></form-input>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-control-group\">\n      <p class=\"group-label\" v-t=\"'school_registration_form.funding.headline'\"></p>\n      <div class=\"row\">\n        <div class=\"col-sm-4\">\n          <div class=\"founding-option\" :class=\"[isFinancingSelf ? 'founding-option-active' : '']\" v-on:click=\"onClickFinancing('self')\" @touch=\"onClickFinancing('self')\"><i class=\"mdi mdi-radiobox-marked\" v-if=\"isFinancingSelf\"></i><i class=\"mdi mdi-radiobox-blank\" v-else></i>\n            <p v-t=\"'school_registration_form.funding.option_self'\"></p>\n          </div>\n        </div>\n        <div class=\"col-sm-4\">\n          <div class=\"founding-option\" :class=\"[isFinancingExternal ? 'founding-option-active' : '']\" v-on:click=\"onClickFinancing('external')\" @touch=\"onClickFinancing('external')\"><i class=\"mdi mdi-radiobox-marked\" v-if=\"isFinancingExternal\"></i><i class=\"mdi mdi-radiobox-blank\" v-else></i>\n            <p v-t=\"'school_registration_form.funding.option_external'\"></p>\n          </div>\n        </div>\n        <div class=\"col-sm-4\">\n          <div class=\"founding-option\" :class=\"[isFinancingNone ? 'founding-option-active' : '']\" v-on:click=\"onClickFinancing('none')\" @touch=\"onClickFinancing('none')\"><i class=\"mdi mdi-radiobox-marked\" v-if=\"isFinancingNone\"></i><i class=\"mdi mdi-radiobox-blank\" v-else></i>\n            <p v-html=\"$t('school_registration_form.funding.option_none')\"></p>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-control-group\" v-if=\"isFinancingSelf\">\n      <p class=\"group-label\" v-t=\"'school_registration_form.funding_self.headline'\"></p>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <form-input id=\"school-registration-financing-self-name\" v-model=\"formData.financing_self_name\" :label=\"$t('school_registration_form.funding_self.name')\" :error=\"getErrorMessage('financing_self_name')\" required=\"true\"></form-input>\n          <form-input id=\"school-registration-financing-self-email\" v-model=\"formData.financing_self_email\" :label=\"$t('contact_form.email')\" :error=\"getErrorMessage('financing_self_email')\" required=\"true\"></form-input>\n        </div>\n        <div class=\"col-sm-6\">\n          <form-textarea id=\"school-registration-financing-self-address\" v-model=\"formData.financing_self_address\" :label=\"$t('school_registration_form.funding_self.address')\" :error=\"getErrorMessage('financing_self_address')\" required=\"true\"></form-textarea>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-control-group\" v-if=\"isFinancingExternal\">\n      <p class=\"group-label\" v-t=\"'school_registration_form.funding_external_1.headline'\"></p>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <form-input id=\"school-registration-financing-external-sponsor-name\" v-model=\"formData.financing_external_sponsor_name\" :label=\"$t('school_registration_form.funding_external_1.name')\" :error=\"getErrorMessage('financing_external_sponsor_name')\" required=\"true\"></form-input>\n          <form-textarea id=\"school-registration-financing-external-sponsor-address\" v-model=\"formData.financing_external_sponsor_address\" :label=\"$t('school_registration_form.funding_external_1.address')\" :error=\"getErrorMessage('financing_external_sponsor_address')\" required=\"true\" rows=\"6\"></form-textarea>\n        </div>\n        <div class=\"col-sm-6\">\n          <form-input id=\"school-registration-financing-external-sponsor-country\" v-model=\"formData.financing_external_sponsor_country\" :label=\"$t('contact_form.country')\" :error=\"getErrorMessage('financing_external_sponsor_country')\" required=\"true\"></form-input>\n          <form-input id=\"school-registration-financing-external-sponsor-mail\" v-model=\"formData.financing_external_sponsor_mail\" :label=\"$t('contact_form.email')\" :error=\"getErrorMessage('financing_external_sponsor_mail')\" required=\"true\"></form-input>\n          <form-input id=\"school-registration-financing-external-sponsor-website\" v-model=\"formData.financing_external_sponsor_website\" :label=\"$t('contact_form.website')\" :error=\"getErrorMessage('financing_external_sponsor_website')\"></form-input>\n          <form-input id=\"school-registration-financing-external-sponsor-phone\" v-model=\"formData.financing_external_sponsor_phone\" :label=\"$t('contact_form.phone')\" :error=\"getErrorMessage('financing_external_sponsor_phone')\"></form-input>\n          <form-input id=\"school-registration-financing-external-sponsor-fax\" v-model=\"formData.financing_external_sponsor_fax\" :label=\"$t('contact_form.fax')\" :error=\"getErrorMessage('financing_external_sponsor_fax')\"></form-input>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-control-group\" v-if=\"isFinancingExternal\">\n      <p class=\"group-label\" v-t=\"'school_registration_form.funding_external_2.headline'\"></p>\n      <div class=\"row\">\n        <div class=\"col-sm-2\">\n          <form-select id=\"school-registration-financing-external-contact-salutation\" v-model=\"formData.financing_external_contact_salutation\" :label=\"$t('contact_form.salutation')\" :error=\"getErrorMessage('financing_external_contact_salutation')\" required=\"true\">\n            <option value=\"\"></option>\n            <option value=\"f\" v-t=\"'contact_form.salutation_f'\"></option>\n            <option value=\"m\" v-t=\"'contact_form.salutation_m'\"></option>\n          </form-select>\n        </div>\n        <div class=\"col-sm-5\">\n          <form-input id=\"school-registration-financing-external-sponsor-firstname\" v-model=\"formData.financing_external_sponsor_firstname\" :label=\"$t('contact_form.firstname')\" :error=\"getErrorMessage('financing_external_sponsor_firstname')\" required=\"true\"></form-input>\n        </div>\n        <div class=\"col-sm-5\">\n          <form-input id=\"school-registration-financing-external-sponsor-lastname\" v-model=\"formData.financing_external_sponsor_lastname\" :label=\"$t('contact_form.lastname')\" :error=\"getErrorMessage('financing_external_sponsor_lastname')\" required=\"true\"></form-input>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-control-group\" v-if=\"isFinancingNone\">\n      <p v-t=\"'school_registration_form.funding_none.message'\"></p>\n    </div>\n    <div class=\"form-control-group\" v-if=\"isFinancingSelected\"><br>\n      <hr><br>\n      <recaptcha ref=\"recaptcha\"></recaptcha><br>\n      <form-checkbox :label=\"termsCheckboxContent\" v-model=\"formData.terms_accepted\" :error=\"getErrorMessage('terms_accepted')\"></form-checkbox><br><a class=\"kgm-btn kgm-btn-primary\" href=\"#\" v-on:click.prevent=\"onClickSubmit\" v-t=\"'school_registration_form.submit'\"></a>\n    </div>\n  </prevented-form>\n  <div class=\"done-container\" v-else><i class=\"mdi mdi-check-circle\"></i>\n    <div class=\"done-container-inside\">\n      <p v-t=\"'school_registration_form.success.message_1'\"></p>\n      <p v-t=\"'school_registration_form.success.message_2'\"></p>\n    </div>\n  </div>\n</div>";

/***/ }),

/***/ 693:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-form-abstract\"></div>";

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-form-input\" :class=\"[hasError ? 'comp-form-input-error' : '']\">\n  <label v-if=\"hasLabel\" :for=\"id\"><em class=\"required\" v-if=\"isRequired\">*</em>{{ label }}</label>\n  <input :name=\"id\" :id=\"id\" :value=\"value\" v-on:input=\"updateValue($event.target.value)\" ref=\"input\">\n  <div class=\"error\" v-if=\"hasError\">{{ error }}</div>\n</div>";

/***/ }),

/***/ 695:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-form-input\" :class=\"[hasError ? 'comp-form-input-error' : '']\">\n  <label v-if=\"hasLabel\" :for=\"id\"><em class=\"required\" v-if=\"isRequired\">*</em>{{ label }}</label>\n  <textarea :name=\"id\" :id=\"id\" :value=\"value\" v-on:input=\"updateValue($event.target.value)\" ref=\"input\" :rows=\"rows\"></textarea>\n  <div class=\"error\" v-if=\"hasError\">{{ error }}</div>\n</div>";

/***/ }),

/***/ 696:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-form-input comp-form-select\" :class=\"[hasError ? 'comp-form-input-error' : '']\">\n  <label v-if=\"hasLabel\" :for=\"id\"><em class=\"required\" v-if=\"isRequired\">*</em>{{ label }}</label>\n  <select :name=\"id\" :id=\"id\" :value=\"value\" v-on:change=\"updateValue($event.target.value)\" ref=\"select\">\n    <slot></slot>\n  </select>\n  <div class=\"error\" v-if=\"hasError\">{{ error }}</div>\n</div>";

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(187).extend({
  template: __webpack_require__(698),
  props: {
    value: {
      "default": false
    }
  },
  data: function() {
    return {
      checked: this.value === true
    };
  },
  computed: {
    isChecked: function() {
      return this.checked === true;
    }
  },
  methods: {
    updateValue: function(value) {
      return this.$emit('input', value);
    },
    onCheckClick: function() {
      this.$set(this, 'checked', this.checked === false);
      return this.$emit('input', this.checked);
    }
  }
});


/***/ }),

/***/ 698:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-form-input comp-form-checkbox\" :class=\"[hasError ? 'comp-form-input-error' : '', isChecked ? 'comp-form-checkbox-checked' : '']\">\n  <div class=\"comp-form-checkbox-inside\">\n    <div class=\"comp-form-container\" v-on:click=\"onCheckClick\"><i class=\"mdi mdi-checkbox-blank-outline icon-inactive\"></i><i class=\"mdi mdi-checkbox-marked icon-active\"></i>\n      <input :id=\"id\" :name=\"id\" :value=\"value\" :checked=\"isChecked\" type=\"checkbox\" ref=\"input\">\n    </div>\n    <label :for=\"id\" v-on:click=\"onCheckClick\" v-html=\"label\"></label>\n  </div>\n  <div class=\"error\" v-if=\"hasError\">{{ error }}</div>\n</div>";

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

var _;

_ = __webpack_require__(0);

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(700),
  components: {
    'prevented-form': __webpack_require__(117),
    'loading-indicator': __webpack_require__(118),
    'form-input': __webpack_require__(119),
    'form-textarea': __webpack_require__(188),
    'form-select': __webpack_require__(189)
  },
  data: function() {
    return {
      done: false,
      formData: {},
      errors: {}
    };
  },
  methods: {
    onClickSubmit: function() {
      return this.$refs.form.submit();
    },
    onClickFinancing: function(option) {
      return this.$set(this.formData, 'financing', option);
    },
    resetDataToDefaults: function() {
      this.$set(this, 'formData', {
        salutation: null,
        firstname: null,
        lastname: null,
        phone: null,
        mail: null,
        message: null
      });
      return this.$set(this, 'errors', {});
    },
    showLoadingIndicator: function() {
      return this.$refs.loadingIndicator.show();
    },
    hideLoadingIndicator: function() {
      return this.$refs.loadingIndicator.hide();
    },
    getErrorMessage: function(attrName) {
      if (!_.any(this.errors[attrName] || [])) {
        return null;
      }
      return _.first(this.errors[attrName]);
    },
    submit: function() {
      var gRecaptchaResponse;
      gRecaptchaResponse = this.$refs.recaptcha.getRecaptchaResponse();
      if (!(_.isString(gRecaptchaResponse) && _.size(gRecaptchaResponse) > 0)) {
        return;
      }
      this.showLoadingIndicator();
      return this.$store.dispatch('net/call', {
        method: 'post',
        url: '/api/contact_form',
        data: {
          data: this.formData,
          g_recaptcha_response: gRecaptchaResponse
        }
      }).then((function(_this) {
        return function(response) {
          var data, ref;
          data = ((ref = response.data) != null ? ref.data : void 0) || {};
          _this.$set(_this, 'errors', data.errors || {});
          if (!(_.size(_this.errors) > 0)) {
            return _this.$set(_this, 'done', true);
          }
        };
      })(this))["catch"]((function(_this) {
        return function(error) {
          var ref;
          if (((ref = error.response) != null ? ref.data : void 0) != null) {
            return _this.$set(_this, 'error', error.response.data.error);
          } else {
            return _this.$set(_this, 'error', 'Fehler bei der Übermittlung der Daten');
          }
        };
      })(this))["finally"]((function(_this) {
        return function() {
          return _this.hideLoadingIndicator();
        };
      })(this)).done();
    }
  },
  created: function() {
    return this.resetDataToDefaults();
  }
});


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

var _;

_ = __webpack_require__(0);

module.exports = __webpack_require__(3).extend({
  created: function() {
    var data;
    if (!_.isFunction(this.$options.template)) {
      return;
    }
    if (_.isFunction(this.serializeData)) {
      data = this.serializeData();
    }
    data || (data = {});
    return this.$options.template = this.$options.template(data);
  }
});


/***/ }),

/***/ 700:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-contact-form-default\">\n  <loading-indicator ref=\"loadingIndicator\"></loading-indicator>\n  <prevented-form v-if=\"!done\" ref=\"form\" v-on:submit=\"submit\">\n    <div class=\"form-control-group\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <form-select id=\"contact-form-default-salutation\" v-model=\"formData.salutation\" label=\"Anrede\" :label=\"$t('contact_form.salutation')\" required=\"true\">\n            <option value=\"\"></option>\n            <option value=\"f\" v-t=\"'contact_form.salutation_f'\"></option>\n            <option value=\"m\" v-t=\"'contact_form.salutation_m'\"></option>\n          </form-select>\n        </div>\n        <div class=\"col-sm-6\">\n          <form-input id=\"contact-form-default-firstname\" v-model=\"formData.firstname\" :label=\"$t('contact_form.firstname')\" :error=\"getErrorMessage('firstname')\" required=\"true\"></form-input>\n          <form-input id=\"contact-form-default-lastname\" v-model=\"formData.lastname\" :label=\"$t('contact_form.lastname')\" :error=\"getErrorMessage('lastname')\" required=\"true\"></form-input>\n        </div>\n        <div class=\"col-sm-6\">\n          <form-input id=\"contact-form-default-phone\" v-model=\"formData.phone\" :label=\"$t('contact_form.phone')\" :error=\"getErrorMessage('phone')\" required=\"true\"></form-input>\n          <form-input id=\"contact-form-default-mail\" v-model=\"formData.mail\" :label=\"$t('contact_form.email')\" :error=\"getErrorMessage('mail')\" required=\"true\"></form-input>\n        </div>\n        <div class=\"col-xs-12\">\n          <form-textarea id=\"contact-form-default-message\" v-model=\"formData.message\" :label=\"$t('contact_form.message')\" :error=\"getErrorMessage('message')\" rows=\"8\"></form-textarea>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-control-group\"><br>\n      <recaptcha ref=\"recaptcha\"></recaptcha><br><a class=\"kgm-btn kgm-btn-primary\" href=\"#\" v-on:click.prevent=\"onClickSubmit\" v-t=\"'contact_form.submit_message'\"></a>\n    </div>\n  </prevented-form>\n  <div class=\"done-container\" v-else><i class=\"mdi mdi-check-circle\"></i>\n    <div class=\"done-container-inside\">\n      <p v-t=\"'default_contact_form.success.message_1'\"></p>\n      <p v-t=\"'default_contact_form.success.message_2'\"></p>\n    </div>\n  </div>\n</div>";

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

var _;

_ = __webpack_require__(0);

module.exports = __webpack_require__(7).extend({
  template: __webpack_require__(702),
  components: {
    'prevented-form': __webpack_require__(117),
    'loading-indicator': __webpack_require__(118),
    'form-input': __webpack_require__(119),
    'form-textarea': __webpack_require__(188),
    'form-select': __webpack_require__(189)
  },
  data: function() {
    return {
      done: false,
      formData: {},
      errors: {}
    };
  },
  methods: {
    onClickSubmit: function() {
      return this.$refs.form.submit();
    },
    onClickFinancing: function(option) {
      return this.$set(this.formData, 'financing', option);
    },
    resetDataToDefaults: function() {
      this.$set(this, 'formData', {
        salutation: null,
        firstname: null,
        lastname: null,
        company_name: null,
        phone: null,
        mail: null,
        website: null,
        message: null,
        amount_students: null,
        website_mention: false,
        forward_data: false,
        invoice_name: null,
        invoice_address: null,
        invoice_email: null
      });
      return this.$set(this, 'errors', {});
    },
    showLoadingIndicator: function() {
      return this.$refs.loadingIndicator.show();
    },
    hideLoadingIndicator: function() {
      return this.$refs.loadingIndicator.hide();
    },
    getErrorMessage: function(attrName) {
      if (!_.any(this.errors[attrName] || [])) {
        return null;
      }
      return _.first(this.errors[attrName]);
    },
    submit: function() {
      var formData, gRecaptchaResponse;
      gRecaptchaResponse = this.$refs.recaptcha.getRecaptchaResponse();
      if (!(_.isString(gRecaptchaResponse) && _.size(gRecaptchaResponse) > 0)) {
        return;
      }
      this.showLoadingIndicator();
      formData = this.formData;
      formData.website_mention = formData.website_mention === true || formData.website_mention === 'true';
      formData.forward_data = formData.forward_data === true || formData.forward_data === 'true';
      return this.$store.dispatch('net/call', {
        method: 'post',
        url: '/api/contact_form_become_partner',
        data: {
          data: this.formData,
          g_recaptcha_response: gRecaptchaResponse
        }
      }).then((function(_this) {
        return function(response) {
          var data, ref;
          data = ((ref = response.data) != null ? ref.data : void 0) || {};
          _this.$set(_this, 'errors', data.errors || {});
          if (!(_.size(_this.errors) > 0)) {
            return _this.$set(_this, 'done', true);
          }
        };
      })(this))["catch"]((function(_this) {
        return function(error) {
          var ref;
          if (((ref = error.response) != null ? ref.data : void 0) != null) {
            return _this.$set(_this, 'error', error.response.data.error);
          } else {
            return _this.$set(_this, 'error', 'Fehler bei der Übermittlung der Daten');
          }
        };
      })(this))["finally"]((function(_this) {
        return function() {
          return _this.hideLoadingIndicator();
        };
      })(this)).done();
    }
  },
  created: function() {
    return this.resetDataToDefaults();
  }
});


/***/ }),

/***/ 702:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-contact-form-become-partner\">\n  <loading-indicator ref=\"loadingIndicator\"></loading-indicator>\n  <prevented-form v-if=\"!done\" ref=\"form\" v-on:submit=\"submit\">\n    <div class=\"form-control-group\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <form-select id=\"contact-form-become-partner-salutation\" v-model=\"formData.salutation\" :label=\"$t('contact_form.salutation')\" :error=\"getErrorMessage('salutation')\" required=\"true\">\n            <option value=\"\"></option>\n            <option value=\"f\" v-t=\"'contact_form.salutation_f'\"></option>\n            <option value=\"m\" v-t=\"'contact_form.salutation_m'\"></option>\n          </form-select>\n        </div>\n        <div class=\"col-sm-6\">\n          <form-input id=\"contact-form-become-partner-firstname\" v-model=\"formData.firstname\" :label=\"$t('contact_form.firstname')\" :error=\"getErrorMessage('firstname')\" required=\"true\"></form-input>\n          <form-input id=\"contact-form-become-partner-lastname\" v-model=\"formData.lastname\" :label=\"$t('contact_form.lastname')\" :error=\"getErrorMessage('lastname')\" required=\"true\"></form-input>\n          <form-input id=\"contact-form-become-partner-company-name\" v-model=\"formData.company_name\" :label=\"$t('become_partner_form.company_name')\" :error=\"getErrorMessage('company_name')\"></form-input>\n        </div>\n        <div class=\"col-sm-6\">\n          <form-input id=\"contact-form-become-partner-phone\" v-model=\"formData.phone\" :label=\"$t('contact_form.phone')\" :error=\"getErrorMessage('phone')\" required=\"true\"></form-input>\n          <form-input id=\"contact-form-become-partner-mail\" v-model=\"formData.mail\" :label=\"$t('contact_form.email')\" :error=\"getErrorMessage('mail')\" required=\"true\"></form-input>\n          <form-input id=\"contact-form-become-partner-website\" v-model=\"formData.website\" :label=\"$t('contact_form.website')\" :error=\"getErrorMessage('website')\"></form-input>\n        </div>\n        <div class=\"col-xs-12\">\n          <hr>\n          <form-input id=\"contact-form-become-partner-amount-students\" v-model=\"formData.amount_students\" :label=\"$t('become_partner_form.amount_students')\" :error=\"getErrorMessage('amount_students')\" :hint=\"$t('become_partner_form.amount_students_hint')\"> </form-input>\n          <p>\n            Nennung auf unserer Homepage: \n            &nbsp;\n            <input type=\"radio\" id=\"form-input-partner-website-mention-yes\" name=\"partner[website_mention]\" value=\"true\" v-model=\"formData.website_mention\">&nbsp;\n            <label for=\"form-input-partner-website-mention-yes\">{{ $t('support.yes') }}</label>&nbsp;\n            <input type=\"radio\" id=\"form-input-partner-website-mention-no\" name=\"partner[website_mention]\" value=\"false\" v-model=\"formData.website_mention\">&nbsp;\n            <label for=\"form-input-partner-website-mention-no\">{{ $t('support.no') }}</label>\n          </p>\n          <p>\n            Weiterleitung Ihrer Daten an  betreffende Schule(n): \n            &nbsp;\n            <input type=\"radio\" id=\"form-input-partner-forward-data-yes\" name=\"partner[forward_data]\" value=\"true\" v-model=\"formData.forward_data\">&nbsp;\n            <label for=\"form-input-partner-forward-data-yes\">{{ $t('support.yes') }}</label>&nbsp;\n            <input type=\"radio\" id=\"form-input-partner-forward-data-no\" name=\"partner[forward_data]\" value=\"false\" v-model=\"formData.forward_data\">&nbsp;\n            <label for=\"form-input-partner-forward-data-no\">{{ $t('support.no') }}</label>\n          </p>\n        </div>\n        <div class=\"col-xs-12\">\n          <form-textarea id=\"contact-form-become-partner-message\" v-model=\"formData.message\" :label=\"$t('contact_form.message')\" :error=\"getErrorMessage('message')\" rows=\"8\"></form-textarea>\n        </div>\n        <div class=\"col-xs-12\">\n          <p>{{ $t('become_partner_form.invoice_data') }}</p>\n        </div>\n        <div class=\"col-sm-6\">\n          <form-input id=\"contact-form-become-partner-invoice-name\" v-model=\"formData.invoice_name\" :label=\"$t('contact_form.name')\" :error=\"getErrorMessage('invoice_name')\"></form-input>\n          <form-input id=\"contact-form-become-partner-invoice-email\" type=\"email\" v-model=\"formData.invoice_email\" :label=\"$t('contact_form.email')\" :error=\"getErrorMessage('invoice_email')\"></form-input>\n        </div>\n        <div class=\"col-sm-6\">\n          <form-textarea id=\"contact-form-become-partner-invoice-address\" v-model=\"formData.invoice_address\" :label=\"$t('contact_form.address')\" :error=\"getErrorMessage('invoice_address')\" rows=\"4\"></form-textarea>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-control-group\"><br>\n      <recaptcha ref=\"recaptcha\"></recaptcha><br><a class=\"kgm-btn kgm-btn-primary\" href=\"#\" v-on:click.prevent=\"onClickSubmit\" v-t=\"'contact_form.submit_message'\"></a>\n    </div>\n  </prevented-form>\n  <div class=\"done-container\" v-else><i class=\"mdi mdi-check-circle\"></i>\n    <div class=\"done-container-inside\">\n      <p v-t=\"'become_partner_form.success.message_1'\"></p>\n      <p v-t=\"'become_partner_form.success.message_2'\"></p>\n    </div>\n  </div>\n</div>";

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

var RootStoreModule, Vuex;

Vuex = __webpack_require__(17)["default"];

module.exports = RootStoreModule = (function() {
  function RootStoreModule() {}

  RootStoreModule.prototype.modules = null;

  RootStoreModule.prototype.setup = function() {};

  RootStoreModule.prototype.getVuexStore = function() {
    return this._vuexStore || (this._vuexStore = new Vuex.Store(this.getVuexStoreConfig()));
  };

  RootStoreModule.prototype.getVuexState = function() {
    return this.getVuexStore().state;
  };

  RootStoreModule.prototype.getVuexStoreConfig = function() {
    return this._vuexStoreConfig || (this._vuexStoreConfig = {
      state: {},
      getters: {},
      mutations: {},
      actions: {},
      modules: {
        settings: __webpack_require__(704),
        cookie: __webpack_require__(705),
        net: __webpack_require__(706),
        popups: __webpack_require__(707),
        window: __webpack_require__(708),
        accordion: __webpack_require__(709),
        lightbox: __webpack_require__(710),
        partners: __webpack_require__(711),
        server: __webpack_require__(712),
        googleMaps: __webpack_require__(713)
      }
    });
  };

  return RootStoreModule;

})();


/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

var Vue, _;

_ = __webpack_require__(0);

Vue = __webpack_require__(3);

module.exports = {
  namespaced: true,
  state: {
    environment: null,
    revision: null,
    session: null
  },
  getters: {
    environment: function(state, getters) {
      return state.environment;
    }
  },
  mutations: {
    _set: function(state, config) {
      return _.each(config, (function(_this) {
        return function(value, key) {
          return Vue.set(state, key, value);
        };
      })(this));
    }
  },
  actions: {
    set: function(context, config) {
      return context.commit('_set', config);
    }
  }
};


/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

var Cookie, Q, Vue, _, appName;

Q = __webpack_require__(2);

_ = __webpack_require__(0);

Cookie = __webpack_require__(111);

Vue = __webpack_require__(3);

appName = 'kgm';

module.exports = {
  namespaced: true,
  state: {
    cookies: {}
  },
  getters: {
    getChainedName: function(state, getters) {
      return function(name, module) {
        var n;
        n = [appName];
        if (_.isString(module) && _.size(module) > 0) {
          n.push(module);
        }
        n.push(name);
        return n.join('-');
      };
    },
    getPlain: function(state, getters) {
      return function(name) {
        return Cookie.getJSON(name);
      };
    },
    get: function(state, getters) {
      return function(name, module) {
        if (module == null) {
          module = null;
        }
        return getters['getPlain'](getters['getChainedName'](name, module));
      };
    },
    isHttpsOnly: function(state, getters, rootState, rootGetters) {
      var env;
      env = rootGetters['settings/environment'];
      return env !== 'development' && env !== 'test';
    }
  },
  mutations: {
    setToStore: function(state, payload) {
      if (payload == null) {
        payload = {};
      }
      return Vue.set(state.cookies, payload.name, payload.value);
    },
    setToCookie: function(state, payload) {
      if (payload == null) {
        payload = {};
      }
      return Cookie.set(payload.name, payload.value, payload.options);
    },
    removeCookie: function(state, payload) {
      if (payload == null) {
        payload = {};
      }
      return Cookie.remove(payload.name, payload.options);
    }
  },
  actions: {
    loadPlain: function(context, payload) {
      var value;
      if (payload == null) {
        payload = {};
      }
      value = context.getters['getPlain'](payload.name);
      context.commit('setToStore', {
        name: payload.name,
        value: value
      });
      return Q(value);
    },
    load: function(context, payload) {
      if (payload == null) {
        payload = {};
      }
      payload.name = context.getters['getChainedName'](payload.name, payload.module || null);
      payload.value = context.getters['getPlain'](payload.name, payload.module || null);
      context.commit('setToStore', payload);
      return Q(payload.value);
    },
    setPlain: function(context, payload) {
      var secure, value;
      if (payload == null) {
        payload = {};
      }
      value = payload.value || null;
      secure = context.getters['isHttpsOnly'] === true;
      context.commit('setToStore', {
        name: payload.name,
        value: value
      });
      context.commit('setToCookie', {
        name: payload.name,
        value: value,
        options: {
          secure: secure
        }
      });
      return Q(value);
    },
    removePlain: function(context, payload) {
      var secure;
      if (payload == null) {
        payload = {};
      }
      secure = context.getters['isHttpsOnly'] === true;
      context.commit('removeCookie', {
        name: payload.name,
        options: {
          secure: secure
        }
      });
      return Q();
    },
    set: function(context, payload) {
      if (payload == null) {
        payload = {};
      }
      payload.name = context.getters['getChainedName'](payload.name, payload.module || null);
      context.dispatch('setPlain', payload);
      return Q(payload.value);
    },
    remove: function(context, payload) {
      if (payload == null) {
        payload = {};
      }
      payload.name = context.getters['getChainedName'](payload.name, payload.module || null);
      context.dispatch('removePlain', payload);
      return Q();
    }
  }
};


/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

var Q, axios, csrfToken;

Q = __webpack_require__(2);

axios = __webpack_require__(13);

csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

module.exports = {
  namespaced: true,
  state: {
    csrfToken: csrfToken
  },
  actions: {
    call: function(context, axiosConfig) {
      var d, host;
      if (axiosConfig == null) {
        axiosConfig = {};
      }
      d = Q.defer();
      host = context.rootState.settings.host.full;
      host = (host.replace(/\/$/, '')) + "/";
      axiosConfig.baseURL = host;
      axiosConfig.headers || (axiosConfig.headers = {});
      axiosConfig.headers['X-CSRF-Token'] = context.state.csrfToken;
      axiosConfig.headers['Accept'] = 'application/json';
      axiosConfig;
      axiosConfig.maxRedirects = 0;
      axios(axiosConfig).then((function(_this) {
        return function(responseData) {
          return d.resolve(responseData);
        };
      })(this))["catch"]((function(_this) {
        return function(error) {
          return d.reject(error);
        };
      })(this));
      return d.promise;
    }
  }
};


/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

var EventBus, Vue, _;

_ = __webpack_require__(0);

Vue = __webpack_require__(3);

EventBus = __webpack_require__(198).EventBus;

module.exports = {
  namespaced: true,
  state: {
    popupsOrder: [],
    popups: {}
  },
  mutations: {
    _pushPopup: function(state, payload) {
      var popups, popupsOrder;
      if (_.isObject(state.popups[payload.key])) {
        return;
      }
      popupsOrder = [].concat(state.popupsOrder);
      popupsOrder.push(payload.key);
      popups = _.extend({}, state.popups);
      popups[payload.key] = payload;
      Vue.set(state, 'popups', popups);
      Vue.set(state, 'popupsOrder', popupsOrder);
      return EventBus.get().$emit('push', payload);
    },
    _popPopup: function(state, payload) {
      var popups, popupsOrder;
      if (!_.isObject(state.popups[payload.key])) {
        return;
      }
      popupsOrder = _.without(state.popupsOrder, payload.key);
      popups = _.omit(state.popups, payload.key);
      Vue.set(state, 'popups', popups);
      Vue.set(state, 'popupsOrder', popupsOrder);
      return EventBus.get().$emit('pop', payload);
    },
    _ignoreEsc: function(state, payload) {
      if (!_.isObject(state.popups[payload.key])) {
        return;
      }
      return Vue.set(state.popups[payload.key], 'ignoreEsc', true);
    }
  },
  actions: {
    show: function(context, payload) {
      if (!(_.isString(payload.name) && _.size(payload.name) > 0)) {
        return;
      }
      payload.key = [payload.name];
      if (_.isString(payload.id) && _.size(payload.id) > 0) {
        payload.key.push(payload.id);
      }
      payload.key = payload.key.join('-');
      return context.commit('_pushPopup', payload);
    },
    hide: function(context, payload) {
      if (!(_.isString(payload.name) && _.size(payload.name) > 0)) {
        return;
      }
      payload.key = [payload.name];
      if (_.isString(payload.id) && _.size(payload.id) > 0) {
        payload.key.push(payload.id);
      }
      payload.key = payload.key.join('-');
      return context.commit('_popPopup', payload);
    },
    windowKeyupEsc: function(context) {
      var data, key;
      key = _.last(context.state.popupsOrder);
      if (!(_.isString(key) && _.size(key) > 0)) {
        return;
      }
      data = context.state.popups[key] || {};
      if (data.ignoreEsc !== true) {
        return context.commit('_popPopup', data);
      }
    },
    ignoreEsc: function(context, payload) {
      if (!(_.isString(payload.name) && _.size(payload.name) > 0)) {
        return;
      }
      return context.commit('_ignoreEsc', payload);
    }
  }
};


/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

var Vue, _;

_ = __webpack_require__(0);

Vue = __webpack_require__(3);

module.exports = {
  namespaced: true,
  state: {
    height: 0,
    width: 0,
    scrollTop: 0,
    scrollLeft: 0,
    footerSpacerHeight: 0
  },
  mutations: {
    _updateClientWidthHeight: function(state, payload) {
      Vue.set(state, 'height', payload.height);
      return Vue.set(state, 'width', payload.width);
    },
    _updateScroll: function(state, payload) {
      Vue.set(state, 'scrollTop', payload.scrollTop);
      return Vue.set(state, 'scrollLeft', payload.scrollLeft);
    },
    _setFooterSpacerHeight: function(state, height) {
      if (!(_.isNumber(height) && !_.isNaN(height))) {
        height = 0;
      }
      if (!(height >= 0)) {
        height = 0;
      }
      return Vue.set(state, 'footerSpacerHeight', height);
    }
  },
  actions: {
    updateClientWidthHeight: function(context, payload) {
      return context.commit('_updateClientWidthHeight', payload);
    },
    updateScroll: function(context, payload) {
      return context.commit('_updateScroll', payload);
    },
    updateFooterSpacerHeight: function(context, payload) {
      return context.commit('_setFooterSpacerHeight', payload.height || 0);
    }
  }
};


/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

var Vue, _;

_ = __webpack_require__(0);

Vue = __webpack_require__(3);

module.exports = {
  namespaced: true,
  state: {
    collections: {
      "default": {}
    }
  },
  getters: {
    isCollapsed: function(state) {
      return function(collection, id) {
        return (state.collections[collection] || {})[id] === true;
      };
    }
  },
  mutations: {
    _setItem: function(state, payload) {
      if (!((payload.collection != null) && (payload.id != null))) {
        return;
      }
      if (state.collections[payload.collection] == null) {
        Vue.set(state.collections, payload.collection, {});
      }
      return Vue.set(state.collections[payload.collection], payload.id, payload.collapsed === true);
    },
    _removeItem: function(state, payload) {
      var collection;
      if (!((payload.collection != null) && (state.collections[payload.collection] != null))) {
        return;
      }
      collection = _.omit(state.collections[payload.collection] || {}, payload.id);
      if (state.collections[payload.collection] == null) {
        Vue.set(state.collections, payload.collection, {});
      }
      return Vue.set(state.collections, payload.collection, collection);
    },
    _updateState: function(state, payload) {
      var collection;
      if (!((payload.collection != null) && (state.collections[payload.collection] != null))) {
        return;
      }
      collection = state.collections[payload.collection];
      _.each(collection, function(value, key) {
        return collection[key] = true;
      });
      collection[payload.id] = payload.collapsed === true;
      return Vue.set(state.collections, payload.collection, collection);
    }
  },
  actions: {
    register: function(context, payload) {
      payload.collection || (payload.collection = 'default');
      payload.id || (payload.id = _.uniqueId('accordion-'));
      payload.collapsed = true;
      return context.commit('_setItem', payload);
    },
    unregister: function(context, payload) {
      payload.collection || (payload.collection = 'default');
      if (payload.id != null) {
        return context.commit('_removeItem', payload);
      }
    },
    toggle: function(context, payload) {
      var collapsed;
      if (!context.state.collections[payload.collection]) {
        return;
      }
      collapsed = context.state.collections[payload.collection][payload.id] === false;
      return context.commit('_updateState', {
        collection: payload.collection,
        id: payload.id,
        collapsed: collapsed
      });
    }
  }
};


/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

var Vue, _, sortCollectionByKey;

_ = __webpack_require__(0);

Vue = __webpack_require__(3);

sortCollectionByKey = function(collection) {
  var array, result;
  array = [];
  result = {};
  _.each(collection, function(item, key) {
    item.id = key;
    return array.push(item);
  });
  array = _.sortBy(array, function(item) {
    return item.id;
  });
  _.each(array, function(item) {
    return result[item.id] = item;
  });
  return result;
};

module.exports = {
  namespaced: true,
  state: {
    openedCollection: null,
    openedItem: null,
    collections: {
      "default": {}
    }
  },
  getters: {
    current: function(state) {
      if (!((state.openedCollection != null) && (state.openedItem != null))) {
        return null;
      }
      return state.collections[state.openedCollection][state.openedItem];
    },
    hasPreviousItem: function(state) {
      var index, keys;
      if (!((state.openedCollection != null) && (state.openedItem != null))) {
        return false;
      }
      keys = _.keys(state.collections[state.openedCollection]);
      index = _.indexOf(keys, state.openedItem);
      if (index - 1 >= 0) {
        return true;
      } else {
        return false;
      }
    },
    hasNextItem: function(state) {
      var index, keys;
      if (!((state.openedCollection != null) && (state.openedItem != null))) {
        return false;
      }
      keys = _.keys(state.collections[state.openedCollection]);
      index = _.indexOf(keys, state.openedItem);
      if (index + 1 < _.size(keys)) {
        return true;
      } else {
        return false;
      }
    }
  },
  mutations: {
    _setItem: function(state, payload) {
      var collection, name;
      collection = _.extend({}, state.collections[payload.collection] || {});
      collection[name = payload.id] || (collection[name] = {});
      collection[payload.id].thumbUrl = payload.thumbUrl || null;
      collection[payload.id].imageUrl = payload.imageUrl || null;
      collection[payload.id].title = payload.title || null;
      return Vue.set(state.collections, payload.collection, collection);
    },
    _removeItem: function(state, payload) {
      var collection;
      if (state.collections[payload.collection] == null) {
        return;
      }
      collection = _.extend({}, state.collections[payload.collection] || {});
      collection = _.omit(collection, payload.id);
      return Vue.set(state.collections, payload.collection, collection);
    },
    _setOpenedCollection: function(state, collection) {
      return Vue.set(state, 'openedCollection', collection);
    },
    _setOpenedItem: function(state, item) {
      return Vue.set(state, 'openedItem', item);
    }
  },
  actions: {
    register: function(context, payload) {
      payload.collection || (payload.collection = 'default');
      payload.id || (payload.id = _.uniqueId('lightbox-'));
      return context.commit('_setItem', payload);
    },
    unregister: function(context, payload) {
      payload.collection || (payload.collection = 'default');
      if (payload.id != null) {
        return context.commit('_removeItem', payload);
      }
    },
    open: function(context, payload) {
      context.commit('_setOpenedCollection', payload.collection);
      return context.commit('_setOpenedItem', payload.id);
    },
    close: function(context) {
      context.commit('_setOpenedCollection', null);
      return context.commit('_setOpenedItem', null);
    },
    openPrevious: function(context) {
      var index, keys;
      if (!((context.state.openedCollection != null) && (context.state.openedItem != null))) {
        return;
      }
      keys = _.keys(context.state.collections[context.state.openedCollection]);
      index = _.indexOf(keys, context.state.openedItem);
      index -= 1;
      if (!(index >= 0)) {
        return;
      }
      return context.dispatch('open', {
        collection: context.state.openedCollection,
        id: keys[index]
      });
    },
    openNext: function(context) {
      var index, keys;
      if (!((context.state.openedCollection != null) && (context.state.openedItem != null))) {
        return;
      }
      keys = _.keys(context.state.collections[context.state.openedCollection]);
      index = _.indexOf(keys, context.state.openedItem);
      index += 1;
      if (!(index < _.size(keys))) {
        return;
      }
      return context.dispatch('open', {
        collection: context.state.openedCollection,
        id: keys[index]
      });
    }
  }
};


/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

var Q, Vue;

Q = __webpack_require__(2);

Vue = __webpack_require__(3);

module.exports = {
  namespaced: true,
  state: {
    partners: []
  },
  mutations: {
    _setPartners: function(state, payload) {
      return Vue.set(state, 'partners', payload.partners);
    }
  },
  actions: {
    load: function(context) {
      var axiosData, d;
      d = Q.defer();
      axiosData = {
        method: 'get',
        url: '/api/partners'
      };
      context.dispatch('net/call', axiosData, {
        root: true
      }).then(function(responseData) {
        var ref, ref1;
        context.commit('_setPartners', {
          partners: ((ref = responseData.data) != null ? ref.data : void 0) || []
        });
        return d.resolve({
          partners: ((ref1 = responseData.data) != null ? ref1.data : void 0) || []
        });
      }).done();
      return d.promise;
    }
  }
};


/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

var Vue, _;

_ = __webpack_require__(0);

Vue = __webpack_require__(3);

module.exports = {
  namespaced: true,
  state: {
    openRequests: 0
  },
  getters: {
    hasOpenRequests: function(state) {
      return state.openRequests > 0;
    }
  },
  mutations: {
    setOpenRequestCount: function(state, count) {
      if (count == null) {
        count = 0;
      }
      if (count < 0 || !_.isNumber(count) || _.isNaN(count)) {
        count = 0;
      }
      return Vue.set(state, 'openRequests', count);
    }
  },
  actions: {
    startRequest: function(context) {
      return context.commit('setOpenRequestCount', context.state.openRequests + 1);
    },
    finishRequest: function(context) {
      return context.commit('setOpenRequestCount', context.state.openRequests - 1);
    }
  }
};


/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

var Q, _, callbackQueue, googleMaps, loaded, scriptUrl, util;

Q = __webpack_require__(2);

_ = __webpack_require__(0);

loaded = false;

googleMaps = null;

callbackQueue = [];

scriptUrl = "//maps.googleapis.com/maps/api/js";

util = {
  mapsLoadCallback: function() {
    loaded = true;
    googleMaps = window.google.maps;
    return _.each(callbackQueue, function(deferred) {
      return deferred.resolve(googleMaps);
    });
  },
  scriptExists: function() {
    return (document.getElementById('maps-script') != null) === true;
  },
  loadTag: function(googleMapsKey) {
    var script, url;
    if (this.scriptExists()) {
      return;
    }
    url = scriptUrl + "?key=" + googleMapsKey + "&callback=mapsLoadCallback";
    script = document.createElement('script');
    script.id = 'maps-script';
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;
    script.defer = true;
    script;
    return document.body.appendChild(script);
  }
};

window.mapsLoadCallback = util.mapsLoadCallback;

module.exports = {
  namespaced: true,
  state: {
    defaultMapStyles: __webpack_require__(714)
  },
  actions: {
    load: function(context) {
      var d;
      d = Q.defer();
      if (loaded === true && (googleMaps != null)) {
        d.resolve(googleMaps);
      } else {
        callbackQueue.push(d);
        if (util.scriptExists !== true) {
          util.loadTag(context.rootState.settings.google.maps_key);
        }
      }
      return d.promise;
    }
  }
};


/***/ }),

/***/ 714:
/***/ (function(module, exports) {

module.exports = [];


/***/ })

},[626]);


// WEBPACK FOOTER //
// js/frontend-544fd5cd0105164271ce.js